// @ts-nocheck
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** Decimal (fixed-point) */
  Decimal: { input: any; output: any; }
  /** Decimal value serialized as a floating-point number */
  DecimalAsFloat: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AchAssetInput = {
  monetary: AchMonetaryUnitInput;
};

export type AchAssetResponse = {
  __typename?: 'ACHAssetResponse';
  monetary: AchMonetaryUnitResponse;
};

export type AchMonetaryUnitInput = {
  amount: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
};

export type AchMonetaryUnitResponse = {
  __typename?: 'ACHMonetaryUnitResponse';
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
};

export type AchOriginatorInput = {
  accountNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  routingCode: Scalars['String']['input'];
};

export type AchOriginatorResponse = {
  __typename?: 'ACHOriginatorResponse';
  accountNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  routingCode: Scalars['String']['output'];
};

export type AchPaymentInstruction = {
  __typename?: 'ACHPaymentInstruction';
  asset: AchAssetResponse;
  effectiveEntryDate: Scalars['String']['output'];
  originator: AchOriginatorResponse;
  paymentAuthorizationDetails: Scalars['String']['output'];
  recipient: AchRecipientResponse;
  standardEntryClassCode: Scalars['String']['output'];
  transactionDate: Scalars['String']['output'];
  transactionSpeed: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
};

export type AchPaymentInstructionInput = {
  asset: AchAssetInput;
  effectiveEntryDate: Scalars['String']['input'];
  originator: AchOriginatorInput;
  paymentAuthorizationDetails: Scalars['String']['input'];
  recipient: AchRecipientInput;
  standardEntryClassCode: Scalars['String']['input'];
  transactionDate: Scalars['String']['input'];
  transactionSpeed: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
};

export type AchPaymentInstructionResponse = {
  __typename?: 'ACHPaymentInstructionResponse';
  id: Scalars['String']['output'];
  paymentInstruction: AchPaymentInstruction;
  status: Scalars['String']['output'];
};

export type AchRecipientInput = {
  accountNumber: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  routingCode: Scalars['String']['input'];
};

export type AchRecipientResponse = {
  __typename?: 'ACHRecipientResponse';
  accountNumber: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  routingCode: Scalars['String']['output'];
};

export type AcceptorInput = {
  acceptorId?: InputMaybe<Scalars['Int']['input']>;
  acceptorNameLocation?: InputMaybe<Scalars['String']['input']>;
  acceptorTerminalId?: InputMaybe<Scalars['Int']['input']>;
};

export type Account = {
  __typename?: 'Account';
  accountHolderId?: Maybe<Scalars['String']['output']>;
  activeCardsCount?: Maybe<Scalars['Int']['output']>;
  auditFields?: Maybe<AuditFields>;
  category?: Maybe<AccountCategory>;
  clientAssignedId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ledgerBalances?: Maybe<Array<LedgerBalance>>;
  lineOfCredit?: Maybe<LineOfCredit>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AccountStatus>;
};


export type AccountActiveCardsCountArgs = {
  clientId: Scalars['String']['input'];
};

export enum AccountCategory {
  AccountCategoryUnspecified = 'ACCOUNT_CATEGORY_UNSPECIFIED',
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type AccountHolder = {
  __typename?: 'AccountHolder';
  accountHolderDeceasedData?: Maybe<AccountHolderDeceasedData>;
  accountHolderScraData?: Maybe<AccountHolderScraData>;
  accountHolderStatus?: Maybe<AccountHolderStatus>;
  accountHolderType?: Maybe<AccountHolderType>;
  clientAssignedId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  commercialDetails?: Maybe<AccountHolderCommercialDetails>;
  companyId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<PhoneNumbers>;
  retailDetails?: Maybe<AccountHolderRetailDetails>;
  subClientId?: Maybe<Scalars['String']['output']>;
};

export type AccountHolderCommercialDetails = {
  __typename?: 'AccountHolderCommercialDetails';
  companyName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AccountHolderCommercialDetailsInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type AccountHolderConfigurationInput = {
  length?: InputMaybe<Scalars['Int']['input']>;
  numberingType: NumberingType;
  segments?: InputMaybe<Array<SegmentInput>>;
};

export type AccountHolderDeceasedData = {
  __typename?: 'AccountHolderDeceasedData';
  dateDeceasedVerified?: Maybe<Scalars['String']['output']>;
  dateOfDeath?: Maybe<Scalars['String']['output']>;
  deathMasterId?: Maybe<Scalars['String']['output']>;
  deleteNotes?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Scalars['String']['output']>>;
  editNotes?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type AccountHolderDeceasedDataInput = {
  dateDeceasedVerified?: InputMaybe<Scalars['String']['input']>;
  dateOfDeath?: InputMaybe<Scalars['String']['input']>;
  deathMasterId?: InputMaybe<Scalars['String']['input']>;
  deleteNotes?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  editNotes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AccountHolderInput = {
  accountHolderDeceasedData?: InputMaybe<AccountHolderDeceasedDataInput>;
  accountHolderScraData?: InputMaybe<AccountHolderScraDataInput>;
  accountHolderStatus?: InputMaybe<AccountHolderStatus>;
  accountHolderType?: InputMaybe<AccountHolderType>;
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  commercialDetails?: InputMaybe<AccountHolderCommercialDetailsInput>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<PhoneNumbersInput>;
  retailDetails?: InputMaybe<AccountHolderRetailDetailsInput>;
  subClientId?: InputMaybe<Scalars['String']['input']>;
};

export type AccountHolderNumberGenerationPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<AccountHolderNumberGenerationPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type AccountHolderNumberGenerationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<AccountHolderConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type AccountHolderRetailDetails = {
  __typename?: 'AccountHolderRetailDetails';
  dateOfBirth?: Maybe<DateOfBirth>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AccountHolderRetailDetailsInput = {
  dateOfBirth?: InputMaybe<DateOfBirthInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccountHolderScraData = {
  __typename?: 'AccountHolderSCRAData';
  deleteNotes?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Scalars['String']['output']>>;
  editNotes?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  scraActiveDutyEndDate?: Maybe<Scalars['String']['output']>;
  scraActiveDutyOrdersReceived?: Maybe<Scalars['String']['output']>;
  scraActiveDutyStartDate?: Maybe<Scalars['String']['output']>;
  scraMilitaryBranch?: Maybe<Scalars['String']['output']>;
  scraRequestBenefitsDate?: Maybe<Scalars['String']['output']>;
  scraVerificationDate?: Maybe<Scalars['String']['output']>;
};

export type AccountHolderScraDataInput = {
  deleteNotes?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  editNotes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scraActiveDutyEndDate?: InputMaybe<Scalars['String']['input']>;
  scraActiveDutyOrdersReceived?: InputMaybe<Scalars['String']['input']>;
  scraActiveDutyStartDate?: InputMaybe<Scalars['String']['input']>;
  scraMilitaryBranch?: InputMaybe<Scalars['String']['input']>;
  scraRequestBenefitsDate?: InputMaybe<Scalars['String']['input']>;
  scraVerificationDate?: InputMaybe<Scalars['String']['input']>;
};

export enum AccountHolderStatus {
  AccountHolderStatusUnspecified = 'ACCOUNT_HOLDER_STATUS_UNSPECIFIED',
  Active = 'ACTIVE',
  Deceased = 'DECEASED'
}

export enum AccountHolderType {
  AccountHolderStatusUnspecified = 'ACCOUNT_HOLDER_STATUS_UNSPECIFIED',
  Commercial = 'COMMERCIAL',
  Individual = 'INDIVIDUAL'
}

export type AccountInput = {
  accountHolderId: Scalars['String']['input'];
  category?: InputMaybe<AccountCategory>;
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  lineOfCredit?: InputMaybe<LineOfCreditInput>;
  productId: Scalars['String']['input'];
  status?: InputMaybe<AccountStatus>;
};

export type AccountNumberGenerationPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<AccountHolderNumberGenerationPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export enum AccountStatus {
  AccountStatusUnspecified = 'ACCOUNT_STATUS_UNSPECIFIED',
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Frozen = 'FROZEN',
  Pending = 'PENDING'
}

export type AccountUpdateInput = {
  accountHolderId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<AccountCategory>;
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lineOfCredit?: InputMaybe<LineOfCreditInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
  status: AccountStatus;
};

export type AccountV2 = {
  __typename?: 'AccountV2';
  accountId?: Maybe<Scalars['String']['output']>;
  activeCardsCount?: Maybe<Scalars['Int']['output']>;
  clientAssignedId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  fundingType?: Maybe<AccountCategory>;
  ledgers?: Maybe<Array<LedgerV2>>;
  lineOfCredit?: Maybe<LineOfCreditV2>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};


export type AccountV2ActiveCardsCountArgs = {
  clientId: Scalars['String']['input'];
};

export type ActivateKeyInput = {
  keyId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type ActivateKeyResponse = {
  __typename?: 'ActivateKeyResponse';
  key?: Maybe<KeyResponse>;
};

export type AddSubscriptionsInnerResponse = {
  __typename?: 'AddSubscriptionsInnerResponse';
  responseStatus?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type AddSubscriptionsResponse = {
  __typename?: 'AddSubscriptionsResponse';
  response?: Maybe<AddSubscriptionsInnerResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AddWebhookSubscriptionsInput = {
  events: Array<Scalars['Int']['input']>;
};

export type AdditionalAmount = {
  __typename?: 'AdditionalAmount';
  accountType: TypeValue;
  amount: TypeValue;
  amountType: TypeValue;
  currencyCode: TypeValue;
  occurence: Scalars['String']['output'];
  transactionType: TypeValue;
};

export type AdditionalDataDecodResponse = {
  __typename?: 'AdditionalDataDecodResponse';
  additionalDataDecoded?: Maybe<Array<AdditionalDataDecoded>>;
  additionalDataDecodedMc?: Maybe<AdditionalDataDecodeMc>;
  btnPds0043IsVisible: Scalars['Boolean']['output'];
  btnPds0146IsVisible: Scalars['Boolean']['output'];
  btnPds0158IsVisible: Scalars['Boolean']['output'];
  btnPds0159IsVisible: Scalars['Boolean']['output'];
  heading: Scalars['String']['output'];
  pds0043: Scalars['String']['output'];
  pds0146: Scalars['String']['output'];
  pds0158: Scalars['String']['output'];
  pds0159: Scalars['String']['output'];
};

export type AdditionalDataDecodeMc = {
  __typename?: 'AdditionalDataDecodeMC';
  additionalDataDecoded?: Maybe<Array<AdditionalDataDecoded>>;
  tcc: Scalars['String']['output'];
  totalLength: Scalars['String']['output'];
};

export type AdditionalDataDecoded = {
  __typename?: 'AdditionalDataDecoded';
  item: Scalars['String']['output'];
  pdsmc?: Maybe<Scalars['String']['output']>;
  subElements?: Maybe<Array<AdditionalDataDecoded>>;
  value: Scalars['String']['output'];
};

export type AdditionalDetail = {
  __typename?: 'AdditionalDetail';
  acquirerForwarderId?: Maybe<Scalars['String']['output']>;
  authorisationExpiryDateUtc?: Maybe<Scalars['DateTime']['output']>;
  authorisationType?: Maybe<Scalars['String']['output']>;
  branchCode?: Maybe<Scalars['String']['output']>;
  cardDeviceType?: Maybe<Scalars['String']['output']>;
  checkResultsSent?: Maybe<Scalars['String']['output']>;
  checkResultsSentLocation?: Maybe<Scalars['String']['output']>;
  currencyCodeFee?: Maybe<Scalars['String']['output']>;
  currencyCodeFeeSettlement?: Maybe<Scalars['String']['output']>;
  dccIndicator?: Maybe<Scalars['Boolean']['output']>;
  emv?: Maybe<Emv>;
  fxRate?: Maybe<Scalars['Decimal']['output']>;
  instantFundingGps?: Maybe<Scalars['Boolean']['output']>;
  instantFundingNetwork?: Maybe<Scalars['Boolean']['output']>;
  interchangeAmountFee?: Maybe<Scalars['Decimal']['output']>;
  interchangeAmountFeeSettlement?: Maybe<Scalars['Decimal']['output']>;
  loadedBy?: Maybe<Scalars['String']['output']>;
  matchingTransactionId?: Maybe<Scalars['Long']['output']>;
  merchant?: Maybe<Merchant>;
  multiPartCount?: Maybe<Scalars['Int']['output']>;
  multiPartNumber?: Maybe<Scalars['Int']['output']>;
  multiPartTransaction?: Maybe<Scalars['Boolean']['output']>;
  multiPartTransactionFinal?: Maybe<Scalars['Boolean']['output']>;
  pos?: Maybe<Pos>;
  posCapabilities?: Maybe<PosCapabilities>;
  preAuthorisationDays?: Maybe<Scalars['Int']['output']>;
  psdScaExempt?: Maybe<Scalars['String']['output']>;
  rateType?: Maybe<Scalars['String']['output']>;
  settlementIndicator?: Maybe<Scalars['String']['output']>;
};

export type AdditionalResponseData = {
  __typename?: 'AdditionalResponseData';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  accountHolderId: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressType: AddressType;
  auditFields?: Maybe<AuditFields>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  accountHolderId: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType: AddressType;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressType {
  Dispatch = 'DISPATCH',
  Employer = 'EMPLOYER',
  Main = 'MAIN'
}

export type AddressUpdateInput = {
  accountHolderId?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<AddressType>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpdateRequestInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AddressV2 = {
  __typename?: 'AddressV2';
  addressId?: Maybe<Scalars['String']['output']>;
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  type: AddressType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum Algorithm {
  Ibm = 'IBM',
  Visa = 'VISA'
}

export enum AllocationOrderOption {
  CashFirst = 'CASH_FIRST',
  HighestInterestFirst = 'HIGHEST_INTEREST_FIRST',
  PurchasesFirst = 'PURCHASES_FIRST'
}

export type ApexAddress = {
  __typename?: 'ApexAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ApplicationInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type ApplicationMessageResponse = {
  __typename?: 'ApplicationMessageResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  appId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
};

export type AssignPermissionToGroupInput = {
  permissionId: Scalars['String']['input'];
  resourceArn?: InputMaybe<Scalars['String']['input']>;
};

export type AtmWithdrawalInternationalPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<AtmWithdrawalInternationalPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type AtmWithdrawalInternationalPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeMapping = {
  __typename?: 'AttributeMapping';
  externalAttribute: Scalars['String']['output'];
  internalAttribute: InternalAttributeMappingType;
  isRequired: Scalars['Boolean']['output'];
};

export type AttributeMappingInput = {
  externalAttribute: Scalars['String']['input'];
  internalAttribute: InternalAttributeMappingType;
  isRequired?: Scalars['Boolean']['input'];
};

export type AuditFields = {
  __typename?: 'AuditFields';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  companyId?: Maybe<Scalars['String']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type AuditLogFieldValuePair = {
  __typename?: 'AuditLogFieldValuePair';
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AuditLogLookupTableResponse = {
  __typename?: 'AuditLogLookupTableResponse';
  items: Array<AuditLogFieldValuePair>;
};

export type AuditLogRequestInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  screenName?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogsExportResponse = {
  __typename?: 'AuditLogsExportResponse';
  logs: Array<AuditLog>;
};

export type AuditLogsResponse = {
  __typename?: 'AuditLogsResponse';
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  logs: Array<AuditLog>;
};

export type AuthFees = {
  __typename?: 'AuthFees';
  capDomesticFee?: Maybe<Scalars['Decimal']['output']>;
  capFxFee?: Maybe<Scalars['Decimal']['output']>;
  capNonDomesticFee?: Maybe<Scalars['Decimal']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  declineFee?: Maybe<Scalars['Decimal']['output']>;
  description: Scalars['String']['output'];
  domesticFee?: Maybe<Scalars['Decimal']['output']>;
  domesticFeeRate?: Maybe<Scalars['Decimal']['output']>;
  domesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  fxFixed?: Maybe<Scalars['Decimal']['output']>;
  fxRate?: Maybe<Scalars['Decimal']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  nonDomesticFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticRate?: Maybe<Scalars['Decimal']['output']>;
  numberOfFreeTransactionPerActivation?: Maybe<Scalars['Int']['output']>;
  numberOfFreeTransactionPerMonth?: Maybe<Scalars['Int']['output']>;
  partialAllowed?: Maybe<Scalars['Boolean']['output']>;
  processingCode?: Maybe<Scalars['String']['output']>;
  smsFee?: Maybe<Scalars['Decimal']['output']>;
  thresholdType?: Maybe<Scalars['String']['output']>;
};

export enum AuthProvider {
  Cloudentity = 'CLOUDENTITY',
  Cognito = 'COGNITO',
  Unspecified = 'UNSPECIFIED'
}

export type AuthReversalRequestInput = {
  note: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type AuthReversalResponse = {
  __typename?: 'AuthReversalResponse';
  transactionId: Scalars['Long']['output'];
};

export type AuthorisationDecision = {
  __typename?: 'AuthorisationDecision';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type AuthorisationStatus = {
  __typename?: 'AuthorisationStatus';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type Authorisor = {
  __typename?: 'Authorisor';
  key: Scalars['String']['output'];
  value: AuthorisorType;
};

export enum AuthorisorType {
  ApexMc = 'APEX_MC',
  ApexMpEcsPrd0Mastercard = 'APEX_MP_ECS_PRD0_Mastercard',
  ApexMpEcsPrd0Visa = 'APEX_MP_ECS_PRD0_Visa',
  ApexMpEcsPrd1Mastercard = 'APEX_MP_ECS_PRD1_Mastercard',
  ApexMpEcsPrd1Visa = 'APEX_MP_ECS_PRD1_Visa',
  ApexMpEcsPrd2Mastercard = 'APEX_MP_ECS_PRD2_Mastercard',
  ApexMpEcsPrd2Visa = 'APEX_MP_ECS_PRD2_Visa',
  ApexPrd0Discover = 'APEX_PRD0_DISCOVER',
  ApexPrd0Mastercard = 'APEX_PRD0_MASTERCARD',
  ApexPrd0Mne = 'APEX_PRD0_MNE',
  ApexPrd0Visa = 'APEX_PRD0_VISA',
  ApexPrd1Discover = 'APEX_PRD1_DISCOVER',
  ApexPrd1Mastercard = 'APEX_PRD1_MASTERCARD',
  ApexPrd1Mne = 'APEX_PRD1_MNE',
  ApexPrd1Visa = 'APEX_PRD1_VISA',
  ApexPrd2Discover = 'APEX_PRD2_DISCOVER',
  ApexPrd2Mastercard = 'APEX_PRD2_MASTERCARD',
  ApexPrd2Mne = 'APEX_PRD2_MNE',
  ApexPrd2Visa = 'APEX_PRD2_VISA',
  ApexPrd2VisaWhale_1 = 'APEX_PRD2_VISA_WHALE_1',
  ApexVisa = 'APEX_VISA',
  Btp = 'BTP',
  BtpApexPrd0Mastercard = 'BTP_APEX_PRD0_MASTERCARD',
  BtpApexPrd0Visa = 'BTP_APEX_PRD0_VISA',
  BtpApexPrd1Mastercard = 'BTP_APEX_PRD1_MASTERCARD',
  BtpApexPrd1Visa = 'BTP_APEX_PRD1_VISA',
  BtpApexPrd2Mastercard = 'BTP_APEX_PRD2_MASTERCARD',
  BtpApexPrd2Visa = 'BTP_APEX_PRD2_VISA',
  BtpMas = 'BTP_MAS'
}

export type AvsCardResponse = {
  __typename?: 'AvsCardResponse';
  addressResult?: Maybe<Scalars['String']['output']>;
  avsResponse?: Maybe<Scalars['String']['output']>;
  postcodeDigits?: Maybe<Scalars['String']['output']>;
  postcodeResult?: Maybe<Scalars['String']['output']>;
  streetAddressDigits?: Maybe<Scalars['String']['output']>;
};

export type BalanceLimit = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  decider: BalanceLimitDecider;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export enum BalanceLimitDecider {
  FixedAmount = 'FIXED_AMOUNT',
  GreaterOf = 'GREATER_OF',
  LesserOf = 'LESSER_OF',
  Percentage = 'PERCENTAGE'
}

export type BalanceResponse = {
  __typename?: 'BalanceResponse';
  availableBalance: Scalars['Decimal']['output'];
  cardBalance: Scalars['Decimal']['output'];
  currencyCode: Scalars['String']['output'];
  pendingAmount: Scalars['Decimal']['output'];
};

export type BalanceTransferInput = {
  balanceTransferRequest: TransactionsRequestInput;
  publicToken: Scalars['String']['input'];
};

export type BaseConfigurationInput = {
  buckets?: InputMaybe<Array<BucketConfigurationInput>>;
  limitConfiguration: LimitConfigurationInput;
  paymentAllocation: PaymentAllocationConfigurationInput;
};

export type BaseConfigurationPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<BaseConfigurationPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type BaseConfigurationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<BaseConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type BaseVerificationConfigurationInput = {
  bypassAnyTransaction?: Scalars['Boolean']['input'];
};

/** Represents a Bin Range. */
export type BinRange = {
  __typename?: 'BinRange';
  /** The database generated UUID string which uniquely identifies the bin. */
  binId?: Maybe<Scalars['String']['output']>;
  /** The maximum of the bin range the client has provided. */
  binMax?: Maybe<Scalars['String']['output']>;
  /** The minimum of the bin range the client has provided. */
  binMin?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the bin range. */
  id?: Maybe<Scalars['String']['output']>;
};

/** The input required to alter/query a Bin Range. */
export type BinRangeInput = {
  /** The database generated UUID string which uniquely identifies the bin. */
  binId?: InputMaybe<Scalars['String']['input']>;
  /** The maximum of the bin range the client has provided. */
  binMax?: InputMaybe<Scalars['String']['input']>;
  /** The minimum of the bin range the client has provided. */
  binMin?: InputMaybe<Scalars['String']['input']>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: InputMaybe<Scalars['String']['input']>;
};

export type BlockedCurrenciesConfigurationInput = {
  isoCode: Scalars['String']['input'];
  isoNum: Scalars['String']['input'];
};

export type BlockedCurrenciesPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<BlockedCurrenciesPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type BlockedCurrenciesPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<BlockedCurrenciesConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export enum BreachType {
  DoNothing = 'DO_NOTHING',
  HardDecline = 'HARD_DECLINE',
  SoftDecline = 'SOFT_DECLINE'
}

export type BucketConfigurationInput = {
  balanceLimit?: InputMaybe<BalanceLimit>;
  bucketId?: InputMaybe<BucketId>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: Scalars['Boolean']['input'];
  transactionType: TransactionTypeBtp;
};

export enum BucketId {
  Cash = 'CASH',
  Purchases = 'PURCHASES'
}

export enum BucketOrderOption {
  BalanceTransfer = 'BALANCE_TRANSFER',
  Cash = 'CASH',
  Purchases = 'PURCHASES'
}

export type BypassedAuthorisationVerificationConfigurationInput = {
  avs: CardNotPresentVerificationConfigurationInput;
  chipArqc: BaseVerificationConfigurationInput;
  chipAtc: BaseVerificationConfigurationInput;
  chipServiceCode: BaseVerificationConfigurationInput;
  cvvCvc: GenericVerificationConfigurationInput;
  expiryDateCheck: GenericVerificationConfigurationInput;
  magStripeServiceCode: BaseVerificationConfigurationInput;
  startDate: GenericVerificationConfigurationInput;
};

export type BypassedAuthorisationVerificationPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<BypassedAuthorisationVerificationPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type BypassedAuthorisationVerificationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<BypassedAuthorisationVerificationConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ClAddress = {
  __typename?: 'CLAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countyCity?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type ClAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countyCity?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type CvrDecodedResponse = {
  __typename?: 'CVRDecodedResponse';
  cvrDetails?: Maybe<Array<CvrDecodedResponse>>;
  item: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Cvv2Cvc2ConfigurationInput = {
  bypassAnyCvv2Cvc2Check?: Scalars['Boolean']['input'];
  cardNotPresent: CvvCardNotPresentConfigurationInput;
};

export type Cvv2PolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<Cvv2PolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type Cvv2PolicyInput = {
  allowValueReset?: InputMaybe<Array<Scalars['String']['input']>>;
  bypassCvv2Cvc2: Cvv2Cvc2ConfigurationInput;
  cardVerificationValue2MaxAttempts: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Cvv2Cvc2ConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type CvvCardNotPresentConfigurationInput = {
  ecommerce?: Scalars['Boolean']['input'];
  manual?: Scalars['Boolean']['input'];
  recurring?: Scalars['Boolean']['input'];
  telephone?: Scalars['Boolean']['input'];
};

export type CalendarGroupResponse = {
  __typename?: 'CalendarGroupResponse';
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  weekDay?: Maybe<Array<WeekDay>>;
};

export type CapAsset = {
  __typename?: 'CapAsset';
  monetary?: Maybe<CapMonetaryUnit>;
};

export type CapMonetaryUnit = {
  __typename?: 'CapMonetaryUnit';
  amount?: Maybe<Scalars['Decimal']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
};

export type CardAcceptanceMethods = {
  __typename?: 'CardAcceptanceMethods';
  defaultTicked?: Maybe<Scalars['Boolean']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  variableDescription?: Maybe<Scalars['String']['output']>;
  variableType?: Maybe<Scalars['String']['output']>;
  variableTypeCode?: Maybe<Scalars['String']['output']>;
};

export type CardAcceptorDetailResponse = {
  __typename?: 'CardAcceptorDetailResponse';
  id: Scalars['Int']['output'];
  isConfiguredGroup?: Maybe<Scalars['Boolean']['output']>;
  merchantIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type CardAcceptorDetailResponseWithResolver = {
  __typename?: 'CardAcceptorDetailResponseWithResolver';
  id: Scalars['Int']['output'];
  isConfiguredGroup?: Maybe<Scalars['Boolean']['output']>;
  merchantIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type CardAcceptorPolicyConfigInput = {
  bannedCardAcceptors?: InputMaybe<Array<AcceptorInput>>;
};

export type CardAcceptorPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<CardAcceptorPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type CardAcceptorPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<CardAcceptorPolicyConfigInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type CardAcceptorsResponse = {
  __typename?: 'CardAcceptorsResponse';
  cardAcceptorAllowList?: Maybe<Array<CardAcceptorDetailResponse>>;
  cardAcceptorDisallowList?: Maybe<Array<CardAcceptorDetailResponse>>;
};

export type CardActionUsers = {
  __typename?: 'CardActionUsers';
  userCode: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type CardActions = {
  __typename?: 'CardActions';
  actionCode: Scalars['String']['output'];
  actionName: Scalars['String']['output'];
};

export type CardDetails = {
  __typename?: 'CardDetails';
  activationDate?: Maybe<Scalars['String']['output']>;
  clearPan?: Maybe<Scalars['String']['output']>;
  customerReference?: Maybe<Scalars['String']['output']>;
  cvv?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  fullNameOnCard?: Maybe<Scalars['String']['output']>;
  gpsExpiryDate?: Maybe<Scalars['String']['output']>;
  maskedPan: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CardFeeResponse = {
  __typename?: 'CardFeeResponse';
  authFees: Array<AuthFees>;
  recurringFees: Array<RecurringFees>;
  webServiceGroupFees: Array<WebServiceGroupFees>;
  webServiceProductFees: Array<WebServiceProductFees>;
};

export type CardGroupLimits = {
  __typename?: 'CardGroupLimits';
  accumulatedFrequencyLimit1: Scalars['Int']['output'];
  accumulatedFrequencyLimit2: Scalars['Int']['output'];
  accumulatedPeriod1?: Maybe<Scalars['String']['output']>;
  accumulatedPeriod2?: Maybe<Scalars['String']['output']>;
  accumulatedValueLimit1: Scalars['Float']['output'];
  accumulatedValueLimit2: Scalars['Float']['output'];
  dailyFrequencyLimit: Scalars['Int']['output'];
  dailyValueLimit: Scalars['Float']['output'];
  groupCode?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  maxAllowableBalance: Scalars['Float']['output'];
  maxPerTransaction: Scalars['Float']['output'];
  minPerTransaction: Scalars['Float']['output'];
  subGroup?: Maybe<Scalars['String']['output']>;
};

export type CardHistoryResponse = {
  __typename?: 'CardHistoryResponse';
  action: Scalars['String']['output'];
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  note: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type CardHolder = {
  __typename?: 'CardHolder';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CardHolderUpdateRequestInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardLimits = {
  __typename?: 'CardLimits';
  accumulatedPeriod1?: Maybe<CardLimitsSub>;
  accumulatedPeriod2?: Maybe<CardLimitsSub>;
  daily?: Maybe<CardLimitsSub>;
  subGroup?: Maybe<Scalars['String']['output']>;
};

export type CardLimitsSub = {
  __typename?: 'CardLimitsSub';
  frequency: Scalars['Int']['output'];
  limit: Scalars['Decimal']['output'];
  period?: Maybe<Scalars['Int']['output']>;
  spent: Scalars['Decimal']['output'];
  transactionCount: Scalars['Int']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type CardLoadSourcesResponse = {
  __typename?: 'CardLoadSourcesResponse';
  accumulatedFrequencyLimit1: Scalars['Int']['output'];
  accumulatedFrequencyLimit2: Scalars['Int']['output'];
  accumulatedPeriod1?: Maybe<Scalars['String']['output']>;
  accumulatedPeriod2?: Maybe<Scalars['String']['output']>;
  accumulatedValueLimit1: Scalars['Float']['output'];
  accumulatedValueLimit2: Scalars['Float']['output'];
  dailyFrequencyLimit: Scalars['Int']['output'];
  dailyValueLimit: Scalars['Float']['output'];
  groupCode?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  loadSrcDescription: Scalars['String']['output'];
  maxPerTransaction: Scalars['Float']['output'];
  minPerTransaction: Scalars['Float']['output'];
  subGroup?: Maybe<Scalars['String']['output']>;
};

export type CardMccDetailResponse = {
  __typename?: 'CardMccDetailResponse';
  mccCode: Scalars['String']['output'];
  mccHigh?: Maybe<Scalars['Int']['output']>;
  mccLow?: Maybe<Scalars['Int']['output']>;
};

export type CardMetaHistoryInput = {
  fromDateTime: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  toDateTime: Scalars['String']['input'];
};

export type CardMetaHistoryResponse = {
  __typename?: 'CardMetaHistoryResponse';
  activity: Scalars['String']['output'];
  changeDate: Scalars['DateTime']['output'];
  note: Scalars['String']['output'];
};

export type CardNetworkType = {
  __typename?: 'CardNetworkType';
  description: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type CardNotPresentConfigurationInput = {
  ecommerce?: Scalars['Boolean']['input'];
  manual?: Scalars['Boolean']['input'];
  recurring?: Scalars['Boolean']['input'];
  telephone?: Scalars['Boolean']['input'];
};

export type CardNotPresentVerificationConfigurationInput = {
  bypassAnyTransaction?: Scalars['Boolean']['input'];
  cardNotPresent: CardNotPresentConfigurationInput;
};

export type CardPinStatusResponse = {
  __typename?: 'CardPinStatusResponse';
  remainingOfflineTries?: Maybe<Scalars['String']['output']>;
  remainingTries: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CardPosSubLimitsResponse = {
  __typename?: 'CardPosSubLimitsResponse';
  cardPosSubLimits?: Maybe<Array<PosSubLimitsResult>>;
};

export type CardPresentConfigurationInput = {
  chip?: Scalars['Boolean']['input'];
  magStripe?: Scalars['Boolean']['input'];
};

export type CardProduct = {
  __typename?: 'CardProduct';
  ehiMode: Scalars['Decimal']['output'];
  networkId: Scalars['Decimal']['output'];
  product: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productShortName: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
  subBinHigh?: Maybe<Scalars['Int']['output']>;
  subBinLow?: Maybe<Scalars['Int']['output']>;
};

export type CardSpendLimitByProductResponse = {
  __typename?: 'CardSpendLimitByProductResponse';
  limitsWithCounter?: Maybe<Array<LimitCategory>>;
  public_token?: Maybe<Scalars['String']['output']>;
};

export type CardStatus = {
  __typename?: 'CardStatus';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isEditableByProgramManager: Scalars['Boolean']['output'];
};

export enum CardStatusCode {
  AllowablePinTriesExceededCapture = 'ALLOWABLE_PIN_TRIES_EXCEEDED_CAPTURE',
  AllGood = 'ALL_GOOD',
  ApprovedSpecial = 'APPROVED_SPECIAL',
  BlockedByCardholder = 'BLOCKED_BY_CARDHOLDER',
  BlockedByCardholderContactCardholder = 'BLOCKED_BY_CARDHOLDER_CONTACT_CARDHOLDER',
  BlockedByIssuer = 'BLOCKED_BY_ISSUER',
  CaptureCard = 'CAPTURE_CARD',
  CardholderToContactIssuer = 'CARDHOLDER_TO_CONTACT_ISSUER',
  CardAcceptorCallAcquirersSecurityDepartment = 'CARD_ACCEPTOR_CALL_ACQUIRERS_SECURITY_DEPARTMENT',
  CardAcceptorCallAcquirerSecurityCapture = 'CARD_ACCEPTOR_CALL_ACQUIRER_SECURITY_CAPTURE',
  CardDestroyed = 'CARD_DESTROYED',
  CardExpired = 'CARD_EXPIRED',
  CardNotActivatedYet = 'CARD_NOT_ACTIVATED_YET',
  CardPinBlocked = 'CARD_PIN_BLOCKED',
  CardToBePickedUpAtAtm = 'CARD_TO_BE_PICKED_UP_AT_ATM',
  CardVoided = 'CARD_VOIDED',
  ClosedAccount = 'CLOSED_ACCOUNT',
  CompletedPartially = 'COMPLETED_PARTIALLY',
  CryptographicFailure = 'CRYPTOGRAPHIC_FAILURE',
  CustomerCancellation = 'CUSTOMER_CANCELLATION',
  DeclineForCvv2Failure = 'DECLINE_FOR_CVV2_FAILURE',
  DoNotHonour = 'DO_NOT_HONOUR',
  DuplicateTransmission = 'DUPLICATE_TRANSMISSION',
  ExceedsWithdrawalFrequencyLimit = 'EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT',
  ExceedsWithdrawalLimit = 'EXCEEDS_WITHDRAWAL_LIMIT',
  ExpiredCardCapture = 'EXPIRED_CARD_CAPTURE',
  ForceStip = 'FORCE_STIP',
  ForeignNetworkError = 'FOREIGN_NETWORK_ERROR',
  FormatError = 'FORMAT_ERROR',
  GpsProtectLongTermDebitBlock = 'GPS_PROTECT_LONG_TERM_DEBIT_BLOCK',
  GpsProtectLongTermFullBlock = 'GPS_PROTECT_LONG_TERM_FULL_BLOCK',
  GpsProtectShortTermDebitBlock = 'GPS_PROTECT_SHORT_TERM_DEBIT_BLOCK',
  GpsProtectShortTermFullBlock = 'GPS_PROTECT_SHORT_TERM_FULL_BLOCK',
  HonourWithIdentification = 'HONOUR_WITH_IDENTIFICATION',
  Inactive = 'INACTIVE',
  IncorrectPin = 'INCORRECT_PIN',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidFromAccountInField3 = 'INVALID_FROM_ACCOUNT_IN_FIELD3',
  InvalidMerchant = 'INVALID_MERCHANT',
  InvalidToAccountInField3 = 'INVALID_TO_ACCOUNT_IN_FIELD3',
  InvalidTransaction = 'INVALID_TRANSACTION',
  InvalidVerificationCode = 'INVALID_VERIFICATION_CODE',
  IssuerOrSwitchInoperative = 'ISSUER_OR_SWITCH_INOPERATIVE',
  IssuerSignOff = 'ISSUER_SIGN_OFF',
  IvrLostStolenBlock = 'IVR_LOST_STOLEN_BLOCK',
  LongTermDebitBlock = 'LONG_TERM_DEBIT_BLOCK',
  LongTermFullBlock = 'LONG_TERM_FULL_BLOCK',
  LostCard = 'LOST_CARD',
  NetworkError = 'NETWORK_ERROR',
  NoSuchCardNumber = 'NO_SUCH_CARD_NUMBER',
  NoSuchIssuer = 'NO_SUCH_ISSUER',
  OriginalAmountIncorrect = 'ORIGINAL_AMOUNT_INCORRECT',
  PartialApproval = 'PARTIAL_APPROVAL',
  PinChangeUnblockDeclined = 'PIN_CHANGE_UNBLOCK_DECLINED',
  PinNotChanged = 'PIN_NOT_CHANGED',
  PinValidationNotPossible = 'PIN_VALIDATION_NOT_POSSIBLE',
  PurchaseOnlyNoCashBack = 'PURCHASE_ONLY_NO_CASH_BACK',
  ReconcileError = 'RECONCILE_ERROR',
  ReferToIssuer = 'REFER_TO_ISSUER',
  RefundGivenToCustomer = 'REFUND_GIVEN_TO_CUSTOMER',
  RequiresScaCard = 'REQUIRES_SCA_CARD',
  RequiresScaNonCard = 'REQUIRES_SCA_NON_CARD',
  ResponseReceivedTooLate = 'RESPONSE_RECEIVED_TOO_LATE',
  RestrictedCard = 'RESTRICTED_CARD',
  RestrictedCardCapture = 'RESTRICTED_CARD_CAPTURE',
  SecurityViolation = 'SECURITY_VIOLATION',
  ShortTermDebitBlock = 'SHORT_TERM_DEBIT_BLOCK',
  ShortTermFullBlock = 'SHORT_TERM_FULL_BLOCK',
  StolenCard = 'STOLEN_CARD',
  SuspectedFraud = 'SUSPECTED_FRAUD',
  SystemMalfunction = 'SYSTEM_MALFUNCTION',
  TimeoutAtIem = 'TIMEOUT_AT_IEM',
  TransactionNotPermittedToCardholder = 'TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER',
  TransactionNotPermittedToTerminal = 'TRANSACTION_NOT_PERMITTED_TO_TERMINAL',
  TransactionNotSupportedBlockedByIssuer = 'TRANSACTION_NOT_SUPPORTED_BLOCKED_BY_ISSUER',
  UnableToRoute = 'UNABLE_TO_ROUTE',
  UnacceptablePin = 'UNACCEPTABLE_PIN',
  UnacceptablePinRetry = 'UNACCEPTABLE_PIN_RETRY',
  UnknownCardStatus = 'UNKNOWN_CARD_STATUS',
  UnsafePin = 'UNSAFE_PIN',
  UnspecifiedError = 'UNSPECIFIED_ERROR',
  VerificationDataFailed = 'VERIFICATION_DATA_FAILED',
  ViolationOfLaw = 'VIOLATION_OF_LAW'
}

export enum CardStatusCodeNumeric {
  AllGood = 'AllGood',
  AllowableNumberOfPinTriesExceeded = 'AllowableNumberOfPinTriesExceeded',
  AllowablePinTriesExceededCapture = 'AllowablePinTriesExceededCapture',
  ApprovedSpecial = 'ApprovedSpecial',
  BlockedByCardholderOrContactCardholder = 'BlockedByCardholderOrContactCardholder',
  CaptureCard = 'CaptureCard',
  CardAcceptorCallAcquirerSecurity = 'CardAcceptorCallAcquirerSecurity',
  CardAcceptorCallAcquirersSecurityDepartment = 'CardAcceptorCallAcquirersSecurityDepartment',
  CardDestroyed = 'CardDestroyed',
  CardExpired = 'CardExpired',
  CardNotActivatedYet = 'CardNotActivatedYet',
  CardNotYetActivated = 'CardNotYetActivated',
  CardToBePickedUpAtAtm = 'CardToBePickedUpAtAtm',
  CardVoided = 'CardVoided',
  CardholderToContactIssuer = 'CardholderToContactIssuer',
  ClosedAccount = 'ClosedAccount',
  CompletedPartially = 'CompletedPartially',
  CryptographicFailure = 'CryptographicFailure',
  CustomerCancellation = 'CustomerCancellation',
  DeclineForCvv2Failure = 'DeclineForCvv2Failure',
  DoNotHonour = 'DoNotHonour',
  DuplicateTransmission = 'DuplicateTransmission',
  ExceedsWithdrawalFrequencyLimit = 'ExceedsWithdrawalFrequencyLimit',
  ExceedsWithdrawalLimit = 'ExceedsWithdrawalLimit',
  ExpiredCard = 'ExpiredCard',
  ForceStip = 'ForceStip',
  ForeignNetworkFailure = 'ForeignNetworkFailure',
  FormatError = 'FormatError',
  HonourWithIdentification = 'HonourWithIdentification',
  IncorrectPin = 'IncorrectPin',
  InsufficientFunds = 'InsufficientFunds',
  InvalidAmount = 'InvalidAmount',
  InvalidArqcOrCvv1OrCvv2OrCvv3OrIcvv = 'InvalidArqcOrCvv1OrCvv2OrCvv3OrIcvv',
  InvalidFromAccountInField3 = 'InvalidFromAccountInField3',
  InvalidMerchant = 'InvalidMerchant',
  InvalidToAccountInField3 = 'InvalidToAccountInField3',
  InvalidTransaction = 'InvalidTransaction',
  IssuerOrSwitchInoperative = 'IssuerOrSwitchInoperative',
  IssuerSignOff = 'IssuerSignOff',
  IvrLostOrStolenBlock = 'IvrLostOrStolenBlock',
  LongTermDebitBlock = 'LongTermDebitBlock',
  LongTermFullBlock = 'LongTermFullBlock',
  LostCard = 'LostCard',
  NetworkError = 'NetworkError',
  NoSuchCardNumber = 'NoSuchCardNumber',
  NoSuchIssuer = 'NoSuchIssuer',
  OriginalAmountIncorrect = 'OriginalAmountIncorrect',
  PartialApproval = 'PartialApproval',
  PinChangeUnblockDeclined = 'PinChangeUnblockDeclined',
  PinNotChanged = 'PinNotChanged',
  PinValidationNotPossible = 'PinValidationNotPossible',
  PurchaseOnlyNoCashBack = 'PurchaseOnlyNoCashBack',
  ReconcileError = 'ReconcileError',
  ReferToCardIssuer = 'ReferToCardIssuer',
  RefundGivenToCustomer = 'RefundGivenToCustomer',
  RequiresScaNonCard = 'RequiresScaNonCard',
  ResponseReceivedTooLate = 'ResponseReceivedTooLate',
  RestrictedCard = 'RestrictedCard',
  RestrictedCardCapture = 'RestrictedCardCapture',
  ScaRequired = 'ScaRequired',
  SecurityViolation = 'SecurityViolation',
  ShortTermDebitBlock = 'ShortTermDebitBlock',
  ShortTermFullBlock = 'ShortTermFullBlock',
  StolenCard = 'StolenCard',
  SuspectedFraud = 'SuspectedFraud',
  SystemMalfunction = 'SystemMalfunction',
  ThreddProtectLongTermDebitBlock = 'ThreddProtectLongTermDebitBlock',
  ThreddProtectLongTermFullBlock = 'ThreddProtectLongTermFullBlock',
  ThreddProtectShortTermDebitBlock = 'ThreddProtectShortTermDebitBlock',
  ThreddProtectShortTermFullBlock = 'ThreddProtectShortTermFullBlock',
  TimeoutAtIem = 'TimeoutAtIem',
  TransactionNotPermittedToCardholder = 'TransactionNotPermittedToCardholder',
  TransactionNotPermittedToTerminal = 'TransactionNotPermittedToTerminal',
  TransactionNotSupportedOrBlockedByIssuer = 'TransactionNotSupportedOrBlockedByIssuer',
  UnableToRoute = 'UnableToRoute',
  UnacceptablePin = 'UnacceptablePin',
  UnacceptablePinRetry = 'UnacceptablePinRetry',
  UnknownCardStatus = 'UnknownCardStatus',
  UnsafePin = 'UnsafePin',
  UnspecifiedError = 'UnspecifiedError',
  VerificationDataFailed = 'VerificationDataFailed',
  ViolationOfLaw = 'ViolationOfLaw'
}

export type CardStatusHistoryInput = {
  fromDateTime: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  toDateTime: Scalars['String']['input'];
};

export type CardStatusResponse = {
  __typename?: 'CardStatusResponse';
  cardStatusCode: Scalars['String']['output'];
  cardStatusDescription: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum CardType {
  MasterVirtual = 'MASTER_VIRTUAL',
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export enum CardVerificationMethod {
  NoCardVerification = 'NO_CARD_VERIFICATION',
  OnlineAndOfflinePin = 'ONLINE_AND_OFFLINE_PIN',
  OnlinePin = 'ONLINE_PIN',
  Signature = 'SIGNATURE'
}

export type CardsResponse = {
  __typename?: 'CardsResponse';
  actualBalance?: Maybe<Scalars['Decimal']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  availableBalance?: Maybe<Scalars['Decimal']['output']>;
  cardStatus?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customerReference?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endPointBase?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isLive: Scalars['Boolean']['output'];
  issuerId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  panPubt?: Maybe<Scalars['Long']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  programManagerId?: Maybe<Scalars['String']['output']>;
  publicToken: Scalars['Long']['output'];
  schemeId: Scalars['Int']['output'];
  schemeName?: Maybe<Scalars['String']['output']>;
  tel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  certificateType: CertificateType;
  fingerprint: Scalars['String']['output'];
  keyId: Scalars['String']['output'];
  status: CertificateStatus;
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
};

export type CertificateMessageResponse = {
  __typename?: 'CertificateMessageResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export enum CertificateStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export enum CertificateType {
  Encryption = 'ENCRYPTION',
  Signing = 'SIGNING',
  Transport = 'TRANSPORT'
}

export type ChangeCardStatusInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  publicToken: Scalars['String']['input'];
  status: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePaymentTokenStatusInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  newStatus: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
  updatedBy: Scalars['String']['input'];
};

export type Channel = {
  __typename?: 'Channel';
  /** The channel type, used for easier identification and categorisation of channels */
  channelType?: Maybe<ChannelType>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The datetime of when the Channel was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who created the Channel. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the Channel. */
  id?: Maybe<Scalars['String']['output']>;
  /** A simple name field for Channel. Unique constraint in place. */
  name?: Maybe<Scalars['String']['output']>;
  /** How transaction rejections are handled, whether they are rejected and reported or rejected and suspended. */
  rejectionRule?: Maybe<RejectionRule>;
  /** Represents the origin of the Channel. */
  sourceType?: Maybe<ChannelSourceType>;
  /** A brief description used in the transaction posting. */
  transactionDescriptionText?: Maybe<Scalars['String']['output']>;
  /** The datetime of when the Channel was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who last updated the Channel. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ChannelInput = {
  /** The channel type, used for easier identification and categorisation of channels */
  channelType?: InputMaybe<ChannelType>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who created the Channel. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** A simple name field for Channel. Unique constraint in place. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** How transaction rejections are handled, whether they are rejected and reported or rejected and suspended. */
  rejectionRule?: InputMaybe<RejectionRule>;
  /** Represents the origin of the Channel. */
  sourceType?: InputMaybe<ChannelSourceType>;
  /** A brief description used in the transaction posting. */
  transactionDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who last updated the Channel. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the origin of the Channel. */
export enum ChannelSourceType {
  Custom = 'CUSTOM'
}

/** Represents the type of the Channel. */
export enum ChannelType {
  CustomChannel = 'CUSTOM_CHANNEL',
  LoadChannel = 'LOAD_CHANNEL',
  SchemeChannel = 'SCHEME_CHANNEL'
}

export type ClearCacheResponse = {
  __typename?: 'ClearCacheResponse';
  /** Number of exchanged tokens removed */
  exchangedTokensCleared: Scalars['Int']['output'];
  /** Number of subject tokens removed */
  subjectTokensCleared: Scalars['Int']['output'];
  /** Whether the cache was successfully cleared */
  success: Scalars['Boolean']['output'];
};

export type Client = {
  __typename?: 'Client';
  addresses: Array<ClAddress>;
  /** @deprecated old requirement, no longer needed for any client type */
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ProductCategory>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  emails: Array<Email>;
  id?: Maybe<Scalars['String']['output']>;
  institutionId?: Maybe<Scalars['Int']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  /** @deprecated old requirement, no longer needed for any client type */
  issuerCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated old requirement, no longer needed for any client type */
  issuerName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<PhoneNumber>;
  programManagerCode?: Maybe<Scalars['String']['output']>;
  programManagerId?: Maybe<Scalars['Int']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  reportingCurrency?: Maybe<Scalars['String']['output']>;
  reportingCutoffTime?: Maybe<Scalars['String']['output']>;
  reportingTimezone?: Maybe<Scalars['String']['output']>;
  rulesType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClientStatus>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export enum ClientAuthMethod {
  ClientSecretBasic = 'CLIENT_SECRET_BASIC',
  PrivateKeyJwt = 'PRIVATE_KEY_JWT'
}

export type ClientGroupInput = {
  groupType: GroupType;
  mccGroups?: InputMaybe<Array<MerchantCategoryCodeGroupInput>>;
  name: Scalars['String']['input'];
  restrictedProcessingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  singleAuthorisationLimit?: InputMaybe<Scalars['Float']['input']>;
  status: GroupStatus;
};

export type ClientInput = {
  addresses?: InputMaybe<Array<ClAddressInput>>;
  /** @deprecated old requirement, no longer needed for any client type */
  brandName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<ProductCategory>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<EmailInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated old requirement, no longer needed for any client type */
  issuerCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated old requirement, no longer needed for any client type */
  issuerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<PhoneNumberInput>>;
  programManagerCode?: InputMaybe<Scalars['String']['input']>;
  programManagerId?: InputMaybe<Scalars['Int']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  reportingCurrency?: InputMaybe<Scalars['String']['input']>;
  reportingCutoffTime?: InputMaybe<Scalars['String']['input']>;
  reportingTimezone?: InputMaybe<Scalars['String']['input']>;
  rulesType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ClientStatus>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ClientSpace = {
  __typename?: 'ClientSpace';
  accountEmail?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountStatus?: Maybe<Scalars['String']['output']>;
  awsAccountId?: Maybe<Scalars['String']['output']>;
  awsRegion?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deploymentStatus?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['String']['output']>;
  pmId?: Maybe<Scalars['Int']['output']>;
  provisionedProductId?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  sk?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  whaleAccount?: Maybe<Scalars['String']['output']>;
  writeRegion?: Maybe<Scalars['String']['output']>;
};

/** Indicates the Client state. */
export enum ClientStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  ClosureScheduled = 'CLOSURE_SCHEDULED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export type CodeDescription = {
  __typename?: 'CodeDescription';
  bitPositionDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Company = {
  __typename?: 'Company';
  auditFields?: Maybe<AuditFields>;
  companyStatus?: Maybe<CompanyStatus>;
  companyType?: Maybe<CompanyType>;
  id?: Maybe<Scalars['String']['output']>;
  industryType?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentCompanyId?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  subClientId?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  companyStatus?: InputMaybe<CompanyStatus>;
  companyType?: InputMaybe<CompanyType>;
  id?: InputMaybe<Scalars['String']['input']>;
  industryType?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  subClientId?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanyStatus {
  Active = 'ACTIVE',
  CompanyStatusUnspecified = 'COMPANY_STATUS_UNSPECIFIED',
  Inactive = 'INACTIVE',
  PendingVerification = 'PENDING_VERIFICATION'
}

export enum CompanyType {
  CompanyTypeUnspecified = 'COMPANY_TYPE_UNSPECIFIED',
  Partnership = 'PARTNERSHIP',
  PrivateLimited = 'PRIVATE_LIMITED',
  PublicLimited = 'PUBLIC_LIMITED'
}

export type Component = {
  __typename?: 'Component';
  component?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  limitedNetworkGroup?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type Condition = {
  /** Context attribute to evaluate (e.g., 'user_type', 'country') */
  attribute: Scalars['String']['input'];
  /** Comparison operator: equals, not_equals, contains, not_contains, starts_with, ends_with, in, not_in, greater_than, less_than, greater_than_or_equal, less_than_or_equal */
  operator: Scalars['String']['input'];
  /** Value to compare against. Note: Arrays and numbers must be stringified due to schema limitations */
  value: Scalars['String']['input'];
};

export enum ConditionOperator {
  BeginsWith = 'BEGINS_WITH',
  ConditionOperatorUnspecified = 'CONDITION_OPERATOR_UNSPECIFIED',
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type ConnectionServiceLatestBuildNumber = {
  __typename?: 'ConnectionServiceLatestBuildNumber';
  connectionServiceLatestBuildNumber?: Maybe<Scalars['String']['output']>;
};

export enum ConnectionType {
  Mtls = 'MTLS',
  Tls = 'TLS'
}

export type ContactlessConfigurationInput = {
  accumulateNonPin?: Scalars['Boolean']['input'];
  allowAccumulationReset?: Scalars['Boolean']['input'];
  limitResetMode?: InputMaybe<LimitResetMode>;
  maximumAccumulatedAmountBreached?: InputMaybe<BreachType>;
  maximumAccumulatedCountBreached?: InputMaybe<BreachType>;
  maximumAmountExemptionThreshold: Scalars['Float']['input'];
  maximumConsecutiveSpendAmount: Scalars['Float']['input'];
  maximumConsecutiveSpendCount: Scalars['Int']['input'];
  maximumSingleAmount: Scalars['Float']['input'];
  maximumSingleAmountBreached?: InputMaybe<BreachType>;
};

export type ContactlessDomesticPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<ContactlessDomesticPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type ContactlessDomesticPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ContactlessInternationalPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<ContactlessInternationalPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type ContactlessInternationalPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ContactlessPolicyConfigurationInput = {
  accumulateNonPin?: Scalars['Boolean']['input'];
  allowAccumulationReset?: Scalars['Boolean']['input'];
  allowValueReset?: InputMaybe<Array<Scalars['String']['input']>>;
  contactlessEnabled?: Scalars['Boolean']['input'];
  contactlessSupport?: Scalars['Boolean']['input'];
  contactlessThresholdExemptAmount: Scalars['Float']['input'];
  limitResetMode?: InputMaybe<LimitResetMode>;
  maxAccumulatedContactlessAmount: Scalars['Float']['input'];
  maxContactlessTransactions: Scalars['Int']['input'];
  maxSingleContactlessAmount: Scalars['Float']['input'];
  maximumAccumulatedAmountBreached?: InputMaybe<BreachType>;
  maximumAccumulatedCountBreached?: InputMaybe<BreachType>;
  maximumSingleAmountBreached?: InputMaybe<BreachType>;
};

export type ContactlessPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<ContactlessPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type ContactlessPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<ContactlessPolicyConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ControlGroups = {
  __typename?: 'ControlGroups';
  authFeeGroup?: Maybe<Scalars['Long']['output']>;
  calendarGroup?: Maybe<Scalars['Long']['output']>;
  cardAcceptorAllowList?: Maybe<Scalars['Long']['output']>;
  cardAcceptorDisallowList?: Maybe<Scalars['Long']['output']>;
  cardLinkageGroup?: Maybe<Scalars['Long']['output']>;
  fxGroup?: Maybe<Scalars['Long']['output']>;
  limitedNetworkGroup?: Maybe<Scalars['Long']['output']>;
  limitsGroup?: Maybe<Scalars['Long']['output']>;
  mccGroup?: Maybe<Scalars['Long']['output']>;
  paymentTokenUsageGroup?: Maybe<Scalars['Long']['output']>;
  recurringFeeGroup?: Maybe<Scalars['Long']['output']>;
  usageGroup?: Maybe<Scalars['Long']['output']>;
  webServiceFeeGroup?: Maybe<Scalars['Long']['output']>;
};

export type ControlGroupsInput = {
  authFeeGroup?: InputMaybe<Scalars['Long']['input']>;
  calendarGroup?: InputMaybe<Scalars['Long']['input']>;
  cardAcceptorAllowList?: InputMaybe<Scalars['Long']['input']>;
  cardAcceptorDisallowList?: InputMaybe<Scalars['Long']['input']>;
  cardLinkageGroup?: InputMaybe<Scalars['Long']['input']>;
  fxGroup?: InputMaybe<Scalars['Long']['input']>;
  limitedNetworkGroup?: InputMaybe<Scalars['Long']['input']>;
  limitsGroup?: InputMaybe<Scalars['Long']['input']>;
  mccGroup?: InputMaybe<Scalars['Long']['input']>;
  paymentTokenUsageGroup?: InputMaybe<Scalars['Long']['input']>;
  publicToken?: InputMaybe<Scalars['String']['input']>;
  recurringFeeGroup?: InputMaybe<Scalars['Long']['input']>;
  usageGroup?: InputMaybe<Scalars['Long']['input']>;
  webServiceFeeGroup?: InputMaybe<Scalars['Long']['input']>;
};

export type ControlGroupsSub = {
  __typename?: 'ControlGroupsSub';
  authFeeGroup?: Maybe<Scalars['Long']['output']>;
  calendarGroup?: Maybe<Scalars['Long']['output']>;
  cardAcceptorAllowList?: Maybe<Scalars['Long']['output']>;
  cardAcceptorDisallowList?: Maybe<Scalars['Long']['output']>;
  cardLinkageGroup?: Maybe<Scalars['Long']['output']>;
  fxGroup?: Maybe<Scalars['Long']['output']>;
  limitedNetworkGroup?: Maybe<Scalars['Long']['output']>;
  limitsGroup?: Maybe<Scalars['Long']['output']>;
  mccGroup?: Maybe<Scalars['Long']['output']>;
  paymentTokenUsageGroup?: Maybe<Scalars['Long']['output']>;
  recurringFeeGroup?: Maybe<Scalars['Long']['output']>;
  usageGroup?: Maybe<Scalars['Long']['output']>;
  webServiceFeeGroup?: Maybe<Scalars['Long']['output']>;
};

export type Counters = {
  __typename?: 'Counters';
  accumlimit1_amount?: Maybe<Scalars['Decimal']['output']>;
  accumlimit1_count?: Maybe<Scalars['Int']['output']>;
  accumlimit2_amount?: Maybe<Scalars['Decimal']['output']>;
  accumlimit2_count?: Maybe<Scalars['Int']['output']>;
  daily_amount?: Maybe<Scalars['Decimal']['output']>;
  daily_count?: Maybe<Scalars['Int']['output']>;
};

export type Country = {
  __typename?: 'Country';
  alphaCode: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  numericCode: Scalars['String']['output'];
};

/** Represents a Country Currency Code. */
export type CountryCurrencyCode = {
  __typename?: 'CountryCurrencyCode';
  /** The alpha 2 abreviation of of the Country Currency Code. */
  alpha2?: Maybe<Scalars['String']['output']>;
  /** The alpha 3 abreviation of of the Country Currency Code. */
  alpha3?: Maybe<Scalars['String']['output']>;
  /** The alpha currency value of of the Country Currency Code. */
  alphaCurrency?: Maybe<Scalars['String']['output']>;
  /** The country of the Country Currency Code. */
  country?: Maybe<Scalars['String']['output']>;
  /** The currency of of the Country Currency Code. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The expnonet for the currency of of the Country Currency Code. */
  currencyExponent?: Maybe<Scalars['Int']['output']>;
  /** The numeric code of the Country Currency Code. */
  numeric?: Maybe<Scalars['String']['output']>;
  /** The numeric value of the currency of of the Country Currency Code. */
  numericCurrency?: Maybe<Scalars['String']['output']>;
  /** The warning bulletin region of of the Country Currency Code. */
  warningBulletinRegion?: Maybe<Scalars['String']['output']>;
};

/** The input required to alter/query a Country Currency Code. */
export type CountryCurrencyCodeInput = {
  /** The alpha 2 abreviation of of the Country Currency Code. */
  alpha2?: InputMaybe<Scalars['String']['input']>;
  /** The alpha 3 abreviation of of the Country Currency Code. */
  alpha3?: InputMaybe<Scalars['String']['input']>;
  /** The alpha currency value of of the Country Currency Code. */
  alphaCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The country of the Country Currency Code. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The currency of of the Country Currency Code. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The expnonet for the currency of of the Country Currency Code. */
  currencyExponent?: InputMaybe<Scalars['Int']['input']>;
  /** The numeric code of the Country Currency Code. */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /** The numeric value of the currency of of the Country Currency Code. */
  numericCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The warning bulletin region of of the Country Currency Code. */
  warningBulletinRegion?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAchPaymentInstructionInput = {
  paymentInstruction: AchPaymentInstructionInput;
};

export type CreateAccountByProductInput = {
  accountHolderId: Scalars['String']['input'];
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  financialProductId: Scalars['String']['input'];
};

export type CreateAccountHolderInput = {
  accountHolder: AccountHolderInput;
};

export type CreateAccountInput = {
  account: AccountInput;
  policyGroups?: InputMaybe<Array<PolicyGroupInput>>;
};

export type CreateAccountWorkflowInput = {
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  fundingType: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type CreateAddressInput = {
  address: AddressInput;
};

export type CreateAddressV2Input = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  type: AddressType;
};

export type CreateCertificateIssuerInput = {
  caType?: InputMaybe<Scalars['String']['input']>;
  csrPem?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientSpaceInput = {
  awsRegion?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  pmId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCompanyInput = {
  company: CompanyInput;
};

export type CreateCurrencyInput = {
  code: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateCustomerWorkflowInput = {
  customer: CustomerInput;
};

export type CreateFeatureFlagResponse = {
  __typename?: 'CreateFeatureFlagResponse';
  deploymentId?: Maybe<Scalars['Int']['output']>;
  flagName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CreateGroupRequest = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  services: Array<Scalars['String']['input']>;
};

export type CreateIdpInput = {
  attributeMappings?: InputMaybe<Array<AttributeMappingInput>>;
  autoCreateUsers?: Scalars['Boolean']['input'];
  defaultGroupMappings: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  idpType: Scalars['String']['input'];
  metadata: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  oidcConfig?: InputMaybe<CreateOidcConfigInput>;
  samlConfig?: InputMaybe<CreateSamlConfigInput>;
};

export type CreateKmsBinRangeInput = {
  productName: Scalars['String']['input'];
  rangeHighLimit: Scalars['String']['input'];
  rangeLowLimit: Scalars['String']['input'];
};

export type CreateKmsBinRangeResponse = {
  __typename?: 'CreateKmsBinRangeResponse';
  product?: Maybe<ProductResponse>;
};

export type CreateLedgerInput = {
  ledger: LedgerInput;
};

export type CreateLedgerInputV2 = {
  asset: Scalars['String']['input'];
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLedgerPlaygroundBalance = {
  accountId: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  ledgerType: LedgerType;
  sessionId: Scalars['String']['input'];
};

export type CreateLedgerPlaygroundBalanceResponse = {
  __typename?: 'CreateLedgerPlaygroundBalanceResponse';
  ledgerId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CreateLedgerPlaygroundTransaction = {
  accountId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['String']['input']>;
  feeLedgerId?: InputMaybe<Scalars['String']['input']>;
  ledgerId: Scalars['String']['input'];
  offsetLedgerId?: InputMaybe<Scalars['String']['input']>;
  processingChannel?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  sign: LedgerPlaygroundTransactionSign;
  transactionType: LedgerPlaygroundTransactionType;
};

export type CreateLedgerPlaygroundTransactionResponse = {
  __typename?: 'CreateLedgerPlaygroundTransactionResponse';
  message: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type CreateOAuthClientInput = {
  allowedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  applicationId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  ipWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['JSON']['input']>;
  usageNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOidcConfigInput = {
  authorizationEndpoint: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  discoveryUrl: Scalars['String']['input'];
  issuer: Scalars['String']['input'];
  jwksUri: Scalars['String']['input'];
  responseMode: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
  tokenEndpoint: Scalars['String']['input'];
  userinfoEndpoint: Scalars['String']['input'];
};

export type CreateOrganisationGroupInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOrganisationInput = {
  authProvider?: AuthProvider;
  clientAuthMethod?: ClientAuthMethod;
  connection?: ConnectionType;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  identityProviderConfig?: InputMaybe<Scalars['JSON']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  issuerId?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  pmInformation?: InputMaybe<Array<PmInformationInput>>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subClientId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentNetworkConfigInput = {
  caCertificatePath?: InputMaybe<Scalars['String']['input']>;
  certificatePath?: InputMaybe<Scalars['String']['input']>;
  hostIps: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  network: NetworkType;
  privateKeyPath?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePermissionInput = {
  category: Scalars['String']['input'];
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  oauthScopes: Array<Scalars['String']['input']>;
  permissionId: Scalars['String']['input'];
  riskLevel: Scalars['String']['input'];
};

export type CreatePolicyV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateSamlConfigInput = {
  metadataFile?: InputMaybe<Scalars['Upload']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  metadataXml?: InputMaybe<Scalars['String']['input']>;
};

export type CreateServiceRequest = {
  authorisor: AuthorisorType;
  client: Scalars['String']['input'];
  discoverSignOnParams?: InputMaybe<DiscoverSignOnParamsInput>;
  mastercardSignOnParams?: InputMaybe<MastercardSignOnParamsInput>;
  mneSignOnParams?: InputMaybe<MneSignOnParamsInput>;
  name: Scalars['String']['input'];
  networkConfig: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  region: Scalars['String']['input'];
  sessions: Scalars['Int']['input'];
  visaSignOnParams?: InputMaybe<VisaSignOnParamsInput>;
};

export type CreateTransactionResponse = {
  __typename?: 'CreateTransactionResponse';
  declineReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CreateTransactionStatus>;
};

export enum CreateTransactionStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export type CreateTransactionWorkflowInput = {
  accountId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ledgerId?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
  sign: TransactionWorkflowSign;
  transactionReason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  sendInvitation?: Scalars['Boolean']['input'];
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
  threddRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  userAttributes?: InputMaybe<Scalars['JSON']['input']>;
};

export type CredentialConfigurationResponse = {
  __typename?: 'CredentialConfigurationResponse';
  configuration?: Maybe<Scalars['String']['output']>;
  defaultCredentials?: Maybe<Array<CredentialResponse>>;
  fallbackCredentials?: Maybe<CredentialResponse>;
};

export type CredentialResponse = {
  __typename?: 'CredentialResponse';
  credentialType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  kbaQuestion?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CreditCyclingConfigurationInput = {
  dueDateOffsetDays: Scalars['Int']['input'];
  minimumPaymentPercentage: Scalars['Decimal']['input'];
};

export type CreditCyclingConfigurationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<CreditCyclingConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCyclingPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<CreditCyclingConfigurationPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

/** Request type for GraphQL Query */
export type CurConRateInput = {
  /** The Selling currency in the currency pair */
  fromCurrency: Scalars['String']['input'];
  /** The Buying currency in the currency pair */
  toCurrency: Scalars['String']['input'];
};

/** Currency Conversion Rate Response. */
export type CurConRateResponse = {
  __typename?: 'CurConRateResponse';
  conversionRate?: Maybe<Scalars['Decimal']['output']>;
};

/** ISO‑4217 currency held in Thredd reference‑data */
export type Currency = {
  __typename?: 'Currency';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deprecatedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CurrencyCode = {
  __typename?: 'CurrencyCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  accountHolderDeceasedData?: Maybe<AccountHolderDeceasedData>;
  accountHolderScraData?: Maybe<AccountHolderScraData>;
  addresses?: Maybe<Array<CustomerAddress>>;
  clientAssignedId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerType?: Maybe<AccountHolderType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<CustomerPhoneNumbers>;
  status?: Maybe<CustomerStatus>;
  subClientId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  addressId?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AddressType>;
};

export type CustomerAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  type: AddressType;
};

export type CustomerInput = {
  addresses: Array<CustomerAddressInput>;
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  customerType: AccountHolderType;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers: PhoneNumbersInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerPhoneNumbers = {
  __typename?: 'CustomerPhoneNumbers';
  home?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  primaryContact: PhoneContactPriority;
  secondaryContact?: Maybe<PhoneContactPriority>;
  work?: Maybe<Scalars['String']['output']>;
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  CustomerStatusUnspecified = 'CUSTOMER_STATUS_UNSPECIFIED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export type CvvUnblockInput = {
  description?: Scalars['String']['input'];
  updatedBy?: Scalars['String']['input'];
};

export type DateOfBirth = {
  __typename?: 'DateOfBirth';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateOfBirthInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DeactivateKeyInput = {
  keyId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type DeactivateKeyResponse = {
  __typename?: 'DeactivateKeyResponse';
  key?: Maybe<KeyResponse>;
};

export type DefaultMastercardSignOnParams = {
  __typename?: 'DefaultMastercardSignOnParams';
  acquirerOrIssuerIndicator: Scalars['String']['output'];
  addressDataIndicator: Scalars['String']['output'];
  forwardingInstitutionIdentificationCode: Scalars['String']['output'];
  groupSignOnId?: Maybe<Scalars['String']['output']>;
  messageSecurityCode: Scalars['String']['output'];
  pinBlockFormatCode: Scalars['String']['output'];
  pinEncryptionTypeCode: Scalars['String']['output'];
  pinKeyIndexNumber: Scalars['String']['output'];
  pinSecurityTypeCode: Scalars['String']['output'];
};

export type DeleteAccountHolderInput = {
  accountHolderId: Scalars['String']['input'];
};

export type DeleteAccountInput = {
  accountId: Scalars['String']['input'];
};

export type DeleteAddressInput = {
  addressId: Scalars['String']['input'];
};

export type DeleteAddressV2Input = {
  addressId: Scalars['String']['input'];
};

export type DeleteFeatureFlagResponse = {
  __typename?: 'DeleteFeatureFlagResponse';
  deploymentId?: Maybe<Scalars['Int']['output']>;
  flagName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type DeleteProductKeyLinkInput = {
  keyId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type DeleteProductKeyLinkResponse = {
  __typename?: 'DeleteProductKeyLinkResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSubscriptionResponse = {
  __typename?: 'DeleteSubscriptionResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeploymentStatusResponse = {
  __typename?: 'DeploymentStatusResponse';
  state?: Maybe<Scalars['String']['output']>;
};

export type DiscoverSignOnParams = {
  __typename?: 'DiscoverSignOnParams';
  transactionDestinationInstitutionIdentificationCode: Scalars['String']['output'];
  transactionOriginatorInstitutionIdentificationCode: Scalars['String']['output'];
};

export type DiscoverSignOnParamsInput = {
  transactionDestinationInstitutionIdentificationCode: Scalars['String']['input'];
  transactionOriginatorInstitutionIdentificationCode: Scalars['String']['input'];
};

export type EhiAcknowledgementResponse = {
  __typename?: 'EhiAcknowledgementResponse';
  resendToEhi: Scalars['Boolean']['output'];
};

export type EhiResendResponse = {
  __typename?: 'EhiResendResponse';
  resendMessage: Scalars['String']['output'];
};

export type Email = {
  __typename?: 'Email';
  address?: Maybe<Scalars['String']['output']>;
};

export type EmailInput = {
  address?: InputMaybe<Scalars['String']['input']>;
};

export type Emv = {
  __typename?: 'Emv';
  applicationTransactionCounter?: Maybe<Scalars['Int']['output']>;
  cardholderVerificationCode?: Maybe<Scalars['Int']['output']>;
  cardholderVerificationResult?: Maybe<Scalars['Int']['output']>;
  terminalCapabilities?: Maybe<Scalars['String']['output']>;
  terminalType?: Maybe<Scalars['String']['output']>;
  transactionCode?: Maybe<Scalars['String']['output']>;
};

export type EvaluateFeatureFlagResponse = {
  __typename?: 'EvaluateFeatureFlagResponse';
  /** Evaluated flags with their status */
  flags: Array<FeatureFlagEntry>;
  /** Flags that were requested but don't exist */
  missingFlags: Array<Scalars['String']['output']>;
};

export type EventSubscriptionItem = {
  __typename?: 'EventSubscriptionItem';
  description?: Maybe<Scalars['String']['output']>;
  eventCode?: Maybe<Scalars['Int']['output']>;
};

export type ExchangedTokenResponse = {
  __typename?: 'ExchangedTokenResponse';
  /** Whether this token was retrieved from cache or newly generated */
  cached: Scalars['Boolean']['output'];
  /** The exchanged token that will be used for upstream requests */
  exchangedToken: Scalars['String']['output'];
  /** The PM code that was used in the token exchange (if provided) */
  pmCode?: Maybe<Scalars['String']['output']>;
};

export enum ExpiryPeriodAction {
  CloseInstrument = 'CLOSE_INSTRUMENT',
  GenerateRandomPin = 'GENERATE_RANDOM_PIN',
  Unspecified = 'UNSPECIFIED'
}

export type ExpiryPolicyConfigurationInput = {
  expireOnPreviousMonth?: Scalars['Boolean']['input'];
  expiryStrategy: Scalars['String']['input'];
  nonExpiryMonths: Array<Scalars['Int']['input']>;
  periodMonths: Scalars['Int']['input'];
};

export type ExpiryPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<ExpiryPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type ExpiryPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<ExpiryPolicyConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ExportAuditLogsInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ExportKeyInput = {
  keyExchangeKeyArn: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
};

export type ExportKeyResponse = {
  __typename?: 'ExportKeyResponse';
  exportedKeyCheckValue?: Maybe<Scalars['String']['output']>;
  keyExchangeKeyArn?: Maybe<Scalars['String']['output']>;
  wrappedKey?: Maybe<Scalars['String']['output']>;
};

export type ExtendExpiryDateInput = {
  newThreddExpiryDate: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type ExtendExpiryDateResponse = {
  __typename?: 'ExtendExpiryDateResponse';
  gpsExpirationDate: Scalars['String']['output'];
};

export type FeatureContextInput = {
  /** Number of days since account creation */
  accountAgeDays: Scalars['Int']['input'];
  /** Whether the user has admin privileges */
  admin: Scalars['Boolean']['input'];
  /** Unique client identifier */
  clientId: Scalars['String']['input'];
  /** ISO country code for geographic targeting */
  country: Scalars['String']['input'];
  /** Organizational department or team */
  department: Scalars['String']['input'];
  /** List of currently enabled features for this user */
  featuresEnabled: Array<Scalars['String']['input']>;
  /** Average monthly spending in base currency */
  monthlySpend: Scalars['Float']['input'];
  /** Service subscription tier */
  subscriptionLevel: Scalars['String']['input'];
  /** User classification (e.g., 'premium', 'basic', 'enterprise') */
  userType: Scalars['String']['input'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** Evaluated flag data */
  flagData?: Maybe<FlagData>;
  /** Unique flag identifier */
  flagName?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagEntry = {
  __typename?: 'FeatureFlagEntry';
  /** Flag name */
  name?: Maybe<Scalars['String']['output']>;
  /** Evaluation status */
  status: FeatureFlagStatus;
};

export type FeatureFlagMetadata = {
  __typename?: 'FeatureFlagMetadata';
  /** Flag description */
  description?: Maybe<Scalars['String']['output']>;
  /** Flag owner */
  owner?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagRequestInput = {
  /** User context for evaluation */
  context: FeatureContextInput;
  /** List of flag names to evaluate (max 50) */
  flags: Array<Scalars['String']['input']>;
};

export type FeatureFlagStatus = {
  __typename?: 'FeatureFlagStatus';
  /** Whether flag is enabled for this context */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Flag metadata if available */
  metadata?: Maybe<FeatureFlagMetadata>;
  /** Why the flag evaluated this way */
  reason?: Maybe<Scalars['String']['output']>;
  /** Resolved flag value */
  value?: Maybe<Scalars['String']['output']>;
};

export type FeatureRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name: Scalars['String']['input'];
  priority: Priority;
  problem: Scalars['String']['input'];
};

export type FieldMask = {
  fieldMask: Array<Scalars['String']['input']>;
};

export type FieldMaskInput = {
  paths: Array<Scalars['String']['input']>;
};

export type Filter = {
  conditions: Array<FilterCondition>;
  logicalOperator?: InputMaybe<LogicalOperator>;
  subFilters?: InputMaybe<Array<Filter>>;
};

export type FilterCondition = {
  field: Scalars['String']['input'];
  operator: ConditionOperator;
  value: Scalars['String']['input'];
};

/** Represents an Account/Financial Product configuration which has been agreed between a Client and Thredd. */
export type FinancialProduct = {
  __typename?: 'FinancialProduct';
  /** The datetime when the financial Product concludes an ACTIVE period. */
  activeEnd?: Maybe<Scalars['String']['output']>;
  /** The datetime when the financial Product commences an ACTIVE period. */
  activeStart?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the financial Product is part of the DEBIT or CREDIT stream. */
  category?: Maybe<ProductCategory>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who created the financial Product. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** A brief description of the financial Product. */
  description?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the financial product. */
  id?: Maybe<Scalars['String']['output']>;
  /** A list of ledger configurations associated with the Financial Product */
  ledgers: Array<LedgerConfiguration>;
  /** A simple name field for a financial Product. No unique constraint is in place. */
  name?: Maybe<Scalars['String']['output']>;
  /** The user friendly string that uniquely identifies the financial product. */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Indication of whether a financial Product can be accessed by SUB clients or not. */
  scope?: Maybe<ProductScope>;
  /** Indicates the financial Product state. */
  status?: Maybe<ProductStatus>;
  /** A list of sub-client string UUIDs associated with the financial Product. Only GLOBAL products may have SUB clients assigned. SUB clients also require a GLOBAL policy set. */
  subClientIds: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who last updated the financial Product. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** The input required to alter/query an Account/Financial Product. */
export type FinancialProductInput = {
  /** Allows the desired datetime for when the financial Product concludes an ACTIVE period. Is optional, but when both values are provided, it is required to follow the active_start value. */
  activeEnd?: InputMaybe<TimestampInput>;
  /** Allows the desired datetime for when the financial Product commences an ACTIVE period. Is optional, but when both values are provided, it is required to precede the active_end value. */
  activeStart?: InputMaybe<TimestampInput>;
  /** Indicates whether the financial Product is part of the DEBIT or CREDIT stream. */
  category?: InputMaybe<ProductCategory>;
  /** The database generated UUID string which uniquely identifies the client */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who created the financialProduct. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** A list of ledger configurations associated with the Financial Product. */
  ledgers?: InputMaybe<Array<LedgerConfigurationInput>>;
  /** A simple name field for a financial Product. No unique constraint is in place. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The user friendly string that uniquely identifies the financial product. This value is autogenerated if a value is not provided, however one can be specified if needed. */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Indication of financial Product access to SUB clients. Only MSA clients can own GLOBAL products and vice versa (SUB clients own LOCAL) */
  scope?: InputMaybe<ProductScope>;
  /** Indicates the financial Product state. */
  status?: InputMaybe<ProductStatus>;
  /** A list of sub-client string UUIDs associated with the financial Product. Only GLOBAL products may have SUB clients assigned. SUB clients also require a GLOBAL policy set. */
  subClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The identifier of the user who last updated the financial Product. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type FlagData = {
  __typename?: 'FlagData';
  /** Whether the flag is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Flag metadata for documentation */
  metadata?: Maybe<Metadata>;
  /** Rollout percentage (0-100) if configured */
  percentage?: Maybe<Scalars['Int']['output']>;
  /** Why the flag evaluated this way: flag_enabled, flag_disabled, targeting_rule_matched, percentage_rollout_included, percentage_rollout_excluded, shadow_mode, not_found */
  reason?: Maybe<Scalars['String']['output']>;
  /** The flag's value (e.g., 'enabled', 'disabled', 'shadow', or custom) */
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagDataConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<MetadataInput>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  rules?: InputMaybe<Array<InputMaybe<Rule>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagDataInput = {
  config: FlagDataConfigInput;
  name: Scalars['String']['input'];
};

export type FlagsResponse = {
  __typename?: 'FlagsResponse';
  flags?: Maybe<Array<FeatureFlag>>;
};

export type FundsInput = {
  accountId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ledgerId?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
};

export type FxGroupResponse = {
  __typename?: 'FxGroupResponse';
  fxRates?: Maybe<Array<FxRates>>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
};

export type FxRates = {
  __typename?: 'FxRates';
  buy?: Maybe<Scalars['Decimal']['output']>;
  destinationCurrency?: Maybe<Scalars['String']['output']>;
  fxDate?: Maybe<Scalars['String']['output']>;
  mid?: Maybe<Scalars['Decimal']['output']>;
  rateSource?: Maybe<Scalars['String']['output']>;
  sell?: Maybe<Scalars['Decimal']['output']>;
  sourceCurrency?: Maybe<Scalars['String']['output']>;
};

export type GenerateKeyInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  keyAlgorithm?: InputMaybe<Scalars['String']['input']>;
  keyPolicy?: Scalars['Boolean']['input'];
  keyReference?: InputMaybe<Scalars['String']['input']>;
  keyType: Scalars['String']['input'];
  keyUsageType?: InputMaybe<Scalars['String']['input']>;
  modesOfUse?: InputMaybe<ModesOfUse>;
  productId: Scalars['String']['input'];
  tr31Type?: InputMaybe<Scalars['String']['input']>;
};

export enum GenerationOption {
  Fixed = 'FIXED',
  Incremental = 'INCREMENTAL'
}

export type GenericVerificationConfigurationInput = {
  bypassAnyTransaction?: Scalars['Boolean']['input'];
  cardNotPresent: CardNotPresentConfigurationInput;
  cardPresent: CardPresentConfigurationInput;
};

export type GetApplicationCertificatePemResponse = {
  __typename?: 'GetApplicationCertificatePemResponse';
  body: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GetCardGroupLimitDetailResponse = {
  __typename?: 'GetCardGroupLimitDetailResponse';
  cardGroupLimits?: Maybe<Array<CardGroupLimits>>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  maxAllowableBalance: Scalars['Float']['output'];
};

export type GetCardImageResponse = {
  __typename?: 'GetCardImageResponse';
  image: Scalars['String']['output'];
};

export type GetCardLimitResponse = {
  __typename?: 'GetCardLimitResponse';
  availableBalance: Scalars['Decimal']['output'];
  blockedAmount: Scalars['Decimal']['output'];
  cardLimits?: Maybe<Array<CardLimits>>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  maxAllowableBalance: Scalars['Decimal']['output'];
};

export type GetCardMccResponse = {
  __typename?: 'GetCardMCCResponse';
  mccAllowList?: Maybe<Array<CardMccDetailResponse>>;
  mccDisallowList?: Maybe<Array<CardMccDetailResponse>>;
  mccGroup?: Maybe<Scalars['String']['output']>;
};

export type GetCardPaymentTokenDetailsResponse = {
  __typename?: 'GetCardPaymentTokenDetailsResponse';
  activationCode?: Maybe<Scalars['String']['output']>;
  activationCodeExpdate?: Maybe<Scalars['String']['output']>;
  activationMethod?: Maybe<Scalars['String']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  bnReference?: Maybe<Scalars['String']['output']>;
  cardAcceptorNameLocation?: Maybe<Scalars['String']['output']>;
  cardUsageGroup?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['String']['output']>;
  creatorPanReference?: Maybe<Scalars['String']['output']>;
  creatorTokenReference?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceIp?: Maybe<Scalars['String']['output']>;
  deviceLanguage?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  digitisationReference?: Maybe<Scalars['String']['output']>;
  ehiRequestTime?: Maybe<Scalars['String']['output']>;
  ehiResponseTime?: Maybe<Scalars['String']['output']>;
  endOfPhoneNumber?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  externalStatusSetBy?: Maybe<Scalars['String']['output']>;
  finalDecisionBy?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  linkedToken?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  mtid?: Maybe<Scalars['String']['output']>;
  oldExpDate?: Maybe<Scalars['String']['output']>;
  panSource?: Maybe<Scalars['String']['output']>;
  panSourceDescription?: Maybe<Scalars['String']['output']>;
  paymentTokenUsageGroup?: Maybe<Scalars['String']['output']>;
  replacementCount?: Maybe<Scalars['Int']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  statuses?: Maybe<PaymentTokenStatus>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  threddDecision?: Maybe<Scalars['String']['output']>;
  threddDecisionAt?: Maybe<Scalars['String']['output']>;
  tokenPan?: Maybe<Scalars['Long']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  tokenisedDate?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['String']['output']>;
  transactionID?: Maybe<Scalars['Long']['output']>;
  txnStatusChanged?: Maybe<Scalars['String']['output']>;
  walletAccountHash?: Maybe<Scalars['String']['output']>;
  walletAccountScore?: Maybe<Scalars['Int']['output']>;
  walletDeviceScore?: Maybe<Scalars['Int']['output']>;
  walletId?: Maybe<Scalars['String']['output']>;
  walletProvider?: Maybe<Scalars['String']['output']>;
  walletReasons?: Maybe<Scalars['String']['output']>;
};

export type GetCardPaymentTokenDevicesResponse = {
  __typename?: 'GetCardPaymentTokenDevicesResponse';
  bindDate?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  gpsId?: Maybe<Scalars['Long']['output']>;
  gpsStatus?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Long']['output']>;
  paymentSchemeStatus?: Maybe<Scalars['String']['output']>;
  statusDate?: Maybe<Scalars['String']['output']>;
};

export type GetCardResponse = {
  __typename?: 'GetCardResponse';
  address?: Maybe<ApexAddress>;
  balance?: Maybe<BalanceResponse>;
  cardDetails?: Maybe<CardDetails>;
  cardHolder?: Maybe<CardHolder>;
  cardProduct?: Maybe<CardProduct>;
  cardStatusCode: Scalars['String']['output'];
  cardStatusDescription?: Maybe<Scalars['String']['output']>;
  cardType: CardType;
  childCards?: Maybe<Array<Scalars['Long']['output']>>;
  controlGroups?: Maybe<ControlGroupsSub>;
  credentials?: Maybe<CredentialConfigurationResponse>;
  designId?: Maybe<Scalars['String']['output']>;
  freetext1?: Maybe<Scalars['String']['output']>;
  freetext2?: Maybe<Scalars['String']['output']>;
  fulfilment?: Maybe<ApexAddress>;
  isMfxPrimary?: Maybe<Scalars['Boolean']['output']>;
  isMultiFx?: Maybe<Scalars['Boolean']['output']>;
  isoLanguage?: Maybe<Scalars['String']['output']>;
  networkSharingOptOut?: Maybe<Scalars['String']['output']>;
  panPubt?: Maybe<Scalars['Long']['output']>;
  parentCard?: Maybe<Scalars['String']['output']>;
  publicToken: Scalars['String']['output'];
  siblingCards?: Maybe<Array<Scalars['Long']['output']>>;
  status: CardStatusCodeNumeric;
};

export type GetCardSpendLimitDetailsByProductInput = {
  productId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type GetKeyByKeyIdResponse = {
  __typename?: 'GetKeyByKeyIdResponse';
  key?: Maybe<KeyResponse>;
};

export type GetLedgerOffsetPositionInput = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  ledgerId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetLedgerOffsetPositionResponse = {
  __typename?: 'GetLedgerOffsetPositionResponse';
  asset: Scalars['String']['output'];
  closingPosition: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  ledgerId: Scalars['String']['output'];
  netChange: Scalars['String']['output'];
  openingPosition: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type GetLoadSourceResponse = {
  __typename?: 'GetLoadSourceResponse';
  cardLoadSources?: Maybe<Array<CardLoadSourcesResponse>>;
};

export type GetOauthClientResponse = {
  __typename?: 'GetOauthClientResponse';
  allowedGroupIds: Array<Scalars['String']['output']>;
  allowedScopes?: Maybe<Array<Scalars['String']['output']>>;
  applicationId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  cognitoClientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Int']['output']>;
  ipWhitelist?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  issuerId?: Maybe<Scalars['Int']['output']>;
  lastSecretRotation?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  pmId?: Maybe<Scalars['Int']['output']>;
  scopes: Array<Scalars['String']['output']>;
  tags: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  usageNotes?: Maybe<Scalars['String']['output']>;
};

export type GetPaymentTokenUsageGroupDetailsResponse = {
  __typename?: 'GetPaymentTokenUsageGroupDetailsResponse';
  activateAutoCallCentre?: Maybe<Scalars['String']['output']>;
  activateCallCentre?: Maybe<Scalars['String']['output']>;
  activateCallback?: Maybe<Scalars['Boolean']['output']>;
  activateEmail?: Maybe<Scalars['Boolean']['output']>;
  activateMobileApp?: Maybe<Scalars['String']['output']>;
  activateSMS?: Maybe<Scalars['Boolean']['output']>;
  activateWebsiteURL?: Maybe<Scalars['String']['output']>;
  avsMissing?: Maybe<Scalars['String']['output']>;
  cvv2Missing?: Maybe<Scalars['String']['output']>;
  defaultWalletProviderAuthentication?: Maybe<Scalars['String']['output']>;
  groupUsageDefaultName?: Maybe<Scalars['String']['output']>;
  institute?: Maybe<Scalars['String']['output']>;
  minTokensToAuth?: Maybe<Scalars['String']['output']>;
  minTokensToDecline?: Maybe<Scalars['String']['output']>;
  notifyEmail?: Maybe<Scalars['Boolean']['output']>;
  notifyPost?: Maybe<Scalars['Boolean']['output']>;
  notifySMS?: Maybe<Scalars['Boolean']['output']>;
  overrideApproveAuth?: Maybe<Scalars['Boolean']['output']>;
  tokenUsage?: Maybe<Scalars['String']['output']>;
  walletAccountMaxScoreAuth?: Maybe<Scalars['String']['output']>;
  walletAccountMaxScoreDecline?: Maybe<Scalars['String']['output']>;
  walletDecisionsAuth?: Maybe<Scalars['String']['output']>;
  walletDecisionsDecline?: Maybe<Scalars['String']['output']>;
  walletDeviceMaxScoreAuth?: Maybe<Scalars['String']['output']>;
  walletDeviceMaxScoreDecline?: Maybe<Scalars['String']['output']>;
};

export type GetPingWebhook = {
  __typename?: 'GetPingWebhook';
  response?: Maybe<PingWebhookDetailResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetPortalTransactionsInput = {
  amountMax?: InputMaybe<Scalars['Decimal']['input']>;
  amountMin?: InputMaybe<Scalars['Decimal']['input']>;
  billingAmountMax?: InputMaybe<Scalars['Decimal']['input']>;
  billingAmountMin?: InputMaybe<Scalars['Decimal']['input']>;
  billingCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  cardNetwork?: InputMaybe<Array<Scalars['String']['input']>>;
  cardType?: InputMaybe<Scalars['Int']['input']>;
  fromDate: Scalars['DateTime']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  publicToken?: InputMaybe<Scalars['String']['input']>;
  sortAscending: Scalars['Boolean']['input'];
  sortBy?: InputMaybe<TransactionsSortByField>;
  toDate: Scalars['DateTime']['input'];
  traceIdLifeCycle?: InputMaybe<Scalars['String']['input']>;
  transactionCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetSingleTransactionResponse = {
  __typename?: 'GetSingleTransactionResponse';
  acquirerReferenceData?: Maybe<Scalars['String']['output']>;
  additionalAmounts?: Maybe<Scalars['String']['output']>;
  additionalAuthorisationDataDgn?: Maybe<Scalars['String']['output']>;
  additionalAuthorizationDataDgn?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<Scalars['String']['output']>;
  additionalResponseData?: Maybe<Scalars['String']['output']>;
  adviceReasonData?: Maybe<Scalars['String']['output']>;
  aid?: Maybe<Scalars['String']['output']>;
  authorisationCode?: Maybe<Scalars['String']['output']>;
  availableBalance?: Maybe<Scalars['Decimal']['output']>;
  avsCardResponse?: Maybe<AvsCardResponse>;
  avsPostcode?: Maybe<Scalars['String']['output']>;
  avsStreet?: Maybe<Scalars['String']['output']>;
  billingAmount?: Maybe<Scalars['Decimal']['output']>;
  billingAmountWithDirection?: Maybe<Scalars['Decimal']['output']>;
  billingCurrency?: Maybe<Scalars['String']['output']>;
  billingCurrencyNumericCode?: Maybe<Scalars['String']['output']>;
  blockedAmount?: Maybe<Scalars['Decimal']['output']>;
  cardAcceptorIdentificationCode?: Maybe<Scalars['String']['output']>;
  cardAcceptorNameLocation?: Maybe<Scalars['String']['output']>;
  cardAcceptorTerminalIdentification?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyCodeFee?: Maybe<Scalars['String']['output']>;
  currencyCodeFeeSettlement?: Maybe<Scalars['String']['output']>;
  customerReference?: Maybe<Scalars['String']['output']>;
  dateExpiry?: Maybe<Scalars['String']['output']>;
  decodedAdditionalAmount?: Maybe<Array<AdditionalAmount>>;
  decodedAdditionalResponseData?: Maybe<Array<AdditionalResponseData>>;
  description?: Maybe<Scalars['String']['output']>;
  diffInReqResp?: Maybe<Scalars['Int']['output']>;
  ehiMode?: Maybe<Scalars['Int']['output']>;
  feeProcessingCode?: Maybe<Scalars['String']['output']>;
  feeType?: Maybe<Scalars['String']['output']>;
  fid?: Maybe<Scalars['String']['output']>;
  fixedFee?: Maybe<Scalars['Decimal']['output']>;
  functionCode?: Maybe<Scalars['String']['output']>;
  fxPadding?: Maybe<Scalars['Decimal']['output']>;
  gpsPosData?: Maybe<Scalars['String']['output']>;
  iccData?: Maybe<Scalars['String']['output']>;
  interchangeAmountFee?: Maybe<Scalars['String']['output']>;
  interchangeAmountFeeSettlement?: Maybe<Scalars['String']['output']>;
  isMfx?: Maybe<Scalars['Boolean']['output']>;
  mccPadding?: Maybe<Scalars['Decimal']['output']>;
  merchant?: Maybe<Merchant>;
  merchantCategoryCode?: Maybe<Scalars['String']['output']>;
  merchantCategoryDescription?: Maybe<Scalars['String']['output']>;
  messageReasonData?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  networkData?: Maybe<Scalars['String']['output']>;
  networkId?: Maybe<Scalars['Int']['output']>;
  networkReferenceId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  panPubt?: Maybe<Scalars['String']['output']>;
  panReport?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentTokenId?: Maybe<Scalars['Int']['output']>;
  pds146Value?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Pos>;
  posCapabilities?: Maybe<PosCapabilities>;
  posConditionCode?: Maybe<Scalars['String']['output']>;
  posData?: Maybe<Scalars['String']['output']>;
  posEntry?: Maybe<PosEntry>;
  posEntryMode?: Maybe<Scalars['String']['output']>;
  processingCode?: Maybe<Scalars['Long']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  pubToken?: Maybe<Scalars['String']['output']>;
  rateFee?: Maybe<Scalars['Decimal']['output']>;
  recapDate?: Maybe<Scalars['String']['output']>;
  recapNumber?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['Long']['output']>;
  requestTime?: Maybe<Scalars['String']['output']>;
  responseReason?: Maybe<Scalars['String']['output']>;
  responseSource?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  responseStatusDescription?: Maybe<Scalars['String']['output']>;
  responseTime?: Maybe<Scalars['String']['output']>;
  retrievalReference?: Maybe<Scalars['String']['output']>;
  settlementAmount?: Maybe<Scalars['Decimal']['output']>;
  settlementCurrency?: Maybe<Scalars['String']['output']>;
  settlementIndicator?: Maybe<Scalars['String']['output']>;
  stan?: Maybe<Scalars['String']['output']>;
  surchargeFee?: Maybe<Scalars['String']['output']>;
  tillTime?: Maybe<Scalars['Long']['output']>;
  traceIdLifeCycle?: Maybe<Scalars['String']['output']>;
  transactionAmount?: Maybe<Scalars['Decimal']['output']>;
  transactionCurrency?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['String']['output']>;
  transactionDestinationIic?: Maybe<Scalars['String']['output']>;
  transactionDestrinationIic?: Maybe<Scalars['String']['output']>;
  transactionFees?: Maybe<TransactionFeesResponse>;
  transactionId?: Maybe<Scalars['Long']['output']>;
  transactionOriginatingInstitution?: Maybe<Scalars['String']['output']>;
  transactionStatus?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  visaFleet?: Maybe<VisaFleet>;
};

export type GetTransactionsInput = {
  amountMax?: InputMaybe<Scalars['Decimal']['input']>;
  amountMin?: InputMaybe<Scalars['Decimal']['input']>;
  billingAmountMax?: InputMaybe<Scalars['Decimal']['input']>;
  billingAmountMin?: InputMaybe<Scalars['Decimal']['input']>;
  billingCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate: Scalars['DateTime']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productNames?: InputMaybe<Array<Scalars['String']['input']>>;
  publicToken?: InputMaybe<Scalars['String']['input']>;
  sortAscending: Scalars['Boolean']['input'];
  sortBy: Scalars['String']['input'];
  toDate: Scalars['DateTime']['input'];
  traceIdLifeCycle?: InputMaybe<Scalars['String']['input']>;
  transactionCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionStates?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetTransactionsResponse = {
  __typename?: 'GetTransactionsResponse';
  acquirerId?: Maybe<Scalars['String']['output']>;
  additionalDetail?: Maybe<AdditionalDetail>;
  amount: TransactionAmount;
  billingCurrencyNumericCode?: Maybe<Scalars['String']['output']>;
  cardNetwork?: Maybe<Scalars['String']['output']>;
  customerReference?: Maybe<Scalars['String']['output']>;
  dateTime: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ehiMode?: Maybe<Scalars['Int']['output']>;
  endPointBase?: Maybe<Scalars['String']['output']>;
  fees: TransactionFees;
  id?: Maybe<Scalars['Long']['output']>;
  isMfx?: Maybe<Scalars['Boolean']['output']>;
  issuerId?: Maybe<Scalars['Int']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  lifeCycleId?: Maybe<Scalars['String']['output']>;
  lifecycleId?: Maybe<Scalars['Int']['output']>;
  merchant?: Maybe<Merchant>;
  merchantCategoryCode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  panPubt?: Maybe<Scalars['Long']['output']>;
  panToken?: Maybe<Scalars['Long']['output']>;
  pant?: Maybe<Scalars['Long']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentTokenId?: Maybe<Scalars['Int']['output']>;
  processingCode?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  pubToken?: Maybe<Scalars['Long']['output']>;
  recordId?: Maybe<Scalars['Long']['output']>;
  schemeName?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  systemTraceAuditNumber?: Maybe<Scalars['Long']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  traceIdLifeCycle?: Maybe<Scalars['String']['output']>;
  transactionCountry?: Maybe<Scalars['String']['output']>;
  transactionLink?: Maybe<Scalars['Long']['output']>;
  type?: Maybe<TransactionType>;
};

export type GetUsageGroupListDetailsResponse = {
  __typename?: 'GetUsageGroupListDetailsResponse';
  cardAcceptanceMethods?: Maybe<Array<CardAcceptanceMethods>>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  misc?: Maybe<Array<Misc>>;
  transactionTypes?: Maybe<Array<TransactionTypes>>;
  verificationChecks?: Maybe<Array<VerificationChecks>>;
};

export type GetWalletResponse = {
  __typename?: 'GetWalletResponse';
  isAutoTransfer?: Maybe<Scalars['Boolean']['output']>;
  wallets: Array<WalletDetails>;
};

export type GpsStatusInfo = {
  __typename?: 'GpsStatusInfo';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type GroupDetails = {
  __typename?: 'GroupDetails';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type GroupPermissionsResponse = {
  __typename?: 'GroupPermissionsResponse';
  permissions: Array<Permission>;
  totalCount: Scalars['Int']['output'];
};

export type GroupResponse = {
  __typename?: 'GroupResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  isUpdating?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pk: Scalars['String']['output'];
  services?: Maybe<Array<ServiceResponse>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum GroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum GroupType {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED'
}

export type GroupsResponse = {
  __typename?: 'GroupsResponse';
  groupType?: Maybe<Scalars['String']['output']>;
  groups: Array<GroupDetails>;
};

export type HealthCheckFlagging = {
  __typename?: 'HealthCheckFlagging';
  status?: Maybe<Scalars['String']['output']>;
};

export type HealthCheckSource = {
  __typename?: 'HealthCheckSource';
  environment?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceHealthCheck>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type HealthcheckResponse = {
  __typename?: 'HealthcheckResponse';
  allServices: Array<ServiceHealthCheck>;
  overallStatus: Scalars['String']['output'];
  sources: Array<HealthCheckSource>;
  timestamp: Scalars['String']['output'];
};

export type HistoryResponse = {
  __typename?: 'HistoryResponse';
  changeDate: Scalars['String']['output'];
  changeNote?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  newStatus?: Maybe<Scalars['String']['output']>;
  oldStatus?: Maybe<Scalars['String']['output']>;
};

export type HmacSecretResponse = {
  __typename?: 'HmacSecretResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  lastRotatedAt?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
};

export type IccDataDecoded = {
  __typename?: 'IccDataDecoded';
  pds?: Maybe<Scalars['String']['output']>;
  pdsDescription?: Maybe<Scalars['String']['output']>;
  pdsHexa?: Maybe<Scalars['String']['output']>;
  pdsValue?: Maybe<Scalars['String']['output']>;
  subLevelPDS?: Maybe<Array<IccDataDecoded>>;
  subfieldValue: Scalars['String']['output'];
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  attributeMappings: Array<AttributeMapping>;
  autoCreateUsers: Scalars['Boolean']['output'];
  cognitoProviderName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  defaultGroupMappings: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  healthCheckStatus: Scalars['String']['output'];
  idpId: Scalars['String']['output'];
  idpType: IdpType;
  lastHealthCheck?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oidcConfig: OidcConfig;
  organisationId: Scalars['String']['output'];
  samlConfig: SamlConfig;
  status: IdpStatus;
  updatedAt: Scalars['String']['output'];
};

export type IdentityProviderSamlConfigData = {
  __typename?: 'IdentityProviderSamlConfigData';
  acsUrl: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
};

export type IdpHealthCheckResponse = {
  __typename?: 'IdpHealthCheckResponse';
  details?: Maybe<Scalars['JSON']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  idpId: Scalars['String']['output'];
  lastChecked: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum IdpStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum IdpType {
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export type ImportKeyInput = {
  certificateAuthorityPublicKeyIdentifier?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  importToken?: InputMaybe<Scalars['String']['input']>;
  keyAlgorithm?: InputMaybe<Scalars['String']['input']>;
  keyBlockFormat?: InputMaybe<Scalars['String']['input']>;
  keyCheckValueAlgorithm?: InputMaybe<Scalars['String']['input']>;
  keyImportType: Scalars['String']['input'];
  keyReference?: InputMaybe<Scalars['String']['input']>;
  keyType: Scalars['String']['input'];
  keyUsageType?: InputMaybe<Scalars['String']['input']>;
  modesOfUse?: InputMaybe<ModesOfUse>;
  productId: Scalars['String']['input'];
  publicKeyCertificate?: InputMaybe<Scalars['String']['input']>;
  randomNonce?: InputMaybe<Scalars['String']['input']>;
  signingKeyCertificate?: InputMaybe<Scalars['String']['input']>;
  tr31Type?: InputMaybe<Scalars['String']['input']>;
  wrappedKeyBlock?: InputMaybe<Scalars['String']['input']>;
  wrappingKeyIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type ImportParametersResponse = {
  __typename?: 'ImportParametersResponse';
  importToken?: Maybe<Scalars['String']['output']>;
  parametersValidUntilTimestamp?: Maybe<Scalars['String']['output']>;
  wrappingKeyAlgorithm?: Maybe<Scalars['String']['output']>;
  wrappingKeyCertificate?: Maybe<Scalars['String']['output']>;
  wrappingKeyCertificateChain?: Maybe<Scalars['String']['output']>;
};

export enum InstrumentForm {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export type InstrumentFormConfigurationInput = {
  form: InstrumentForm;
  isFormOverridable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InstrumentFormPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<InstrumentFormPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type InstrumentFormPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<InstrumentFormConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type InstrumentMccGroupConfigurationInput = {
  excludedClientGroups?: InputMaybe<Array<ClientGroupInput>>;
  includedClientGroups?: InputMaybe<Array<ClientGroupInput>>;
  invalidMccCheckEnabled?: Scalars['Boolean']['input'];
  mccRestrictionEnabled?: Scalars['Boolean']['input'];
};

export type InstrumentMccGroupPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<InstrumentMccGroupPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type InstrumentMccGroupPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<InstrumentMccGroupConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an Instrument Product configuration which has been agreed between a Client and Thredd. */
export type InstrumentProduct = {
  __typename?: 'InstrumentProduct';
  /** The datetime when the Instrument Product concludes an ACTIVE period. */
  activeEnd?: Maybe<Scalars['String']['output']>;
  /** The datetime when the Instrument Product commences an ACTIVE period. */
  activeStart?: Maybe<Scalars['String']['output']>;
  /** The apex product id of the Instrument Product. */
  apexProductId?: Maybe<Scalars['String']['output']>;
  /** The currency of the Instrument Product. */
  baseCurrency?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the bin range. */
  binRangeId?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the Instrument Product is part of the DEBIT or CREDIT stream. */
  category?: Maybe<ProductCategory>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The country of issue of the Instrument Product. */
  countryOfIssue?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who created the Instrument Product. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** A brief description of the Instrument Product. */
  description?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the instrument product. */
  id?: Maybe<Scalars['String']['output']>;
  /** A simple name field for an Instrument Product. No unique constraint is in place. */
  name?: Maybe<Scalars['String']['output']>;
  /** The user friendly string that uniquely identifies the instrument product for a client. */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** The scheme or service of the Instrument Product. */
  scheme?: Maybe<Scalars['String']['output']>;
  /** The scheme membership id of the Instrument Product. */
  schemeMembershipId?: Maybe<Scalars['String']['output']>;
  /** Indication of whether an Instrument Product can be accessed by SUB clients or not. */
  scope?: Maybe<ProductScope>;
  /** Indicates the Instrument Product state. */
  status?: Maybe<ProductStatus>;
  /** A list of sub-client string UUIDs associated with the Instrument Product. Only GLOBAL instrument products may have SUB clients assigned. SUB clients also require a GLOBAL policy set. */
  subClientIds: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who last updated the Instrument Product. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** The input required to alter/query an Instrument Product. */
export type InstrumentProductInput = {
  /** Allows the desired datetime for when the Instrument Product concludes an ACTIVE period. Is optional, but when both values are provided, it is required to follow the active_start value. */
  activeEnd?: InputMaybe<TimestampInput>;
  /** Allows the desired datetime for when the Instrument Product commences an ACTIVE period. Is optional, but when both values are provided, it is required to precede the active_end value. */
  activeStart?: InputMaybe<TimestampInput>;
  /** The apex product id of the Instrument Product. */
  apexProductId?: InputMaybe<Scalars['String']['input']>;
  /** The currency of the Instrument Product. */
  baseCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The database generated UUID string which uniquely identifies the bin range. */
  binRangeId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the Instrument Product is part of the DEBIT or CREDIT stream. */
  category?: InputMaybe<ProductCategory>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The country of issue of the Instrument Product. */
  countryOfIssue?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who created the Instrument Product. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** A brief description of the Instrument Product. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A simple name field for an Instrument Product. No unique constraint is in place. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The user friendly string that uniquely identifies the instrument product. This value is unique per client. */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** The scheme or service of the Instrument Product. */
  scheme?: InputMaybe<Scalars['String']['input']>;
  /** The scheme membership id of the Instrument Product. */
  schemeMembershipId?: InputMaybe<Scalars['String']['input']>;
  /** Indication of Instrument Product access to SUB clients. Only MSA clients can own GLOBAL instrument products and vice versa (SUB clients own LOCAL) */
  scope?: InputMaybe<ProductScope>;
  /** Indicates the Instrument Product state. */
  status?: InputMaybe<ProductStatus>;
  /** A list of sub-client string UUIDs associated with the Instrument Product. Only GLOBAL instrument products may have SUB clients assigned. SUB clients also require a GLOBAL policy set. */
  subClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The identifier of the user who last updated the Instrument Product. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type InstrumentProvisioningConfigurationInput = {
  contactlessConfiguration?: InputMaybe<ContactlessConfigurationInput>;
  contactlessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  form: InstrumentForm;
  isFormOverridable?: InputMaybe<Scalars['Boolean']['input']>;
  physicalConfiguration?: InputMaybe<PhysicalConfigurationInput>;
};

export type InstrumentProvisioningPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<InstrumentProvisioningPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type InstrumentProvisioningPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<InstrumentProvisioningConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export enum InternalAttributeMappingType {
  Address = 'ADDRESS',
  Birthdate = 'BIRTHDATE',
  Email = 'EMAIL',
  EmailVerified = 'EMAIL_VERIFIED',
  FamilyName = 'FAMILY_NAME',
  Gender = 'GENDER',
  GivenName = 'GIVEN_NAME',
  Locale = 'LOCALE',
  MiddleName = 'MIDDLE_NAME',
  Name = 'NAME',
  Nickname = 'NICKNAME',
  PhoneNumber = 'PHONE_NUMBER',
  PhoneNumberVerified = 'PHONE_NUMBER_VERIFIED',
  Picture = 'PICTURE',
  PreferredUsername = 'PREFERRED_USERNAME',
  Profile = 'PROFILE',
  UpdatedAt = 'UPDATED_AT',
  Username = 'USERNAME',
  Website = 'WEBSITE',
  Zoneinfo = 'ZONEINFO'
}

export type KeyResponse = {
  __typename?: 'KeyResponse';
  active?: Maybe<Scalars['String']['output']>;
  checkValue?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  keyAlgorithm?: Maybe<Scalars['String']['output']>;
  keyArn?: Maybe<Scalars['String']['output']>;
  keyId?: Maybe<Scalars['String']['output']>;
  keyModesOfUse?: Maybe<Scalars['String']['output']>;
  keyReference?: Maybe<Scalars['String']['output']>;
  keyType?: Maybe<Scalars['String']['output']>;
  keyUsageType?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  tr31Type?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KmsBinRangeInput = {
  productId: Scalars['String']['input'];
  rangeHighLimit: Scalars['String']['input'];
  rangeLowLimit: Scalars['String']['input'];
};

export type KmsBinRangeResponse = {
  __typename?: 'KmsBinRangeResponse';
  productId?: Maybe<Scalars['String']['output']>;
  rangeHighLimit?: Maybe<Scalars['String']['output']>;
  rangeLowLimit?: Maybe<Scalars['String']['output']>;
};

export type Ledger = {
  __typename?: 'Ledger';
  accountId?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Scalars['String']['output']>;
  auditFields?: Maybe<AuditFields>;
  balance?: Maybe<LedgerBalance>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LedgerStatus>;
  type?: Maybe<LedgerTypeInput>;
};

export type LedgerBalance = {
  __typename?: 'LedgerBalance';
  accountId?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Scalars['String']['output']>;
  availableBalance?: Maybe<Scalars['Int']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  currentBalance?: Maybe<Scalars['Int']['output']>;
  ledgerId?: Maybe<Scalars['String']['output']>;
  pendingCredit?: Maybe<Scalars['String']['output']>;
  pendingDebit?: Maybe<Scalars['String']['output']>;
  postedCredit?: Maybe<Scalars['String']['output']>;
  postedDebit?: Maybe<Scalars['String']['output']>;
};

export type LedgerConfig = {
  __typename?: 'LedgerConfig';
  /** Indicates whether the Ledger will be automatically or manually created */
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  /** The UUID string which uniquely identifies the Client */
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who created the Ledger Configuration */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The currency of the Ledger Configuration */
  currency?: Maybe<Scalars['String']['output']>;
  /** The UUID string which uniquely identifies the Financial Product */
  financialProductId?: Maybe<Scalars['String']['output']>;
  /** The UUID string which uniquely identifies the Ledger Configuration */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * A list of Instrument Product Ids associated with the Ledger Configuration
   * @deprecated Not populated on list results. Use the REST GET ledgerConfiguration path to retrieve accurate instrument product IDs for a specific ledger.
   */
  instrumentProductIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Load limits of the Ledger Configuration */
  loadLimits?: Maybe<LedgerLoadLimits>;
  /** The name of the Ledger Configuration */
  name?: Maybe<Scalars['String']['output']>;
  /** The unique client friendly reference id to be used in place of the uuid */
  referenceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who last updated the Ledger Configuration */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** The version of the Ledger Configuration */
  version?: Maybe<Scalars['Int']['output']>;
};

export type LedgerConfigInput = {
  /** Indicates whether the Ledger will be automatically or manually created */
  autoCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID string which uniquely identifies the Client */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who created the Ledger Configuration */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The currency of the Ledger Configuration */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The UUID string which uniquely identifies the Financial Product */
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  /** The UUID string which uniquely identifies the Ledger Configuration */
  id?: InputMaybe<Scalars['String']['input']>;
  /** A list of Instrument Product Ids associated with the Ledger Configuration */
  instrumentProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Load limits of the Ledger Configuration */
  loadLimits?: InputMaybe<LedgerLoadLimitsInput>;
  /** The name of the Ledger Configuration */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique client friendly reference id to be used in place of the uuid */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who last updated the Ledger Configuration */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** The version of the Ledger Configuration */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type LedgerConfiguration = {
  __typename?: 'LedgerConfiguration';
  autoCreate?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not populated on list or nested results. Use the REST GET ledgerConfiguration path to retrieve accurate instrument product IDs for a specific ledger. */
  instrumentProductIds: Array<Scalars['String']['output']>;
  loadLimits?: Maybe<LoadLimits>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type LedgerConfigurationInput = {
  autoCreate?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instrumentProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  loadLimits?: InputMaybe<LoadLimitsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type LedgerConfigurationInputBtp = {
  autoCreate?: Scalars['Boolean']['input'];
  currency: Scalars['String']['input'];
  loadLimit: LoadLimitInputBtp;
  name: Scalars['String']['input'];
};

export type LedgerCreationPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<LedgerCreationPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type LedgerCreationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Array<LedgerConfigurationInputBtp>>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type LedgerInput = {
  accountId: Scalars['String']['input'];
  asset: Scalars['String']['input'];
  status?: LedgerStatus;
  type?: LedgerTypeInput;
};

export type LedgerLoadLimit = {
  __typename?: 'LedgerLoadLimit';
  max?: Maybe<Scalars['Int']['output']>;
};

export type LedgerLoadLimitInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type LedgerLoadLimits = {
  __typename?: 'LedgerLoadLimits';
  annually?: Maybe<LedgerLoadLimit>;
  balance?: Maybe<LedgerLoadLimit>;
  daily?: Maybe<LedgerLoadLimit>;
  monthly?: Maybe<LedgerLoadLimit>;
  single?: Maybe<LedgerLoadLimit>;
  weekly?: Maybe<LedgerLoadLimit>;
};

export type LedgerLoadLimitsInput = {
  annually?: InputMaybe<LedgerLoadLimitInput>;
  balance?: InputMaybe<LedgerLoadLimitInput>;
  daily?: InputMaybe<LedgerLoadLimitInput>;
  monthly?: InputMaybe<LedgerLoadLimitInput>;
  single?: InputMaybe<LedgerLoadLimitInput>;
  weekly?: InputMaybe<LedgerLoadLimitInput>;
};

export type LedgerLoadLimitsPolicyConfigurationInput = {
  annually?: InputMaybe<MaximumLoadLimitInput>;
  balance?: InputMaybe<MaximumLoadLimitInput>;
  daily?: InputMaybe<MaximumLoadLimitInput>;
  monthly?: InputMaybe<MaximumLoadLimitInput>;
  single?: InputMaybe<MaximumLoadLimitInput>;
  weekly?: InputMaybe<MaximumLoadLimitInput>;
};

export type LedgerLoadLimitsPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<LedgerLoadLimitsPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type LedgerLoadLimitsPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<LedgerLoadLimitsPolicyConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type LedgerPlaygroundBalance = {
  __typename?: 'LedgerPlaygroundBalance';
  accountId: Scalars['String']['output'];
  asset: Scalars['String']['output'];
  availableBalance: Scalars['String']['output'];
  currentBalance: Scalars['String']['output'];
  ledgerId: Scalars['String']['output'];
  ledgerType: Scalars['String']['output'];
  pendingCredit: Scalars['String']['output'];
  pendingDebit: Scalars['String']['output'];
  postedCredit: Scalars['String']['output'];
  postedDebit: Scalars['String']['output'];
};

export type LedgerPlaygroundSubtransaction = {
  __typename?: 'LedgerPlaygroundSubtransaction';
  amount: Scalars['String']['output'];
  asset: Scalars['String']['output'];
  subTransactionId: Scalars['String']['output'];
  subTransactionType: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type LedgerPlaygroundTransaction = {
  __typename?: 'LedgerPlaygroundTransaction';
  accountId: Scalars['String']['output'];
  billing: LedgerPlaygroundTransactionBilling;
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  feeLedgerId?: Maybe<Scalars['String']['output']>;
  instrumentId?: Maybe<Scalars['String']['output']>;
  ledgerEntries?: Maybe<Array<LedgerPlaygroundTransactionLedgerEntry>>;
  ledgerId: Scalars['String']['output'];
  offsetLedgerId?: Maybe<Scalars['String']['output']>;
  processingChannel: Scalars['String']['output'];
  sign: Scalars['String']['output'];
  status: LedgerPlaygroundTransactionStatus;
  subTransactions?: Maybe<Array<LedgerPlaygroundSubtransaction>>;
  transactionId: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
};

export type LedgerPlaygroundTransactionBilling = {
  __typename?: 'LedgerPlaygroundTransactionBilling';
  billingAmount: Scalars['String']['output'];
  billingAsset: Scalars['String']['output'];
  cashbackAmount?: Maybe<Scalars['String']['output']>;
  cashbackAsset?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<Scalars['String']['output']>;
  feeAsset?: Maybe<Scalars['String']['output']>;
  settlementAmount?: Maybe<Scalars['String']['output']>;
  settlementAsset?: Maybe<Scalars['String']['output']>;
  transactionAmount: Scalars['String']['output'];
  transactionAsset: Scalars['String']['output'];
};

export type LedgerPlaygroundTransactionLedgerEntry = {
  __typename?: 'LedgerPlaygroundTransactionLedgerEntry';
  amount: Scalars['String']['output'];
  asset: Scalars['String']['output'];
  ledgerId: Scalars['String']['output'];
  ledgerType: Scalars['String']['output'];
  sign: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subTransactionId: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum LedgerPlaygroundTransactionSign {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type LedgerPlaygroundTransactionStatus = {
  __typename?: 'LedgerPlaygroundTransactionStatus';
  authorisedOn?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  processedOn?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export enum LedgerPlaygroundTransactionType {
  Funding = 'FUNDING'
}

export enum LedgerStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Frozen = 'FROZEN',
  LedgerStatusUnspecified = 'LEDGER_STATUS_UNSPECIFIED',
  Pending = 'PENDING'
}

export enum LedgerType {
  Customer = 'CUSTOMER',
  Fee = 'FEE',
  Offset = 'OFFSET'
}

export enum LedgerTypeInput {
  Customer = 'CUSTOMER',
  Fee = 'FEE',
  LedgerTypeUnspecified = 'LEDGER_TYPE_UNSPECIFIED',
  Offset = 'OFFSET'
}

export type LedgerUpdateInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  status: LedgerStatus;
  type?: InputMaybe<LedgerTypeInput>;
};

export type LedgerV2 = {
  __typename?: 'LedgerV2';
  asset?: Maybe<Scalars['String']['output']>;
  availableBalance?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentBalance?: Maybe<Scalars['Int']['output']>;
  ledgerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LimitCategory = {
  __typename?: 'LimitCategory';
  category?: Maybe<Scalars['String']['output']>;
  counters?: Maybe<Counters>;
  limits?: Maybe<ProductLimits>;
  subcategories?: Maybe<Array<Subcategories>>;
};

export type LimitConfigurationInput = {
  cashLimitPercentage: Scalars['Float']['input'];
  maxCreditLimit: Scalars['Float']['input'];
};

export type LimitPropertyInput = {
  frequencyCount?: InputMaybe<Scalars['Int']['input']>;
  maximumSpend?: InputMaybe<Scalars['Int']['input']>;
  minimumSpend?: InputMaybe<Scalars['Int']['input']>;
};

export enum LimitResetMode {
  ContactWithoutPin = 'CONTACT_WITHOUT_PIN',
  ContactWithPin = 'CONTACT_WITH_PIN'
}

export type LimitedNetworkGroupResponse = {
  __typename?: 'LimitedNetworkGroupResponse';
  component?: Maybe<Array<Component>>;
  groupDescription?: Maybe<Scalars['String']['output']>;
};

export type LineOfCredit = {
  __typename?: 'LineOfCredit';
  cashAvailable?: Maybe<Scalars['Int']['output']>;
  cashLimit?: Maybe<Scalars['Int']['output']>;
  creditAvailable?: Maybe<Scalars['Int']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  cycleDay?: Maybe<Scalars['Int']['output']>;
  cycleMinPayment?: Maybe<Scalars['Int']['output']>;
  nextCycleDate?: Maybe<Scalars['String']['output']>;
  nextDueDate?: Maybe<Scalars['String']['output']>;
  oldestPd?: Maybe<Scalars['String']['output']>;
  pastDueAmounts?: Maybe<Array<PastDueAmount>>;
  preApproved?: Maybe<Scalars['Boolean']['output']>;
  pricingTier?: Maybe<Scalars['String']['output']>;
  remainingMinPayment?: Maybe<Scalars['Int']['output']>;
  totalPastDue?: Maybe<Scalars['Int']['output']>;
};

export type LineOfCreditInput = {
  cashAvailable?: InputMaybe<Scalars['Int']['input']>;
  cashLimit?: InputMaybe<Scalars['Int']['input']>;
  creditAvailable?: InputMaybe<Scalars['Int']['input']>;
  creditLimit?: InputMaybe<Scalars['Int']['input']>;
  cycleDay?: InputMaybe<Scalars['Int']['input']>;
  cycleMinPayment?: InputMaybe<Scalars['Int']['input']>;
  nextCycleDate?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['String']['input']>;
  oldestPd?: InputMaybe<Scalars['String']['input']>;
  pastDueAmounts?: InputMaybe<Array<PastDueAmountInput>>;
  preApproved?: InputMaybe<Scalars['Boolean']['input']>;
  pricingTier?: InputMaybe<Scalars['String']['input']>;
  remainingMinPayment?: InputMaybe<Scalars['Int']['input']>;
  totalPastDue?: InputMaybe<Scalars['Int']['input']>;
};

export type LineOfCreditV2 = {
  __typename?: 'LineOfCreditV2';
  cashAvailable?: Maybe<Scalars['Int']['output']>;
  cashLimit?: Maybe<Scalars['Int']['output']>;
  creditAvailable?: Maybe<Scalars['Int']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  cycleDay?: Maybe<Scalars['Int']['output']>;
  cycleMinPayment?: Maybe<Scalars['Int']['output']>;
  nextCycleDate?: Maybe<Scalars['String']['output']>;
  nextDueDate?: Maybe<Scalars['String']['output']>;
  oldestPd?: Maybe<Scalars['String']['output']>;
  pastDueAmounts?: Maybe<Array<PastDueAmountV2>>;
  preApproved?: Maybe<Scalars['Boolean']['output']>;
  pricingTier?: Maybe<Scalars['String']['output']>;
  remainingMinPayment?: Maybe<Scalars['Int']['output']>;
  totalPastDue?: Maybe<Scalars['Int']['output']>;
};

export type LinkKeyToProductInput = {
  keyId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type LinkKeyToProductResponse = {
  __typename?: 'LinkKeyToProductResponse';
  keyId?: Maybe<Scalars['String']['output']>;
  linkCreatedAt?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductResponse>;
};

export type LinkageGroupResponse = {
  __typename?: 'LinkageGroupResponse';
  dailyTransferMaxLimit?: Maybe<Scalars['Int']['output']>;
  groupCode: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  returnBalWithPrimaryBit: Scalars['String']['output'];
  shareBalWithPrimaryBit: Scalars['String']['output'];
  shareVelocityLimitsBit: Scalars['String']['output'];
  singleTransferMaxLimit?: Maybe<Scalars['Int']['output']>;
  sweepRemainingFundsToPrimary?: Maybe<Scalars['Boolean']['output']>;
  unlimitedTransfers?: Maybe<Scalars['Boolean']['output']>;
};

export type ListAchPaymentInstructionsInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  ledgerId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionDate?: InputMaybe<Scalars['String']['input']>;
};

export type ListAccountHoldersInput = {
  fieldMask?: InputMaybe<FieldMask>;
  filters: Array<Filter>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListAccountHoldersResponse = {
  __typename?: 'ListAccountHoldersResponse';
  accountHolders?: Maybe<Array<AccountHolder>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ListAccountsInput = {
  fieldMask?: InputMaybe<FieldMask>;
  filters?: InputMaybe<Array<Filter>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListAccountsResponse = {
  __typename?: 'ListAccountsResponse';
  accounts?: Maybe<Array<Account>>;
  nextPageToken: Scalars['String']['output'];
};

export type ListAccountsV2Input = {
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ListAddressesInput = {
  fieldMask?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<Filter>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListAddressesResponse = {
  __typename?: 'ListAddressesResponse';
  addresses?: Maybe<Array<Address>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ListAddressesResponseV2 = {
  __typename?: 'ListAddressesResponseV2';
  addresses?: Maybe<Array<AddressV2>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ListAddressesV2Input = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListApplicationCertificatesResponse = {
  __typename?: 'ListApplicationCertificatesResponse';
  certificates: Array<Certificate>;
};

export type ListApplicationsResponse = {
  __typename?: 'ListApplicationsResponse';
  applications: Array<ApplicationResponse>;
};

export type ListCompaniesInput = {
  fieldMask?: InputMaybe<FieldMaskInput>;
  filters: Array<Filter>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListCompaniesResponse = {
  __typename?: 'ListCompaniesResponse';
  companies?: Maybe<Array<Company>>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ListIdentityProvidersResponse = {
  __typename?: 'ListIdentityProvidersResponse';
  identityProviders: Array<IdentityProvider>;
  totalCount: Scalars['Int']['output'];
};

export type ListKeysResponse = {
  __typename?: 'ListKeysResponse';
  count?: Maybe<Scalars['String']['output']>;
  keys?: Maybe<Array<KeyResponse>>;
  pageToken?: Maybe<Scalars['String']['output']>;
};

export type ListKmsBinRangesInput = {
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  rangeLowLimit?: InputMaybe<Scalars['String']['input']>;
};

export type ListKmsBinRangesResponse = {
  __typename?: 'ListKmsBinRangesResponse';
  binRanges?: Maybe<Array<KmsBinRangeResponse>>;
  count?: Maybe<Scalars['String']['output']>;
  pageToken?: Maybe<Scalars['String']['output']>;
};

export type ListLedgersInput = {
  fieldMask?: InputMaybe<FieldMask>;
  filters: Array<Filter>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListLedgersInputV2 = {
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListLedgersResponse = {
  __typename?: 'ListLedgersResponse';
  ledgers?: Maybe<Array<Ledger>>;
  nextPageToken: Scalars['String']['output'];
};

export type ListOAuthClientsResponse = {
  __typename?: 'ListOAuthClientsResponse';
  clients: Array<OAuthClient>;
  nextKey?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ListOrganisationGroupsResponse = {
  __typename?: 'ListOrganisationGroupsResponse';
  groups: Array<OrganisationGroup>;
  totalCount: Scalars['Int']['output'];
};

export type ListOrganisationsResponse = {
  __typename?: 'ListOrganisationsResponse';
  organisations: Array<Organisation>;
  totalCount: Scalars['Int']['output'];
};

export type ListPermissionsResponse = {
  __typename?: 'ListPermissionsResponse';
  permissions: Array<Permission>;
  totalCount: Scalars['Int']['output'];
};

export type ListProductsResponse = {
  __typename?: 'ListProductsResponse';
  count?: Maybe<Scalars['String']['output']>;
  pageToken?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductResponse>>;
};

export type ListSubscriptionsInnerResponse = {
  __typename?: 'ListSubscriptionsInnerResponse';
  content?: Maybe<Array<EventSubscriptionItem>>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type ListSubscriptionsResponse = {
  __typename?: 'ListSubscriptionsResponse';
  response?: Maybe<ListSubscriptionsInnerResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ListTransactionsInput = {
  fieldMask?: InputMaybe<FieldMask>;
  filters: Array<Filter>;
  orderBy: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ListTransactionsResponse = {
  __typename?: 'ListTransactionsResponse';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<Transaction>>;
};

export type ListWebhooksInput = {
  endpointUrl?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListWebhooksResponse = {
  __typename?: 'ListWebhooksResponse';
  response?: Maybe<WebhookListDataResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LoadFundsInput = {
  transaction: FundsInput;
};

export type LoadLimit = {
  __typename?: 'LoadLimit';
  max?: Maybe<Scalars['Int']['output']>;
};

export type LoadLimitInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type LoadLimitInputBtp = {
  annually?: InputMaybe<MaximumLoadLimitInput>;
  balance?: InputMaybe<MaximumLoadLimitInput>;
  daily?: InputMaybe<MaximumLoadLimitInput>;
  monthly?: InputMaybe<MaximumLoadLimitInput>;
  single?: InputMaybe<MaximumLoadLimitInput>;
  weekly?: InputMaybe<MaximumLoadLimitInput>;
};

export type LoadLimits = {
  __typename?: 'LoadLimits';
  annually?: Maybe<LoadLimit>;
  balance?: Maybe<LoadLimit>;
  daily?: Maybe<LoadLimit>;
  monthly?: Maybe<LoadLimit>;
  single?: Maybe<LoadLimit>;
  weekly?: Maybe<LoadLimit>;
};

export type LoadLimitsInput = {
  annually?: InputMaybe<LoadLimitInput>;
  balance?: InputMaybe<LoadLimitInput>;
  daily?: InputMaybe<LoadLimitInput>;
  monthly?: InputMaybe<LoadLimitInput>;
  single?: InputMaybe<LoadLimitInput>;
  weekly?: InputMaybe<LoadLimitInput>;
};

export type LoadUnloadCardInput = {
  loadUnloadCardRequest: LoadUnloadCardRequestInput;
  publicToken: Scalars['String']['input'];
};

export type LoadUnloadCardRequestInput = {
  amount: Scalars['Decimal']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type LoadUnloadCardResponse = {
  __typename?: 'LoadUnloadCardResponse';
  balance?: Maybe<BalanceResponse>;
  transaction?: Maybe<Array<TransactionResponse>>;
};

export enum LogicalOperator {
  And = 'AND',
  LogicalOperatorUnspecified = 'LOGICAL_OPERATOR_UNSPECIFIED',
  Or = 'OR'
}

export type MfaInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MfaResponse = {
  __typename?: 'MFAResponse';
  expiresAt?: Maybe<Scalars['String']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type MfxCardType = {
  __typename?: 'MFXCardType';
  description: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type MneSignOnParams = {
  __typename?: 'MNESignOnParams';
  messageSecurityCode: Scalars['String']['output'];
};

export type MneSignOnParamsInput = {
  messageSecurityCode: Scalars['String']['input'];
};

export type MastercardSignOnParams = {
  __typename?: 'MastercardSignOnParams';
  acquirerOrIssuerIndicator: Scalars['String']['output'];
  addressDataIndicator: Scalars['String']['output'];
  forwardingInstitutionIdentificationCode: Scalars['String']['output'];
  groupSignOnId: Scalars['String']['output'];
  messageSecurityCode: Scalars['String']['output'];
  pinBlockFormatCode: Scalars['String']['output'];
  pinEncryptionTypeCode: Scalars['String']['output'];
  pinKeyIndexNumber: Scalars['String']['output'];
  pinSecurityTypeCode: Scalars['String']['output'];
};

export type MastercardSignOnParamsInput = {
  acquirerOrIssuerIndicator: Scalars['String']['input'];
  addressDataIndicator: Scalars['String']['input'];
  forwardingInstitutionIdentificationCode: Scalars['String']['input'];
  groupSignOnId: Scalars['String']['input'];
  messageSecurityCode: Scalars['String']['input'];
  pinBlockFormatCode: Scalars['String']['input'];
  pinEncryptionTypeCode: Scalars['String']['input'];
  pinKeyIndexNumber: Scalars['String']['input'];
  pinSecurityTypeCode: Scalars['String']['input'];
};

export type MaximumLoadLimitInput = {
  max: Scalars['Int']['input'];
};

export type Merchant = {
  __typename?: 'Merchant';
  city?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  countyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameOther?: Maybe<Scalars['String']['output']>;
  networkId?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents a Merchant Category Code. */
export type MerchantCategoryCode = {
  __typename?: 'MerchantCategoryCode';
  /** The category of the Merchant Category Code. */
  category?: Maybe<Scalars['String']['output']>;
  /** The lower numeric value of the Merchant Category Code. */
  lower?: Maybe<Scalars['Int']['output']>;
  /** The unique refrence id of the Merchant Category Code. */
  referenceId?: Maybe<Scalars['Int']['output']>;
  /** The upper numeric value of the Merchant Category Code. */
  upper?: Maybe<Scalars['Int']['output']>;
};

export type MerchantCategoryCodeGroupInput = {
  category: Scalars['String']['input'];
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

/** The input required to alter/query a Country Currency Code. */
export type MerchantCategoryCodeInput = {
  /** The category of the Merchant Category Code. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** The lower numeric value of the Merchant Category Code. */
  lower?: InputMaybe<Scalars['Int']['input']>;
  /** The unique refrence id of the Merchant Category Code. */
  referenceId?: InputMaybe<Scalars['Int']['input']>;
  /** The upper numeric value of the Merchant Category Code. */
  upper?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  /** Human-readable flag description */
  description?: Maybe<Scalars['String']['output']>;
  /** Associated JIRA ticket for tracking */
  jiraTicket?: Maybe<Scalars['String']['output']>;
  /** Team or person responsible for this flag */
  owner?: Maybe<Scalars['String']['output']>;
  /** Planned rollout strategy */
  rolloutPlan?: Maybe<Scalars['String']['output']>;
};

export type MetadataInput = {
  /** Human-readable flag description */
  description: Scalars['String']['input'];
  /** Associated JIRA ticket */
  jiraTicket?: InputMaybe<Scalars['String']['input']>;
  /** Team or person responsible for this flag */
  owner: Scalars['String']['input'];
  /** Planned rollout strategy */
  rolloutPlan?: InputMaybe<Scalars['String']['input']>;
};

export type MfxBalanceAdjInput = {
  mfxCardBalanceAdjRequest: MfxBalanceAdjRequestInput;
  publicToken: Scalars['String']['input'];
};

export type MfxBalanceAdjRequestInput = {
  adjustmentType: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

/** Mfx Balance Transfer request type for GraphQL Query */
export type MfxBalanceTransferInput = {
  /** The requested amount to transfer */
  amtTxn: Scalars['String']['input'];
  /** The Currency Code */
  currCode: Scalars['String']['input'];
  /** Description */
  description: Scalars['String']['input'];
  /** Iss Code */
  issCode: Scalars['String']['input'];
  /** The public token to where funds should be transferred to */
  newToken: Scalars['String']['input'];
  /** The Public token */
  publicToken: Scalars['String']['input'];
  /** Loaded By user */
  user: Scalars['String']['input'];
};

export type MfxCardTranResponse = {
  __typename?: 'MfxCardTranResponse';
  balance?: Maybe<BalanceResponse>;
  transaction?: Maybe<TransactionResponse>;
};

export type MfxCardWalletTrnsfrDetailResponse = {
  __typename?: 'MfxCardWalletTrnsfrDetailResponse';
  actualBalance: Scalars['Decimal']['output'];
  amount: Scalars['Decimal']['output'];
  availableBalance: Scalars['Decimal']['output'];
  blockedAmount: Scalars['Decimal']['output'];
  currencyCode: Scalars['String']['output'];
  publicToken: Scalars['String']['output'];
  transactionId: Scalars['Long']['output'];
};

export type MfxCardWalletTrnsfrResponse = {
  __typename?: 'MfxCardWalletTrnsfrResponse';
  destinationWalletTransaction?: Maybe<MfxCardWalletTrnsfrDetailResponse>;
  sourceWalletTransaction?: Maybe<MfxCardWalletTrnsfrDetailResponse>;
};

export type MfxLoadCardInput = {
  currCode: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  issCode: Scalars['String']['input'];
  loadFee?: InputMaybe<Scalars['String']['input']>;
  loadFundsType?: InputMaybe<Scalars['String']['input']>;
  loadSrc?: InputMaybe<Scalars['String']['input']>;
  loadValue: Scalars['String']['input'];
  loadedBy: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  publicToken: Scalars['String']['input'];
  txnCode: Scalars['String']['input'];
};

export type MfxUnloadCardInput = {
  amtUnLoad: Scalars['String']['input'];
  currCode: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  issCode: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  publicToken: Scalars['String']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};

export type MfxWalletTransferInput = {
  mfxCardWalletTransferRequest: MfxWalletTransferRequestInput;
  publicToken: Scalars['String']['input'];
};

export type MfxWalletTransferRequestInput = {
  amount: Scalars['Decimal']['input'];
  description: Scalars['String']['input'];
  fromCurrencyCode: Scalars['String']['input'];
  toCurrencyCode: Scalars['String']['input'];
  toPublicToken: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type Misc = {
  __typename?: 'Misc';
  defaultTicked?: Maybe<Scalars['Boolean']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  variableDescription?: Maybe<Scalars['String']['output']>;
  variableType?: Maybe<Scalars['String']['output']>;
  variableTypeCode?: Maybe<Scalars['String']['output']>;
};

export type ModesOfUse = {
  decrypt?: Scalars['Boolean']['input'];
  deriveKey?: Scalars['Boolean']['input'];
  encrypt?: Scalars['Boolean']['input'];
  generate?: Scalars['Boolean']['input'];
  noRestrictions?: Scalars['Boolean']['input'];
  sign?: Scalars['Boolean']['input'];
  unwrap?: Scalars['Boolean']['input'];
  verify?: Scalars['Boolean']['input'];
  wrap?: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Activates a key, marking it available for cryptographic operations */
  activateKey?: Maybe<ActivateKeyResponse>;
  /** Add a manual note to card history. Creates timestamped annotation for administrative tracking and customer service. */
  addCardHistoryNote?: Maybe<Scalars['Boolean']['output']>;
  /** Add a user to a group. Grants user all permissions associated with the group. */
  addUserToGroup?: Maybe<MessageResponse>;
  /** Add a user to an organisation. Grants user access and assigns default permissions. */
  addUserToOrganisation?: Maybe<MessageResponse>;
  /** Add event subscriptions to a webhook. Subscribes the webhook to receive notifications for specified event codes. */
  addWebhookSubscriptions?: Maybe<AddSubscriptionsResponse>;
  /** Assign a permission to a group. Grants the permission to all current and future group members. */
  assignPermissionToGroup?: Maybe<MessageResponse>;
  /** Adjust balance to account for blocked authorizations. Corrects available balance after authorization release or expiry. */
  balanceAjustmentForBlockedAmt?: Maybe<LoadUnloadCardResponse>;
  /** Transfer balance between wallets or cards. Moves funds whilst maintaining balance integrity and audit trail. */
  balanceTransfer?: Maybe<LoadUnloadCardResponse>;
  /**
   * Bulk create country-currency mappings. Efficiently imports multiple country-currency configurations in a single operation.
   * @deprecated Bulk create is no longer supported; currency reference data is seeded server-side.
   */
  bulkCreateCountryCurrencyCode?: Maybe<Array<CountryCurrencyCode>>;
  /** Cancel an existing ACH payment instruction by its unique identifier. */
  cancelPaymentInstruction?: Maybe<AchPaymentInstructionResponse>;
  /** Change card status (activate, block, close, suspend). Updates card state and records status change in history. */
  changeCardStatus?: Maybe<StatusResponse>;
  /** Change digital wallet payment token status. Activates, suspends, or deletes tokens for Apple Pay, Google Pay, etc. */
  changePaymentTokenStatus?: Maybe<PaymentTokenStatusResponse>;
  /** Clear all cached authentication tokens. Development and debugging tool only. Blocked in production environments. */
  clearTokenCache?: Maybe<ClearCacheResponse>;
  /**
   * Create a new account for an account holder. Sets up account with initial balance, limits, and product configuration.
   * @deprecated Use createAccountWorkflow instead for additional validation.
   */
  createAccount?: Maybe<Account>;
  /** Create account using a financial product ID. Account configuration is derived from product policies. */
  createAccountByProduct?: Maybe<Account>;
  /**
   * Create a new account holder. Registers customer information, KYC details, and contact information.
   * @deprecated Use createAccountHolderWorkflow instead for additional validation.
   */
  createAccountHolder?: Maybe<AccountHolder>;
  /**
   * Create account holder via conductor workflow. Includes client validation and policy group resolution.
   * @deprecated Use createCustomerWorkflow instead for creating customers with addresses.
   */
  createAccountHolderWorkflow?: Maybe<AccountHolder>;
  /** Create account via conductor workflow. Includes client validation and policy group resolution. */
  createAccountWorkflow?: Maybe<AccountV2>;
  /**
   * Create a new address.
   * @deprecated Use createAddressWorkflow instead for additional validation.
   */
  createAddress?: Maybe<Address>;
  /** Create address via conductor workflow using the V2 Address endpoints. */
  createAddressV2Workflow?: Maybe<AddressV2>;
  /** Create address via conductor workflow. */
  createAddressWorkflow?: Maybe<Address>;
  /** Create an application. */
  createApplication?: Maybe<ApplicationMessageResponse>;
  /** Create a certificate. */
  createApplicationCertificate?: Maybe<CertificateMessageResponse>;
  /** Create an audit log entry. Records manual actions and administrative changes for compliance and tracking purposes. */
  createAuditLog?: Maybe<Scalars['Boolean']['output']>;
  /** Create authorization reversal transaction. Manually reverses a previous authorization to release blocked funds. */
  createAuthReversalTransaction?: Maybe<AuthReversalResponse>;
  /** Create a new BIN range allocation. Reserves Bank Identification Numbers for card issuance on specific networks. */
  createBinRange?: Maybe<BinRange>;
  /** Create a new channel. Defines client configuration for reconciliation purposes. */
  createChannel?: Maybe<Channel>;
  /** Create a new channel via conductor workflow. Provides orchestrated creation with client validation and policy group resolution. */
  createChannelV2?: Maybe<Channel>;
  /** Create a new client organisation. Sets up the foundational entity for products, accounts, and configurations. */
  createClient?: Maybe<Client>;
  /** Create a new client space. */
  createClientSpace?: Maybe<ClientSpace>;
  /**
   * Create a new company.
   * @deprecated Use createCompanyWorkflow instead for additional validation.
   */
  createCompany?: Maybe<Company>;
  /** Create company via conductor workflow. */
  createCompanyWorkflow?: Maybe<Company>;
  /** Create a country-currency mapping. Links ISO country codes with their supported currencies and exchange configurations. */
  createCountryCurrencyCode?: Maybe<CountryCurrencyCode>;
  /** Create a new currency. Defines ISO currency code, symbol, decimal places, and formatting rules. */
  createCurrency?: Maybe<Currency>;
  /** Create customer with addresses via conductor workflow. This mutation creates a customer with embedded addresses in a single atomic operation with client validation, policy group resolution, and compensation on failure. */
  createCustomerWorkflow?: Maybe<Customer>;
  /** Create a new financial product (account type). Requires an existing client. Defines account features, limits, and fee structures. */
  createFinancialProduct?: Maybe<FinancialProduct>;
  /**
   * Create a new feature flag with targeting rules and rollout configuration.
   *
   *         Input requirements:
   *         - name: Unique flag identifier (alphanumeric, hyphens, underscores, max 100 chars)
   *         - config.enabled: Boolean flag state
   *         - config.value: String value when flag evaluates (e.g., 'enabled', 'disabled', custom values)
   *         - config.percentage: Optional rollout percentage (0-100)
   *         - config.metadata: Owner, description, JIRA ticket, rollout plan
   *         - config.rules: Targeting rules with conditions (AND logic within a rule)
   *
   *         Returns:
   *         - message: Success/error message
   *         - flag_name: Created flag identifier
   *         - version: Configuration version
   *         - deployment_id: AWS AppConfig deployment ID
   *
   *         Note: May return 409 if another deployment is in progress.
   */
  createFlag?: Maybe<CreateFeatureFlagResponse>;
  /** Create a service group. Organizes related payment services for collective management and configuration. */
  createGroup?: Maybe<GroupResponse>;
  /** Create an identity provider configuration. Sets up SSO with SAML or OIDC for user authentication. */
  createIdentityProvider?: Maybe<IdentityProvider>;
  /** Create a new instrument product (card product). Defines card features, design, limits, and network configurations. */
  createInstrumentProduct?: Maybe<InstrumentProduct>;
  /** Create a BIN range in the Key Management Service. Allocates BIN numbers with associated cryptographic keys. */
  createKmsBinRange?: Maybe<CreateKmsBinRangeResponse>;
  /**
   * Create a new ledger
   * @deprecated Use createLedgerWorkflow instead for additional validation.
   */
  createLedger?: Maybe<Ledger>;
  /** Create a ledger configuration. */
  createLedgerConfiguration?: Maybe<LedgerConfig>;
  /** Create a new ledger balance in the playground environment. Sets up test balance for development and demonstration purposes. */
  createLedgerPlaygroundBalance?: Maybe<CreateLedgerPlaygroundBalanceResponse>;
  /** Create a new ledger transaction in the playground environment. Creates test transaction for development and testing purposes. */
  createLedgerPlaygroundTransaction?: Maybe<CreateLedgerPlaygroundTransactionResponse>;
  /** Create ledger via conductor workflow. Includes client validation and policy group resolution. */
  createLedgerWorkflow?: Maybe<LedgerV2>;
  /** Create a new merchant category code (MCC). Defines business categories for transaction classification and reporting. */
  createMerchantCategoryCode?: Maybe<MerchantCategoryCode>;
  /** Create an OAuth client application. Generates client credentials for API authentication. */
  createOauthClient?: Maybe<OAuthClientCreatedResponse>;
  /** Create a new organisation. Sets up the organisational entity with initial configuration and settings. */
  createOrganisation?: Maybe<Organisation>;
  /** Create a new user group. Defines group for collective permission management and role assignment. */
  createOrganisationGroup?: Maybe<OrganisationGroup>;
  /** Create a new ACH payment instruction. */
  createPaymentInstruction?: Maybe<AchPaymentInstructionResponse>;
  /** Create payment network configuration. Sets up network routing, card types, and processing rules for a payment network. */
  createPaymentNetworkConfig?: Maybe<PaymentNetworkConfigResponse>;
  /** Create a new permission. Defines access control for specific resources or operations. */
  createPermission?: Maybe<Permission>;
  /** Create a new policy group. Defines business rules, transaction limits, and authorization policies. */
  createPolicyGroup?: Maybe<PolicyGroup>;
  /** Create a new policy. Defines business rules, transaction limits, and authorization logic. */
  createPolicyV2?: Maybe<PolicyV2>;
  /** Create a new payment service. Sets up service endpoints, authentication, and processing capabilities. */
  createService?: Maybe<ServiceResponse>;
  /** Create a new system channel. Defines global configuration for transaction processing. */
  createSystemChannel?: Maybe<SystemChannel>;
  /** Create a new transaction reason code. Used to categorize transaction outcomes, failures, and processing results. */
  createTransactionReasonCode?: Maybe<TransactionReasonCode>;
  /** Create a funding transaction via conductor workflow. Orchestrates function transaction creation with fields validation, limits validation and double-entry bookkeeping. */
  createTransactionWorkflow?: Maybe<CreateTransactionResponse>;
  /** Create a new user account. Sets up user profile with authentication credentials and initial permissions. */
  createUser?: Maybe<User>;
  /** Create new webhook endpoint. Configures webhook URL, authentication, and event subscriptions for real-time notifications. */
  createWebhook?: Maybe<WebhookResponse>;
  /** Deactivates a key, marking it unavailable for cryptographic operations */
  deactivateKey?: Maybe<DeactivateKeyResponse>;
  /** Delete account using account id. */
  deleteAccount?: Maybe<Account>;
  /** Delete an account holder. */
  deleteAccountHolder?: Maybe<AccountHolder>;
  /** Delete an address. */
  deleteAddress?: Maybe<Address>;
  /** Delete an address using the V2 Address endpoints. */
  deleteAddressV2?: Maybe<AddressV2>;
  /** Delete a company. */
  deleteCompany?: Maybe<Company>;
  /** Delete a currency. Removes currency configuration if not referenced by accounts or transactions. */
  deleteCurrency?: Maybe<Currency>;
  /**
   * Delete a feature flag permanently from the system.
   *
   *         Input:
   *         - flag_name: Identifier of flag to delete
   *
   *         Effects:
   *         - Removes flag from AWS AppConfig
   *         - All evaluations will return flag not found
   *         - Cannot be undone - flag must be recreated if needed
   *
   *         Returns:
   *         - message: Deletion confirmation
   *         - flag_name: Deleted flag identifier
   *         - version: Final configuration version
   *         - deployment_id: AWS AppConfig deployment ID
   *
   *         Throws NotFoundError if flag doesn't exist.
   *         Returns 409 if another deployment is in progress.
   */
  deleteFeatureFlag?: Maybe<DeleteFeatureFlagResponse>;
  /** Delete a service group. Removes the group while preserving individual service configurations. */
  deleteGroup?: Maybe<GroupResponse>;
  /** Delete an identity provider. Removes SSO configuration and requires users to use alternative authentication. */
  deleteIdentityProvider?: Maybe<MessageResponse>;
  /** Delete an OAuth client. Revokes all associated access tokens and removes client configuration. */
  deleteOauthClient?: Maybe<MessageResponse>;
  /** Delete an organisation. Removes the organisation and all associated data if permitted. */
  deleteOrganisation?: Maybe<MessageResponse>;
  /** Delete a user group. Removes the group while preserving individual user accounts. */
  deleteOrganisationGroup?: Maybe<MessageResponse>;
  /** Delete payment network configuration. Removes network settings if not in use by active services. */
  deletePaymentNetworkConfig?: Maybe<PaymentNetworkConfigResponse>;
  /** Delete a policy group. Removes the group if not actively used by products or accounts. */
  deletePolicyGroup?: Maybe<PolicyGroup>;
  /** Delete a policy. Removes the policy if not in active use. */
  deletePolicyV2?: Maybe<PolicyV2>;
  /** Unlink a cryptographic key from a product. */
  deleteProductKeyLink?: Maybe<DeleteProductKeyLinkResponse>;
  /** Delete a payment service. Removes the service configuration if not actively processing transactions. */
  deleteService?: Maybe<ServiceResponse>;
  /** Delete a system channel by ID. */
  deleteSystemChannel?: Maybe<SystemChannel>;
  /** Delete a transaction reason code. Removes the code from the system if not in use by existing transactions. */
  deleteTransactionReasonCode?: Maybe<TransactionReasonCode>;
  /** Remove an event subscription from a webhook. The webhook will no longer receive notifications for the specified event code. */
  deleteWebhookSubscription?: Maybe<DeleteSubscriptionResponse>;
  /** Resend a transaction to EHI. Triggers re-delivery of the transaction message to the External Host Interface. */
  ehiResend?: Maybe<EhiResendResponse>;
  /**
   * Batch evaluate multiple feature flags for a specific user context.
   *
   *         Input:
   *         - flags: Array of flag names to evaluate (max 50)
   *         - context: User attributes for rule evaluation
   *           - clientId: Client identifier
   *           - userType: User classification (e.g., 'premium', 'basic')
   *           - country: Geographic location
   *           - subscriptionLevel: Service tier
   *           - accountAgeDays: Account age in days
   *           - monthlySpend: Monthly spending amount
   *           - department: Organizational unit
   *           - featuresEnabled: List of enabled features
   *           - admin: Boolean admin status
   *
   *         Returns evaluated flags with:
   *         - enabled: Boolean state after evaluation
   *         - value: Resolved value based on rules/percentage
   *         - reason: Why flag evaluated this way
   *         - metadata: Flag metadata if available
   *         - missing_flags: List of requested flags that don't exist
   */
  evaluateFeatureFlags?: Maybe<EvaluateFeatureFlagResponse>;
  /** Export all audit logs matching the given filters. Iterates all DynamoDB pages server-side and records the export action as an audit event. */
  exportAuditLogs?: Maybe<AuditLogsExportResponse>;
  /** Export a cryptographic key. Retrieves key material for backup or transfer to external systems. */
  exportKey?: Maybe<ExportKeyResponse>;
  /** Generate a new cryptographic key. Creates keys for card security, PIN encryption, or data protection. */
  generateKey?: Maybe<KeyResponse>;
  /** Import an external cryptographic key. Allows integration of existing keys into the key management system. */
  importKey?: Maybe<KeyResponse>;
  /** Link a cryptographic key to a product. Associates security keys with specific card products for encryption. */
  linkKeyToProduct?: Maybe<LinkKeyToProductResponse>;
  /**
   * Load funds into a ledger. Required information: ledger_id, payment_id, amount, asset and optionally a description.
   * @deprecated Use createTransaction workflow instead.
   */
  loadFunds?: Maybe<CreateTransactionResponse>;
  /** Load or unload funds on a card. Credits or debits the card balance with transaction recording. */
  loadUnloadCard?: Maybe<LoadUnloadCardResponse>;
  /** Create MFA session */
  mfaInitiate?: Maybe<MfaResponse>;
  /** Verify MFA session */
  mfaVerify?: Maybe<MfaResponse>;
  /** Adjust balance on multi-currency card. Corrects wallet balance with audit trail and reason code. */
  mfxBalanceAdjustment?: Maybe<MfxCardTranResponse>;
  /** Transfer balance between multi-currency cards. Moves funds from one card to another with currency conversion if needed. */
  mfxBalanceTransfer?: Maybe<WsBalanceTransferResponse>;
  /** Load funds onto multi-currency card. Credits specified currency wallet with transaction recording. */
  mfxLoadCard?: Maybe<WsLoadCardResponse>;
  /** Unload funds from multi-currency card. Debits specified currency wallet with balance validation. */
  mfxUnloadCard?: Maybe<WsLoadCardResponse>;
  /** Transfer funds between currency wallets on multi-currency card. Moves balance between wallets with exchange rate application. */
  mfxWalletTransfer?: Maybe<MfxCardWalletTrnsfrResponse>;
  /** Perform identity provider health check. Tests SSO connectivity and configuration validity. */
  performIdpHealthCheck?: Maybe<IdpHealthCheckResponse>;
  /** Execute an arbitrary HTTP request to the API Hub. Supports all standard HTTP methods and headers while filtering sensitive authentication data. */
  proxyRequest?: Maybe<ProxyResponse>;
  /** Remove a permission from a group. Revokes the permission from all group members. */
  removePermissionFromGroup?: Maybe<MessageResponse>;
  /** Remove a user from a group. Revokes group permissions while maintaining other access rights. */
  removeUserFromGroup?: Maybe<MessageResponse>;
  /** Remove a user from an organisation. Revokes access and removes all organisation-specific permissions. */
  removeUserFromOrganisation?: Maybe<MessageResponse>;
  /** Resend previously sent notifications. Re-delivers notifications to the webhook endpoint for the specified notification IDs. */
  resendNotifications?: Maybe<ResendNotificationsResponse>;
  /** Resend the invite email with a new temporary password. Not available for SSO or disabled users */
  resendUserInvitation?: Maybe<MessageResponse>;
  /** Revoke a certificate. */
  revokeApplicationCertificate?: Maybe<CertificateMessageResponse>;
  /** Rotate OAuth client secret. Generates new client secret while maintaining existing tokens. */
  rotateOauthClientSecret?: Maybe<RotateSecretResponse>;
  /** Save user PM preference. Stores the user's preferred payment method for an organisation. */
  saveUserPmPreference?: Maybe<MessageResponse>;
  /** Submit feature request or feedback. Sends enhancement suggestions to the development team. */
  sendFeatureRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Extend card expiry date. Updates card validity period whilst maintaining same card number and configuration. */
  setExtendExpiryDate?: Maybe<ExtendExpiryDateResponse>;
  /** Split a BIN range in the Key Management Service by creating sub ranges: lower bin range - upper bin range. */
  splitKmsBinRange?: Maybe<SplitKmsBinRangeResponse>;
  /** Unblock a blocked card. Removes block status and restores card functionality for transactions. */
  unblockCard?: Maybe<Scalars['Boolean']['output']>;
  /** Unblock CVV/CVC2 verification. Resets failed CVV verification counter after excessive failed attempts. */
  unblockCvv?: Maybe<Scalars['Boolean']['output']>;
  /** Unblock offline PIN verification. Resets chip card offline PIN counter after exceeded attempts. */
  unblockOfflinePin?: Maybe<Scalars['Boolean']['output']>;
  /** Unblock online PIN verification. Resets failed PIN counter to allow online PIN transactions again. */
  unblockOnlinePin?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Unload funds from a ledger. Required information: ledger_id, payment_id, amount, asset and optionally a description.
   * @deprecated Use createTransaction workflow instead.
   */
  unloadFunds?: Maybe<CreateTransactionResponse>;
  /** Update 3D Secure credential configuration. Modifies directory server authentication settings and credentials. */
  update3dsCredentialDetails?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Update account  details. Modifies status.
   * @deprecated Use updateAccountWorkflow instead for additional validation.
   */
  updateAccount?: Maybe<Account>;
  /** Update account holder details. Modifies personal information, contact details, or KYC status. */
  updateAccountHolder?: Maybe<AccountHolder>;
  /** Update account via conductor workflow. Sends only the status to PATCH /accounts/{accountId}. */
  updateAccountWorkflow?: Maybe<AccountV2>;
  /**
   * Update an address.
   * @deprecated Use updateAddressWorkflow instead for additional validation.
   */
  updateAddress?: Maybe<Address>;
  /** Update address via conductor workflow using the V2 Address endpoints. */
  updateAddressV2Workflow?: Maybe<AddressV2>;
  /** Update address via conductor workflow. */
  updateAddressWorkflow?: Maybe<Address>;
  /** Update an application. */
  updateApplication?: Maybe<ApplicationMessageResponse>;
  /** Update card configuration and settings. Modifies card metadata, custom fields, and operational parameters. */
  updateCard?: Maybe<Scalars['Boolean']['output']>;
  /** Update channel details. Modifies client configuration for reconciliation purposes. */
  updateChannel?: Maybe<Channel>;
  /** Update existing client details. Modifies client configuration, settings, and operational parameters. */
  updateClient?: Maybe<Client>;
  /**
   * Update a company. Fields available for update are: name, legal_name, industry type, registration number, tax id and company status.
   * @deprecated Use updateCompanyWorkflow instead for additional validation.
   */
  updateCompany?: Maybe<Company>;
  /** Update company via conductor workflow. */
  updateCompanyWorkflow?: Maybe<Company>;
  /** Update currency configuration. Modifies currency properties, exchange rates, or formatting specifications. */
  updateCurrency?: Maybe<Currency>;
  /** Update customer via conductor workflow. Sends only the fields provided (partial update) to PATCH /customers/{customerId}. All customer fields are optional — include only those you want to change. */
  updateCustomerWorkflow?: Maybe<Customer>;
  /**
   * Update an existing feature flag's configuration.
   *
   *         Input:
   *         - flag_name: Identifier of flag to update
   *         - config.enabled: New boolean state
   *         - config.value: New value when enabled
   *         - config.metadata.disabled_reason: Reason for disabling (if applicable)
   *
   *         Returns:
   *         - message: Update confirmation
   *         - flag_name: Updated flag identifier
   *         - version: New configuration version
   *         - deployment_id: AWS AppConfig deployment ID
   *
   *         Note: Rules cannot be updated via this endpoint - delete and recreate the flag
   *         for rule changes. Returns 404 if flag doesn't exist, 409 if deployment in progress.
   */
  updateFeatureFlag?: Maybe<UpdateFeatureFlagResponse>;
  /** Update an existing financial product. Modifies product configuration, limits, fees, and associated business rules. */
  updateFinancialProduct?: Maybe<FinancialProduct>;
  /** Update an existing financial product via conductor workflow. Provides orchestrated updates with validation and policy group resolution. */
  updateFinancialProductV2?: Maybe<FinancialProduct>;
  /** Update service group configuration. Modifies group settings, member services, or collective parameters. */
  updateGroup?: Maybe<GroupResponse>;
  /** Update all services in a group to latest version. Performs batch upgrade of service builds for consistency. */
  updateGroupedServices?: Maybe<GroupResponse>;
  /** Update card control groups. Modifies group membership and associated rules for card controls and restrictions. */
  updateGroups?: Maybe<ControlGroups>;
  /** Update identity provider settings. Modifies SSO configuration, metadata, or attribute mappings. */
  updateIdentityProvider?: Maybe<IdentityProvider>;
  /** Update an existing instrument product. Modifies card features, limits, and processing configurations. */
  updateInstrumentProduct?: Maybe<InstrumentProduct>;
  /**
   * Update a ledger
   * @deprecated Use updateLedgerWorkflow instead for additional validation.
   */
  updateLedger?: Maybe<Ledger>;
  /** Update a ledger configuration. */
  updateLedgerConfiguration?: Maybe<LedgerConfig>;
  /** Update ledger via conductor workflow. Includes client validation and policy group resolution. */
  updateLedgerWorkflow?: Maybe<LedgerV2>;
  /** Update OAuth client configuration. Modifies redirect URIs, scopes, or client settings. */
  updateOauthClient?: Maybe<OAuthClient>;
  /** Update organisation details. Modifies organisation settings, configuration, or metadata. */
  updateOrganisation?: Maybe<Organisation>;
  /** Update group configuration. Modifies group name, description, or associated permissions. */
  updateOrganisationGroup?: Maybe<OrganisationGroup>;
  /** Update payment network configuration. Modifies network settings, routing rules, or supported features. */
  updatePaymentNetworkConfig?: Maybe<PaymentNetworkConfigResponse>;
  /** Update permission configuration. Modifies permission scope, resources, or access levels. */
  updatePermission?: Maybe<Permission>;
  /** Update an existing policy group. Modifies business rules, limits, and transaction processing policies. */
  updatePolicyGroup?: Maybe<PolicyGroup>;
  /** Update an existing policy. Modifies business rules, limits, and transaction processing details. */
  updatePolicyV2?: Maybe<PolicyV2>;
  /** Update an existing payment service. Modifies service configuration, endpoints, or processing parameters. */
  updateService?: Maybe<ServiceResponse>;
  /** Update an existing system channel. Note: name field is immutable. */
  updateSystemChannel?: Maybe<SystemChannel>;
  /** Update an existing transaction reason code. Modifies code description, category, or processing rules. */
  updateTransactionReasonCode?: Maybe<TransactionReasonCode>;
  /** Update user attributes and thredd roles. */
  updateUser?: Maybe<MessageResponse>;
  /** Update user account status. Enables, disables, or suspends user access to the system. */
  updateUserStatus?: Maybe<MessageResponse>;
  /** Update Visa file maintenance records. Manages Visa network file updates and card lifecycle notifications. */
  updateVisaFileMaintenance?: Maybe<VisaFileMaintenanceResponse>;
  /** Update webhook configuration. Modifies webhook URL, authentication credentials, or event subscriptions. */
  updateWebhookDetails?: Maybe<WebhookResponse>;
  /** Update webhook status (enable/disable). Activates or deactivates webhook without deleting configuration. */
  updateWebhookStatus?: Maybe<WebhookResponse>;
};


export type MutationActivateKeyArgs = {
  input: ActivateKeyInput;
};


export type MutationAddCardHistoryNoteArgs = {
  note: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};


export type MutationAddUserToGroupArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationAddUserToOrganisationArgs = {
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationAddWebhookSubscriptionsArgs = {
  input: AddWebhookSubscriptionsInput;
  webhookId: Scalars['String']['input'];
};


export type MutationAssignPermissionToGroupArgs = {
  groupId: Scalars['String']['input'];
  input: AssignPermissionToGroupInput;
  organisationId: Scalars['String']['input'];
};


export type MutationBalanceAjustmentForBlockedAmtArgs = {
  input: UpdateBlockedAmountInput;
};


export type MutationBalanceTransferArgs = {
  input: BalanceTransferInput;
};


export type MutationBulkCreateCountryCurrencyCodeArgs = {
  input: CountryCurrencyCodeInput;
};


export type MutationCancelPaymentInstructionArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationChangeCardStatusArgs = {
  input: ChangeCardStatusInput;
};


export type MutationChangePaymentTokenStatusArgs = {
  input: ChangePaymentTokenStatusInput;
};


export type MutationCreateAccountArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAccountInput;
};


export type MutationCreateAccountByProductArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAccountByProductInput;
};


export type MutationCreateAccountHolderArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAccountHolderInput;
};


export type MutationCreateAccountHolderWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAccountHolderInput;
};


export type MutationCreateAccountWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAccountWorkflowInput;
};


export type MutationCreateAddressArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAddressInput;
};


export type MutationCreateAddressV2WorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAddressV2Input;
};


export type MutationCreateAddressWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAddressInput;
};


export type MutationCreateApplicationArgs = {
  input: ApplicationInput;
};


export type MutationCreateApplicationCertificateArgs = {
  applicationId: Scalars['String']['input'];
  input: CreateCertificateIssuerInput;
};


export type MutationCreateAuditLogArgs = {
  input: AuditLogRequestInput;
};


export type MutationCreateAuthReversalTransactionArgs = {
  input: AuthReversalRequestInput;
  transactionId: Scalars['String']['input'];
};


export type MutationCreateBinRangeArgs = {
  input: BinRangeInput;
};


export type MutationCreateChannelArgs = {
  input: ChannelInput;
};


export type MutationCreateChannelV2Args = {
  input: ChannelInput;
};


export type MutationCreateClientArgs = {
  input: ClientInput;
};


export type MutationCreateClientSpaceArgs = {
  input: CreateClientSpaceInput;
};


export type MutationCreateCompanyArgs = {
  clientId: Scalars['String']['input'];
  input: CreateCompanyInput;
};


export type MutationCreateCompanyWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateCompanyInput;
};


export type MutationCreateCountryCurrencyCodeArgs = {
  input: CountryCurrencyCodeInput;
};


export type MutationCreateCurrencyArgs = {
  input: CreateCurrencyInput;
};


export type MutationCreateCustomerWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateCustomerWorkflowInput;
};


export type MutationCreateFinancialProductArgs = {
  input: FinancialProductInput;
};


export type MutationCreateFlagArgs = {
  input: FlagDataInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupRequest;
};


export type MutationCreateIdentityProviderArgs = {
  input: CreateIdpInput;
  organisationId: Scalars['String']['input'];
};


export type MutationCreateInstrumentProductArgs = {
  input: InstrumentProductInput;
};


export type MutationCreateKmsBinRangeArgs = {
  input: CreateKmsBinRangeInput;
};


export type MutationCreateLedgerArgs = {
  clientId: Scalars['String']['input'];
  input: CreateLedgerInput;
};


export type MutationCreateLedgerConfigurationArgs = {
  input: LedgerConfigInput;
};


export type MutationCreateLedgerPlaygroundBalanceArgs = {
  clientId: Scalars['String']['input'];
  input: CreateLedgerPlaygroundBalance;
};


export type MutationCreateLedgerPlaygroundTransactionArgs = {
  clientId: Scalars['String']['input'];
  input: CreateLedgerPlaygroundTransaction;
};


export type MutationCreateLedgerWorkflowArgs = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  input: CreateLedgerInputV2;
};


export type MutationCreateMerchantCategoryCodeArgs = {
  input: MerchantCategoryCodeInput;
};


export type MutationCreateOauthClientArgs = {
  input: CreateOAuthClientInput;
  organisationId: Scalars['String']['input'];
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreateOrganisationGroupArgs = {
  input: CreateOrganisationGroupInput;
  organisationId: Scalars['String']['input'];
};


export type MutationCreatePaymentInstructionArgs = {
  clientId: Scalars['String']['input'];
  input: CreateAchPaymentInstructionInput;
};


export type MutationCreatePaymentNetworkConfigArgs = {
  input: CreatePaymentNetworkConfigInput;
};


export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput;
};


export type MutationCreatePolicyGroupArgs = {
  input: PolicyGroupInput;
};


export type MutationCreatePolicyV2Args = {
  input: CreatePolicyV2Input;
};


export type MutationCreateServiceArgs = {
  input: CreateServiceRequest;
};


export type MutationCreateSystemChannelArgs = {
  input: SystemChannelInput;
};


export type MutationCreateTransactionReasonCodeArgs = {
  input: TransactionReasonCodeInput;
};


export type MutationCreateTransactionWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: CreateTransactionWorkflowInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
  organisationId: Scalars['String']['input'];
};


export type MutationCreateWebhookArgs = {
  input: WebhookRequestInput;
};


export type MutationDeactivateKeyArgs = {
  input: DeactivateKeyInput;
};


export type MutationDeleteAccountArgs = {
  clientId: Scalars['String']['input'];
  input: DeleteAccountInput;
};


export type MutationDeleteAccountHolderArgs = {
  clientId: Scalars['String']['input'];
  input: DeleteAccountHolderInput;
};


export type MutationDeleteAddressArgs = {
  clientId: Scalars['String']['input'];
  input: DeleteAddressInput;
};


export type MutationDeleteAddressV2Args = {
  clientId: Scalars['String']['input'];
  input: DeleteAddressV2Input;
};


export type MutationDeleteCompanyArgs = {
  clientId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type MutationDeleteCurrencyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFeatureFlagArgs = {
  flagName: Scalars['String']['input'];
};


export type MutationDeleteGroupArgs = {
  PK: Scalars['String']['input'];
};


export type MutationDeleteIdentityProviderArgs = {
  idpId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationDeleteOauthClientArgs = {
  clientId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationDeleteOrganisationArgs = {
  organisationId: Scalars['String']['input'];
};


export type MutationDeleteOrganisationGroupArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationDeletePaymentNetworkConfigArgs = {
  PK: Scalars['String']['input'];
};


export type MutationDeletePolicyGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePolicyV2Args = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProductKeyLinkArgs = {
  input: DeleteProductKeyLinkInput;
};


export type MutationDeleteServiceArgs = {
  PK: Scalars['String']['input'];
};


export type MutationDeleteSystemChannelArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTransactionReasonCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWebhookSubscriptionArgs = {
  eventCode: Scalars['Int']['input'];
  webhookId: Scalars['String']['input'];
};


export type MutationEhiResendArgs = {
  transactionId: Scalars['String']['input'];
};


export type MutationEvaluateFeatureFlagsArgs = {
  input: FeatureFlagRequestInput;
};


export type MutationExportAuditLogsArgs = {
  input: ExportAuditLogsInput;
};


export type MutationExportKeyArgs = {
  input: ExportKeyInput;
};


export type MutationGenerateKeyArgs = {
  input: GenerateKeyInput;
};


export type MutationImportKeyArgs = {
  input: ImportKeyInput;
};


export type MutationLinkKeyToProductArgs = {
  input: LinkKeyToProductInput;
};


export type MutationLoadFundsArgs = {
  clientId: Scalars['String']['input'];
  input: LoadFundsInput;
};


export type MutationLoadUnloadCardArgs = {
  input: LoadUnloadCardInput;
};


export type MutationMfaInitiateArgs = {
  input: MfaInput;
};


export type MutationMfaVerifyArgs = {
  input: MfaInput;
};


export type MutationMfxBalanceAdjustmentArgs = {
  input: MfxBalanceAdjInput;
};


export type MutationMfxBalanceTransferArgs = {
  input: MfxBalanceTransferInput;
};


export type MutationMfxLoadCardArgs = {
  input: MfxLoadCardInput;
};


export type MutationMfxUnloadCardArgs = {
  input: MfxUnloadCardInput;
};


export type MutationMfxWalletTransferArgs = {
  input: MfxWalletTransferInput;
};


export type MutationPerformIdpHealthCheckArgs = {
  idpId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationProxyRequestArgs = {
  input: ProxyRequestInput;
};


export type MutationRemovePermissionFromGroupArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  permissionId: Scalars['String']['input'];
};


export type MutationRemoveUserFromGroupArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationRemoveUserFromOrganisationArgs = {
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationResendNotificationsArgs = {
  input: ResendNotificationsInput;
  webhookId: Scalars['String']['input'];
};


export type MutationResendUserInvitationArgs = {
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationRevokeApplicationCertificateArgs = {
  applicationId: Scalars['String']['input'];
  input: RevokeCertificateInput;
  kid: Scalars['String']['input'];
};


export type MutationRotateOauthClientSecretArgs = {
  clientId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type MutationSaveUserPmPreferenceArgs = {
  input: SaveUserPmPreferenceInput;
};


export type MutationSendFeatureRequestArgs = {
  input: FeatureRequestInput;
};


export type MutationSetExtendExpiryDateArgs = {
  input: ExtendExpiryDateInput;
};


export type MutationSplitKmsBinRangeArgs = {
  input: SplitKmsBinRangeInput;
};


export type MutationUnblockCardArgs = {
  input: UnblockCardInput;
  publicToken: Scalars['String']['input'];
};


export type MutationUnblockCvvArgs = {
  input: CvvUnblockInput;
  publicToken: Scalars['String']['input'];
};


export type MutationUnblockOfflinePinArgs = {
  input: PinUnblockInput;
  publicToken: Scalars['String']['input'];
};


export type MutationUnblockOnlinePinArgs = {
  input: PinUnblockInput;
  publicToken: Scalars['String']['input'];
};


export type MutationUnloadFundsArgs = {
  clientId: Scalars['String']['input'];
  input: UnloadFundsInput;
};


export type MutationUpdate3dsCredentialDetailsArgs = {
  input: Update3DsCredentialInput;
  publicToken: Scalars['String']['input'];
};


export type MutationUpdateAccountArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateAccountInput;
};


export type MutationUpdateAccountHolderArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateAccountHolderInput;
};


export type MutationUpdateAccountWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateAccountWorkflowInput;
};


export type MutationUpdateAddressArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateAddressInput;
};


export type MutationUpdateAddressV2WorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateAddressV2Input;
};


export type MutationUpdateAddressWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateAddressInput;
};


export type MutationUpdateApplicationArgs = {
  applicationId: Scalars['String']['input'];
  input: ApplicationInput;
};


export type MutationUpdateCardArgs = {
  input: UpdateCardInput;
};


export type MutationUpdateChannelArgs = {
  id: Scalars['String']['input'];
  input: ChannelInput;
};


export type MutationUpdateClientArgs = {
  id: Scalars['String']['input'];
  input: ClientInput;
};


export type MutationUpdateCompanyArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCurrencyArgs = {
  id: Scalars['String']['input'];
  input: UpdateCurrencyInput;
};


export type MutationUpdateCustomerWorkflowArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateCustomerWorkflowInput;
};


export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagRequest;
};


export type MutationUpdateFinancialProductArgs = {
  id: Scalars['String']['input'];
  input: FinancialProductInput;
};


export type MutationUpdateFinancialProductV2Args = {
  id: Scalars['String']['input'];
  input: FinancialProductInput;
};


export type MutationUpdateGroupArgs = {
  PK: Scalars['String']['input'];
  input: UpdateGroupRequest;
};


export type MutationUpdateGroupedServicesArgs = {
  PK: Scalars['String']['input'];
};


export type MutationUpdateGroupsArgs = {
  input: UpdateControlGroupsInput;
};


export type MutationUpdateIdentityProviderArgs = {
  idpId: Scalars['String']['input'];
  input: UpdateIdpInput;
  organisationId: Scalars['String']['input'];
};


export type MutationUpdateInstrumentProductArgs = {
  id: Scalars['String']['input'];
  input: InstrumentProductInput;
};


export type MutationUpdateLedgerArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateLedgerInput;
};


export type MutationUpdateLedgerConfigurationArgs = {
  id: Scalars['String']['input'];
  input: LedgerConfigInput;
};


export type MutationUpdateLedgerWorkflowArgs = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  input: UpdateLedgerInputV2;
  ledgerId: Scalars['String']['input'];
};


export type MutationUpdateOauthClientArgs = {
  clientId: Scalars['String']['input'];
  input: UpdateOAuthClientInput;
  organisationId: Scalars['String']['input'];
};


export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
  organisationId: Scalars['String']['input'];
};


export type MutationUpdateOrganisationGroupArgs = {
  groupId: Scalars['String']['input'];
  input: UpdateOrganisationGroupInput;
  organisationId: Scalars['String']['input'];
};


export type MutationUpdatePaymentNetworkConfigArgs = {
  PK: Scalars['String']['input'];
  input: UpdatePaymentNetworkConfigInput;
};


export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput;
  permissionId: Scalars['String']['input'];
};


export type MutationUpdatePolicyGroupArgs = {
  id: Scalars['String']['input'];
  input: PolicyGroupInput;
};


export type MutationUpdatePolicyV2Args = {
  id: Scalars['String']['input'];
  input: UpdatePolicyV2Input;
};


export type MutationUpdateServiceArgs = {
  PK: Scalars['String']['input'];
  input: UpdateServiceRequest;
};


export type MutationUpdateSystemChannelArgs = {
  id: Scalars['String']['input'];
  input: SystemChannelInput;
};


export type MutationUpdateTransactionReasonCodeArgs = {
  id: Scalars['String']['input'];
  input: TransactionReasonCodeInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  username: Scalars['String']['input'];
};


export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput;
  username: Scalars['String']['input'];
};


export type MutationUpdateVisaFileMaintenanceArgs = {
  input: VisaFileMaintenanceInput;
  publicToken: Scalars['String']['input'];
};


export type MutationUpdateWebhookDetailsArgs = {
  input: UpdateWebhookRequestInput;
  webhookId: Scalars['String']['input'];
};


export type MutationUpdateWebhookStatusArgs = {
  input: UpdateWebhookStatusInput;
  webhookId: Scalars['String']['input'];
};

export type NetworkSignOnParamsResponse = {
  __typename?: 'NetworkSignOnParamsResponse';
  discoverSignOnParams?: Maybe<DiscoverSignOnParams>;
  mastercardSignOnParams?: Maybe<DefaultMastercardSignOnParams>;
  mneSignOnParams?: Maybe<MneSignOnParams>;
  visaSignOnParams?: Maybe<VisaSignOnParams>;
};

export enum NetworkType {
  DiscoverDiners = 'DISCOVER_DINERS',
  Mastercard = 'MASTERCARD',
  Mne = 'MNE',
  Visa = 'VISA'
}

export enum NumberingType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type OAuthClient = {
  __typename?: 'OAuthClient';
  allowedGroupIds: Array<Scalars['String']['output']>;
  allowedScopes?: Maybe<Array<Scalars['String']['output']>>;
  applicationId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  cognitoClientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Int']['output']>;
  ipWhitelist?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  issuerId?: Maybe<Scalars['Int']['output']>;
  lastSecretRotation?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  pmId?: Maybe<Scalars['Int']['output']>;
  scopes: Array<Scalars['String']['output']>;
  tags: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  usageNotes?: Maybe<Scalars['String']['output']>;
};

export type OAuthClientCreatedResponse = {
  __typename?: 'OAuthClientCreatedResponse';
  allowedGroupIds: Array<Scalars['String']['output']>;
  allowedScopes?: Maybe<Array<Scalars['String']['output']>>;
  applicationId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  cognitoClientId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Int']['output']>;
  ipWhitelist?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  issuerId?: Maybe<Scalars['Int']['output']>;
  lastSecretRotation?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  pmId?: Maybe<Scalars['Int']['output']>;
  scopes: Array<Scalars['String']['output']>;
  tags: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  usageNotes?: Maybe<Scalars['String']['output']>;
};

export type OffsetLedger = {
  __typename?: 'OffsetLedger';
  /** The database generated UUID string which uniquely identifies the channel. */
  channelId?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** The datetime of when the Offset Ledger was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who created the Offset Ledger. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The currency code associated with the Offset Ledger. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the Offset Ledger. */
  id?: Maybe<Scalars['String']['output']>;
  /** Reference to Customer Account Offset Ledger. */
  offsetLedgerId?: Maybe<Scalars['String']['output']>;
  /** Represents the type of offset ledger. */
  offsetLedgerType?: Maybe<OffsetLedgerType>;
};

export type OffsetLedgerInput = {
  /** The database generated UUID string which uniquely identifies the channel. */
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** The database generated UUID string which uniquely identifies the client. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the user who created the Offset Ledger. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** The currency code associated with the Offset Ledger. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Reference to Customer Account Offset Ledger. */
  offsetLedgerId?: InputMaybe<Scalars['String']['input']>;
  /** Represents the type of offset ledger. */
  offsetLedgerType?: InputMaybe<OffsetLedgerType>;
};

/** Represents the type of offset ledger. */
export enum OffsetLedgerType {
  ClientFees = 'CLIENT_FEES',
  DisputesSuspense = 'DISPUTES_SUSPENSE',
  InterchangeRevenue = 'INTERCHANGE_REVENUE',
  InternalTransferSuspense = 'INTERNAL_TRANSFER_SUSPENSE',
  LoadUnload = 'LOAD_UNLOAD',
  OperationalLosses = 'OPERATIONAL_LOSSES',
  Pending = 'PENDING',
  SchemeSettlement = 'SCHEME_SETTLEMENT',
  TypeUnspecified = 'TYPE_UNSPECIFIED'
}

export type OidcConfig = {
  __typename?: 'OidcConfig';
  authorizationEndpoint?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  discoveryUrl?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  jwksUri?: Maybe<Scalars['String']['output']>;
  responseMode?: Maybe<Scalars['String']['output']>;
  responseType?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  tokenEndpoint?: Maybe<Scalars['String']['output']>;
  userinfoEndpoint?: Maybe<Scalars['String']['output']>;
};

export type OnlineEcomDomesticPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<OnlineEcomDomesticPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type OnlineEcomDomesticPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type OnlineEcomInternationalPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<OnlineEcomInternationalPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type OnlineEcomInternationalPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type OrangeFlowReason = {
  __typename?: 'OrangeFlowReason';
  meaning: Scalars['String']['output'];
  offset: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
};

export type Organisation = {
  __typename?: 'Organisation';
  authProvider: AuthProvider;
  clientAuthMethod: ClientAuthMethod;
  clientId?: Maybe<Scalars['String']['output']>;
  cognitoGroupName: Scalars['String']['output'];
  connection: ConnectionType;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emailDomains: Array<Scalars['String']['output']>;
  identityProviderConfig?: Maybe<Scalars['String']['output']>;
  internalId?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  issuerId?: Maybe<Scalars['Int']['output']>;
  metadata: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  pmInformation: Array<PmInformation>;
  products: Array<Scalars['String']['output']>;
  scopes: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: OrganisationStatus;
  subClientId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type OrganisationEmailDomainResponse = {
  __typename?: 'OrganisationEmailDomainResponse';
  /** Authentication provider for this organisation */
  authProvider: AuthProvider;
  /** List of email domains configured for this organisation */
  emailDomains: Array<Scalars['String']['output']>;
  /** Identity provider configuration for SSO authentication (can be a list of IDPs or a single config) */
  identityProviderConfig?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the organisation */
  organisationId: Scalars['String']['output'];
};

export type OrganisationGroup = {
  __typename?: 'OrganisationGroup';
  cognitoGroupName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum OrganisationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

export type PanRequestInput = {
  value: Scalars['String']['input'];
  valueType: PanFinderValueType;
};

export type PanResponse = {
  __typename?: 'PANResponse';
  clearPan?: Maybe<Scalars['String']['output']>;
  panPubToken?: Maybe<Scalars['String']['output']>;
  pubToken?: Maybe<Scalars['String']['output']>;
};

export type PmInformation = {
  __typename?: 'PMInformation';
  pmCode: Scalars['String']['output'];
  pmId: Scalars['Int']['output'];
};

export type PmInformationInput = {
  pmCode?: InputMaybe<Scalars['String']['input']>;
  pmId?: InputMaybe<Scalars['Int']['input']>;
};

export type PosDataDecoded = {
  __typename?: 'POSDataDecoded';
  additionalInformation: Scalars['String']['output'];
  description: Scalars['String']['output'];
  position: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum PanFinderValueType {
  ClearPan = 'CLEAR_PAN',
  PanPublicToken = 'PAN_PUBLIC_TOKEN',
  PublicToken = 'PUBLIC_TOKEN'
}

export type PartialAuthorisationControlPolicyConfigurationInput = {
  partialAuthEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheme: Scalars['String']['input'];
  serviceCode: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type PartialAuthorisationControlPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<PartialAuthorisationControlPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type PartialAuthorisationControlPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<PartialAuthorisationControlPolicyConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PastDueAmount = {
  __typename?: 'PastDueAmount';
  amount: Scalars['Int']['output'];
  pastDue: Scalars['String']['output'];
};

export type PastDueAmountInput = {
  amount: Scalars['Int']['input'];
  pastDue: Scalars['String']['input'];
};

export type PastDueAmountV2 = {
  __typename?: 'PastDueAmountV2';
  amount?: Maybe<Scalars['Int']['output']>;
  pastDue?: Maybe<Scalars['String']['output']>;
};

export type PaymentAllocationConfigurationInput = {
  allocationOrder?: InputMaybe<Array<AllocationOrderOption>>;
  bucketOrder?: InputMaybe<Array<BucketOrderOption>>;
};

export type PaymentNetworkConfigResponse = {
  __typename?: 'PaymentNetworkConfigResponse';
  caCertificatePath?: Maybe<Scalars['String']['output']>;
  certificatePath?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  hostIps: Array<Scalars['String']['output']>;
  maintenanceMode: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  network: NetworkType;
  pk: Scalars['String']['output'];
  privateKeyPath?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type PaymentTokenStatus = {
  __typename?: 'PaymentTokenStatus';
  authorisationDecision: AuthorisationDecision;
  authorisationStatus: AuthorisationStatus;
  gpsStatusInfo: GpsStatusInfo;
  tokenisedStatus: TokenisationStatus;
  transactionStatus: TransStatus;
};

export type PaymentTokenStatusResponse = {
  __typename?: 'PaymentTokenStatusResponse';
  comment: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PaymentTokenUsageRuleDetail = {
  __typename?: 'PaymentTokenUsageRuleDetail';
  defaultTicked: Scalars['Boolean']['output'];
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  variableDescription?: Maybe<Scalars['String']['output']>;
  variableType?: Maybe<Scalars['String']['output']>;
  variableTypeCode?: Maybe<Scalars['String']['output']>;
};

/** Payment token usage rule group response. */
export type PaymentTokenUsageRuleGroupResponse = {
  __typename?: 'PaymentTokenUsageRuleGroupResponse';
  cardAcceptanceMethods: Array<PaymentTokenUsageRuleDetail>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  misc: Array<PaymentTokenUsageRuleDetail>;
  transactionTypes: Array<PaymentTokenUsageRuleDetail>;
  verificationChecks: Array<PaymentTokenUsageRuleDetail>;
};

export type Permission = {
  __typename?: 'Permission';
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  dependencies: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  riskLevel: PermissionRiskLevel;
  scopes: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum PermissionRiskLevel {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum PhoneContactPriority {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Work = 'WORK'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  number?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberInput = {
  number?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneNumbers = {
  __typename?: 'PhoneNumbers';
  home?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  primaryContact?: Maybe<PhoneContactPriority>;
  secondaryContact?: Maybe<PhoneContactPriority>;
  work?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumbersInput = {
  home?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<PhoneContactPriority>;
  secondaryContact?: InputMaybe<PhoneContactPriority>;
  work?: InputMaybe<Scalars['String']['input']>;
};

export type PhysicalConfigurationInput = {
  cardVerificationMethods: Array<CardVerificationMethod>;
  defaultCardVerificationMethod: CardVerificationMethod;
  defaultTransactionAuthorisationMethod: TransactionAuthorisationMethod;
  transactionAuthorisationMethods: Array<TransactionAuthorisationMethod>;
};

export type PinConfigurationInput = {
  algorithm: Algorithm;
  autoGenerate?: Scalars['Boolean']['input'];
  decimalizationTable: Scalars['String']['input'];
  maxPinAttempts: Scalars['Int']['input'];
  padCharacter: Scalars['String']['input'];
  pinIsOverridable?: Scalars['Boolean']['input'];
  pinIsUpdatable?: Scalars['Boolean']['input'];
  pinLength: Scalars['Int']['input'];
  selfSelectPin?: InputMaybe<SelfSelectPinInput>;
  selfSelectPinEnabled?: Scalars['Boolean']['input'];
};

export type PinConfigurationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<PinConfigurationInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PinUnblockInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PingWebhookDetailResponse = {
  __typename?: 'PingWebhookDetailResponse';
  healthStatus?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type PolicyConfiguration = {
  __typename?: 'PolicyConfiguration';
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChangeable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nullable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type PolicyConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyGroup = {
  __typename?: 'PolicyGroup';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  financialProductId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instrumentProductId?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<PolicyConfiguration>>;
  status?: Maybe<PolicyStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<PolicyConfigurationInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export enum PolicyStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Processing = 'PROCESSING'
}

export type PolicyV2 = {
  __typename?: 'PolicyV2';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isChangeable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nullable?: Maybe<Scalars['Boolean']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PortalTransactionsCollectionSegment = {
  __typename?: 'PortalTransactionsCollectionSegment';
  items?: Maybe<Array<GetTransactionsResponse>>;
  pageInfo?: Maybe<CollectionSegmentInfo>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Pos = {
  __typename?: 'Pos';
  acquirerExemptScaIndicator?: Maybe<Scalars['String']['output']>;
  authenticationAmountAndCurrencyComparisonResult?: Maybe<Scalars['String']['output']>;
  cardDeviceFormFactor?: Maybe<Scalars['String']['output']>;
  cardInput?: Maybe<Scalars['String']['output']>;
  cardPresent?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationEntity1?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationEntity2?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationEntity3?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationEntity4?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationMethod1?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationMethod2?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationMethod3?: Maybe<Scalars['String']['output']>;
  cardholderAuthenticationMethod4?: Maybe<Scalars['String']['output']>;
  cardholderPresent?: Maybe<Scalars['String']['output']>;
  chipFallback?: Maybe<Scalars['String']['output']>;
  extendedAuthorizationIndicator?: Maybe<Scalars['String']['output']>;
  fraudIndicator?: Maybe<Scalars['String']['output']>;
  instantFundingNetwork?: Maybe<Scalars['String']['output']>;
  instantFundingThredd?: Maybe<Scalars['String']['output']>;
  merchantCardholderInitiatedIndicator?: Maybe<Scalars['String']['output']>;
  merchantInitiatedTransactionTypeIndicator?: Maybe<Scalars['String']['output']>;
  originalTransactionScaAssessmentResult?: Maybe<Scalars['String']['output']>;
  originalTransactionScaExemptIndicator?: Maybe<Scalars['String']['output']>;
  originalTransactionStatusValue?: Maybe<Scalars['String']['output']>;
  scaAssessment?: Maybe<Scalars['String']['output']>;
  scaBiometricTest?: Maybe<Scalars['String']['output']>;
  scaExempt?: Maybe<Scalars['String']['output']>;
  scaKnowledgeTest?: Maybe<Scalars['String']['output']>;
  scaPossessionTest?: Maybe<Scalars['String']['output']>;
  secure3DAuthenticationMethod?: Maybe<Scalars['String']['output']>;
  securityCardholderToMerchant?: Maybe<Scalars['String']['output']>;
  threddDetectedScaExemption?: Maybe<Scalars['String']['output']>;
};

export type PosCapabilities = {
  __typename?: 'PosCapabilities';
  attended?: Maybe<Scalars['String']['output']>;
  cardCapture?: Maybe<Scalars['String']['output']>;
  cardInput?: Maybe<Scalars['String']['output']>;
  cardOutput?: Maybe<Scalars['String']['output']>;
  cardholderAuthentication?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  partialApproval?: Maybe<Scalars['String']['output']>;
  pinCapture?: Maybe<Scalars['String']['output']>;
  purchaseAmountOnlyApproval?: Maybe<Scalars['String']['output']>;
  terminalOutput?: Maybe<Scalars['String']['output']>;
  terminalType?: Maybe<Scalars['String']['output']>;
};

export type PosEntry = {
  __typename?: 'PosEntry';
  code?: Maybe<Scalars['String']['output']>;
  codeDescription?: Maybe<Array<CodeDescription>>;
};

export type PosMerchantDomesticPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<PosMerchantDomesticPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type PosMerchantDomesticPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PosMerchantInternationalPolicyGroupInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  instrumentProductId?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policies?: InputMaybe<Array<PosMerchantInternationalPolicyInput>>;
  status?: InputMaybe<PolicyStatus>;
};

export type PosMerchantInternationalPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<SpendLimitInput>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type PosSubLimitsResult = {
  __typename?: 'PosSubLimitsResult';
  accumulatedFrequencyLimit1?: Maybe<Scalars['Int']['output']>;
  accumulatedFrequencyLimit2?: Maybe<Scalars['Int']['output']>;
  accumulatedPeriod1?: Maybe<Scalars['String']['output']>;
  accumulatedPeriod2?: Maybe<Scalars['String']['output']>;
  accumulatedValueLimit1?: Maybe<Scalars['Decimal']['output']>;
  accumulatedValueLimit2?: Maybe<Scalars['Decimal']['output']>;
  dailyFrequencyLimit?: Maybe<Scalars['Int']['output']>;
  dailyValueLimit?: Maybe<Scalars['Decimal']['output']>;
  maxPerTransaction?: Maybe<Scalars['Decimal']['output']>;
  minPerTransaction?: Maybe<Scalars['Decimal']['output']>;
  posLimitDescription?: Maybe<Scalars['String']['output']>;
};

export enum Priority {
  Critical = 'CRITICAL',
  Major = 'MAJOR',
  Minor = 'MINOR'
}

export type ProcessingCode = {
  __typename?: 'ProcessingCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** Indicates whether the Product is part of the DEBIT or CREDIT stream. */
export enum ProductCategory {
  CategoryUnspecified = 'CATEGORY_UNSPECIFIED',
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type ProductLimits = {
  __typename?: 'ProductLimits';
  accumFrequency1?: Maybe<Scalars['Int']['output']>;
  accumFrequency2?: Maybe<Scalars['Int']['output']>;
  accumLimit1?: Maybe<Scalars['Decimal']['output']>;
  accumLimit2?: Maybe<Scalars['Decimal']['output']>;
  accumPeriod1?: Maybe<Scalars['Int']['output']>;
  accumPeriod2?: Maybe<Scalars['Int']['output']>;
  dailyFrequency?: Maybe<Scalars['Int']['output']>;
  dailyLimit?: Maybe<Scalars['Decimal']['output']>;
  maximumPerTransaction?: Maybe<Scalars['Decimal']['output']>;
  minimumPerTransaction?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductResponse = {
  __typename?: 'ProductResponse';
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  rangeHighLimit?: Maybe<Scalars['String']['output']>;
  rangeLowLimit?: Maybe<Scalars['String']['output']>;
};

/** Represents the whether a Product has multiple accessors or not. A GLOBAL product is governed by an MSA client, a LOCAL product is governed by a SUB client. */
export enum ProductScope {
  Global = 'GLOBAL',
  Local = 'LOCAL',
  ScopeUnspecified = 'SCOPE_UNSPECIFIED'
}

/** Indicates the Product state. */
export enum ProductStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Open = 'OPEN',
  Processing = 'PROCESSING',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  Suspended = 'SUSPENDED'
}

export type ProgramManagerProductBasic = {
  __typename?: 'ProgramManagerProductBasic';
  accountCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  ehiMode: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  schemeName: Scalars['String']['output'];
};

export type ProxyRequestInput = {
  /** Request body for POST/PUT/PATCH requests */
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** Additional headers to include in the request */
  headers?: InputMaybe<Scalars['JSON']['input']>;
  /** HTTP method (GET, POST, PUT, PATCH, DELETE) */
  method: Scalars['String']['input'];
  /** API endpoint path (e.g., '/api/v1/accounts') */
  path: Scalars['String']['input'];
  /** Query parameters as key-value pairs */
  queryParams?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProxyResponse = {
  __typename?: 'ProxyResponse';
  /** Response body from the proxied request */
  body: Scalars['JSON']['output'];
  /** Response headers from the proxied request */
  headers: Scalars['JSON']['output'];
  /** Unique identifier for tracking the request */
  requestId: Scalars['String']['output'];
  /** HTTP status code from the proxied request */
  statusCode: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type PublicTokenCardHistoryCollectionSegment = {
  __typename?: 'PublicTokenCardHistoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CardHistoryResponse>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicTokenCardHistoryInput = {
  input?: InputMaybe<SearchCardHistoryInput>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type PublicTokenCardStatusHistoryCollectionSegment = {
  __typename?: 'PublicTokenCardStatusHistoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<HistoryResponse>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A segment of a collection. */
export type PublicTokenMetaHistoryCollectionSegment = {
  __typename?: 'PublicTokenMetaHistoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CardMetaHistoryResponse>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get list of 3D Secure directory server credentials. Returns authentication credentials for 3DS protocol integration. */
  _dsCredentialsList?: Maybe<Array<CredentialResponse>>;
  /** Get 3D Secure directory server version and supplier information. Returns DS configuration for 3DS authentication flows. */
  _dsVersionAndSupplier?: Maybe<SupplierAndVersionResponse>;
  /** Retrieve detailed information about a specific account by ID. Returns balance, status, limits, and transaction history. */
  account?: Maybe<Account>;
  /**
   * Retrieve detailed information about a specific account holder by ID. Returns personal details, KYC status, and linked accounts.
   * @deprecated Use accountHolderWorkflow instead for additional validation.
   */
  accountHolder?: Maybe<AccountHolder>;
  /**
   * Get account holder via conductor workflow. Returns account holder details with associated addresses orchestrated through conductor.
   * @deprecated Use customerWorkflow instead, which returns a Customer object with a richer, flattened representation.
   */
  accountHolderWorkflow?: Maybe<AccountHolder>;
  /** List accounts with pagination and filtering. Supports searching by account holder, status, product type, and balance ranges. */
  accounts?: Maybe<ListAccountsResponse>;
  /** Retrieve detailed information about a specific address by ID. */
  address?: Maybe<Address>;
  /** Retrieve detailed information about a specific address by ID using the V2 Address endpoints. */
  addressV2?: Maybe<AddressV2>;
  /** List all users who can perform card actions. Returns user information for auditing and permission management. */
  allCardActionUsers?: Maybe<Array<CardActionUsers>>;
  /** List all card action reference data. Returns possible operations that can be performed on cards (activate, block, unblock, close, etc.). */
  allCardActions?: Maybe<Array<CardActions>>;
  /** List all card status reference data. Returns possible card states (active, blocked, closed, suspended, etc.). */
  allCardStatuses?: Maybe<Array<CardStatus>>;
  /** List all country reference data. Returns ISO country codes with names and regional information. */
  allCountries?: Maybe<Array<Country>>;
  /** List all currency code reference data. Returns ISO 4217 currency codes with names and numeric identifiers. */
  allCurrencyCodes?: Maybe<Array<CurrencyCode>>;
  /**
   * Retrieve all configured feature flags with optional filtering and context evaluation.
   *
   *         Supports query parameters for context-based evaluation:
   *         - filter_flags: Comma-separated list of flag names to filter
   *         - client_id: Client identifier for flag evaluation
   *         - client_type: Type of client (e.g., 'web', 'mobile')
   *         - user_type: User classification (e.g., 'premium', 'basic')
   *         - region: Geographic region for regional targeting
   *         - beta_tester: Beta testing status ('true'/'false')
   *
   *         Returns all flags with their current state, value, reason for evaluation,
   *         percentage rollout settings, and metadata including owner and description.
   */
  allFeatureFlags?: Maybe<FlagsResponse>;
  /** List all ISO 8583 processing code reference data. Returns codes that define transaction types and account combinations. */
  allProcessingCodes?: Maybe<Array<ProcessingCode>>;
  /** List all region reference data. Returns available processing regions with their configurations and capabilities. */
  allRegions?: Maybe<Array<Regions>>;
  /** List all transaction status reference data. Returns possible transaction states (approved, declined, pending, reversed, etc.). */
  allTransactionStatus?: Maybe<Array<TransactionStatus>>;
  /** List all transaction type reference data. Returns classification codes for different payment operations (purchase, refund, withdrawal, etc.). */
  allTransactionTypes?: Maybe<Array<TransactionType>>;
  /** Retrieve audit log lookup tables. Returns reference data for interpreting audit log entries including event types and categories. */
  auditLogLookups?: Maybe<AuditLogLookupTableResponse>;
  /** Retrieve audit logs with filtering options. Returns system events, user actions, and changes with timestamps and actor information. */
  auditLogs?: Maybe<AuditLogsResponse>;
  /** List all available payment authorisors. Returns authorisation endpoints, supported features, and routing configurations. */
  authorisors?: Maybe<Array<Authorisor>>;
  /** Retrieve information about a specific BIN (Bank Identification Number) range. Returns BIN configuration and associated network details. */
  binRange?: Maybe<BinRange>;
  /** List all BIN ranges configured in the system. Returns BIN allocations for card issuance across different networks and products. */
  binRangeList?: Maybe<Array<BinRange>>;
  /** Get both allow and disallow lists of card acceptors by public token. Returns complete merchant control configuration with groups and individual merchants. */
  cardAcceptorAllowDisallowList?: Maybe<CardAcceptorsResponse>;
  /** Retrieve complete card details by public token. Returns card information including status, limits, balances, and configuration. */
  cardByPublicToken?: Maybe<GetCardResponse>;
  /** Get CVV/CVC2 verification status and remaining tries. Returns attempt count and whether the CVV is blocked due to excessive failures. */
  cardCvvStatus?: Maybe<CardPinStatusResponse>;
  /** Get fees configured for a card by public token. Returns fee schedule including issuance, maintenance, transaction, and other applicable fees. */
  cardFees?: Maybe<CardFeeResponse>;
  /** Get group limit details for a card. Returns spending limits configured at the group level including daily, monthly, and per-transaction restrictions. */
  cardGroupLimitDetails?: Maybe<GetCardGroupLimitDetailResponse>;
  /** Retrieve card image by public token. Returns the visual card design including artwork, branding, and layout configuration. */
  cardImageByPublicToken?: Maybe<GetCardImageResponse>;
  /** Get card spending limits by public token. Returns configured daily, monthly, and per-transaction limits with current usage and remaining balances. */
  cardLimitDetails?: Maybe<GetCardLimitResponse>;
  /** List all card network type reference data. Returns payment network classifications (Visa, Mastercard, etc.). */
  cardNetworkType?: Maybe<Array<CardNetworkType>>;
  /** Get online PIN verification status and remaining tries. Returns attempt count and whether the PIN is blocked due to excessive failures. */
  cardOnlinePinStatus?: Maybe<CardPinStatusResponse>;
  /** Get list of devices with payment tokens for a card. Returns device information for all provisioned digital wallets. */
  cardPaymentTokenDevices?: Maybe<Array<GetCardPaymentTokenDevicesResponse>>;
  /** List all payment tokens associated with a card. Returns digital wallet tokens (Apple Pay, Google Pay) with provisioning status and device information. */
  cardPaymentTokenList?: Maybe<Array<GetCardPaymentTokenDetailsResponse>>;
  /** Get point-of-sale sub-limits for a card. Returns spending restrictions by transaction type (contactless, ATM, POS, etc.). */
  cardPosSubLimits?: Maybe<CardPosSubLimitsResponse>;
  /** Get card spending limits configured at the product level. Returns default limits inherited from the product configuration. */
  cardSpendLimitDetailsByProduct?: Maybe<CardSpendLimitByProductResponse>;
  /** Retrieve current status of a specific card by public token. Returns card state with status code and description. */
  cardStatus?: Maybe<CardStatusResponse>;
  /** List all card type reference data. Returns card categories (debit, credit, prepaid, virtual, etc.). */
  cardType?: Maybe<Array<MfxCardType>>;
  /** Get allow list of card acceptors by public token. Returns merchants and merchant groups where the card is permitted to transact. */
  cardsAcceptorList?: Maybe<Array<CardAcceptorDetailResponseWithResolver>>;
  /** Get disallow list of card acceptors by public token. Returns merchants and merchant groups where the card is blocked from transacting. */
  cardsDisallowList?: Maybe<Array<CardAcceptorDetailResponseWithResolver>>;
  /** Retrieve detailed information about a specific channel by ID. Returns complete channel configuration and associated rules. */
  channel?: Maybe<Channel>;
  /** List all channels. Returns channel configurations and associated rules. */
  channelList?: Maybe<Array<Channel>>;
  /** Retrieves all client spaces. */
  clientSpacesList?: Maybe<Array<ClientSpace>>;
  /** List companies with pagination and filtering. Supports filtering by parent company id and name. */
  companies?: Maybe<ListCompaniesResponse>;
  /** Retrieve detailed information about company. */
  company?: Maybe<Company>;
  /** Retrieve the latest build number of the connection service. Used for version tracking and compatibility checks. */
  connectionServiceLatestBuildNumber?: Maybe<ConnectionServiceLatestBuildNumber>;
  /** List all country and currency code mappings. Returns ISO country codes with their associated currency codes and configurations. */
  countryCurrencyCodeList?: Maybe<Array<CountryCurrencyCode>>;
  /** Retrieve currency details by ISO code (e.g., USD, EUR, GBP). Returns currency configuration and formatting specifications. */
  currencyByCode?: Maybe<Currency>;
  /** Retrieve currency details by unique identifier. Returns complete currency configuration including code, name, and formatting rules. */
  currencyById?: Maybe<Currency>;
  /** Get currency conversion rates for multi-currency transactions. Returns current exchange rates and markup configurations. */
  currencyConversionRates?: Maybe<CurConRateResponse>;
  /** List all supported currencies. Returns ISO currency codes, symbols, decimal places, and exchange rate configurations. */
  currencyList?: Maybe<Array<Currency>>;
  /** Get customer via conductor workflow. Returns the customer in the flattened camelCase representation produced by the get_customer conductor workflow, including addresses and individual/commercial fields. */
  customerWorkflow?: Maybe<Customer>;
  /** Decode ISO 8583 DE055 ICC (chip card) data from authorization messages. Returns parsed EMV tag-value pairs with descriptions. */
  decodeDe055?: Maybe<Array<IccDataDecoded>>;
  /** Decode ISO 8583 DE055 ICC (chip card) data from presentment/financial messages. Returns parsed EMV tag-value pairs specific to clearing transactions. */
  decodeDe055ForPresentment?: Maybe<Array<IccDataDecoded>>;
  /** Decode EMV Card Verification Results (CVR) data. Returns detailed chip card verification status including cryptogram validation and risk management decisions. */
  decodingCVR?: Maybe<Array<CvrDecodedResponse>>;
  /** Decode ISO 8583 DE022 POS entry mode. Returns card data input method (chip, swipe, contactless, manual entry) and authentication capabilities. */
  decodingDE022?: Maybe<Array<PosDataDecoded>>;
  /** Decode ISO 8583 DE025 POS condition code. Returns point-of-service operating conditions and capabilities. */
  decodingDE025?: Maybe<PosDataDecoded>;
  /** Decode ISO 8583 DE048 additional data field. Returns parsed subelements with network-specific additional transaction information. */
  decodingDE048?: Maybe<AdditionalDataDecodResponse>;
  /** Decode ISO 8583 DE061 POS data - extended. Returns additional point-of-sale information including card data input and authentication methods. */
  decodingDE061?: Maybe<Array<PosDataDecoded>>;
  /** Decode ISO 8583 DE063 network data. Returns network-specific routing and processing information. */
  decodingDE063?: Maybe<Array<PosDataDecoded>>;
  /** Decode ISO 8583 DE060 POS data code. Returns detailed point-of-sale terminal capabilities and transaction context. */
  decodingDE60?: Maybe<Array<PosDataDecoded>>;
  /** Decode Mastercard Orange Flow reason codes. Returns detailed explanations for why a transaction was flagged for additional authentication. */
  decodingOrangeFlow?: Maybe<Array<OrangeFlowReason>>;
  /** Decode Mastercard PDS 0043 Transaction Type Identifier from DE048. Returns transaction classification and category codes. */
  decodingPDS0043?: Maybe<AdditionalDataDecoded>;
  /** Decode Mastercard PDS 0146 Fee/Transaction Amount Data from DE048. Returns interchange fees, transaction amounts, and currency codes. */
  decodingPDS0146?: Maybe<Array<AdditionalDataDecoded>>;
  /** Decode Mastercard PDS 0158 Business Service Data from DE048. Returns merchant and business service classification codes. */
  decodingPDS0158?: Maybe<Array<AdditionalDataDecoded>>;
  /** Decode Mastercard PDS 0159 Settlement Service Data from DE048. Returns settlement and reconciliation service codes. */
  decodingPDS0159?: Maybe<Array<AdditionalDataDecoded>>;
  /** Development testing endpoint that returns a dummy account object. Not for production use. */
  dummyAccount?: Maybe<Account>;
  /** Check whether a transaction has been resent to EHI. Returns the resend-to-EHI status for the given transaction ID. */
  ehiAcknowledgement?: Maybe<EhiAcknowledgementResponse>;
  /** Retrieve detailed information about a specific financial product by ID. Returns product configuration, limits, and associated rules. */
  financialProduct?: Maybe<FinancialProduct>;
  /** Retrieve a list of financial products (account types). Supports filtering by client, product type, and status to refine results. */
  financialProductList?: Maybe<Array<FinancialProduct>>;
  /**
   * Check the health status of the feature flagging service.
   *
   *         Returns:
   *         - status: 'healthy' if service is operational and can access AWS AppConfig
   *         - status: 'unhealthy' with 503 error if service cannot access configuration
   *
   *         Use this endpoint for monitoring and alerting on service availability.
   */
  flaggingHealthCheck?: Maybe<HealthCheckFlagging>;
  /** Retrieve detailed information about a specific account by ID. Returns balance, status, limits, and transaction history. */
  getAccount?: Maybe<AccountV2>;
  /** Get Application. */
  getApplication?: Maybe<ApplicationResponse>;
  /** Get Application Certificate Pem. Returns Pem encoded certificate. */
  getApplicationCertificatePem?: Maybe<GetApplicationCertificatePemResponse>;
  /** Get the exchanged token that will be used for upstream requests. Development and debugging tool that performs token exchange and returns the resulting token. Blocked in production environments. */
  getExchangedToken?: Maybe<ExchangedTokenResponse>;
  /** Get group calendar details of a pubtoken */
  getGroupCalendarDetails?: Maybe<CalendarGroupResponse>;
  /** Get group fx details of a pubtoken */
  getGroupFxDetails?: Maybe<FxGroupResponse>;
  /** Get group limited network details of a pubtoken */
  getGroupLimitedNetworkDetails?: Maybe<LimitedNetworkGroupResponse>;
  /** Get group linkage details of a pubtoken */
  getGroupLinkageDetails?: Maybe<LinkageGroupResponse>;
  /** Retrieve detailed information about a specific cryptographic key by its ID. Returns complete key configuration and metadata. */
  getKeyByKeyId?: Maybe<GetKeyByKeyIdResponse>;
  /** List all cryptographic keys in the system. Returns key metadata, statuses, and associated configurations for key management. */
  getKeys?: Maybe<ListKeysResponse>;
  /** Retrieve all cryptographic keys associated with a specific product ID. Returns key details including type, status, and usage. */
  getKeysByProductId?: Maybe<Array<KeyResponse>>;
  /** Get a ledger by id using the V2 Ledger endpoints. */
  getLedger?: Maybe<LedgerV2>;
  /** Get a ledger by id */
  getLedgerById?: Maybe<Ledger>;
  /** Get ledger offset positions for specific timeframe */
  getLedgerOffsetPosition?: Maybe<GetLedgerOffsetPositionResponse>;
  /** Get organisations by email domain. Unauthenticated: used for IDP discovery prior to login. */
  getOrganisationsByEmailDomain?: Maybe<Array<OrganisationEmailDomainResponse>>;
  /** Retrieve parameters required for importing cryptographic keys. Returns format specifications and validation requirements. */
  getParametersForImport?: Maybe<ImportParametersResponse>;
  /** Retrieve an ACH payment instruction by its unique identifier. */
  getPaymentInstruction?: Maybe<AchPaymentInstructionResponse>;
  /** List all products configured in the system. Returns product details including features, limits, and associated configurations. */
  getProducts?: Maybe<ListProductsResponse>;
  /** Retrieve all products associated with a specific cryptographic key. Returns product configurations linked to the key. */
  getProductsByKey?: Maybe<Array<ProductResponse>>;
  /** Get trust chain details for a certificate authority type. */
  getTrustChain?: Maybe<TrustChainResponse>;
  /** Get detailed information about a specific webhook. Returns configuration, event subscriptions, delivery history, and status. */
  getWebhookDetails?: Maybe<WebhookDetailsResponse>;
  /** Retrieve details about a specific service group by ID. Returns group configuration and associated services. */
  group?: Maybe<GroupResponse>;
  /** List all permissions assigned to a specific group. Returns effective permissions and inheritance details. */
  groupPermissions?: Maybe<GroupPermissionsResponse>;
  /** List all users within a specific group. Returns user profiles and their roles within the group context. */
  groupUsers?: Maybe<UserListResponse>;
  /** Get list of card control groups. Returns configured control groups with their rules, restrictions, and member cards. */
  groups?: Maybe<Array<GroupsResponse>>;
  /** Perform health checks across all backend services. Returns service statuses, response times, and dependency availability. */
  healthcheck?: Maybe<HealthcheckResponse>;
  /** Create/Fetch hmac secret - Secret Manager */
  hmacSecret?: Maybe<HmacSecretResponse>;
  /** Rotate a secret in Secret Manger */
  hmacSecretRotate?: Maybe<HmacSecretResponse>;
  /** Retrieve configuration for a specific identity provider. Returns SSO settings, metadata, and user attribute mappings. */
  identityProvider?: Maybe<IdentityProvider>;
  /** Retrieve SAML configuration data */
  identityProviderSamlConfigurationData?: Maybe<IdentityProviderSamlConfigData>;
  /** List all configured identity providers (IdPs). Returns SSO configurations, SAML/OIDC settings, and attribute mappings. */
  identityProviders?: Maybe<ListIdentityProvidersResponse>;
  /** Retrieve detailed information about a specific instrument product by ID. Returns complete product configuration and associated rules. */
  instrumentProduct?: Maybe<InstrumentProduct>;
  /** List all instrument products (card products). Returns product configurations including card design, features, and limits. */
  instrumentProductList?: Maybe<Array<InstrumentProduct>>;
  /** Get policies for an instrument product via conductor workflow. Returns resolved policy configurations for the product. */
  instrumentProductPolicies?: Maybe<Array<PolicyConfiguration>>;
  /**
   * Retrieve the latest AWS AppConfig deployment status.
   *
   *             Returns the current deployment state which can be:
   *             - BAKING: Configuration is being validated
   *             - VALIDATING: Configuration validation in progress
   *             - DEPLOYING: Configuration is being deployed
   *             - COMPLETE: Deployment finished successfully
   *             - ROLLED_BACK: Deployment was rolled back due to errors
   *
   *             Includes deployment number, timestamp, and configuration version.
   */
  latestAppconfigDeploymentStatus?: Maybe<DeploymentStatusResponse>;
  /** List all ledger configurations. Returns ledger settings including currency, auto-create options, and load limits. */
  ledgerConfigurationList?: Maybe<Array<LedgerConfig>>;
  /** List all ledgers based on account id */
  ledgerList?: Maybe<ListLedgersResponse>;
  /** Retrieve a specific ledger balance by ID from the playground environment. Returns test balance data for development purposes. */
  ledgerPlaygroundBalance?: Maybe<LedgerPlaygroundBalance>;
  /** List all ledger balances in the playground environment. Returns test ledger data for development and demonstration purposes. */
  ledgerPlaygroundBalanceList?: Maybe<Array<LedgerPlaygroundBalance>>;
  /** Retrieve a specific ledger transaction by ID from the playground environment. Returns test transaction details. */
  ledgerPlaygroundTransaction?: Maybe<LedgerPlaygroundTransaction>;
  /** List all ledger transactions for a specific session ID in the playground environment. Returns test transaction history. */
  ledgerPlaygroundTransactionList?: Maybe<Array<LedgerPlaygroundTransaction>>;
  /** List all ledgers based on account id using the V2 Ledger endpoints. */
  ledgers?: Maybe<Array<LedgerV2>>;
  /** List account holders with pagination and filtering. Supports searching by name, email, status, and other attributes. */
  listAccountHolders?: Maybe<ListAccountHoldersResponse>;
  /** List accounts with pagination and filtering. Supports searching by account holder, status, product type, and balance ranges. */
  listAccounts?: Maybe<Array<AccountV2>>;
  /** List addresses with pagination and filtering. */
  listAddresses?: Maybe<ListAddressesResponse>;
  /** List addresses with pagination and filtering using the V2 Address endpoints. */
  listAddressesV2?: Maybe<ListAddressesResponseV2>;
  /** List all application certificates. Returns a list of all application certificate metadata. */
  listApplicationCertificates?: Maybe<ListApplicationCertificatesResponse>;
  /** Get Applications. */
  listApplications?: Maybe<ListApplicationsResponse>;
  /** List all clients with optional filtering. Supports search criteria for finding specific clients based on various attributes. */
  listClients?: Maybe<Array<Client>>;
  /** List all BIN ranges managed by the Key Management Service. Returns BIN allocations and their cryptographic key associations. */
  listKmsBinRanges?: Maybe<ListKmsBinRangesResponse>;
  /** List all organisations in the system. Returns organisation details including settings, users, and configured features. */
  listOrganisations?: Maybe<ListOrganisationsResponse>;
  /** List ACH payment instructions with optional filtering by file name, payment flow type, or status. */
  listPaymentInstructions?: Maybe<Array<AchPaymentInstructionResponse>>;
  /** List transactions with pagination and filtering. */
  listTransactions?: Maybe<ListTransactionsResponse>;
  /** List event subscriptions for a webhook. Returns all events the webhook is currently subscribed to. */
  listWebhookSubscriptions?: Maybe<ListSubscriptionsResponse>;
  /** List all configured webhooks. Returns webhook endpoints, event subscriptions, and delivery status. */
  listWebhooks?: Maybe<ListWebhooksResponse>;
  /** Get list of load sources for funding cards. Returns available methods for loading funds onto cards (bank transfer, cash, etc.). */
  loadSourceList?: Maybe<GetLoadSourceResponse>;
  /** Get list of merchant category codes (MCCs) configured for a card. Returns MCC restrictions and controls for the card. */
  mccList?: Maybe<GetCardMccResponse>;
  /** List all merchant category codes (MCCs). Returns classification codes used to categorize businesses for transaction processing. */
  merchantCategoryCodeList?: Maybe<Array<MerchantCategoryCode>>;
  /** Retrieve details about a specific OAuth client. Returns client configuration, scopes, and authentication settings. */
  oauthClient?: Maybe<GetOauthClientResponse>;
  /** List all OAuth clients configured for the organisation. Returns client IDs, redirect URIs, and granted scopes. */
  oauthClients?: Maybe<ListOAuthClientsResponse>;
  /** List all offset ledgers. Returns offset ledgers details including currency, ledger type, and linked Customer Account offset ledger ID. */
  offsetLedgerList?: Maybe<Array<OffsetLedger>>;
  /** Retrieve detailed information about a specific organisation by ID. Returns complete organisation configuration and metadata. */
  organisation?: Maybe<Organisation>;
  /** Retrieve organisation details by URL slug. Returns organisation configuration using the human-readable identifier. */
  organisationBySlug?: Maybe<Organisation>;
  /** Retrieve details about a specific user group by ID. Returns group configuration, members, and permission assignments. */
  organisationGroup?: Maybe<OrganisationGroup>;
  /** List all user groups within an organisation. Returns group configurations, members, and associated permissions. */
  organisationGroups?: Maybe<ListOrganisationGroupsResponse>;
  /** List all users within an organisation. Returns user profiles, roles, and access permissions for the organisation. */
  organisationUsers?: Maybe<UserListResponse>;
  /** Get tokenized PAN (primary account number) for a card. Returns secure token representation of the card number for API integrations. */
  panToken?: Maybe<PanResponse>;
  /** Retrieve configuration details for a specific payment network by ID. Returns network settings, routing rules, and connection parameters. */
  paymentNetworkConfig?: Maybe<PaymentNetworkConfigResponse>;
  /** List all payment network configurations. Returns network settings, supported card types, and processing capabilities for each network. */
  paymentNetworkConfigList?: Maybe<Array<PaymentNetworkConfigResponse>>;
  /** Get payment token usage group details. Returns configuration for how digital wallet tokens can be used including transaction limits and merchant restrictions. */
  paymentTokenUsageGroupDetails?: Maybe<GetPaymentTokenUsageGroupDetailsResponse>;
  /** Get payment token usage rules for digital wallets. Returns rule groups controlling how provisioned tokens can be used for transactions. */
  paymentTokenUsageRules?: Maybe<PaymentTokenUsageRuleGroupResponse>;
  /** Retrieve details about a specific permission by ID. Returns permission scope, resources, and grant configurations. */
  permission?: Maybe<Permission>;
  /** List all available permissions in the system. Returns permission definitions, scopes, and resource access controls. */
  permissions?: Maybe<ListPermissionsResponse>;
  /** Test webhook endpoint connectivity. Sends a test ping to verify webhook configuration and reachability. */
  pingWebhook?: Maybe<GetPingWebhook>;
  /** Retrieve details about a specific policy group. Returns configured rules, limits, and restrictions for transaction processing. */
  policyGroup?: Maybe<PolicyGroup>;
  /** List all policy groups. Returns collections of business rules and policies for transaction authorization and processing. */
  policyGroupList?: Maybe<Array<PolicyGroup>>;
  /** Retrieve a specific policy. Returns configured rules, limits, and restrictions for transaction processing. */
  policyV2?: Maybe<PolicyV2>;
  /** List all policies. Returns collections of business rules for transaction authorization and processing. */
  policyV2List?: Maybe<Array<PolicyV2>>;
  /** List portal transactions with enhanced filtering and pagination. Returns comprehensive transaction data with additional portal-specific fields and search capabilities. */
  portalTransactions?: Maybe<PortalTransactionsCollectionSegment>;
  /** List all card products available in the programme. Returns product configurations including features, limits, and card designs. */
  products?: Maybe<Array<ProgramManagerProductBasic>>;
  /** List card history events for a public token. Returns paginated history of card actions, status changes, and updates with timestamps and user information. */
  publicTokenCardHistory?: Maybe<PublicTokenCardHistoryCollectionSegment>;
  /** List card status changes in given period. Returns paginated history of status transitions with timestamps, previous and new status, and change reasons. */
  publicTokenCardStatusHistory?: Maybe<PublicTokenCardStatusHistoryCollectionSegment>;
  /** Get card metadata change history in given time period. Returns paginated history of configuration changes, custom fields, and other metadata updates. */
  publicTokenMetaHistory?: Maybe<PublicTokenMetaHistoryCollectionSegment>;
  /** Search for cards with filters and pagination. Supports searching by card number, holder name, status, product, and other attributes. */
  searchCards?: Maybe<SearchCardsCollectionSegment>;
  /** Retrieve detailed information about a specific payment service by ID. Returns service configuration, endpoints, and capabilities. */
  service?: Maybe<ServiceResponse>;
  /** List all service groups configured in the payment integration system. Returns group hierarchies and service associations. */
  serviceGroups?: Maybe<Array<GroupResponse>>;
  /** Retrieve default sign-on parameters for a payment network. Returns authentication requirements and session configuration. */
  serviceSignOnParameters?: Maybe<NetworkSignOnParamsResponse>;
  /** List all configured payment services. Returns service details including status, endpoints, and supported operations. */
  services?: Maybe<Array<ServiceResponse>>;
  /** Get detailed information about a specific payment token. Returns token status, device details, and provisioning metadata. */
  singleCardPaymentTokenDetails?: Maybe<GetCardPaymentTokenDetailsResponse>;
  /**
   * Retrieve a specific feature flag by its unique name.
   *
   *         Args:
   *             flag_name: The unique identifier of the feature flag
   *
   *         Returns flag details including:
   *         - enabled: Boolean flag state
   *         - value: The flag's current value (e.g., 'enabled', 'disabled', 'shadow', or custom values)
   *         - reason: Evaluation reason (e.g., 'flag_enabled', 'targeting_rule_matched', 'percentage_rollout')
   *         - percentage: Rollout percentage if applicable
   *         - metadata: Owner, description, JIRA ticket, and rollout plan
   *
   *         Throws NotFoundError if the flag doesn't exist.
   */
  singleFeatureFlags?: Maybe<SingleFlagData>;
  /** Retrieve detailed information about a specific transaction by ID. Returns complete transaction data including amounts, status, and merchant details. */
  singleTransaction?: Maybe<GetSingleTransactionResponse>;
  /** Retrieve detailed information about a specific system channel by ID. Returns complete system channel configuration. */
  systemChannel?: Maybe<SystemChannel>;
  /** List all system channels. Returns all system channel configurations. */
  systemChannelList?: Maybe<Array<SystemChannel>>;
  /** Get token cache statistics. Development and debugging tool for monitoring cached authentication tokens. */
  tokenCacheStats?: Maybe<TokenCacheStats>;
  /** Retrieve detailed information about a specific transaction by ID. Returns amount, status, merchant details, and authorization data. */
  transaction?: Maybe<Transaction>;
  /** Retrieve details about a specific transaction reason code. Returns code description, category, and processing rules. */
  transactionReasonCode?: Maybe<TransactionReasonCode>;
  /** List all transaction reason codes. Returns codes used for categorizing and explaining transaction outcomes and failures. */
  transactionReasonCodeList?: Maybe<Array<TransactionReasonCode>>;
  /** List transactions with pagination and filtering. Returns transaction history with amounts, merchants, dates, and authorization details. */
  transactions?: Maybe<TransactionsCollectionSegment>;
  /** Retrieve detailed information for multiple transactions. Returns comprehensive transaction data including authorization codes and processing details. */
  transactionsDetails?: Maybe<Array<TransactionDetailResponse>>;
  /** Retrieve undelivered notifications for a webhook. Returns count and IDs of notifications that failed delivery, grouped by event code. */
  undeliveredNotifications?: Maybe<UndeliveredNotificationsResponse>;
  /** Get list of usage group details for card controls. Returns configured usage groups with their rules and restrictions. */
  usageGroupListDetails?: Maybe<GetUsageGroupListDetailsResponse>;
  /** Retrieve detailed information about a specific user. Returns user profile, roles, permissions, and organisation associations. */
  user?: Maybe<User>;
  /** Retrieve detailed information about a specific client by ID. Returns client configuration, associated products, and settings. */
  viewClient?: Maybe<Client>;
  /** Get wallet details for a card by public token. Returns available balances across multiple currencies and wallet configurations. */
  walletDetails?: Maybe<GetWalletResponse>;
  /** Get available webhook event types. Returns list of events that can be subscribed to for webhook notifications. */
  webhookEvents?: Maybe<WebhookEventsResponse>;
  /** List all workflow definitions available in the Conductor orchestration engine. Returns workflow names, versions, and descriptions. */
  workflowsNames?: Maybe<WorkflowsNamesResponse>;
};


export type Query_DsCredentialsListArgs = {
  publicToken: Scalars['String']['input'];
};


export type Query_DsVersionAndSupplierArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryAccountArgs = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type QueryAccountHolderArgs = {
  accountHolderId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type QueryAccountHolderWorkflowArgs = {
  accountHolderId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type QueryAccountsArgs = {
  clientId: Scalars['String']['input'];
  input: ListAccountsInput;
};


export type QueryAddressArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryAddressV2Args = {
  addressId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type QueryAllFeatureFlagsArgs = {
  betaTester?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  filterFlags?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuditLogLookupsArgs = {
  field: Scalars['String']['input'];
};


export type QueryAuditLogsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBinRangeArgs = {
  id: Scalars['String']['input'];
};


export type QueryBinRangeListArgs = {
  input?: InputMaybe<BinRangeInput>;
};


export type QueryCardAcceptorAllowDisallowListArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardByPublicTokenArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardCvvStatusArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardFeesArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardGroupLimitDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardImageByPublicTokenArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardLimitDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardOnlinePinStatusArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardPaymentTokenDevicesArgs = {
  paymentTokenId: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
};


export type QueryCardPaymentTokenListArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardPosSubLimitsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardSpendLimitDetailsByProductArgs = {
  input: GetCardSpendLimitDetailsByProductInput;
};


export type QueryCardStatusArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardsAcceptorListArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryCardsDisallowListArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryChannelArgs = {
  id: Scalars['String']['input'];
};


export type QueryChannelListArgs = {
  input?: InputMaybe<ChannelInput>;
};


export type QueryCompaniesArgs = {
  clientId: Scalars['String']['input'];
  input?: InputMaybe<ListCompaniesInput>;
};


export type QueryCompanyArgs = {
  clientId: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};


export type QueryCountryCurrencyCodeListArgs = {
  input?: InputMaybe<CountryCurrencyCodeInput>;
};


export type QueryCurrencyByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryCurrencyByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCurrencyConversionRatesArgs = {
  input: CurConRateInput;
};


export type QueryCustomerWorkflowArgs = {
  clientId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};


export type QueryDecodeDe055Args = {
  iccData: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
};


export type QueryDecodeDe055ForPresentmentArgs = {
  iccData: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
};


export type QueryDecodingCvrArgs = {
  cvrData: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
};


export type QueryDecodingDe022Args = {
  de022?: InputMaybe<Scalars['String']['input']>;
  mtid?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['Int']['input'];
  transactionTypeDescription: Scalars['String']['input'];
};


export type QueryDecodingDe025Args = {
  input: Scalars['String']['input'];
};


export type QueryDecodingDe048Args = {
  de048: Scalars['String']['input'];
  mtid?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  transactionType: Scalars['String']['input'];
};


export type QueryDecodingDe061Args = {
  input: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
};


export type QueryDecodingDe063Args = {
  input: Scalars['String']['input'];
};


export type QueryDecodingDe60Args = {
  input: Scalars['String']['input'];
};


export type QueryDecodingOrangeFlowArgs = {
  input: Scalars['String']['input'];
};


export type QueryDecodingPds0043Args = {
  input: Scalars['String']['input'];
};


export type QueryDecodingPds0146Args = {
  input: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
};


export type QueryDecodingPds0158Args = {
  input: Scalars['String']['input'];
};


export type QueryDecodingPds0159Args = {
  input: Scalars['String']['input'];
};


export type QueryEhiAcknowledgementArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryFinancialProductArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryFinancialProductListArgs = {
  input?: InputMaybe<FinancialProductInput>;
};


export type QueryGetAccountArgs = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type QueryGetApplicationArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetApplicationCertificatePemArgs = {
  applicationId: Scalars['String']['input'];
  kid: Scalars['String']['input'];
};


export type QueryGetGroupCalendarDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryGetGroupFxDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryGetGroupLimitedNetworkDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryGetGroupLinkageDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryGetKeyByKeyIdArgs = {
  keyId: Scalars['String']['input'];
};


export type QueryGetKeysArgs = {
  checkValue?: InputMaybe<Scalars['String']['input']>;
  keyReference?: InputMaybe<Scalars['String']['input']>;
  keyType?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetKeysByProductIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetLedgerArgs = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  ledgerId: Scalars['String']['input'];
};


export type QueryGetLedgerByIdArgs = {
  clientId: Scalars['String']['input'];
  ledgerId: Scalars['String']['input'];
};


export type QueryGetLedgerOffsetPositionArgs = {
  input: GetLedgerOffsetPositionInput;
};


export type QueryGetOrganisationsByEmailDomainArgs = {
  emailDomain: Scalars['String']['input'];
};


export type QueryGetParametersForImportArgs = {
  keyMaterialType: Scalars['String']['input'];
  wrappingKeyAlgorithm: Scalars['String']['input'];
};


export type QueryGetPaymentInstructionArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetProductsArgs = {
  pageSize?: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductsByKeyArgs = {
  keyId: Scalars['String']['input'];
};


export type QueryGetTrustChainArgs = {
  caType: Scalars['String']['input'];
};


export type QueryGetWebhookDetailsArgs = {
  webhookId: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  PK: Scalars['String']['input'];
};


export type QueryGroupPermissionsArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type QueryGroupUsersArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type QueryGroupsArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryHmacSecretArgs = {
  organisationId: Scalars['String']['input'];
};


export type QueryHmacSecretRotateArgs = {
  organisationId: Scalars['String']['input'];
};


export type QueryIdentityProviderArgs = {
  idpId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type QueryIdentityProvidersArgs = {
  idpType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInstrumentProductArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryInstrumentProductListArgs = {
  input?: InputMaybe<InstrumentProductInput>;
};


export type QueryInstrumentProductPoliciesArgs = {
  id: Scalars['String']['input'];
};


export type QueryLedgerConfigurationListArgs = {
  input?: InputMaybe<LedgerConfigInput>;
};


export type QueryLedgerListArgs = {
  clientId: Scalars['String']['input'];
  input: ListLedgersInput;
};


export type QueryLedgerPlaygroundBalanceArgs = {
  clientId: Scalars['String']['input'];
  ledgerId: Scalars['String']['input'];
};


export type QueryLedgerPlaygroundBalanceListArgs = {
  clientId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type QueryLedgerPlaygroundTransactionArgs = {
  clientId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};


export type QueryLedgerPlaygroundTransactionListArgs = {
  clientId: Scalars['String']['input'];
  ledgerId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


export type QueryLedgersArgs = {
  accountId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  input: ListLedgersInputV2;
};


export type QueryListAccountHoldersArgs = {
  clientId: Scalars['String']['input'];
  input: ListAccountHoldersInput;
};


export type QueryListAccountsArgs = {
  clientId: Scalars['String']['input'];
  input: ListAccountsV2Input;
};


export type QueryListAddressesArgs = {
  clientId: Scalars['String']['input'];
  input: ListAddressesInput;
};


export type QueryListAddressesV2Args = {
  clientId: Scalars['String']['input'];
  input: ListAddressesV2Input;
};


export type QueryListApplicationCertificatesArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryListApplicationsArgs = {
  organisationId: Scalars['String']['input'];
};


export type QueryListClientsArgs = {
  input: ClientInput;
};


export type QueryListKmsBinRangesArgs = {
  input: ListKmsBinRangesInput;
};


export type QueryListOrganisationsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryListPaymentInstructionsArgs = {
  clientId: Scalars['String']['input'];
  input?: InputMaybe<ListAchPaymentInstructionsInput>;
};


export type QueryListTransactionsArgs = {
  clientId: Scalars['String']['input'];
  input: ListTransactionsInput;
};


export type QueryListWebhookSubscriptionsArgs = {
  webhookId: Scalars['String']['input'];
};


export type QueryListWebhooksArgs = {
  input?: InputMaybe<ListWebhooksInput>;
};


export type QueryLoadSourceListArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryMccListArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryMerchantCategoryCodeListArgs = {
  input?: InputMaybe<MerchantCategoryCodeInput>;
};


export type QueryOauthClientArgs = {
  clientId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type QueryOauthClientsArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  nextKey?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
};


export type QueryOffsetLedgerListArgs = {
  input?: InputMaybe<OffsetLedgerInput>;
};


export type QueryOrganisationArgs = {
  organisationId: Scalars['String']['input'];
};


export type QueryOrganisationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOrganisationGroupArgs = {
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


export type QueryOrganisationGroupsArgs = {
  limit?: Scalars['Int']['input'];
  organisationId: Scalars['String']['input'];
};


export type QueryOrganisationUsersArgs = {
  organisationId: Scalars['String']['input'];
};


export type QueryPanTokenArgs = {
  request: PanRequestInput;
};


export type QueryPaymentNetworkConfigArgs = {
  PK: Scalars['String']['input'];
};


export type QueryPaymentTokenUsageGroupDetailsArgs = {
  groupId: Scalars['Int']['input'];
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
};


export type QueryPaymentTokenUsageRulesArgs = {
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
};


export type QueryPermissionArgs = {
  permissionId: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  activeOnly?: Scalars['Boolean']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  riskLevel?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPingWebhookArgs = {
  webhookId: Scalars['String']['input'];
};


export type QueryPolicyGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryPolicyGroupListArgs = {
  input?: InputMaybe<PolicyGroupInput>;
};


export type QueryPolicyV2Args = {
  id: Scalars['String']['input'];
};


export type QueryPolicyV2ListArgs = {
  input?: InputMaybe<SearchPolicyV2Input>;
};


export type QueryPortalTransactionsArgs = {
  input: GetPortalTransactionsInput;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryPublicTokenCardHistoryArgs = {
  input: PublicTokenCardHistoryInput;
};


export type QueryPublicTokenCardStatusHistoryArgs = {
  input: CardStatusHistoryInput;
};


export type QueryPublicTokenMetaHistoryArgs = {
  input: CardMetaHistoryInput;
};


export type QuerySearchCardsArgs = {
  input: SearchCardsInput;
};


export type QueryServiceArgs = {
  PK: Scalars['String']['input'];
};


export type QueryServiceSignOnParametersArgs = {
  network: NetworkType;
};


export type QuerySingleCardPaymentTokenDetailsArgs = {
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
};


export type QuerySingleFeatureFlagsArgs = {
  flagName?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySingleTransactionArgs = {
  transactionId: Scalars['Long']['input'];
};


export type QuerySystemChannelArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransactionArgs = {
  clientId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryTransactionReasonCodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransactionReasonCodeListArgs = {
  input: TransactionReasonCodeInput;
};


export type QueryTransactionsArgs = {
  input: GetTransactionsInput;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryTransactionsDetailsArgs = {
  traceIdLifeCycle: Scalars['String']['input'];
};


export type QueryUndeliveredNotificationsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  webhookId: Scalars['String']['input'];
};


export type QueryUsageGroupListDetailsArgs = {
  publicToken: Scalars['String']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryViewClientArgs = {
  id: Scalars['String']['input'];
};


export type QueryWalletDetailsArgs = {
  publicToken: Scalars['String']['input'];
};

export type RecurringFees = {
  __typename?: 'RecurringFees';
  description?: Maybe<Scalars['String']['output']>;
  domesticFee?: Maybe<Scalars['Decimal']['output']>;
  domesticFeeRate?: Maybe<Scalars['Decimal']['output']>;
  domesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  feeAmount?: Maybe<Scalars['Decimal']['output']>;
  feeEndDate?: Maybe<Scalars['String']['output']>;
  feeGroupCode: Scalars['String']['output'];
  feeStartDate?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  frequencyPeriod?: Maybe<Scalars['String']['output']>;
  lowActivityAmount?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticRate?: Maybe<Scalars['Decimal']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  partialAllowed?: Maybe<Scalars['Boolean']['output']>;
  recurringFee: Scalars['String']['output'];
  repeat?: Maybe<Scalars['Int']['output']>;
  repeatPeriod?: Maybe<Scalars['String']['output']>;
};

export type Regions = {
  __typename?: 'Regions';
  defaultRegion: Scalars['Boolean']['output'];
  regionDescription: Scalars['String']['output'];
  regionId: Scalars['Int']['output'];
  regionName: Scalars['String']['output'];
};

/** Represents the rejection handling approach. Possibilities defined are rejecting the transaction and reporting it or rejecting the transaction and add it to the reject suspense account for a client work. */
export enum RejectionRule {
  RejectAndReport = 'REJECT_AND_REPORT',
  RejectAndSuspend = 'REJECT_AND_SUSPEND'
}

export type ResendNotificationItem = {
  __typename?: 'ResendNotificationItem';
  notificationId?: Maybe<Scalars['String']['output']>;
  resendStatus?: Maybe<Scalars['String']['output']>;
};

export type ResendNotificationsInnerResponse = {
  __typename?: 'ResendNotificationsInnerResponse';
  content?: Maybe<Array<ResendNotificationItem>>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type ResendNotificationsInput = {
  notificationIds: Array<Scalars['String']['input']>;
};

export type ResendNotificationsResponse = {
  __typename?: 'ResendNotificationsResponse';
  response?: Maybe<ResendNotificationsInnerResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RevokeCertificateInput = {
  revocationReason?: InputMaybe<Scalars['String']['input']>;
};

export type RotateSecretResponse = {
  __typename?: 'RotateSecretResponse';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  lastSecretRotation: Scalars['String']['output'];
};

export type Rule = {
  /** List of conditions that ALL must match (AND logic) */
  conditions: Array<Condition>;
  /** Unique rule identifier for debugging */
  id: Scalars['String']['input'];
  /** Value to return when this rule matches */
  value: Scalars['String']['input'];
};

export type SamlConfig = {
  __typename?: 'SamlConfig';
  entityId?: Maybe<Scalars['String']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  metadataXml?: Maybe<Scalars['String']['output']>;
  nameIdFormat?: Maybe<Scalars['String']['output']>;
  signRequest?: Maybe<Scalars['Boolean']['output']>;
  sloUrl?: Maybe<Scalars['String']['output']>;
  ssoUrl?: Maybe<Scalars['String']['output']>;
  wantAssertionsSigned?: Maybe<Scalars['Boolean']['output']>;
  wantResponseSigned?: Maybe<Scalars['Boolean']['output']>;
  x509Certificate?: Maybe<Scalars['String']['output']>;
};

export type SaveUserPmPreferenceInput = {
  organisationId: Scalars['String']['input'];
  pmcode: Scalars['String']['input'];
  pmid: Scalars['Int']['input'];
};

export type SearchCardHistoryInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  fromDateTime: Scalars['DateTime']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  publicToken: Scalars['String']['input'];
  toDateTime: Scalars['DateTime']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type SearchCardsCollectionSegment = {
  __typename?: 'SearchCardsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CardsResponse>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  /** total number of entries found */
  totalCount: Scalars['Int']['output'];
};

export type SearchCardsInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  cardStatusCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  customerReference?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  publicToken?: InputMaybe<Scalars['Long']['input']>;
};

export type SearchPolicyV2Input = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentInput = {
  endPosition?: InputMaybe<Scalars['Int']['input']>;
  generationOption?: InputMaybe<GenerationOption>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  startPosition?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SelfSelectPinInput = {
  expiryPeriodAction: ExpiryPeriodAction;
  newInstrument: SelfSelectRule;
  replaceInstrumentNewPan: SelfSelectRule;
  replaceInstrumentSamePan: SelfSelectRule;
  replaceVirtualWithPhysical: SelfSelectRule;
  waitForSspHours: Scalars['Int']['input'];
};

export enum SelfSelectRule {
  Always = 'ALWAYS',
  NotSupported = 'NOT_SUPPORTED',
  Optional = 'OPTIONAL',
  Unspecified = 'UNSPECIFIED'
}

export type ServiceHealthCheck = {
  __typename?: 'ServiceHealthCheck';
  checkType: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ServiceResponse = {
  __typename?: 'ServiceResponse';
  authorisor: AuthorisorType;
  client: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  discoverSignOnParams?: Maybe<DiscoverSignOnParams>;
  groupAssigned?: Maybe<GroupResponse>;
  isUpdating?: Maybe<Scalars['Boolean']['output']>;
  maintenanceMode: Scalars['Boolean']['output'];
  mastercardSignOnParams?: Maybe<MastercardSignOnParams>;
  mneSignOnParams?: Maybe<MneSignOnParams>;
  name: Scalars['String']['output'];
  network: NetworkType;
  networkConfig: Scalars['String']['output'];
  networkConfigName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pk: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  sessions: Scalars['Int']['output'];
  tasks: Array<Task>;
  updatedAt: Scalars['String']['output'];
  visaSignOnParams?: Maybe<VisaSignOnParams>;
};

export enum Sign {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  SignUnspecified = 'SIGN_UNSPECIFIED'
}

export type SingleFlagData = {
  __typename?: 'SingleFlagData';
  flagData: FlagData;
};

export type SpendLimitInput = {
  dailyLimit?: InputMaybe<LimitPropertyInput>;
  monthlyLimit?: InputMaybe<LimitPropertyInput>;
  singlePurchase?: InputMaybe<LimitPropertyInput>;
  weeklyLimit?: InputMaybe<LimitPropertyInput>;
};

export type SplitKmsBinRangeInput = {
  binRange: KmsBinRangeInput;
  keepProductId: Scalars['Boolean']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  splitPoint: Scalars['String']['input'];
};

export type SplitKmsBinRangeResponse = {
  __typename?: 'SplitKmsBinRangeResponse';
  binRanges?: Maybe<Array<KmsBinRangeResponse>>;
};

export enum Status {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Disputed = 'DISPUTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Posted = 'POSTED',
  PostedPartially = 'POSTED_PARTIALLY',
  Rejected = 'REJECTED',
  Reversed = 'REVERSED',
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

export type StatusResponse = {
  __typename?: 'StatusResponse';
  cardStatusCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  status: CardStatusCode;
  updated: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type Subcategories = {
  __typename?: 'Subcategories';
  counters?: Maybe<Counters>;
  limits?: Maybe<ProductLimits>;
  subcategory?: Maybe<Scalars['String']['output']>;
};

export type SupplierAndVersionResponse = {
  __typename?: 'SupplierAndVersionResponse';
  providerName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SystemChannel = {
  __typename?: 'SystemChannel';
  /** The datetime of when the SystemChannel was created. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who created the SystemChannel. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The database generated UUID string which uniquely identifies the system channel. */
  id?: Maybe<Scalars['String']['output']>;
  /** A simple name field for SystemChannel. Unique constraint in place. */
  name?: Maybe<Scalars['String']['output']>;
  /** How transaction rejections are handled. */
  rejectionRule?: Maybe<RejectionRule>;
  /** Represents the origin of the SystemChannel. */
  sourceType?: Maybe<SystemChannelSourceType>;
  /** A brief description used in the transaction posting, if there is no description associated with the transaction. */
  transactionDescriptionText?: Maybe<Scalars['String']['output']>;
  /** The datetime of when the SystemChannel was last updated. */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** The identifier of the user who last updated the SystemChannel. */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SystemChannelInput = {
  /** A simple name field for SystemChannel. Unique constraint in place. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** How transaction rejections are handled. */
  rejectionRule?: InputMaybe<RejectionRule>;
  /** Represents the origin of the SystemChannel. */
  sourceType?: InputMaybe<SystemChannelSourceType>;
  /** A brief description used in the transaction posting. */
  transactionDescriptionText?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the origin of the System Channel. */
export enum SystemChannelSourceType {
  System = 'SYSTEM'
}

/** Represents the Transaction Type for a Transaction Reason Code. */
export enum TrcTransactionType {
  BalanceAdjustment = 'BALANCE_ADJUSTMENT',
  Fee = 'FEE',
  Load = 'LOAD',
  Purchase = 'PURCHASE'
}

export type Task = {
  __typename?: 'Task';
  buildNumber?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  hostIp?: Maybe<Scalars['String']['output']>;
  isUpdating?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  taskId: Scalars['String']['output'];
  taskMaintenanceMode: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  uptime: Scalars['String']['output'];
};

/** Is an object representation of a precise time. A time representation in seconds and nanos is provided in the relevant fields. */
export type TimestampInput = {
  nanos: Scalars['Int']['input'];
  seconds: Scalars['Int']['input'];
};

export type TokenCacheStats = {
  __typename?: 'TokenCacheStats';
  /** Number of cached exchanged tokens */
  exchangedTokens: Scalars['Int']['output'];
  /** Number of cached subject tokens */
  subjectTokens: Scalars['Int']['output'];
};

export type TokenisationStatus = {
  __typename?: 'TokenisationStatus';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type TransStatus = {
  __typename?: 'TransStatus';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  accountId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<CapAsset>;
  authorisationCode?: Maybe<Scalars['String']['output']>;
  billingAmount?: Maybe<CapAsset>;
  cashbackAmount?: Maybe<CapAsset>;
  channelType?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ledgerId?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Scalars['String']['output']>;
  merchantLocation?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  originalChannelType?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['String']['output']>;
  processingChannel?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  settlementAmount?: Maybe<CapAsset>;
  sign?: Maybe<Sign>;
  status?: Maybe<Status>;
  subClientId?: Maybe<Scalars['String']['output']>;
  transactionAmount?: Maybe<CapAsset>;
  transactionReason?: Maybe<Scalars['String']['output']>;
  transactionSubtype?: Maybe<TransactionSubType>;
  transactionType?: Maybe<TransactionTypeEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  valueDate?: Maybe<Scalars['String']['output']>;
};

export type TransactionAmount = {
  __typename?: 'TransactionAmount';
  actualBalance?: Maybe<Scalars['Decimal']['output']>;
  availableBalance?: Maybe<Scalars['Decimal']['output']>;
  billingCurrency?: Maybe<Scalars['String']['output']>;
  billingCurrencyNumericCode?: Maybe<Scalars['String']['output']>;
  billingValue: Scalars['Decimal']['output'];
  billingValueWithDirection?: Maybe<Scalars['Decimal']['output']>;
  blockedAmount?: Maybe<Scalars['Decimal']['output']>;
  settlementAmount?: Maybe<Scalars['Decimal']['output']>;
  settlementCurrency?: Maybe<Scalars['String']['output']>;
  transactionCurrency?: Maybe<Scalars['String']['output']>;
  transactionValue: Scalars['Decimal']['output'];
};

export enum TransactionAuthorisationMethod {
  Chip = 'CHIP',
  MagStrip = 'MAG_STRIP'
}

export type TransactionDetailResponse = {
  __typename?: 'TransactionDetailResponse';
  acquirerReferenceData: Scalars['String']['output'];
  additionalAmounts: Scalars['String']['output'];
  additionalData: Scalars['String']['output'];
  additionalResponseData: Scalars['String']['output'];
  adviceReasonData: Scalars['String']['output'];
  aid: Scalars['String']['output'];
  authorisationCode: Scalars['String']['output'];
  availableBalance: Scalars['Decimal']['output'];
  avsPostcode: Scalars['String']['output'];
  avsStreet: Scalars['String']['output'];
  billingAmount: Scalars['Decimal']['output'];
  billingCurrency: Scalars['String']['output'];
  blockedAmount: Scalars['Decimal']['output'];
  cardAcceptorIdentificationCode: Scalars['String']['output'];
  cardAcceptorNameLocation: Scalars['String']['output'];
  cardAcceptorTerminalIdentification: Scalars['String']['output'];
  dateExpiry: Scalars['String']['output'];
  fees: Scalars['Decimal']['output'];
  fid: Scalars['String']['output'];
  gpsPosData: Scalars['String']['output'];
  iccData: Scalars['String']['output'];
  merchant?: Maybe<Merchant>;
  merchantCategoryCode: Scalars['String']['output'];
  messageType: Scalars['String']['output'];
  networkData: Scalars['String']['output'];
  note: Scalars['String']['output'];
  paymentTokenId?: Maybe<Scalars['Int']['output']>;
  posData: Scalars['String']['output'];
  posEntryMode: Scalars['String']['output'];
  processingCode: Scalars['Long']['output'];
  pubToken: Scalars['String']['output'];
  recordId: Scalars['Long']['output'];
  responseStatus: Scalars['String']['output'];
  retrievalReference: Scalars['String']['output'];
  settlementAmount: Scalars['Decimal']['output'];
  settlementCurrency: Scalars['String']['output'];
  stan: Scalars['String']['output'];
  tillTime: Scalars['Long']['output'];
  traceIdLifeCycle: Scalars['String']['output'];
  transactionAmount: Scalars['Decimal']['output'];
  transactionCurrency: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionFees?: Maybe<TransactionFeesResponse>;
  transactionId: Scalars['Long']['output'];
  transactionOriginatingInstitution: Scalars['String']['output'];
  transactionStatus: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
};

export type TransactionFees = {
  __typename?: 'TransactionFees';
  fixedFee: Scalars['Decimal']['output'];
  fxPadding: Scalars['Decimal']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  mccPadding: Scalars['Decimal']['output'];
  rateFee: Scalars['Decimal']['output'];
};

export type TransactionFeesResponse = {
  __typename?: 'TransactionFeesResponse';
  domesticFixedFee: Scalars['Decimal']['output'];
  domesticRateFee: Scalars['Decimal']['output'];
  fxFixedFee: Scalars['Decimal']['output'];
  fxRateFee: Scalars['Decimal']['output'];
  nonDomesticFixedFee: Scalars['Decimal']['output'];
  nonDomesticRateFee: Scalars['Decimal']['output'];
};

export type TransactionReasonCode = {
  __typename?: 'TransactionReasonCode';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<TrcTransactionType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TransactionReasonCodeInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  /** The Transaction Type associated with the Transaction Reason Code. */
  transactionType?: InputMaybe<TrcTransactionType>;
};

export type TransactionResponse = {
  __typename?: 'TransactionResponse';
  amount: Scalars['Decimal']['output'];
  currencyCode: Scalars['String']['output'];
  publicToken: Scalars['String']['output'];
  transactionId: Scalars['Long']['output'];
  transactionType: Scalars['String']['output'];
};

export type TransactionStatus = {
  __typename?: 'TransactionStatus';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum TransactionSubType {
  Authorisation = 'AUTHORISATION',
  AuthAdvice = 'AUTH_ADVICE',
  AuthAndCapture = 'AUTH_AND_CAPTURE',
  AuthDecrement = 'AUTH_DECREMENT',
  AuthExpired = 'AUTH_EXPIRED',
  AuthIncrement = 'AUTH_INCREMENT',
  AuthRelease = 'AUTH_RELEASE',
  Dispute = 'DISPUTE',
  ErrorReturned = 'ERROR_RETURNED',
  InquiryResponded = 'INQUIRY_RESPONDED',
  PinUpdated = 'PIN_UPDATED',
  Presentment = 'PRESENTMENT',
  PresentmentPartial = 'PRESENTMENT_PARTIAL',
  Representment = 'REPRESENTMENT',
  Reversal = 'REVERSAL',
  SubtypeUnspecified = 'SUBTYPE_UNSPECIFIED'
}

export type TransactionType = {
  __typename?: 'TransactionType';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum TransactionTypeBtp {
  Cash = 'CASH',
  Purchase = 'PURCHASE'
}

export enum TransactionTypeEnum {
  AccountInquiry = 'ACCOUNT_INQUIRY',
  Adjustment = 'ADJUSTMENT',
  BalanceInquiry = 'BALANCE_INQUIRY',
  Cash = 'CASH',
  Fee = 'FEE',
  Funding = 'FUNDING',
  Payment = 'PAYMENT',
  PinChange = 'PIN_CHANGE',
  PinUnblock = 'PIN_UNBLOCK',
  Spend = 'SPEND',
  Transfer = 'TRANSFER',
  TypeUnspecified = 'TYPE_UNSPECIFIED'
}

export type TransactionTypes = {
  __typename?: 'TransactionTypes';
  defaultTicked?: Maybe<Scalars['Boolean']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  variableDescription?: Maybe<Scalars['String']['output']>;
  variableType?: Maybe<Scalars['String']['output']>;
  variableTypeCode?: Maybe<Scalars['String']['output']>;
};

export enum TransactionWorkflowSign {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** A segment of a collection. */
export type TransactionsCollectionSegment = {
  __typename?: 'TransactionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GetTransactionsResponse>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  /** the number of total items availabe */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TransactionsRequestInput = {
  amount: Scalars['Decimal']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  toPublicToken?: InputMaybe<Scalars['String']['input']>;
  transactionType: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export enum TransactionsSortByField {
  Amount = 'AMOUNT',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Location = 'LOCATION',
  Type = 'TYPE'
}

export type TrustChain = {
  __typename?: 'TrustChain';
  caArn?: Maybe<Scalars['String']['output']>;
  certificate?: Maybe<Scalars['String']['output']>;
  certificateChain?: Maybe<Scalars['String']['output']>;
  notAfter?: Maybe<Scalars['String']['output']>;
  notBefore?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TrustChainResponse = {
  __typename?: 'TrustChainResponse';
  downloadUrl: Scalars['String']['output'];
  trustChain: TrustChain;
};

export type TypeValue = {
  __typename?: 'TypeValue';
  decodedData?: Maybe<Scalars['String']['output']>;
  decodedDataString?: Maybe<Scalars['String']['output']>;
  encodedData?: Maybe<Scalars['String']['output']>;
};

export type UnblockCardInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  retrievalReference?: InputMaybe<Scalars['String']['input']>;
  stan?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UndeliveredNotificationItem = {
  __typename?: 'UndeliveredNotificationItem';
  count?: Maybe<Scalars['Int']['output']>;
  eventCode?: Maybe<Scalars['Int']['output']>;
  notificationIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UndeliveredNotificationsInnerResponse = {
  __typename?: 'UndeliveredNotificationsInnerResponse';
  content?: Maybe<Array<UndeliveredNotificationItem>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type UndeliveredNotificationsResponse = {
  __typename?: 'UndeliveredNotificationsResponse';
  response?: Maybe<UndeliveredNotificationsInnerResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UnloadFundsInput = {
  transaction: FundsInput;
};

export type Update3DsCredentialInput = {
  CardholderAnswer?: InputMaybe<Scalars['String']['input']>;
  CredentialId?: InputMaybe<Scalars['Int']['input']>;
  UpdatedBy?: InputMaybe<Scalars['String']['input']>;
  Value?: Scalars['String']['input'];
};

export type UpdateAccountHolderInput = {
  accountHolder: AccountHolderInput;
  updateMask?: InputMaybe<FieldMaskInput>;
};

export type UpdateAccountInput = {
  account: AccountUpdateInput;
  updateMask: FieldMaskInput;
};

export type UpdateAccountWorkflowInput = {
  accountId: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type UpdateAddressInput = {
  address: AddressUpdateInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressV2Input = {
  addressId: Scalars['String']['input'];
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockedAmountInput = {
  publicToken: Scalars['String']['input'];
  updateBlockedAmountRequest: UpdateBlockedAmountRequestInput;
};

export type UpdateBlockedAmountRequestInput = {
  adjustmentType: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  currencyCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  loadedBy: Scalars['String']['input'];
};

export type UpdateCardInput = {
  cardUpdate: UpdateCardRequestInput;
  publicToken: Scalars['String']['input'];
};

export type UpdateCardRequestInput = {
  address?: InputMaybe<AddressUpdateRequestInput>;
  cardHolder?: InputMaybe<CardHolderUpdateRequestInput>;
  customerReference?: InputMaybe<Scalars['String']['input']>;
  designId?: InputMaybe<Scalars['String']['input']>;
  fulfilment?: InputMaybe<AddressUpdateRequestInput>;
  nameOnCard?: InputMaybe<Scalars['String']['input']>;
  parentCard?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  company: CompanyInput;
  updateMask?: InputMaybe<FieldMaskInput>;
};

export type UpdateControlGroupsInput = {
  controlGroups: ControlGroupsInput;
  publicToken: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrencyInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCustomerWorkflowInput = {
  clientAssignedId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<PhoneNumbersInput>;
  status?: InputMaybe<CustomerStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureFlagConfig = {
  enabled: Scalars['Boolean']['input'];
  metadata: UpdateMetadataInput;
  value: Scalars['String']['input'];
};

export type UpdateFeatureFlagRequest = {
  config: UpdateFeatureFlagConfig;
  flagName: Scalars['String']['input'];
};

export type UpdateFeatureFlagResponse = {
  __typename?: 'UpdateFeatureFlagResponse';
  deploymentId?: Maybe<Scalars['Int']['output']>;
  flagName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type UpdateGroupRequest = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateIdpInput = {
  attributeMappings?: InputMaybe<Array<AttributeMappingInput>>;
  autoCreateUsers?: InputMaybe<Scalars['Boolean']['input']>;
  defaultGroupMappings?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oidcConfig?: InputMaybe<CreateOidcConfigInput>;
  samlConfig?: InputMaybe<CreateSamlConfigInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLedgerInput = {
  ledger: LedgerUpdateInput;
  updateMask: FieldMaskInput;
};

export type UpdateLedgerInputV2 = {
  status: LedgerStatus;
};

export type UpdateMetadataInput = {
  disabledReason: Scalars['String']['input'];
};

export type UpdateOAuthClientInput = {
  allowedGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  applicationId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  ipWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  issuerId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pmId?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  usageNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganisationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrganisationInput = {
  authProvider?: InputMaybe<AuthProvider>;
  clientAuthMethod?: InputMaybe<ClientAuthMethod>;
  connection?: InputMaybe<ConnectionType>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  identityProviderConfig?: InputMaybe<Scalars['JSON']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  issuerId?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pmInformation?: InputMaybe<Array<PmInformationInput>>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subClientId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentNetworkConfigInput = {
  caCertificatePath?: InputMaybe<Scalars['String']['input']>;
  certificatePath?: InputMaybe<Scalars['String']['input']>;
  hostIps?: InputMaybe<Array<Scalars['String']['input']>>;
  maintenanceMode?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privateKeyPath?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oauthScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePolicyV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  isChangeable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateServiceRequest = {
  authorisor?: InputMaybe<AuthorisorType>;
  client?: InputMaybe<Scalars['String']['input']>;
  discoverSignOnParams?: InputMaybe<DiscoverSignOnParamsInput>;
  latestBuildNumber?: InputMaybe<Scalars['String']['input']>;
  maintenanceMode?: InputMaybe<Scalars['Boolean']['input']>;
  mastercardSignOnParams?: InputMaybe<MastercardSignOnParamsInput>;
  mneSignOnParams?: InputMaybe<MneSignOnParamsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  networkConfig?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  sessions?: InputMaybe<Scalars['Int']['input']>;
  visaSignOnParams?: InputMaybe<VisaSignOnParamsInput>;
};

export type UpdateUserInput = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  threddRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserStatusInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateWebhookRequestInput = {
  config: WebhookConfig;
  events?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  webhookStatus?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookStatusInput = {
  webhookStatus?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  invitationSent: Scalars['Boolean']['output'];
  organisationId: Scalars['String']['output'];
  organisationName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  temporaryPassword?: Maybe<Scalars['String']['output']>;
  threddRoles?: Maybe<Array<Scalars['String']['output']>>;
  userId: Scalars['String']['output'];
};

export type UserListResponse = {
  __typename?: 'UserListResponse';
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type VerificationChecks = {
  __typename?: 'VerificationChecks';
  defaultTicked?: Maybe<Scalars['Boolean']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  groupDescription?: Maybe<Scalars['String']['output']>;
  variableDescription?: Maybe<Scalars['String']['output']>;
  variableType?: Maybe<Scalars['String']['output']>;
  variableTypeCode?: Maybe<Scalars['String']['output']>;
};

export type VisaFileMaintenance = {
  __typename?: 'VisaFileMaintenance';
  requestData: VisaFileRequest;
  responseData: VisaFileResponse;
};

export type VisaFileMaintenanceInput = {
  requestFileName?: InputMaybe<Scalars['String']['input']>;
  retrievalReference?: InputMaybe<Scalars['String']['input']>;
  stan?: InputMaybe<Scalars['String']['input']>;
};

export type VisaFileMaintenanceResponse = {
  __typename?: 'VisaFileMaintenanceResponse';
  visaFileData?: Maybe<Array<VisaFileMaintenance>>;
};

export type VisaFileRequest = {
  __typename?: 'VisaFileRequest';
  fileUpdateCode?: Maybe<Scalars['String']['output']>;
  requestFileName?: Maybe<Scalars['String']['output']>;
  retrievalReferenceNumber?: Maybe<Scalars['String']['output']>;
  systemTraceAuditNumber?: Maybe<Scalars['String']['output']>;
  transmissionDateTime?: Maybe<Scalars['String']['output']>;
  updateReason?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type VisaFileResponse = {
  __typename?: 'VisaFileResponse';
  fileUpdateCode?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  responseDateTime?: Maybe<Scalars['String']['output']>;
  responseFileName?: Maybe<Scalars['String']['output']>;
  responseResult?: Maybe<Scalars['String']['output']>;
  retrievalReferenceNumber?: Maybe<Scalars['String']['output']>;
  systemTraceAuditNumber?: Maybe<Scalars['String']['output']>;
  transmissionDateTime?: Maybe<Scalars['String']['output']>;
};

export type VisaFleet = {
  __typename?: 'VisaFleet';
  evData?: Maybe<VisaFleetEvData>;
  fleetData?: Maybe<VisaFleetFleetData>;
  invoiceLineItem?: Maybe<Array<VisaFleetInvoiceLineItem>>;
  promptData?: Maybe<VisaFleetPromptData>;
};

export type VisaFleetEvData = {
  __typename?: 'VisaFleetEvData';
  carbonFootprint?: Maybe<Scalars['Int']['output']>;
  chargingPowerOutputCapacity?: Maybe<Scalars['Int']['output']>;
  chargingReasonCode?: Maybe<Scalars['String']['output']>;
  connectorType?: Maybe<Scalars['String']['output']>;
  estimatedKmMilesAdded?: Maybe<Scalars['Int']['output']>;
  estimatedKmMilesAvailable?: Maybe<Scalars['Int']['output']>;
  finishTimeOfCharge?: Maybe<Scalars['String']['output']>;
  maximumPowerDispensed?: Maybe<Scalars['Int']['output']>;
  startTimeOfCharge?: Maybe<Scalars['String']['output']>;
  totalChargingTime?: Maybe<Scalars['String']['output']>;
  totalTimePluggedIn?: Maybe<Scalars['String']['output']>;
};

export type VisaFleetFleetData = {
  __typename?: 'VisaFleetFleetData';
  expandedFuelType?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  grossFuelPrice?: Maybe<Scalars['DecimalAsFloat']['output']>;
  grossNonFuelPrice?: Maybe<Scalars['DecimalAsFloat']['output']>;
  netFuelPrice?: Maybe<Scalars['DecimalAsFloat']['output']>;
  netNonFuelPrice?: Maybe<Scalars['DecimalAsFloat']['output']>;
  nonFuelProductCode1?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode2?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode3?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode4?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode5?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode6?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode7?: Maybe<Scalars['String']['output']>;
  nonFuelProductCode8?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['DecimalAsFloat']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  typeOfPurchase?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['DecimalAsFloat']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
};

export type VisaFleetInvoiceLineItem = {
  __typename?: 'VisaFleetInvoiceLineItem';
  commodityCode?: Maybe<Scalars['String']['output']>;
  discountPerLineItem?: Maybe<Scalars['DecimalAsFloat']['output']>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  itemSequenceNumber?: Maybe<Scalars['Int']['output']>;
  lineItemTotal?: Maybe<Scalars['DecimalAsFloat']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['DecimalAsFloat']['output']>;
  transactionId?: Maybe<Scalars['Long']['output']>;
  unitCost?: Maybe<Scalars['DecimalAsFloat']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['DecimalAsFloat']['output']>;
  vatTaxAmount?: Maybe<Scalars['DecimalAsFloat']['output']>;
};

export type VisaFleetPromptData = {
  __typename?: 'VisaFleetPromptData';
  fleetEmployeeNumber?: Maybe<Scalars['String']['output']>;
  fleetTrailerNumber?: Maybe<Scalars['String']['output']>;
  fleetWorkOrderNumber?: Maybe<Scalars['String']['output']>;
  odometerReading?: Maybe<Scalars['String']['output']>;
  visaFleetServiceId?: Maybe<Scalars['String']['output']>;
};

export type VisaSignOnParams = {
  __typename?: 'VisaSignOnParams';
  batchNumber: Scalars['String']['output'];
  flags: Scalars['String']['output'];
  headerFormat: Scalars['String']['output'];
  messageStatusFlags: Scalars['String']['output'];
  reserved: Scalars['String']['output'];
  roundTripControlInfo: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  textFormat: Scalars['String']['output'];
};

export type VisaSignOnParamsInput = {
  batchNumber: Scalars['String']['input'];
  flags: Scalars['String']['input'];
  headerFormat: Scalars['String']['input'];
  messageStatusFlags: Scalars['String']['input'];
  reserved: Scalars['String']['input'];
  roundTripControlInfo: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  textFormat: Scalars['String']['input'];
};

export type WalletDetails = {
  __typename?: 'WalletDetails';
  balanceDetails?: Maybe<BalanceResponse>;
  isMfxPrimary?: Maybe<Scalars['Boolean']['output']>;
  publicToken?: Maybe<Scalars['String']['output']>;
};

export type WebServiceGroupFees = {
  __typename?: 'WebServiceGroupFees';
  description: Scalars['String']['output'];
  domesticFee?: Maybe<Scalars['Decimal']['output']>;
  domesticFeeRate?: Maybe<Scalars['Decimal']['output']>;
  domesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  group: Scalars['String']['output'];
  nonDomesticFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticRate?: Maybe<Scalars['Decimal']['output']>;
  partialAllowed?: Maybe<Scalars['Boolean']['output']>;
  processingCode: Scalars['String']['output'];
  smsFee?: Maybe<Scalars['Decimal']['output']>;
};

export type WebServiceProductFees = {
  __typename?: 'WebServiceProductFees';
  description: Scalars['String']['output'];
  domesticFee?: Maybe<Scalars['Decimal']['output']>;
  domesticFeeRate?: Maybe<Scalars['Decimal']['output']>;
  domesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticMinimumFee?: Maybe<Scalars['Decimal']['output']>;
  nonDomesticRate?: Maybe<Scalars['Decimal']['output']>;
  partialAllowed?: Maybe<Scalars['Boolean']['output']>;
  product: Scalars['String']['output'];
};

export type WebhookConfig = {
  customHeaders?: InputMaybe<Array<KeyValuePairInput>>;
  url: Scalars['String']['input'];
};

export type WebhookConfigResponse = {
  __typename?: 'WebhookConfigResponse';
  customHeaders?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WebhookDetailsResponse = {
  __typename?: 'WebhookDetailsResponse';
  response?: Maybe<WebhookDtlResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type WebhookDtlResponse = {
  __typename?: 'WebhookDtlResponse';
  config?: Maybe<WebhookConfigResponse>;
  createdTime?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Scalars['Int']['output']>>;
  lastModifiedTime?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
  webhookStatus?: Maybe<Scalars['String']['output']>;
};

export type WebhookEventsResponse = {
  __typename?: 'WebhookEventsResponse';
  response?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type WebhookInnerResponse = {
  __typename?: 'WebhookInnerResponse';
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
  webhookStatus?: Maybe<Scalars['String']['output']>;
};

export type WebhookItemResponse = {
  __typename?: 'WebhookItemResponse';
  config?: Maybe<WebhookConfigResponse>;
  createdTime?: Maybe<Scalars['String']['output']>;
  customHeaders?: Maybe<Scalars['JSON']['output']>;
  events?: Maybe<Array<Scalars['Int']['output']>>;
  lastModifiedTime?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
  webhookStatus?: Maybe<Scalars['String']['output']>;
};

export type WebhookListDataResponse = {
  __typename?: 'WebhookListDataResponse';
  endpointsCount?: Maybe<Scalars['Int']['output']>;
  items: Array<WebhookItemResponse>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type WebhookRequestInput = {
  config: WebhookConfig;
  events?: InputMaybe<Array<Scalars['Int']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  webhookStatus?: InputMaybe<Scalars['String']['input']>;
};

export type WebhookResponse = {
  __typename?: 'WebhookResponse';
  response?: Maybe<WebhookInnerResponse>;
  status?: Maybe<Scalars['String']['output']>;
};

export type WeekDay = {
  __typename?: 'WeekDay';
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  weekDay?: Maybe<Scalars['String']['output']>;
};

export type WorkflowsName = {
  __typename?: 'WorkflowsName';
  workflowName: Scalars['String']['output'];
};

export type WorkflowsNamesResponse = {
  __typename?: 'WorkflowsNamesResponse';
  workflowsNames: Array<WorkflowsName>;
};

export type WsBalanceTransferResponse = {
  __typename?: 'WsBalanceTransferResponse';
  issCode?: Maybe<Scalars['String']['output']>;
  publicToken?: Maybe<Scalars['String']['output']>;
  sysDate?: Maybe<Scalars['String']['output']>;
};

export type WsLoadCardResponse = {
  __typename?: 'WsLoadCardResponse';
  actionCode?: Maybe<Scalars['String']['output']>;
  issCode?: Maybe<Scalars['String']['output']>;
  publicToken?: Maybe<Scalars['String']['output']>;
  sysDate?: Maybe<Scalars['String']['output']>;
};

export type FinancialProductListQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ProductScope>;
  category?: InputMaybe<ProductCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatus>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  subClientIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FinancialProductListQuery = { __typename?: 'Query', financialProductList?: Array<{ __typename?: 'FinancialProduct', id?: string | null, clientId?: string | null, referenceId?: string | null, name?: string | null, scope?: ProductScope | null, category?: ProductCategory | null, description?: string | null, status?: ProductStatus | null, version?: number | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, activeStart?: string | null, activeEnd?: string | null, subClientIds: Array<string>, ledgers: Array<{ __typename?: 'LedgerConfiguration', id?: string | null, name?: string | null, currency?: string | null, autoCreate?: boolean | null, instrumentProductIds: Array<string>, version?: number | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, loadLimits?: { __typename?: 'LoadLimits', single?: { __typename?: 'LoadLimit', max?: number | null } | null, balance?: { __typename?: 'LoadLimit', max?: number | null } | null, daily?: { __typename?: 'LoadLimit', max?: number | null } | null, weekly?: { __typename?: 'LoadLimit', max?: number | null } | null, monthly?: { __typename?: 'LoadLimit', max?: number | null } | null, annually?: { __typename?: 'LoadLimit', max?: number | null } | null } | null }> }> | null };

export type LedgerConfigurationListQueryVariables = Exact<{
  input?: InputMaybe<LedgerConfigInput>;
}>;


export type LedgerConfigurationListQuery = { __typename?: 'Query', ledgerConfigurationList?: Array<{ __typename?: 'LedgerConfig', id?: string | null, name?: string | null, currency?: string | null, autoCreate?: boolean | null, instrumentProductIds?: Array<string> | null, financialProductId?: string | null, clientId?: string | null, version?: number | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, loadLimits?: { __typename?: 'LedgerLoadLimits', single?: { __typename?: 'LedgerLoadLimit', max?: number | null } | null, balance?: { __typename?: 'LedgerLoadLimit', max?: number | null } | null, daily?: { __typename?: 'LedgerLoadLimit', max?: number | null } | null, weekly?: { __typename?: 'LedgerLoadLimit', max?: number | null } | null, monthly?: { __typename?: 'LedgerLoadLimit', max?: number | null } | null, annually?: { __typename?: 'LedgerLoadLimit', max?: number | null } | null } | null }> | null };

export type GetTrustChainQueryVariables = Exact<{
  caType: Scalars['String']['input'];
}>;


export type GetTrustChainQuery = { __typename?: 'Query', getTrustChain?: { __typename?: 'TrustChainResponse', downloadUrl: string, trustChain: { __typename?: 'TrustChain', certificate?: string | null, certificateChain?: string | null, caArn?: string | null, status?: string | null, type?: string | null, notBefore?: string | null, notAfter?: string | null } } | null };

export type CreateOrganisationMutationVariables = Exact<{
  input: CreateOrganisationInput;
}>;


export type CreateOrganisationMutation = { __typename?: 'Mutation', createOrganisation?: { __typename?: 'Organisation', organisationId: string, name: string, slug: string, status: OrganisationStatus, cognitoGroupName: string, metadata: string, identityProviderConfig?: string | null, issuerId?: number | null, internalId?: number | null, products: Array<string>, emailDomains: Array<string>, description?: string | null, createdAt: string, updatedAt: string, createdBy: string, connection: ConnectionType, clientAuthMethod: ClientAuthMethod, authProvider: AuthProvider, subClientId?: string | null, pmInformation: Array<{ __typename?: 'PMInformation', pmId: number, pmCode: string }> } | null };

export type DeleteOrganisationMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
}>;


export type DeleteOrganisationMutation = { __typename?: 'Mutation', deleteOrganisation?: { __typename?: 'MessageResponse', message: string, username?: string | null, enabled?: boolean | null } | null };

export type UpdateOrganisationMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
  input: UpdateOrganisationInput;
}>;


export type UpdateOrganisationMutation = { __typename?: 'Mutation', updateOrganisation?: { __typename?: 'Organisation', organisationId: string, name: string, slug: string, status: OrganisationStatus, cognitoGroupName: string, metadata: string, identityProviderConfig?: string | null, issuerId?: number | null, internalId?: number | null, products: Array<string>, emailDomains: Array<string>, description?: string | null, createdAt: string, updatedAt: string, createdBy: string, connection: ConnectionType, clientAuthMethod: ClientAuthMethod, authProvider: AuthProvider, subClientId?: string | null, pmInformation: Array<{ __typename?: 'PMInformation', pmId: number, pmCode: string }> } | null };

export type GetOrganisationQueryVariables = Exact<{
  organisationId: Scalars['String']['input'];
}>;


export type GetOrganisationQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', organisationId: string, name: string, slug: string, connection: ConnectionType, status: OrganisationStatus, cognitoGroupName: string, metadata: string, identityProviderConfig?: string | null, issuerId?: number | null, internalId?: number | null, products: Array<string>, emailDomains: Array<string>, description?: string | null, createdAt: string, updatedAt: string, createdBy: string, scopes: Array<string>, clientAuthMethod: ClientAuthMethod, clientId?: string | null, subClientId?: string | null, pmInformation: Array<{ __typename?: 'PMInformation', pmId: number, pmCode: string }> } | null };

export type GetOrganisationBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetOrganisationBySlugQuery = { __typename?: 'Query', organisationBySlug?: { __typename?: 'Organisation', cognitoGroupName: string, connection: ConnectionType, createdAt: string, createdBy: string, description?: string | null, emailDomains: Array<string>, isActive: boolean, identityProviderConfig?: string | null, updatedAt: string, status: OrganisationStatus, slug: string, scopes: Array<string>, products: Array<string>, issuerId?: number | null, internalId?: number | null, organisationId: string, name: string, metadata: string, clientAuthMethod: ClientAuthMethod, clientId?: string | null, subClientId?: string | null, pmInformation: Array<{ __typename?: 'PMInformation', pmId: number, pmCode: string }> } | null };

export type ListOrganisationsQueryVariables = Exact<{
  limit?: Scalars['Int']['input'];
}>;


export type ListOrganisationsQuery = { __typename?: 'Query', listOrganisations?: { __typename?: 'ListOrganisationsResponse', totalCount: number, organisations: Array<{ __typename?: 'Organisation', organisationId: string, name: string, slug: string, connection: ConnectionType, status: OrganisationStatus, cognitoGroupName: string, metadata: string, identityProviderConfig?: string | null, issuerId?: number | null, internalId?: number | null, products: Array<string>, emailDomains: Array<string>, description?: string | null, isActive: boolean, createdAt: string, updatedAt: string, createdBy: string, scopes: Array<string>, clientAuthMethod: ClientAuthMethod, authProvider: AuthProvider, subClientId?: string | null, pmInformation: Array<{ __typename?: 'PMInformation', pmId: number, pmCode: string }> }> } | null };

export type CreateApplicationCertificateMutationVariables = Exact<{
  applicationId: Scalars['String']['input'];
  input: CreateCertificateIssuerInput;
}>;


export type CreateApplicationCertificateMutation = { __typename?: 'Mutation', createApplicationCertificate?: { __typename?: 'CertificateMessageResponse', message?: string | null } | null };

export type RevokeApplicationCertificateMutationVariables = Exact<{
  applicationId: Scalars['String']['input'];
  kid: Scalars['String']['input'];
  input: RevokeCertificateInput;
}>;


export type RevokeApplicationCertificateMutation = { __typename?: 'Mutation', revokeApplicationCertificate?: { __typename?: 'CertificateMessageResponse', message?: string | null } | null };

export type DownloadApplicationCertificatesQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
  kid: Scalars['String']['input'];
}>;


export type DownloadApplicationCertificatesQuery = { __typename?: 'Query', getApplicationCertificatePem?: { __typename?: 'GetApplicationCertificatePemResponse', body: string, filename: string } | null };

export type AddUserToGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type AddUserToGroupMutation = { __typename?: 'Mutation', addUserToGroup?: { __typename?: 'MessageResponse', enabled?: boolean | null, message: string, username?: string | null } | null };

export type CreateOrganisationGroupMutationVariables = Exact<{
  input: CreateOrganisationGroupInput;
  organisationId: Scalars['String']['input'];
}>;


export type CreateOrganisationGroupMutation = { __typename?: 'Mutation', createOrganisationGroup?: { __typename?: 'OrganisationGroup', cognitoGroupName: string, createdAt: string, createdBy: string, description: string, groupId: string, isActive: boolean, name: string, organisationId: string, scopes: Array<string>, updatedAt: string } | null };

export type CreateIdentityProviderMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
  input: CreateIdpInput;
}>;


export type CreateIdentityProviderMutation = { __typename?: 'Mutation', createIdentityProvider?: { __typename?: 'IdentityProvider', idpId: string, autoCreateUsers: boolean, defaultGroupMappings: Array<string>, description: string, idpType: IdpType, metadata: string, name: string, attributeMappings: Array<{ __typename?: 'AttributeMapping', internalAttribute: InternalAttributeMappingType, externalAttribute: string, isRequired: boolean }>, oidcConfig: { __typename?: 'OidcConfig', authorizationEndpoint?: string | null, clientId?: string | null, clientSecret?: string | null, discoveryUrl?: string | null, issuer?: string | null, jwksUri?: string | null, responseMode?: string | null, responseType?: string | null, scopes?: Array<string> | null, tokenEndpoint?: string | null, userinfoEndpoint?: string | null }, samlConfig: { __typename?: 'SamlConfig', metadataUrl?: string | null, metadataXml?: string | null } } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
  organisationId: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', email: string, groupId?: string | null, invitationSent: boolean, organisationId: string, organisationName: string, status: string, temporaryPassword?: string | null, userId: string } | null };

export type DeleteOrganisationGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
}>;


export type DeleteOrganisationGroupMutation = { __typename?: 'Mutation', deleteOrganisationGroup?: { __typename?: 'MessageResponse', enabled?: boolean | null, message: string, username?: string | null } | null };

export type DeleteIdentityProviderMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
  idpId: Scalars['String']['input'];
}>;


export type DeleteIdentityProviderMutation = { __typename?: 'Mutation', deleteIdentityProvider?: { __typename?: 'MessageResponse', message: string, enabled?: boolean | null, username?: string | null } | null };

export type CreateOAuthClientMutationVariables = Exact<{
  input: CreateOAuthClientInput;
  organisationId: Scalars['String']['input'];
}>;


export type CreateOAuthClientMutation = { __typename?: 'Mutation', createOauthClient?: { __typename?: 'OAuthClientCreatedResponse', allowedGroupIds: Array<string>, clientId: string, createdAt: string, createdBy: string, description: string, ipWhitelist?: Array<string> | null, isActive: boolean, lastSecretRotation?: string | null, name: string, updatedAt: string, usageNotes?: string | null } | null };

export type UpdateOAuthClientMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  input: UpdateOAuthClientInput;
  organisationId: Scalars['String']['input'];
}>;


export type UpdateOAuthClientMutation = { __typename?: 'Mutation', updateOauthClient?: { __typename?: 'OAuthClient', allowedGroupIds: Array<string>, clientId: string, createdAt: string, createdBy: string, description: string, ipWhitelist?: Array<string> | null, isActive: boolean, lastSecretRotation?: string | null, name: string, scopes: Array<string>, tags: string, updatedAt: string, usageNotes?: string | null } | null };

export type DeleteOAuthClientMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
}>;


export type DeleteOAuthClientMutation = { __typename?: 'Mutation', deleteOauthClient?: { __typename?: 'MessageResponse', username?: string | null, message: string, enabled?: boolean | null } | null };

export type PerformIdpHealthCheckMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
  idpId: Scalars['String']['input'];
}>;


export type PerformIdpHealthCheckMutation = { __typename?: 'Mutation', performIdpHealthCheck?: { __typename?: 'IdpHealthCheckResponse', idpId: string, status: string, lastChecked: string, details?: any | null, errors?: Array<string> | null } | null };

export type RemoveUserFromGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', removeUserFromGroup?: { __typename?: 'MessageResponse', enabled?: boolean | null, message: string, username?: string | null } | null };

export type RemoveUserFromOrganisationMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type RemoveUserFromOrganisationMutation = { __typename?: 'Mutation', removeUserFromOrganisation?: { __typename?: 'MessageResponse', message: string } | null };

export type UpdateOrganisationGroupMutationVariables = Exact<{
  input: UpdateOrganisationGroupInput;
  organisationId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;


export type UpdateOrganisationGroupMutation = { __typename?: 'Mutation', updateOrganisationGroup?: { __typename?: 'OrganisationGroup', cognitoGroupName: string, createdAt: string, createdBy: string, description: string, groupId: string, isActive: boolean, name: string, organisationId: string, scopes: Array<string>, updatedAt: string } | null };

export type UpdateIdentityProviderMutationVariables = Exact<{
  organisationId: Scalars['String']['input'];
  idpId: Scalars['String']['input'];
  input: UpdateIdpInput;
}>;


export type UpdateIdentityProviderMutation = { __typename?: 'Mutation', updateIdentityProvider?: { __typename?: 'IdentityProvider', name: string, status: IdpStatus, description: string, autoCreateUsers: boolean, defaultGroupMappings: Array<string>, metadata: string, samlConfig: { __typename?: 'SamlConfig', metadataUrl?: string | null, metadataXml?: string | null }, oidcConfig: { __typename?: 'OidcConfig', discoveryUrl?: string | null, issuer?: string | null, authorizationEndpoint?: string | null, tokenEndpoint?: string | null, userinfoEndpoint?: string | null, jwksUri?: string | null, clientId?: string | null, clientSecret?: string | null, scopes?: Array<string> | null, responseType?: string | null, responseMode?: string | null }, attributeMappings: Array<{ __typename?: 'AttributeMapping', internalAttribute: InternalAttributeMappingType, externalAttribute: string, isRequired: boolean }> } | null };

export type UpdateUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'MessageResponse', message: string } | null };

export type ListApplicationCertificatesQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;


export type ListApplicationCertificatesQuery = { __typename?: 'Query', listApplicationCertificates?: { __typename?: 'ListApplicationCertificatesResponse', certificates: Array<{ __typename?: 'Certificate', certificateType: CertificateType, fingerprint: string, keyId: string, status: CertificateStatus, validTo: string, validFrom: string }> } | null };

export type GetGroupByIdQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
}>;


export type GetGroupByIdQuery = { __typename?: 'Query', organisationGroup?: { __typename?: 'OrganisationGroup', cognitoGroupName: string, createdAt: string, createdBy: string, description: string, groupId: string, isActive: boolean, name: string, organisationId: string, scopes: Array<string>, updatedAt: string } | null };

export type GetOrganizationDashboardQueryVariables = Exact<{
  organisationId: Scalars['String']['input'];
}>;


export type GetOrganizationDashboardQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', organisationId: string, name: string, slug: string, status: OrganisationStatus, description?: string | null, createdAt: string, updatedAt: string, products: Array<string>, emailDomains: Array<string>, pmInformation: Array<{ __typename?: 'PMInformation', pmId: number, pmCode: string }> } | null, organisationUsers?: { __typename?: 'UserListResponse', totalCount: number, users: Array<{ __typename?: 'User', userId: string, email: string, givenName?: string | null, familyName?: string | null, status: string, groupId?: string | null, invitationSent: boolean }> } | null, oauthClients?: { __typename?: 'ListOAuthClientsResponse', totalCount: number, clients: Array<{ __typename?: 'OAuthClient', clientId: string, name: string, isActive: boolean, createdAt: string, lastSecretRotation?: string | null }> } | null, organisationGroups?: { __typename?: 'ListOrganisationGroupsResponse', totalCount: number, groups: Array<{ __typename?: 'OrganisationGroup', groupId: string, name: string, isActive: boolean, createdAt: string, scopes: Array<string> }> } | null, identityProviders?: { __typename?: 'ListIdentityProvidersResponse', identityProviders: Array<{ __typename?: 'IdentityProvider', idpId: string, name: string, idpType: IdpType, status: IdpStatus, healthCheckStatus: string, lastHealthCheck?: string | null }> } | null };

export type GetIdentityProviderQueryVariables = Exact<{
  organisationId: Scalars['String']['input'];
  idpId: Scalars['String']['input'];
}>;


export type GetIdentityProviderQuery = { __typename?: 'Query', identityProvider?: { __typename?: 'IdentityProvider', cognitoProviderName: string, createdAt: string, createdBy: string, healthCheckStatus: string, idpId: string, idpType: IdpType, lastHealthCheck?: string | null, name: string, status: IdpStatus, updatedAt: string, description: string, samlConfig: { __typename?: 'SamlConfig', metadataUrl?: string | null, ssoUrl?: string | null, sloUrl?: string | null, entityId?: string | null, nameIdFormat?: string | null, signRequest?: boolean | null, wantAssertionsSigned?: boolean | null, wantResponseSigned?: boolean | null, x509Certificate?: string | null, metadataXml?: string | null } } | null };

export type GetIdentityProviderSamlConfigurationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdentityProviderSamlConfigurationDataQuery = { __typename?: 'Query', identityProviderSamlConfigurationData?: { __typename?: 'IdentityProviderSamlConfigData', acsUrl: string, entityId: string } | null };

export type ListIdentityProvidersQueryVariables = Exact<{
  organisationId: Scalars['String']['input'];
  idpType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListIdentityProvidersQuery = { __typename?: 'Query', identityProviders?: { __typename?: 'ListIdentityProvidersResponse', identityProviders: Array<{ __typename?: 'IdentityProvider', idpId: string, name: string, idpType: IdpType, status: IdpStatus, cognitoProviderName: string, description: string, lastHealthCheck?: string | null, healthCheckStatus: string, createdAt: string, updatedAt: string, createdBy: string, attributeMappings: Array<{ __typename?: 'AttributeMapping', internalAttribute: InternalAttributeMappingType, externalAttribute: string, isRequired: boolean }>, samlConfig: { __typename?: 'SamlConfig', metadataUrl?: string | null, metadataXml?: string | null, ssoUrl?: string | null, entityId?: string | null, x509Certificate?: string | null }, oidcConfig: { __typename?: 'OidcConfig', discoveryUrl?: string | null, issuer?: string | null, authorizationEndpoint?: string | null, tokenEndpoint?: string | null, userinfoEndpoint?: string | null, jwksUri?: string | null, clientId?: string | null, clientSecret?: string | null, scopes?: Array<string> | null, responseType?: string | null, responseMode?: string | null } }> } | null };

export type ListGroupUsersQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
}>;


export type ListGroupUsersQuery = { __typename?: 'Query', groupUsers?: { __typename?: 'UserListResponse', users: Array<{ __typename?: 'User', email: string, groupId?: string | null, invitationSent: boolean, organisationId: string, organisationName: string, status: string, temporaryPassword?: string | null, userId: string }> } | null };

export type ListOrganisationGroupsQueryVariables = Exact<{
  limit?: Scalars['Int']['input'];
  organisationId: Scalars['String']['input'];
}>;


export type ListOrganisationGroupsQuery = { __typename?: 'Query', organisationGroups?: { __typename?: 'ListOrganisationGroupsResponse', totalCount: number, groups: Array<{ __typename?: 'OrganisationGroup', cognitoGroupName: string, createdAt: string, createdBy: string, description: string, groupId: string, isActive: boolean, name: string, organisationId: string, updatedAt: string, scopes: Array<string> }> } | null };

export type ListOrganisationUsersQueryVariables = Exact<{
  organisationId: Scalars['String']['input'];
}>;


export type ListOrganisationUsersQuery = { __typename?: 'Query', organisationUsers?: { __typename?: 'UserListResponse', totalCount: number, users: Array<{ __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null, groupId?: string | null, threddRoles?: Array<string> | null, invitationSent: boolean, organisationId: string, organisationName: string, status: string, temporaryPassword?: string | null, userId: string }> } | null };

export type GetOAuthClientsQueryVariables = Exact<{
  organisationId: Scalars['String']['input'];
  applicationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOAuthClientsQuery = { __typename?: 'Query', oauthClients?: { __typename?: 'ListOAuthClientsResponse', nextKey?: string | null, totalCount: number, clients: Array<{ __typename?: 'OAuthClient', allowedGroupIds: Array<string>, clientId: string, usageNotes?: string | null, updatedAt: string, tags: string, scopes: Array<string>, name: string, lastSecretRotation?: string | null, isActive: boolean, ipWhitelist?: Array<string> | null, description: string, createdBy: string, createdAt: string, pmId?: number | null, issuerId?: number | null, internalId?: number | null }> } | null };

export type GetOAuthClientQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
}>;


export type GetOAuthClientQuery = { __typename?: 'Query', oauthClient?: { __typename?: 'GetOauthClientResponse', lastSecretRotation?: string | null, usageNotes?: string | null, allowedGroupIds: Array<string>, clientId: string, createdAt: string, createdBy: string, ipWhitelist?: Array<string> | null, description: string, isActive: boolean, name: string, scopes: Array<string>, tags: string, updatedAt: string, clientSecret: string, pmId?: number | null, issuerId?: number | null, internalId?: number | null } | null };

export type CreateCurrencyMutationVariables = Exact<{
  input: CreateCurrencyInput;
}>;


export type CreateCurrencyMutation = { __typename?: 'Mutation', createCurrency?: { __typename?: 'Currency', code?: string | null, name?: string | null, providerId?: string | null, isActive?: boolean | null, createdBy?: string | null } | null };

export type DeleteCurrencyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCurrencyMutation = { __typename?: 'Mutation', deleteCurrency?: { __typename?: 'Currency', id?: string | null, code?: string | null, name?: string | null, providerId?: string | null, isActive?: boolean | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, deactivatedAt?: string | null, deprecatedAt?: string | null, version?: number | null } | null };

export type UpdateCurrencyMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCurrencyInput;
}>;


export type UpdateCurrencyMutation = { __typename?: 'Mutation', updateCurrency?: { __typename?: 'Currency', name?: string | null, providerId?: string | null, updatedBy?: string | null, version?: number | null } | null };

export type ListCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCurrenciesQuery = { __typename?: 'Query', currencyList?: Array<{ __typename?: 'Currency', id?: string | null, name?: string | null, code?: string | null, providerId?: string | null, isActive?: boolean | null }> | null };

export type GetCurrencyQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetCurrencyQuery = { __typename?: 'Query', currencyByCode?: { __typename?: 'Currency', id?: string | null, code?: string | null, name?: string | null, providerId?: string | null, isActive?: boolean | null, createdAt?: string | null, deactivatedAt?: string | null, deprecatedAt?: string | null, version?: number | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null } | null };

export type GetAccountHolderQueryVariables = Exact<{
  accountHolderId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type GetAccountHolderQuery = { __typename?: 'Query', accountHolder?: { __typename?: 'AccountHolder', id?: string | null, accountHolderStatus?: AccountHolderStatus | null, accountHolderType?: AccountHolderType | null, email?: string | null, retailDetails?: { __typename?: 'AccountHolderRetailDetails', firstName?: string | null, middleName?: string | null, lastName?: string | null } | null } | null };

export type CreateLedgerPlaygroundBalanceMutationVariables = Exact<{
  input: CreateLedgerPlaygroundBalance;
  clientId: Scalars['String']['input'];
}>;


export type CreateLedgerPlaygroundBalanceMutation = { __typename?: 'Mutation', createLedgerPlaygroundBalance?: { __typename?: 'CreateLedgerPlaygroundBalanceResponse', ledgerId: string, sessionId: string } | null };

export type CreateLedgerPlaygroundTransactionMutationVariables = Exact<{
  input: CreateLedgerPlaygroundTransaction;
  clientId: Scalars['String']['input'];
}>;


export type CreateLedgerPlaygroundTransactionMutation = { __typename?: 'Mutation', createLedgerPlaygroundTransaction?: { __typename?: 'CreateLedgerPlaygroundTransactionResponse', sessionId: string, transactionId: string, status: string, message: string } | null };

export type GetLedgerPlaygroundBalanceListQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type GetLedgerPlaygroundBalanceListQuery = { __typename?: 'Query', ledgerPlaygroundBalanceList?: Array<{ __typename?: 'LedgerPlaygroundBalance', accountId: string, asset: string, availableBalance: string, currentBalance: string, ledgerId: string, ledgerType: string, pendingCredit: string, pendingDebit: string, postedCredit: string, postedDebit: string }> | null };

export type GetLedgerPlaygroundTransactionQueryVariables = Exact<{
  input: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type GetLedgerPlaygroundTransactionQuery = { __typename?: 'Query', ledgerPlaygroundTransaction?: { __typename?: 'LedgerPlaygroundTransaction', transactionId: string, accountId: string, ledgerId: string, processingChannel: string, transactionType: string, sign: string, description: string, externalId?: string | null, feeLedgerId?: string | null, offsetLedgerId?: string | null, instrumentId?: string | null, billing: { __typename?: 'LedgerPlaygroundTransactionBilling', billingAmount: string, billingAsset: string, transactionAmount: string, transactionAsset: string, feeAmount?: string | null, feeAsset?: string | null, cashbackAmount?: string | null, cashbackAsset?: string | null, settlementAmount?: string | null, settlementAsset?: string | null, exchangeRate?: string | null }, status: { __typename?: 'LedgerPlaygroundTransactionStatus', status: string, version?: string | null, createdAt?: string | null, authorisedOn?: string | null, processedOn?: string | null, description?: string | null }, ledgerEntries?: Array<{ __typename?: 'LedgerPlaygroundTransactionLedgerEntry', ledgerId: string, ledgerType: string, amount: string, asset: string, sign: string, status: string, subTransactionId: string, timestamp: string }> | null, subTransactions?: Array<{ __typename?: 'LedgerPlaygroundSubtransaction', subTransactionId: string, subTransactionType: string, amount: string, asset: string, timestamp: string }> | null } | null };

export type GetLedgerPlaygroundTransactionListQueryVariables = Exact<{
  input: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type GetLedgerPlaygroundTransactionListQuery = { __typename?: 'Query', ledgerPlaygroundTransactionList?: Array<{ __typename?: 'LedgerPlaygroundTransaction', transactionId: string, accountId: string, ledgerId: string, processingChannel: string, transactionType: string, sign: string, description: string, externalId?: string | null, feeLedgerId?: string | null, offsetLedgerId?: string | null, instrumentId?: string | null, billing: { __typename?: 'LedgerPlaygroundTransactionBilling', billingAmount: string, billingAsset: string, transactionAmount: string, transactionAsset: string, feeAmount?: string | null, feeAsset?: string | null, cashbackAmount?: string | null, cashbackAsset?: string | null, settlementAmount?: string | null, settlementAsset?: string | null, exchangeRate?: string | null }, status: { __typename?: 'LedgerPlaygroundTransactionStatus', status: string, version?: string | null, createdAt?: string | null, authorisedOn?: string | null, processedOn?: string | null, description?: string | null }, ledgerEntries?: Array<{ __typename?: 'LedgerPlaygroundTransactionLedgerEntry', ledgerId: string, ledgerType: string, amount: string, asset: string, sign: string, status: string, subTransactionId: string, timestamp: string }> | null, subTransactions?: Array<{ __typename?: 'LedgerPlaygroundSubtransaction', subTransactionId: string, subTransactionType: string, amount: string, asset: string, timestamp: string }> | null }> | null };

export type AuditLogRequestInputMutationVariables = Exact<{
  input: AuditLogRequestInput;
}>;


export type AuditLogRequestInputMutation = { __typename?: 'Mutation', createAuditLog?: boolean | null };

export type GetLogFilterOptionsQueryVariables = Exact<{
  field: Scalars['String']['input'];
}>;


export type GetLogFilterOptionsQuery = { __typename?: 'Query', auditLogLookups?: { __typename?: 'AuditLogLookupTableResponse', items: Array<{ __typename?: 'AuditLogFieldValuePair', field: string, value: string }> } | null };

export type ExportAuditLogsMutationVariables = Exact<{
  input: ExportAuditLogsInput;
}>;


export type ExportAuditLogsMutation = { __typename?: 'Mutation', exportAuditLogs?: { __typename?: 'AuditLogsExportResponse', logs: Array<{ __typename?: 'AuditLog', id: string, timestamp: string, user: string, email: string, section?: string | null, region?: string | null, note?: string | null, details?: string | null }> } | null };

export type AuditLogsQueryVariables = Exact<{
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsResponse', lastEvaluatedKey?: string | null, logs: Array<{ __typename?: 'AuditLog', id: string, timestamp: string, user: string, email: string, section?: string | null, region?: string | null, note?: string | null, details?: string | null }> } | null };

export type FeatureRequestMutationVariables = Exact<{
  input: FeatureRequestInput;
}>;


export type FeatureRequestMutation = { __typename?: 'Mutation', sendFeatureRequest?: boolean | null };

export type SaveUserPmPreferenceMutationVariables = Exact<{
  input: SaveUserPmPreferenceInput;
}>;


export type SaveUserPmPreferenceMutation = { __typename?: 'Mutation', saveUserPmPreference?: { __typename?: 'MessageResponse', message: string } | null };

export type GetCardsQueryVariables = Exact<{
  input: SearchCardsInput;
}>;


export type GetCardsQuery = { __typename?: 'Query', searchCards?: { __typename?: 'SearchCardsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CardsResponse', firstName?: string | null, lastName?: string | null, publicToken: any, addressLine1?: string | null, customerReference?: string | null, expiryDate?: string | null, currencyCode?: string | null, availableBalance?: any | null, actualBalance?: any | null, cardStatus?: string | null, isLive: boolean, cardType?: string | null, schemeId: number, title?: string | null, schemeName?: string | null, email?: string | null, tel?: string | null, mobile?: string | null, dateOfBirth?: string | null, postCode?: string | null, city?: string | null, productName?: string | null, productId: number, panPubt?: any | null }> | null } | null };

export type GetCardFeesQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardFeesQuery = { __typename?: 'Query', cardFees?: { __typename?: 'CardFeeResponse', authFees: Array<{ __typename?: 'AuthFees', group?: string | null, numberOfFreeTransactionPerActivation?: number | null, smsFee?: any | null, processingCode?: string | null, partialAllowed?: boolean | null, domesticFee?: any | null, domesticFeeRate?: any | null, nonDomesticFee?: any | null, nonDomesticRate?: any | null, domesticMinimumFee?: any | null, nonDomesticMinimumFee?: any | null, currency?: string | null, description: string, declineFee?: any | null, fxFixed?: any | null, fxRate?: any | null, thresholdType?: string | null, capDomesticFee?: any | null, capFxFee?: any | null, capNonDomesticFee?: any | null, numberOfFreeTransactionPerMonth?: number | null }>, recurringFees: Array<{ __typename?: 'RecurringFees', feeGroupCode: string, note?: string | null, partialAllowed?: boolean | null, domesticFee?: any | null, domesticFeeRate?: any | null, nonDomesticFee?: any | null, nonDomesticRate?: any | null, domesticMinimumFee?: any | null, nonDomesticMinimumFee?: any | null, description?: string | null, feeStartDate?: string | null, feeEndDate?: string | null, feeAmount?: any | null, lowActivityAmount?: any | null, frequency?: number | null, frequencyPeriod?: string | null, repeat?: number | null, repeatPeriod?: string | null, recurringFee: string }>, webServiceProductFees: Array<{ __typename?: 'WebServiceProductFees', product: string, partialAllowed?: boolean | null, domesticFee?: any | null, domesticFeeRate?: any | null, nonDomesticFee?: any | null, nonDomesticRate?: any | null, domesticMinimumFee?: any | null, nonDomesticMinimumFee?: any | null, description: string }>, webServiceGroupFees: Array<{ __typename?: 'WebServiceGroupFees', partialAllowed?: boolean | null, processingCode: string, description: string, domesticFee?: any | null, domesticFeeRate?: any | null, domesticMinimumFee?: any | null, nonDomesticFee?: any | null, nonDomesticRate?: any | null, nonDomesticMinimumFee?: any | null, smsFee?: any | null, group: string }> } | null };

export type GetUsageGroupListDetailsResponseQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetUsageGroupListDetailsResponseQuery = { __typename?: 'Query', usageGroupListDetails?: { __typename?: 'GetUsageGroupListDetailsResponse', groupCode?: string | null, groupDescription?: string | null, cardAcceptanceMethods?: Array<{ __typename?: 'CardAcceptanceMethods', variableType?: string | null, variableTypeCode?: string | null, defaultTicked?: boolean | null, groupCode?: string | null, groupDescription?: string | null, variableDescription?: string | null }> | null, transactionTypes?: Array<{ __typename?: 'TransactionTypes', variableType?: string | null, variableTypeCode?: string | null, defaultTicked?: boolean | null, groupCode?: string | null, groupDescription?: string | null, variableDescription?: string | null }> | null, verificationChecks?: Array<{ __typename?: 'VerificationChecks', variableType?: string | null, variableTypeCode?: string | null, defaultTicked?: boolean | null, groupCode?: string | null, groupDescription?: string | null, variableDescription?: string | null }> | null, misc?: Array<{ __typename?: 'Misc', variableType?: string | null, variableTypeCode?: string | null, defaultTicked?: boolean | null, groupCode?: string | null, groupDescription?: string | null, variableDescription?: string | null }> | null } | null };

export type GetPaymentTokenUsageGroupDetailsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
  groupId: Scalars['Int']['input'];
}>;


export type GetPaymentTokenUsageGroupDetailsQuery = { __typename?: 'Query', paymentTokenUsageGroupDetails?: { __typename?: 'GetPaymentTokenUsageGroupDetailsResponse', tokenUsage?: string | null, institute?: string | null, cvv2Missing?: string | null, avsMissing?: string | null, walletDecisionsAuth?: string | null, walletDecisionsDecline?: string | null, walletDeviceMaxScoreAuth?: string | null, walletDeviceMaxScoreDecline?: string | null, walletAccountMaxScoreAuth?: string | null, walletAccountMaxScoreDecline?: string | null, minTokensToAuth?: string | null, minTokensToDecline?: string | null, activateSMS?: boolean | null, activateEmail?: boolean | null, activateCallCentre?: string | null, activateAutoCallCentre?: string | null, activateWebsiteURL?: string | null, activateMobileApp?: string | null, activateCallback?: boolean | null, notifySMS?: boolean | null, notifyEmail?: boolean | null, notifyPost?: boolean | null, groupUsageDefaultName?: string | null, overrideApproveAuth?: boolean | null, defaultWalletProviderAuthentication?: string | null } | null };

export type CardAcceptorAllowDisallowListQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type CardAcceptorAllowDisallowListQuery = { __typename?: 'Query', cardAcceptorAllowDisallowList?: { __typename?: 'CardAcceptorsResponse', cardAcceptorAllowList?: Array<{ __typename?: 'CardAcceptorDetailResponse', id: number, name: string, merchantIds?: Array<string> | null, isConfiguredGroup?: boolean | null }> | null, cardAcceptorDisallowList?: Array<{ __typename?: 'CardAcceptorDetailResponse', id: number, name: string, merchantIds?: Array<string> | null }> | null } | null };

export type GetCardLimitDetailsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardLimitDetailsQuery = { __typename?: 'Query', cardLimitDetails?: { __typename?: 'GetCardLimitResponse', availableBalance: any, maxAllowableBalance: any, currencyCode?: string | null, blockedAmount: any, cardLimits?: Array<{ __typename?: 'CardLimits', subGroup?: string | null, daily?: { __typename?: 'CardLimitsSub', period?: number | null, unit?: string | null, limit: any, frequency: number, spent: any, transactionCount: number } | null, accumulatedPeriod1?: { __typename?: 'CardLimitsSub', period?: number | null, unit?: string | null, limit: any, frequency: number, spent: any, transactionCount: number } | null, accumulatedPeriod2?: { __typename?: 'CardLimitsSub', period?: number | null, unit?: string | null, limit: any, frequency: number, spent: any, transactionCount: number } | null }> | null } | null };

export type GetCardSpendLimitDetailsByProductQueryVariables = Exact<{
  input: GetCardSpendLimitDetailsByProductInput;
}>;


export type GetCardSpendLimitDetailsByProductQuery = { __typename?: 'Query', cardSpendLimitDetailsByProduct?: { __typename?: 'CardSpendLimitByProductResponse', public_token?: string | null, limitsWithCounter?: Array<{ __typename?: 'LimitCategory', category?: string | null, limits?: { __typename?: 'ProductLimits', maximumPerTransaction?: any | null, minimumPerTransaction?: any | null, dailyLimit?: any | null, dailyFrequency?: number | null, accumLimit1?: any | null, accumFrequency1?: number | null, accumPeriod1?: number | null, accumLimit2?: any | null, accumFrequency2?: number | null, accumPeriod2?: number | null } | null, counters?: { __typename?: 'Counters', daily_count?: number | null, daily_amount?: any | null, accumlimit1_count?: number | null, accumlimit1_amount?: any | null, accumlimit2_count?: number | null, accumlimit2_amount?: any | null } | null, subcategories?: Array<{ __typename?: 'Subcategories', subcategory?: string | null, limits?: { __typename?: 'ProductLimits', maximumPerTransaction?: any | null, minimumPerTransaction?: any | null, dailyLimit?: any | null, dailyFrequency?: number | null, accumLimit1?: any | null, accumFrequency1?: number | null, accumPeriod1?: number | null, accumLimit2?: any | null, accumFrequency2?: number | null, accumPeriod2?: number | null } | null, counters?: { __typename?: 'Counters', daily_count?: number | null, daily_amount?: any | null, accumlimit1_count?: number | null, accumlimit1_amount?: any | null, accumlimit2_count?: number | null, accumlimit2_amount?: any | null } | null }> | null }> | null } | null };

export type GetGroupsQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups?: Array<{ __typename?: 'GroupsResponse', groupType?: string | null, groups: Array<{ __typename?: 'GroupDetails', id: number, code?: string | null, description?: string | null }> }> | null };

export type GetPublicTokenCardStatusHistoryQueryVariables = Exact<{
  input: CardStatusHistoryInput;
}>;


export type GetPublicTokenCardStatusHistoryQuery = { __typename?: 'Query', publicTokenCardStatusHistory?: { __typename?: 'PublicTokenCardStatusHistoryCollectionSegment', items?: Array<{ __typename?: 'HistoryResponse', changeDate: string, changeNote?: string | null, newStatus?: string | null, oldStatus?: string | null, description?: string | null }> | null } | null };

export type GetSingleCardPaymentTokenDetailsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
}>;


export type GetSingleCardPaymentTokenDetailsQuery = { __typename?: 'Query', singleCardPaymentTokenDetails?: { __typename?: 'GetCardPaymentTokenDetailsResponse', creatorTokenReference?: string | null, cardUsageGroup?: string | null, paymentTokenUsageGroup?: string | null, walletAccountScore?: number | null, walletDeviceScore?: number | null, walletReasons?: string | null, transactionID?: any | null, responseCode?: string | null, transactionDate?: string | null, cardAcceptorNameLocation?: string | null, bnReference?: string | null, mtid?: string | null, ehiRequestTime?: string | null, ehiResponseTime?: string | null, activationCode?: string | null, activationMethod?: string | null, activationStatus?: string | null, id?: number | null, walletId?: string | null, walletProvider?: string | null, tokenPan?: any | null, tokenisedDate?: string | null, expiryDate?: string | null, tokenType?: string | null, deviceType?: string | null, deviceName?: string | null, deviceId?: string | null, replacementCount?: number | null, oldExpDate?: string | null, externalStatusSetBy?: string | null, deviceIp?: string | null, walletAccountHash?: string | null, digitisationReference?: string | null, threddDecision?: string | null, threddDecisionAt?: string | null, termsAndConditions?: string | null, merchantName?: string | null, linkedToken?: string | null, deviceLanguage?: string | null, location?: string | null, endOfPhoneNumber?: string | null, firstname?: string | null, lastname?: string | null, finalDecisionBy?: string | null, panSource?: string | null, creator?: string | null, txnStatusChanged?: string | null, activationCodeExpdate?: string | null, creatorPanReference?: string | null, statuses?: { __typename?: 'PaymentTokenStatus', tokenisedStatus: { __typename?: 'TokenisationStatus', code?: string | null, description?: string | null }, authorisationStatus: { __typename?: 'AuthorisationStatus', code?: string | null, description?: string | null }, authorisationDecision: { __typename?: 'AuthorisationDecision', code?: string | null, description?: string | null }, transactionStatus: { __typename?: 'TransStatus', code?: string | null, description?: string | null }, gpsStatusInfo: { __typename?: 'GpsStatusInfo', code?: string | null, description?: string | null } } | null } | null };

export type GetCardPosSubLimitsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardPosSubLimitsQuery = { __typename?: 'Query', cardPosSubLimits?: { __typename?: 'CardPosSubLimitsResponse', cardPosSubLimits?: Array<{ __typename?: 'PosSubLimitsResult', posLimitDescription?: string | null, dailyValueLimit?: any | null, dailyFrequencyLimit?: number | null, maxPerTransaction?: any | null, minPerTransaction?: any | null, accumulatedValueLimit1?: any | null, accumulatedFrequencyLimit1?: number | null, accumulatedPeriod1?: string | null, accumulatedValueLimit2?: any | null, accumulatedFrequencyLimit2?: number | null, accumulatedPeriod2?: string | null }> | null } | null };

export type GetLoadSourceResponseQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetLoadSourceResponseQuery = { __typename?: 'Query', loadSourceList?: { __typename?: 'GetLoadSourceResponse', cardLoadSources?: Array<{ __typename?: 'CardLoadSourcesResponse', maxPerTransaction: number, minPerTransaction: number, accumulatedValueLimit1: number, accumulatedFrequencyLimit1: number, accumulatedPeriod1?: string | null, accumulatedValueLimit2: number, accumulatedFrequencyLimit2: number, accumulatedPeriod2?: string | null, dailyValueLimit: number, dailyFrequencyLimit: number }> | null } | null };

export type CardBalanceTransferMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  transactionType: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  currencyCode: Scalars['String']['input'];
  user: Scalars['String']['input'];
  description: Scalars['String']['input'];
  toPublicToken: Scalars['String']['input'];
}>;


export type CardBalanceTransferMutation = { __typename?: 'Mutation', balanceTransfer?: { __typename: 'LoadUnloadCardResponse', transaction?: Array<{ __typename: 'TransactionResponse', transactionType: string, transactionId: any, amount: any }> | null, balance?: { __typename: 'BalanceResponse', availableBalance: any, cardBalance: any, currencyCode: string, pendingAmount: any } | null } | null };

export type MfxBalanceTransferMutationVariables = Exact<{
  input: MfxBalanceTransferInput;
}>;


export type MfxBalanceTransferMutation = { __typename?: 'Mutation', mfxBalanceTransfer?: { __typename: 'WsBalanceTransferResponse', issCode?: string | null, publicToken?: string | null, sysDate?: string | null } | null };

export type UpdateGroupsMutationVariables = Exact<{
  input: UpdateControlGroupsInput;
}>;


export type UpdateGroupsMutation = { __typename?: 'Mutation', updateGroups?: { __typename?: 'ControlGroups', authFeeGroup?: any | null, calendarGroup?: any | null, cardLinkageGroup?: any | null, fxGroup?: any | null, limitsGroup?: any | null, mccGroup?: any | null, paymentTokenUsageGroup?: any | null, recurringFeeGroup?: any | null, usageGroup?: any | null, webServiceFeeGroup?: any | null, limitedNetworkGroup?: any | null, cardAcceptorAllowList?: any | null, cardAcceptorDisallowList?: any | null } | null };

export type Update3DsCredentialDetailsMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  input: Update3DsCredentialInput;
}>;


export type Update3DsCredentialDetailsMutation = { __typename?: 'Mutation', update3dsCredentialDetails?: boolean | null };

export type UpdateCardMutationVariables = Exact<{
  input: UpdateCardInput;
}>;


export type UpdateCardMutation = { __typename?: 'Mutation', updateCard?: boolean | null };

export type ChangeCardStatusMutationVariables = Exact<{
  input: ChangeCardStatusInput;
}>;


export type ChangeCardStatusMutation = { __typename?: 'Mutation', changeCardStatus?: { __typename?: 'StatusResponse', status: CardStatusCode } | null };

export type UnblockCvvMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  cvvUnblockInput: CvvUnblockInput;
}>;


export type UnblockCvvMutation = { __typename?: 'Mutation', unblockCvv?: boolean | null };

export type UnblockOfflinePinMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  pinUnblockInput: PinUnblockInput;
}>;


export type UnblockOfflinePinMutation = { __typename?: 'Mutation', unblockOfflinePin?: boolean | null };

export type UnblockOnlinePinMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  pinUnblockInput: PinUnblockInput;
}>;


export type UnblockOnlinePinMutation = { __typename?: 'Mutation', unblockOnlinePin?: boolean | null };

export type GetCardCvvStatusQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardCvvStatusQuery = { __typename?: 'Query', cardCvvStatus?: { __typename?: 'CardPinStatusResponse', remainingTries: string } | null };

export type GetCardOnlinePinStatusQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardOnlinePinStatusQuery = { __typename?: 'Query', cardOnlinePinStatus?: { __typename?: 'CardPinStatusResponse', remainingTries: string, remainingOfflineTries?: string | null } | null };

export type GetCurrencyConversionRatesQueryVariables = Exact<{
  input: CurConRateInput;
}>;


export type GetCurrencyConversionRatesQuery = { __typename?: 'Query', currencyConversionRates?: { __typename?: 'CurConRateResponse', conversionRate?: any | null } | null };

export type MfxWalletTransferMutationVariables = Exact<{
  input: MfxWalletTransferInput;
}>;


export type MfxWalletTransferMutation = { __typename?: 'Mutation', mfxWalletTransfer?: { __typename: 'MfxCardWalletTrnsfrResponse', sourceWalletTransaction?: { __typename?: 'MfxCardWalletTrnsfrDetailResponse', transactionId: any, amount: any, currencyCode: string, publicToken: string, actualBalance: any, blockedAmount: any, availableBalance: any } | null, destinationWalletTransaction?: { __typename: 'MfxCardWalletTrnsfrDetailResponse', transactionId: any, amount: any, currencyCode: string, publicToken: string, actualBalance: any, blockedAmount: any, availableBalance: any } | null } | null };

export type GetPaymentInstructionQueryVariables = Exact<{
  id: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type GetPaymentInstructionQuery = { __typename?: 'Query', getPaymentInstruction?: { __typename?: 'ACHPaymentInstructionResponse', id: string, status: string, paymentInstruction: { __typename?: 'ACHPaymentInstruction', effectiveEntryDate: string, transactionDate: string, transactionType: string, transactionSpeed: string, standardEntryClassCode: string, paymentAuthorizationDetails: string, originator: { __typename?: 'ACHOriginatorResponse', name: string, accountNumber: string, routingCode: string, reference: string }, recipient: { __typename?: 'ACHRecipientResponse', name: string, accountNumber: string, routingCode: string, reference: string, accountType: string }, asset: { __typename?: 'ACHAssetResponse', monetary: { __typename?: 'ACHMonetaryUnitResponse', amount: number, currencyCode: string } } } } | null };

export type ListPaymentInstructionsQueryVariables = Exact<{
  input?: InputMaybe<ListAchPaymentInstructionsInput>;
  clientId: Scalars['String']['input'];
}>;


export type ListPaymentInstructionsQuery = { __typename?: 'Query', listPaymentInstructions?: Array<{ __typename?: 'ACHPaymentInstructionResponse', id: string, status: string, paymentInstruction: { __typename?: 'ACHPaymentInstruction', transactionDate: string, effectiveEntryDate: string, transactionType: string, transactionSpeed: string, paymentAuthorizationDetails: string, recipient: { __typename?: 'ACHRecipientResponse', name: string, reference: string, accountType: string, accountNumber: string }, originator: { __typename?: 'ACHOriginatorResponse', name: string, accountNumber: string }, asset: { __typename?: 'ACHAssetResponse', monetary: { __typename?: 'ACHMonetaryUnitResponse', amount: number, currencyCode: string } } } }> | null };

export type DecodingPds0146QueryVariables = Exact<{
  input: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
}>;


export type DecodingPds0146Query = { __typename?: 'Query', decodingPDS0146?: Array<{ __typename?: 'AdditionalDataDecoded', item: string, value: string }> | null };

export type DecodingDe061QueryVariables = Exact<{
  input: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
}>;


export type DecodingDe061Query = { __typename?: 'Query', decodingDE061?: Array<{ __typename?: 'POSDataDecoded', additionalInformation: string, description: string, position: string, value: string }> | null };

export type DecodingDe60QueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type DecodingDe60Query = { __typename?: 'Query', decodingDE60?: Array<{ __typename?: 'POSDataDecoded', additionalInformation: string, description: string, position: string, value: string }> | null };

export type DecodingDe022QueryVariables = Exact<{
  de022: Scalars['String']['input'];
  mTID: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
  transactionTypeDescriptions: Scalars['String']['input'];
}>;


export type DecodingDe022Query = { __typename?: 'Query', decodingDE022?: Array<{ __typename: 'POSDataDecoded', value: string, description: string, position: string }> | null };

export type DecodingDe048QueryVariables = Exact<{
  de048: Scalars['String']['input'];
  mtid: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
  transactionType: Scalars['String']['input'];
}>;


export type DecodingDe048Query = { __typename?: 'Query', decodingDE048?: { __typename?: 'AdditionalDataDecodResponse', btnPds0146IsVisible: boolean, pds0146: string, btnPds0158IsVisible: boolean, pds0158: string, btnPds0159IsVisible: boolean, pds0159: string, btnPds0043IsVisible: boolean, pds0043: string, heading: string, additionalDataDecoded?: Array<{ __typename?: 'AdditionalDataDecoded', item: string, value: string }> | null, additionalDataDecodedMc?: { __typename?: 'AdditionalDataDecodeMC', totalLength: string, tcc: string, additionalDataDecoded?: Array<{ __typename?: 'AdditionalDataDecoded', pdsmc?: string | null, item: string, value: string, subElements?: Array<{ __typename?: 'AdditionalDataDecoded', item: string, value: string, subElements?: Array<{ __typename?: 'AdditionalDataDecoded', item: string, value: string }> | null }> | null }> | null } | null } | null };

export type DecodingPds0043QueryVariables = Exact<{
  pds0043: Scalars['String']['input'];
}>;


export type DecodingPds0043Query = { __typename?: 'Query', decodingPDS0043?: { __typename?: 'AdditionalDataDecoded', item: string, value: string } | null };

export type DecodingPds0158QueryVariables = Exact<{
  pds0158: Scalars['String']['input'];
}>;


export type DecodingPds0158Query = { __typename?: 'Query', decodingPDS0158?: Array<{ __typename?: 'AdditionalDataDecoded', item: string, value: string }> | null };

export type DecodingPds0159QueryVariables = Exact<{
  pds0159: Scalars['String']['input'];
}>;


export type DecodingPds0159Query = { __typename?: 'Query', decodingPDS0159?: Array<{ __typename?: 'AdditionalDataDecoded', item: string, value: string }> | null };

export type DecodeCvrQueryVariables = Exact<{
  cvrData: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
}>;


export type DecodeCvrQuery = { __typename?: 'Query', decodingCVR?: Array<{ __typename?: 'CVRDecodedResponse', item: string, value: string, cvrDetails?: Array<{ __typename?: 'CVRDecodedResponse', item: string, value: string }> | null }> | null };

export type DecodeDe055QueryVariables = Exact<{
  iccData: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
}>;


export type DecodeDe055Query = { __typename?: 'Query', decodeDe055?: Array<{ __typename?: 'IccDataDecoded', pds?: string | null, pdsDescription?: string | null, pdsHexa?: string | null, pdsValue?: string | null, subfieldValue: string, subLevelPDS?: Array<{ __typename?: 'IccDataDecoded', pds?: string | null, pdsDescription?: string | null, pdsHexa?: string | null, pdsValue?: string | null }> | null }> | null };

export type DecodeDe055ForPresentmentQueryVariables = Exact<{
  iccData: Scalars['String']['input'];
  networkId: Scalars['Int']['input'];
}>;


export type DecodeDe055ForPresentmentQuery = { __typename?: 'Query', decodeDe055ForPresentment?: Array<{ __typename?: 'IccDataDecoded', pds?: string | null, pdsDescription?: string | null, pdsHexa?: string | null, pdsValue?: string | null, subfieldValue: string, subLevelPDS?: Array<{ __typename?: 'IccDataDecoded', pds?: string | null, pdsDescription?: string | null, pdsHexa?: string | null, pdsValue?: string | null }> | null }> | null };

export type DecodingDe025QueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type DecodingDe025Query = { __typename?: 'Query', decodingDE025?: { __typename: 'POSDataDecoded', value: string, description: string } | null };

export type CreateAuthReversalTransactionMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
  input: AuthReversalRequestInput;
}>;


export type CreateAuthReversalTransactionMutation = { __typename?: 'Mutation', createAuthReversalTransaction?: { __typename?: 'AuthReversalResponse', transactionId: any } | null };

export type UnblockCardMutationVariables = Exact<{
  publicToken: Scalars['String']['input'];
  input: UnblockCardInput;
}>;


export type UnblockCardMutation = { __typename?: 'Mutation', unblockCard?: boolean | null };

export type SendToEhiMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type SendToEhiMutation = { __typename?: 'Mutation', ehiResend?: { __typename?: 'EhiResendResponse', resendMessage: string } | null };

export type GetEhiAcknowledgementQueryVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type GetEhiAcknowledgementQuery = { __typename?: 'Query', ehiAcknowledgement?: { __typename?: 'EhiAcknowledgementResponse', resendToEhi: boolean } | null };

export type UpdateVisaFileMaintenanceMutationVariables = Exact<{
  input: VisaFileMaintenanceInput;
  publicToken: Scalars['String']['input'];
}>;


export type UpdateVisaFileMaintenanceMutation = { __typename?: 'Mutation', updateVisaFileMaintenance?: { __typename?: 'VisaFileMaintenanceResponse', visaFileData?: Array<{ __typename?: 'VisaFileMaintenance', requestData: { __typename?: 'VisaFileRequest', transmissionDateTime?: string | null, retrievalReferenceNumber?: string | null, updatedBy?: string | null, updateReason?: string | null, systemTraceAuditNumber?: string | null, fileUpdateCode?: string | null, requestFileName?: string | null }, responseData: { __typename?: 'VisaFileResponse', responseDateTime?: string | null, responseCode?: string | null, responseResult?: string | null, fileUpdateCode?: string | null, responseFileName?: string | null, transmissionDateTime?: string | null, retrievalReferenceNumber?: string | null } }> | null } | null };

export type DecodingDe063QueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type DecodingDe063Query = { __typename?: 'Query', decodingDE063?: Array<{ __typename: 'POSDataDecoded', position: string, value: string, description: string, additionalInformation: string }> | null };

export type GetLifecycleTransactionsQueryVariables = Exact<{
  traceIdLifeCycle: Scalars['String']['input'];
}>;


export type GetLifecycleTransactionsQuery = { __typename?: 'Query', transactionsDetails?: Array<{ __typename?: 'TransactionDetailResponse', recordId: any, pubToken: string, traceIdLifeCycle: string, transactionId: any, transactionType: string, transactionStatus: string, transactionAmount: any, transactionCurrency: string, transactionDate: any, billingAmount: any, billingCurrency: string, processingCode: any, responseStatus: string, merchantCategoryCode: string, dateExpiry: string, posEntryMode: string, retrievalReference: string, cardAcceptorIdentificationCode: string, cardAcceptorNameLocation: string, aid: string, fid: string, cardAcceptorTerminalIdentification: string, additionalData: string, settlementAmount: any, settlementCurrency: string, authorisationCode: string, additionalAmounts: string, posData: string, tillTime: any, paymentTokenId?: number | null, note: string, availableBalance: any, blockedAmount: any, fees: any, stan: string, messageType: string, iccData: string, gpsPosData: string, adviceReasonData: string, additionalResponseData: string, avsStreet: string, avsPostcode: string, networkData: string, acquirerReferenceData: string, transactionOriginatingInstitution: string, merchant?: { __typename?: 'Merchant', city?: string | null, contact?: string | null, county?: string | null, name?: string | null, nameOther?: string | null, networkId?: string | null, postcode?: string | null, region?: string | null, street?: string | null, taxId?: string | null, telephone?: string | null, url?: string | null } | null, transactionFees?: { __typename?: 'TransactionFeesResponse', domesticFixedFee: any, domesticRateFee: any, fxFixedFee: any, fxRateFee: any, nonDomesticFixedFee: any, nonDomesticRateFee: any } | null }> | null };

export type ListProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProductsQuery = { __typename?: 'Query', getProducts?: { __typename?: 'ListProductsResponse', count?: string | null, pageToken?: string | null, products?: Array<{ __typename?: 'ProductResponse', productId?: string | null, productName?: string | null, rangeLowLimit?: string | null, rangeHighLimit?: string | null }> | null } | null };

export type CreateWebhookMutationVariables = Exact<{
  webhookInput: WebhookRequestInput;
}>;


export type CreateWebhookMutation = { __typename?: 'Mutation', createWebhook?: { __typename?: 'WebhookResponse', status?: string | null, response?: { __typename?: 'WebhookInnerResponse', webhookId?: string | null, webhookStatus?: string | null, message?: string | null, errorCode?: string | null } | null } | null };

export type UpdateWebhookMutationVariables = Exact<{
  webhookId: Scalars['String']['input'];
  updateWebhookRequestInput: UpdateWebhookRequestInput;
}>;


export type UpdateWebhookMutation = { __typename?: 'Mutation', updateWebhookDetails?: { __typename?: 'WebhookResponse', status?: string | null, response?: { __typename?: 'WebhookInnerResponse', webhookId?: string | null, webhookStatus?: string | null, message?: string | null, errorCode?: string | null } | null } | null };

export type UpdateWebhookStatusMutationVariables = Exact<{
  input: UpdateWebhookStatusInput;
  webhookId: Scalars['String']['input'];
}>;


export type UpdateWebhookStatusMutation = { __typename?: 'Mutation', updateWebhookStatus?: { __typename?: 'WebhookResponse', status?: string | null } | null };

export type GetWebhookEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebhookEventsQuery = { __typename?: 'Query', webhookEvents?: { __typename?: 'WebhookEventsResponse', status?: string | null, response?: string | null } | null };

export type PingWebhookQueryVariables = Exact<{
  webhookId: Scalars['String']['input'];
}>;


export type PingWebhookQuery = { __typename?: 'Query', pingWebhook?: { __typename: 'GetPingWebhook', status?: string | null, response?: { __typename?: 'PingWebhookDetailResponse', webhookId?: string | null, healthStatus?: string | null } | null } | null };

export type ListWebhooksQueryVariables = Exact<{
  input: ListWebhooksInput;
}>;


export type ListWebhooksQuery = { __typename?: 'Query', listWebhooks?: { __typename?: 'ListWebhooksResponse', status?: string | null, response?: { __typename?: 'WebhookListDataResponse', endpointsCount?: number | null, pageNumber?: number | null, pageSize?: number | null, totalCount?: number | null, totalPages?: number | null, items: Array<{ __typename?: 'WebhookItemResponse', createdTime?: string | null, customHeaders?: any | null, events?: Array<number> | null, lastModifiedTime?: string | null, productId?: number | null, url?: string | null, webhookId?: string | null, webhookStatus?: string | null, config?: { __typename?: 'WebhookConfigResponse', customHeaders?: any | null, url?: string | null } | null }> } | null } | null };

export type BalanceAdjustmentForBlockedAmountMutationVariables = Exact<{
  input: UpdateBlockedAmountInput;
}>;


export type BalanceAdjustmentForBlockedAmountMutation = { __typename?: 'Mutation', balanceAjustmentForBlockedAmt?: { __typename?: 'LoadUnloadCardResponse', transaction?: Array<{ __typename?: 'TransactionResponse', transactionType: string, transactionId: any, amount: any, currencyCode: string }> | null, balance?: { __typename?: 'BalanceResponse', cardBalance: any, currencyCode: string, pendingAmount: any } | null } | null };

export type CardBalanceAdjustmentMutationVariables = Exact<{
  input: LoadUnloadCardInput;
}>;


export type CardBalanceAdjustmentMutation = { __typename?: 'Mutation', loadUnloadCard?: { __typename: 'LoadUnloadCardResponse', transaction?: Array<{ __typename: 'TransactionResponse', transactionType: string, transactionId: any, amount: any }> | null, balance?: { __typename: 'BalanceResponse', availableBalance: any, cardBalance: any, currencyCode: string, pendingAmount: any } | null } | null };

export type ChangePaymentTokenStatusMutationVariables = Exact<{
  newStatus: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  tokenId: Scalars['Long']['input'];
  description: Scalars['String']['input'];
  updatedBy: Scalars['String']['input'];
}>;


export type ChangePaymentTokenStatusMutation = { __typename?: 'Mutation', changePaymentTokenStatus?: { __typename?: 'PaymentTokenStatusResponse', comment: string, status: string } | null };

export type MfxBalanceAdjustmentMutationVariables = Exact<{
  input: MfxBalanceAdjInput;
}>;


export type MfxBalanceAdjustmentMutation = { __typename?: 'Mutation', mfxBalanceAdjustment?: { __typename?: 'MfxCardTranResponse', transaction?: { __typename?: 'TransactionResponse', transactionType: string, transactionId: any, amount: any } | null, balance?: { __typename?: 'BalanceResponse', availableBalance: any, cardBalance: any, pendingAmount: any, currencyCode: string } | null } | null };

export type MfxLoadCardMutationVariables = Exact<{
  loadCardInput: MfxLoadCardInput;
}>;


export type MfxLoadCardMutation = { __typename?: 'Mutation', mfxLoadCard?: { __typename: 'WsLoadCardResponse', issCode?: string | null, publicToken?: string | null, sysDate?: string | null, actionCode?: string | null } | null };

export type MfxUnloadCardMutationVariables = Exact<{
  unLoadCardInput: MfxUnloadCardInput;
}>;


export type MfxUnloadCardMutation = { __typename?: 'Mutation', mfxUnloadCard?: { __typename: 'WsLoadCardResponse', issCode?: string | null, publicToken?: string | null, sysDate?: string | null } | null };

export type Get3dsCredentialsListQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type Get3dsCredentialsListQuery = { __typename?: 'Query', _dsCredentialsList?: Array<{ __typename?: 'CredentialResponse', type: string, value: string, kbaQuestion?: string | null }> | null };

export type GetCardStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCardStatusesQuery = { __typename?: 'Query', allCardStatuses?: Array<{ __typename?: 'CardStatus', code: string, description: string, isEditableByProgramManager: boolean }> | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', allCountries?: Array<{ __typename?: 'Country', alphaCode: string, numericCode: string, countryCode: string, countryName: string }> | null };

export type AllCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCurrenciesQuery = { __typename?: 'Query', allCurrencyCodes?: Array<{ __typename?: 'CurrencyCode', description: string, code: string }> | null };

export type GetProcessingCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProcessingCodesQuery = { __typename?: 'Query', allProcessingCodes?: Array<{ __typename?: 'ProcessingCode', code: string, description: string }> | null };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'Query', allRegions?: Array<{ __typename?: 'Regions', regionName: string, regionId: number, regionDescription: string, defaultRegion: boolean }> | null };

export type GetTransactionStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionStatusesQuery = { __typename?: 'Query', allTransactionStatus?: Array<{ __typename?: 'TransactionStatus', code: string, description: string }> | null };

export type GetTransactionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionTypesQuery = { __typename?: 'Query', allTransactionTypes?: Array<{ __typename?: 'TransactionType', code?: string | null, description?: string | null }> | null };

export type GetCardQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardQuery = { __typename?: 'Query', cardByPublicToken?: { __typename?: 'GetCardResponse', networkSharingOptOut?: string | null, panPubt?: any | null, cardType: CardType, childCards?: Array<any> | null, parentCard?: string | null, siblingCards?: Array<any> | null, status: CardStatusCodeNumeric, cardStatusCode: string, cardStatusDescription?: string | null, isMultiFx?: boolean | null, isMfxPrimary?: boolean | null, publicToken: string, designId?: string | null, balance?: { __typename?: 'BalanceResponse', availableBalance: any, cardBalance: any, currencyCode: string, pendingAmount: any } | null, cardDetails?: { __typename?: 'CardDetails', customerReference?: string | null, expiryDate?: string | null, fullNameOnCard?: string | null, maskedPan: string, startDate?: string | null, activationDate?: string | null, gpsExpiryDate?: string | null } | null, cardHolder?: { __typename?: 'CardHolder', dateOfBirth?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, mobile?: string | null, title?: string | null } | null, cardProduct?: { __typename?: 'CardProduct', product: number, productShortName: string, scheme: string, productName: string, networkId: any, ehiMode: any } | null, controlGroups?: { __typename?: 'ControlGroupsSub', authFeeGroup?: any | null, calendarGroup?: any | null, cardLinkageGroup?: any | null, fxGroup?: any | null, limitsGroup?: any | null, mccGroup?: any | null, paymentTokenUsageGroup?: any | null, recurringFeeGroup?: any | null, usageGroup?: any | null, webServiceFeeGroup?: any | null, cardAcceptorAllowList?: any | null, cardAcceptorDisallowList?: any | null, limitedNetworkGroup?: any | null } | null, credentials?: { __typename?: 'CredentialConfigurationResponse', configuration?: string | null, defaultCredentials?: Array<{ __typename?: 'CredentialResponse', id: number, type: string, value: string }> | null, fallbackCredentials?: { __typename?: 'CredentialResponse', id: number, type: string, value: string } | null } | null, address?: { __typename?: 'ApexAddress', addressLine1?: string | null, addressLine2?: string | null, addressLine3?: string | null, city?: string | null, country?: string | null, county?: string | null, postCode?: string | null, state?: string | null } | null } | null };

export type GetCardGroupLimitDetailsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardGroupLimitDetailsQuery = { __typename?: 'Query', cardGroupLimitDetails?: { __typename?: 'GetCardGroupLimitDetailResponse', groupCode?: string | null, groupName?: string | null, maxAllowableBalance: number, cardGroupLimits?: Array<{ __typename?: 'CardGroupLimits', dailyValueLimit: number, dailyFrequencyLimit: number, maxPerTransaction: number, minPerTransaction: number, accumulatedValueLimit1: number, accumulatedFrequencyLimit1: number, accumulatedPeriod1?: string | null, accumulatedValueLimit2: number, accumulatedFrequencyLimit2: number, accumulatedPeriod2?: string | null, subGroup?: string | null }> | null } | null };

export type GetCardNetworkTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCardNetworkTypeQuery = { __typename?: 'Query', cardNetworkType?: Array<{ __typename?: 'CardNetworkType', value: number, description: string }> | null };

export type GetCardPaymentTokenDetailsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetCardPaymentTokenDetailsQuery = { __typename?: 'Query', cardPaymentTokenList?: Array<{ __typename?: 'GetCardPaymentTokenDetailsResponse', id?: number | null, creatorTokenReference?: string | null, cardUsageGroup?: string | null, activationMethod?: string | null, walletId?: string | null, walletProvider?: string | null, walletReasons?: string | null, activationCode?: string | null, tokenPan?: any | null, tokenisedDate?: string | null, threddDecisionAt?: string | null, expiryDate?: string | null, tokenType?: string | null, deviceType?: string | null, deviceName?: string | null, merchantName?: string | null, linkedToken?: string | null, deviceLanguage?: string | null, location?: string | null, endOfPhoneNumber?: string | null, firstname?: string | null, lastname?: string | null, finalDecisionBy?: string | null, panSource?: string | null, creator?: string | null, txnStatusChanged?: string | null, activationCodeExpdate?: string | null, creatorPanReference?: string | null, statuses?: { __typename?: 'PaymentTokenStatus', tokenisedStatus: { __typename?: 'TokenisationStatus', code?: string | null, description?: string | null }, authorisationStatus: { __typename?: 'AuthorisationStatus', code?: string | null, description?: string | null }, authorisationDecision: { __typename?: 'AuthorisationDecision', code?: string | null, description?: string | null }, transactionStatus: { __typename?: 'TransStatus', code?: string | null, description?: string | null }, gpsStatusInfo: { __typename?: 'GpsStatusInfo', code?: string | null, description?: string | null } } | null }> | null };

export type GetCardTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCardTypeQuery = { __typename?: 'Query', cardType?: Array<{ __typename?: 'MFXCardType', value: number, description: string }> | null };

export type DecodeOrangeFlowQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type DecodeOrangeFlowQuery = { __typename?: 'Query', decodingOrangeFlow?: Array<{ __typename?: 'OrangeFlowReason', reason: number, offset: number, meaning: string }> | null };

export type GetPortalTransactionsQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  input: GetPortalTransactionsInput;
}>;


export type GetPortalTransactionsQuery = { __typename?: 'Query', portalTransactions?: { __typename?: 'PortalTransactionsCollectionSegment', pageInfo?: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } | null, items?: Array<{ __typename?: 'GetTransactionsResponse', title?: string | null, lifeCycleId?: string | null, cardNetwork?: string | null, note?: string | null, transactionCountry?: string | null, id?: any | null, description?: string | null, dateTime: string, isMfx?: boolean | null, productId?: number | null, processingCode?: string | null, recordId?: any | null, pubToken?: any | null, paymentMethod?: string | null, paymentTokenId?: number | null, productName?: string | null, systemTraceAuditNumber?: any | null, transactionLink?: any | null, panToken?: any | null, pant?: any | null, panPubt?: any | null, customerReference?: string | null, traceIdLifeCycle?: string | null, merchantCategoryCode?: string | null, ehiMode?: number | null, fees: { __typename?: 'TransactionFees', fixedFee: any, rateFee: any, fxPadding: any, mccPadding: any }, type?: { __typename?: 'TransactionType', code?: string | null, description?: string | null } | null, status: { __typename?: 'TransactionStatus', code: string, description: string }, amount: { __typename?: 'TransactionAmount', billingValue: any, billingValueWithDirection?: any | null, billingCurrency?: string | null, transactionValue: any, transactionCurrency?: string | null, availableBalance?: any | null, actualBalance?: any | null, billingCurrencyNumericCode?: string | null, blockedAmount?: any | null }, merchant?: { __typename?: 'Merchant', city?: string | null, contact?: string | null, county?: string | null, name?: string | null, nameOther?: string | null, networkId?: string | null, postcode?: string | null, region?: string | null, street?: string | null, taxId?: string | null, telephone?: string | null, url?: string | null } | null }> | null } | null };

export type GetSingleTransactionQueryVariables = Exact<{
  transactionId: Scalars['Long']['input'];
}>;


export type GetSingleTransactionQuery = { __typename?: 'Query', singleTransaction?: { __typename?: 'GetSingleTransactionResponse', description?: string | null, panPubt?: string | null, panReport?: string | null, billingCurrencyNumericCode?: string | null, isMfx?: boolean | null, pds146Value?: string | null, customerReference?: string | null, recordId?: any | null, pubToken?: string | null, traceIdLifeCycle?: string | null, transactionId?: any | null, transactionType?: string | null, transactionStatus?: string | null, transactionAmount?: any | null, transactionCurrency?: string | null, transactionDate?: string | null, billingAmount?: any | null, billingAmountWithDirection?: any | null, billingCurrency?: string | null, processingCode?: any | null, responseStatus?: string | null, merchantCategoryCode?: string | null, dateExpiry?: string | null, merchantCategoryDescription?: string | null, networkReferenceId?: string | null, retrievalReference?: string | null, cardAcceptorIdentificationCode?: string | null, cardAcceptorNameLocation?: string | null, aid?: string | null, fid?: string | null, cardAcceptorTerminalIdentification?: string | null, additionalData?: string | null, settlementAmount?: any | null, settlementCurrency?: string | null, authorisationCode?: string | null, additionalAmounts?: string | null, posData?: string | null, tillTime?: any | null, paymentMethod?: string | null, paymentTokenId?: number | null, productName?: string | null, ehiMode?: number | null, note?: string | null, availableBalance?: any | null, blockedAmount?: any | null, fixedFee?: any | null, surchargeFee?: string | null, stan?: string | null, messageType?: string | null, iccData?: string | null, gpsPosData?: string | null, adviceReasonData?: string | null, additionalResponseData?: string | null, networkData?: string | null, networkId?: number | null, acquirerReferenceData?: string | null, transactionOriginatingInstitution?: string | null, rateFee?: any | null, fxPadding?: any | null, mccPadding?: any | null, feeType?: string | null, feeProcessingCode?: string | null, settlementIndicator?: string | null, interchangeAmountFee?: string | null, currencyCodeFee?: string | null, interchangeAmountFeeSettlement?: string | null, currencyCodeFeeSettlement?: string | null, functionCode?: string | null, additionalAuthorisationDataDgn?: string | null, transactionDestinationIic?: string | null, recapNumber?: string | null, currencyCode?: string | null, responseReason?: string | null, responseStatusDescription?: string | null, requestTime?: string | null, responseSource?: string | null, responseTime?: string | null, recapDate?: string | null, diffInReqResp?: number | null, posConditionCode?: string | null, avsStreet?: string | null, avsPostcode?: string | null, transactionFees?: { __typename?: 'TransactionFeesResponse', domesticFixedFee: any, domesticRateFee: any, fxFixedFee: any, fxRateFee: any, nonDomesticFixedFee: any, nonDomesticRateFee: any } | null, posEntry?: { __typename?: 'PosEntry', code?: string | null, codeDescription?: Array<{ __typename?: 'CodeDescription', position?: string | null, value?: string | null, bitPositionDescription?: string | null, description?: string | null }> | null } | null, avsCardResponse?: { __typename?: 'AvsCardResponse', streetAddressDigits?: string | null, postcodeDigits?: string | null, postcodeResult?: string | null, addressResult?: string | null, avsResponse?: string | null } | null, merchant?: { __typename?: 'Merchant', city?: string | null, contact?: string | null, county?: string | null, countyCode?: string | null, name?: string | null, nameOther?: string | null, networkId?: string | null, postcode?: string | null, region?: string | null, street?: string | null, taxId?: string | null, telephone?: string | null, url?: string | null } | null, pos?: { __typename?: 'Pos', cardholderAuthenticationEntity1?: string | null, cardholderAuthenticationEntity2?: string | null, cardholderAuthenticationEntity3?: string | null, cardholderAuthenticationEntity4?: string | null, cardholderAuthenticationMethod1?: string | null, cardholderAuthenticationMethod2?: string | null, cardholderAuthenticationMethod3?: string | null, cardholderAuthenticationMethod4?: string | null, cardholderPresent?: string | null, cardInput?: string | null, cardPresent?: string | null, chipFallback?: string | null, fraudIndicator?: string | null, secure3DAuthenticationMethod?: string | null, securityCardholderToMerchant?: string | null, instantFundingNetwork?: string | null, instantFundingThredd?: string | null, scaExempt?: string | null, scaAssessment?: string | null, scaKnowledgeTest?: string | null, scaPossessionTest?: string | null, scaBiometricTest?: string | null, threddDetectedScaExemption?: string | null, cardDeviceFormFactor?: string | null, acquirerExemptScaIndicator?: string | null, authenticationAmountAndCurrencyComparisonResult?: string | null, merchantCardholderInitiatedIndicator?: string | null, merchantInitiatedTransactionTypeIndicator?: string | null, originalTransactionScaExemptIndicator?: string | null, originalTransactionScaAssessmentResult?: string | null, originalTransactionStatusValue?: string | null, extendedAuthorizationIndicator?: string | null } | null, posCapabilities?: { __typename?: 'PosCapabilities', attended?: string | null, cardCapture?: string | null, cardholderAuthentication?: string | null, cardInput?: string | null, cardOutput?: string | null, environment?: string | null, partialApproval?: string | null, pinCapture?: string | null, purchaseAmountOnlyApproval?: string | null, terminalOutput?: string | null, terminalType?: string | null } | null, decodedAdditionalAmount?: Array<{ __typename?: 'AdditionalAmount', occurence: string, accountType: { __typename?: 'TypeValue', encodedData?: string | null, decodedDataString?: string | null }, amount: { __typename?: 'TypeValue', encodedData?: string | null, decodedDataString?: string | null }, amountType: { __typename?: 'TypeValue', encodedData?: string | null, decodedDataString?: string | null }, currencyCode: { __typename?: 'TypeValue', encodedData?: string | null, decodedDataString?: string | null }, transactionType: { __typename?: 'TypeValue', encodedData?: string | null, decodedDataString?: string | null } }> | null, decodedAdditionalResponseData?: Array<{ __typename?: 'AdditionalResponseData', description: string, value: string }> | null, visaFleet?: { __typename?: 'VisaFleet', fleetData?: { __typename?: 'VisaFleetFleetData', typeOfPurchase?: string | null, serviceType?: string | null, fuelType?: string | null, expandedFuelType?: string | null, unitOfMeasure?: string | null, quantity?: any | null, unitCost?: any | null, grossFuelPrice?: any | null, netFuelPrice?: any | null, grossNonFuelPrice?: any | null, netNonFuelPrice?: any | null, nonFuelProductCode1?: string | null, nonFuelProductCode2?: string | null, nonFuelProductCode3?: string | null, nonFuelProductCode4?: string | null, nonFuelProductCode5?: string | null, nonFuelProductCode6?: string | null, nonFuelProductCode7?: string | null, nonFuelProductCode8?: string | null } | null, promptData?: { __typename?: 'VisaFleetPromptData', odometerReading?: string | null, visaFleetServiceId?: string | null, fleetWorkOrderNumber?: string | null, fleetEmployeeNumber?: string | null, fleetTrailerNumber?: string | null } | null, evData?: { __typename?: 'VisaFleetEvData', chargingPowerOutputCapacity?: number | null, chargingReasonCode?: string | null, maximumPowerDispensed?: number | null, connectorType?: string | null, totalTimePluggedIn?: string | null, totalChargingTime?: string | null, startTimeOfCharge?: string | null, finishTimeOfCharge?: string | null, estimatedKmMilesAdded?: number | null, estimatedKmMilesAvailable?: number | null, carbonFootprint?: number | null } | null, invoiceLineItem?: Array<{ __typename?: 'VisaFleetInvoiceLineItem', itemSequenceNumber?: number | null, itemDescription?: string | null, productCode?: string | null, commodityCode?: string | null, quantity?: any | null, unitOfMeasure?: string | null, unitCost?: any | null, discountPerLineItem?: any | null, lineItemTotal?: any | null, vatTaxAmount?: any | null, vatRate?: any | null }> | null } | null } | null };

export type GetTransactionFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransactionFilterOptionsQuery = { __typename?: 'Query', cardNetworkType?: Array<{ __typename?: 'CardNetworkType', value: number, description: string }> | null, allTransactionStatus?: Array<{ __typename?: 'TransactionStatus', code: string, description: string }> | null, allTransactionTypes?: Array<{ __typename?: 'TransactionType', code?: string | null, description?: string | null }> | null, allProcessingCodes?: Array<{ __typename?: 'ProcessingCode', code: string, description: string }> | null };

export type GetTransactionsQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  input: GetTransactionsInput;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', transactions?: { __typename?: 'TransactionsCollectionSegment', totalCount?: number | null, items?: Array<{ __typename?: 'GetTransactionsResponse', title?: string | null, customerReference?: string | null, lifeCycleId?: string | null, cardNetwork?: string | null, note?: string | null, transactionCountry?: string | null, id?: any | null, description?: string | null, dateTime: string, isMfx?: boolean | null, productId?: number | null, processingCode?: string | null, recordId?: any | null, pubToken?: any | null, paymentMethod?: string | null, paymentTokenId?: number | null, productName?: string | null, systemTraceAuditNumber?: any | null, transactionLink?: any | null, pant?: any | null, panPubt?: any | null, traceIdLifeCycle?: string | null, merchantCategoryCode?: string | null, fees: { __typename?: 'TransactionFees', fixedFee: any, rateFee: any, fxPadding: any, mccPadding: any }, type?: { __typename?: 'TransactionType', code?: string | null, description?: string | null } | null, status: { __typename?: 'TransactionStatus', code: string, description: string }, amount: { __typename?: 'TransactionAmount', billingCurrencyNumericCode?: string | null, billingValue: any, billingValueWithDirection?: any | null, billingCurrency?: string | null, transactionValue: any, transactionCurrency?: string | null, availableBalance?: any | null, actualBalance?: any | null, blockedAmount?: any | null }, merchant?: { __typename?: 'Merchant', name?: string | null, city?: string | null, county?: string | null } | null }> | null } | null };

export type GetWalletDetailsQueryVariables = Exact<{
  publicToken: Scalars['String']['input'];
}>;


export type GetWalletDetailsQuery = { __typename?: 'Query', walletDetails?: { __typename?: 'GetWalletResponse', isAutoTransfer?: boolean | null, wallets: Array<{ __typename?: 'WalletDetails', publicToken?: string | null, isMfxPrimary?: boolean | null, balanceDetails?: { __typename?: 'BalanceResponse', cardBalance: any, currencyCode: string, availableBalance: any, pendingAmount: any } | null }> } | null };


export const FinancialProductListDocument = gql`
    query FinancialProductList($clientId: String, $referenceId: String, $name: String, $scope: ProductScope, $category: ProductCategory, $description: String, $status: ProductStatus, $createdBy: String, $updatedBy: String, $subClientIds: [String!]) {
  financialProductList(
    input: {clientId: $clientId, referenceId: $referenceId, name: $name, scope: $scope, category: $category, description: $description, status: $status, createdBy: $createdBy, updatedBy: $updatedBy, subClientIds: $subClientIds}
  ) {
    id
    clientId
    referenceId
    name
    scope
    category
    description
    status
    version
    createdAt
    createdBy
    updatedAt
    updatedBy
    activeStart
    activeEnd
    subClientIds
    ledgers {
      id
      name
      currency
      autoCreate
      instrumentProductIds
      loadLimits {
        single {
          max
        }
        balance {
          max
        }
        daily {
          max
        }
        weekly {
          max
        }
        monthly {
          max
        }
        annually {
          max
        }
      }
      version
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
}
    `;

/**
 * __useFinancialProductListQuery__
 *
 * To run a query within a React component, call `useFinancialProductListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialProductListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialProductListQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      referenceId: // value for 'referenceId'
 *      name: // value for 'name'
 *      scope: // value for 'scope'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      createdBy: // value for 'createdBy'
 *      updatedBy: // value for 'updatedBy'
 *      subClientIds: // value for 'subClientIds'
 *   },
 * });
 */
export function useFinancialProductListQuery(baseOptions?: Apollo.QueryHookOptions<FinancialProductListQuery, FinancialProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialProductListQuery, FinancialProductListQueryVariables>(FinancialProductListDocument, options);
      }
export function useFinancialProductListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialProductListQuery, FinancialProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialProductListQuery, FinancialProductListQueryVariables>(FinancialProductListDocument, options);
        }
// @ts-ignore
export function useFinancialProductListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FinancialProductListQuery, FinancialProductListQueryVariables>): Apollo.UseSuspenseQueryResult<FinancialProductListQuery, FinancialProductListQueryVariables>;
export function useFinancialProductListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancialProductListQuery, FinancialProductListQueryVariables>): Apollo.UseSuspenseQueryResult<FinancialProductListQuery | undefined, FinancialProductListQueryVariables>;
export function useFinancialProductListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinancialProductListQuery, FinancialProductListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinancialProductListQuery, FinancialProductListQueryVariables>(FinancialProductListDocument, options);
        }
export type FinancialProductListQueryHookResult = ReturnType<typeof useFinancialProductListQuery>;
export type FinancialProductListLazyQueryHookResult = ReturnType<typeof useFinancialProductListLazyQuery>;
export type FinancialProductListSuspenseQueryHookResult = ReturnType<typeof useFinancialProductListSuspenseQuery>;
export type FinancialProductListQueryResult = Apollo.QueryResult<FinancialProductListQuery, FinancialProductListQueryVariables>;
export const LedgerConfigurationListDocument = gql`
    query LedgerConfigurationList($input: LedgerConfigInput) {
  ledgerConfigurationList(input: $input) {
    id
    name
    currency
    autoCreate
    instrumentProductIds
    financialProductId
    clientId
    loadLimits {
      single {
        max
      }
      balance {
        max
      }
      daily {
        max
      }
      weekly {
        max
      }
      monthly {
        max
      }
      annually {
        max
      }
    }
    version
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useLedgerConfigurationListQuery__
 *
 * To run a query within a React component, call `useLedgerConfigurationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerConfigurationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerConfigurationListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLedgerConfigurationListQuery(baseOptions?: Apollo.QueryHookOptions<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>(LedgerConfigurationListDocument, options);
      }
export function useLedgerConfigurationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>(LedgerConfigurationListDocument, options);
        }
// @ts-ignore
export function useLedgerConfigurationListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>): Apollo.UseSuspenseQueryResult<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>;
export function useLedgerConfigurationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>): Apollo.UseSuspenseQueryResult<LedgerConfigurationListQuery | undefined, LedgerConfigurationListQueryVariables>;
export function useLedgerConfigurationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>(LedgerConfigurationListDocument, options);
        }
export type LedgerConfigurationListQueryHookResult = ReturnType<typeof useLedgerConfigurationListQuery>;
export type LedgerConfigurationListLazyQueryHookResult = ReturnType<typeof useLedgerConfigurationListLazyQuery>;
export type LedgerConfigurationListSuspenseQueryHookResult = ReturnType<typeof useLedgerConfigurationListSuspenseQuery>;
export type LedgerConfigurationListQueryResult = Apollo.QueryResult<LedgerConfigurationListQuery, LedgerConfigurationListQueryVariables>;
export const GetTrustChainDocument = gql`
    query GetTrustChain($caType: String!) {
  getTrustChain(caType: $caType) {
    trustChain {
      certificate
      certificateChain
      caArn
      status
      type
      notBefore
      notAfter
    }
    downloadUrl
  }
}
    `;

/**
 * __useGetTrustChainQuery__
 *
 * To run a query within a React component, call `useGetTrustChainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrustChainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrustChainQuery({
 *   variables: {
 *      caType: // value for 'caType'
 *   },
 * });
 */
export function useGetTrustChainQuery(baseOptions: Apollo.QueryHookOptions<GetTrustChainQuery, GetTrustChainQueryVariables> & ({ variables: GetTrustChainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrustChainQuery, GetTrustChainQueryVariables>(GetTrustChainDocument, options);
      }
export function useGetTrustChainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrustChainQuery, GetTrustChainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrustChainQuery, GetTrustChainQueryVariables>(GetTrustChainDocument, options);
        }
// @ts-ignore
export function useGetTrustChainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrustChainQuery, GetTrustChainQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrustChainQuery, GetTrustChainQueryVariables>;
export function useGetTrustChainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrustChainQuery, GetTrustChainQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrustChainQuery | undefined, GetTrustChainQueryVariables>;
export function useGetTrustChainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrustChainQuery, GetTrustChainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrustChainQuery, GetTrustChainQueryVariables>(GetTrustChainDocument, options);
        }
export type GetTrustChainQueryHookResult = ReturnType<typeof useGetTrustChainQuery>;
export type GetTrustChainLazyQueryHookResult = ReturnType<typeof useGetTrustChainLazyQuery>;
export type GetTrustChainSuspenseQueryHookResult = ReturnType<typeof useGetTrustChainSuspenseQuery>;
export type GetTrustChainQueryResult = Apollo.QueryResult<GetTrustChainQuery, GetTrustChainQueryVariables>;
export const CreateOrganisationDocument = gql`
    mutation CreateOrganisation($input: CreateOrganisationInput!) {
  createOrganisation(input: $input) {
    organisationId
    name
    slug
    status
    cognitoGroupName
    metadata
    identityProviderConfig
    issuerId
    internalId
    pmInformation {
      pmId
      pmCode
    }
    products
    emailDomains
    description
    createdAt
    updatedAt
    createdBy
    connection
    clientAuthMethod
    authProvider
    subClientId
  }
}
    `;
export type CreateOrganisationMutationFn = Apollo.MutationFunction<CreateOrganisationMutation, CreateOrganisationMutationVariables>;

/**
 * __useCreateOrganisationMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationMutation, { data, loading, error }] = useCreateOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationMutation, CreateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationMutation, CreateOrganisationMutationVariables>(CreateOrganisationDocument, options);
      }
export type CreateOrganisationMutationHookResult = ReturnType<typeof useCreateOrganisationMutation>;
export type CreateOrganisationMutationResult = Apollo.MutationResult<CreateOrganisationMutation>;
export type CreateOrganisationMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationMutation, CreateOrganisationMutationVariables>;
export const DeleteOrganisationDocument = gql`
    mutation DeleteOrganisation($organisationId: String!) {
  deleteOrganisation(organisationId: $organisationId) {
    message
    username
    enabled
  }
}
    `;
export type DeleteOrganisationMutationFn = Apollo.MutationFunction<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;

/**
 * __useDeleteOrganisationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationMutation, { data, loading, error }] = useDeleteOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useDeleteOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>(DeleteOrganisationDocument, options);
      }
export type DeleteOrganisationMutationHookResult = ReturnType<typeof useDeleteOrganisationMutation>;
export type DeleteOrganisationMutationResult = Apollo.MutationResult<DeleteOrganisationMutation>;
export type DeleteOrganisationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;
export const UpdateOrganisationDocument = gql`
    mutation UpdateOrganisation($organisationId: String!, $input: UpdateOrganisationInput!) {
  updateOrganisation(organisationId: $organisationId, input: $input) {
    organisationId
    name
    slug
    status
    cognitoGroupName
    metadata
    identityProviderConfig
    issuerId
    internalId
    pmInformation {
      pmId
      pmCode
    }
    products
    emailDomains
    description
    createdAt
    updatedAt
    createdBy
    connection
    clientAuthMethod
    authProvider
    subClientId
  }
}
    `;
export type UpdateOrganisationMutationFn = Apollo.MutationFunction<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;

/**
 * __useUpdateOrganisationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationMutation, { data, loading, error }] = useUpdateOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>(UpdateOrganisationDocument, options);
      }
export type UpdateOrganisationMutationHookResult = ReturnType<typeof useUpdateOrganisationMutation>;
export type UpdateOrganisationMutationResult = Apollo.MutationResult<UpdateOrganisationMutation>;
export type UpdateOrganisationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;
export const GetOrganisationDocument = gql`
    query GetOrganisation($organisationId: String!) {
  organisation(organisationId: $organisationId) {
    organisationId
    name
    slug
    connection
    status
    cognitoGroupName
    metadata
    identityProviderConfig
    issuerId
    internalId
    pmInformation {
      pmId
      pmCode
    }
    products
    emailDomains
    description
    createdAt
    updatedAt
    createdBy
    scopes
    clientAuthMethod
    clientId
    subClientId
  }
}
    `;

/**
 * __useGetOrganisationQuery__
 *
 * To run a query within a React component, call `useGetOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetOrganisationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables> & ({ variables: GetOrganisationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
      }
export function useGetOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
        }
// @ts-ignore
export function useGetOrganisationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationQuery, GetOrganisationQueryVariables>;
export function useGetOrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationQuery | undefined, GetOrganisationQueryVariables>;
export function useGetOrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
        }
export type GetOrganisationQueryHookResult = ReturnType<typeof useGetOrganisationQuery>;
export type GetOrganisationLazyQueryHookResult = ReturnType<typeof useGetOrganisationLazyQuery>;
export type GetOrganisationSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationSuspenseQuery>;
export type GetOrganisationQueryResult = Apollo.QueryResult<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const GetOrganisationBySlugDocument = gql`
    query GetOrganisationBySlug($slug: String!) {
  organisationBySlug(slug: $slug) {
    cognitoGroupName
    connection
    createdAt
    createdBy
    description
    emailDomains
    isActive
    identityProviderConfig
    updatedAt
    status
    slug
    scopes
    products
    issuerId
    internalId
    pmInformation {
      pmId
      pmCode
    }
    organisationId
    name
    metadata
    clientAuthMethod
    clientId
    subClientId
  }
}
    `;

/**
 * __useGetOrganisationBySlugQuery__
 *
 * To run a query within a React component, call `useGetOrganisationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganisationBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables> & ({ variables: GetOrganisationBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>(GetOrganisationBySlugDocument, options);
      }
export function useGetOrganisationBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>(GetOrganisationBySlugDocument, options);
        }
// @ts-ignore
export function useGetOrganisationBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>;
export function useGetOrganisationBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationBySlugQuery | undefined, GetOrganisationBySlugQueryVariables>;
export function useGetOrganisationBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>(GetOrganisationBySlugDocument, options);
        }
export type GetOrganisationBySlugQueryHookResult = ReturnType<typeof useGetOrganisationBySlugQuery>;
export type GetOrganisationBySlugLazyQueryHookResult = ReturnType<typeof useGetOrganisationBySlugLazyQuery>;
export type GetOrganisationBySlugSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationBySlugSuspenseQuery>;
export type GetOrganisationBySlugQueryResult = Apollo.QueryResult<GetOrganisationBySlugQuery, GetOrganisationBySlugQueryVariables>;
export const ListOrganisationsDocument = gql`
    query ListOrganisations($limit: Int! = 100) {
  listOrganisations(limit: $limit) {
    organisations {
      organisationId
      name
      slug
      connection
      status
      cognitoGroupName
      metadata
      identityProviderConfig
      issuerId
      internalId
      pmInformation {
        pmId
        pmCode
      }
      products
      emailDomains
      description
      isActive
      createdAt
      updatedAt
      createdBy
      scopes
      clientAuthMethod
      authProvider
      subClientId
    }
    totalCount
  }
}
    `;

/**
 * __useListOrganisationsQuery__
 *
 * To run a query within a React component, call `useListOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganisationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<ListOrganisationsQuery, ListOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganisationsQuery, ListOrganisationsQueryVariables>(ListOrganisationsDocument, options);
      }
export function useListOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganisationsQuery, ListOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganisationsQuery, ListOrganisationsQueryVariables>(ListOrganisationsDocument, options);
        }
// @ts-ignore
export function useListOrganisationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrganisationsQuery, ListOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrganisationsQuery, ListOrganisationsQueryVariables>;
export function useListOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganisationsQuery, ListOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrganisationsQuery | undefined, ListOrganisationsQueryVariables>;
export function useListOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganisationsQuery, ListOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganisationsQuery, ListOrganisationsQueryVariables>(ListOrganisationsDocument, options);
        }
export type ListOrganisationsQueryHookResult = ReturnType<typeof useListOrganisationsQuery>;
export type ListOrganisationsLazyQueryHookResult = ReturnType<typeof useListOrganisationsLazyQuery>;
export type ListOrganisationsSuspenseQueryHookResult = ReturnType<typeof useListOrganisationsSuspenseQuery>;
export type ListOrganisationsQueryResult = Apollo.QueryResult<ListOrganisationsQuery, ListOrganisationsQueryVariables>;
export const CreateApplicationCertificateDocument = gql`
    mutation CreateApplicationCertificate($applicationId: String!, $input: CreateCertificateIssuerInput!) {
  createApplicationCertificate(applicationId: $applicationId, input: $input) {
    message
  }
}
    `;
export type CreateApplicationCertificateMutationFn = Apollo.MutationFunction<CreateApplicationCertificateMutation, CreateApplicationCertificateMutationVariables>;

/**
 * __useCreateApplicationCertificateMutation__
 *
 * To run a mutation, you first call `useCreateApplicationCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationCertificateMutation, { data, loading, error }] = useCreateApplicationCertificateMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationCertificateMutation, CreateApplicationCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationCertificateMutation, CreateApplicationCertificateMutationVariables>(CreateApplicationCertificateDocument, options);
      }
export type CreateApplicationCertificateMutationHookResult = ReturnType<typeof useCreateApplicationCertificateMutation>;
export type CreateApplicationCertificateMutationResult = Apollo.MutationResult<CreateApplicationCertificateMutation>;
export type CreateApplicationCertificateMutationOptions = Apollo.BaseMutationOptions<CreateApplicationCertificateMutation, CreateApplicationCertificateMutationVariables>;
export const RevokeApplicationCertificateDocument = gql`
    mutation RevokeApplicationCertificate($applicationId: String!, $kid: String!, $input: RevokeCertificateInput!) {
  revokeApplicationCertificate(
    applicationId: $applicationId
    kid: $kid
    input: $input
  ) {
    message
  }
}
    `;
export type RevokeApplicationCertificateMutationFn = Apollo.MutationFunction<RevokeApplicationCertificateMutation, RevokeApplicationCertificateMutationVariables>;

/**
 * __useRevokeApplicationCertificateMutation__
 *
 * To run a mutation, you first call `useRevokeApplicationCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApplicationCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApplicationCertificateMutation, { data, loading, error }] = useRevokeApplicationCertificateMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      kid: // value for 'kid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeApplicationCertificateMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApplicationCertificateMutation, RevokeApplicationCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApplicationCertificateMutation, RevokeApplicationCertificateMutationVariables>(RevokeApplicationCertificateDocument, options);
      }
export type RevokeApplicationCertificateMutationHookResult = ReturnType<typeof useRevokeApplicationCertificateMutation>;
export type RevokeApplicationCertificateMutationResult = Apollo.MutationResult<RevokeApplicationCertificateMutation>;
export type RevokeApplicationCertificateMutationOptions = Apollo.BaseMutationOptions<RevokeApplicationCertificateMutation, RevokeApplicationCertificateMutationVariables>;
export const DownloadApplicationCertificatesDocument = gql`
    query DownloadApplicationCertificates($applicationId: String!, $kid: String!) {
  getApplicationCertificatePem(applicationId: $applicationId, kid: $kid) {
    body
    filename
  }
}
    `;

/**
 * __useDownloadApplicationCertificatesQuery__
 *
 * To run a query within a React component, call `useDownloadApplicationCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadApplicationCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadApplicationCertificatesQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      kid: // value for 'kid'
 *   },
 * });
 */
export function useDownloadApplicationCertificatesQuery(baseOptions: Apollo.QueryHookOptions<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables> & ({ variables: DownloadApplicationCertificatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>(DownloadApplicationCertificatesDocument, options);
      }
export function useDownloadApplicationCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>(DownloadApplicationCertificatesDocument, options);
        }
// @ts-ignore
export function useDownloadApplicationCertificatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>;
export function useDownloadApplicationCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadApplicationCertificatesQuery | undefined, DownloadApplicationCertificatesQueryVariables>;
export function useDownloadApplicationCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>(DownloadApplicationCertificatesDocument, options);
        }
export type DownloadApplicationCertificatesQueryHookResult = ReturnType<typeof useDownloadApplicationCertificatesQuery>;
export type DownloadApplicationCertificatesLazyQueryHookResult = ReturnType<typeof useDownloadApplicationCertificatesLazyQuery>;
export type DownloadApplicationCertificatesSuspenseQueryHookResult = ReturnType<typeof useDownloadApplicationCertificatesSuspenseQuery>;
export type DownloadApplicationCertificatesQueryResult = Apollo.QueryResult<DownloadApplicationCertificatesQuery, DownloadApplicationCertificatesQueryVariables>;
export const AddUserToGroupDocument = gql`
    mutation AddUserToGroup($groupId: String!, $organisationId: String!, $username: String!) {
  addUserToGroup(
    groupId: $groupId
    organisationId: $organisationId
    username: $username
  ) {
    enabled
    message
    username
  }
}
    `;
export type AddUserToGroupMutationFn = Apollo.MutationFunction<AddUserToGroupMutation, AddUserToGroupMutationVariables>;

/**
 * __useAddUserToGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToGroupMutation, { data, loading, error }] = useAddUserToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      organisationId: // value for 'organisationId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useAddUserToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(AddUserToGroupDocument, options);
      }
export type AddUserToGroupMutationHookResult = ReturnType<typeof useAddUserToGroupMutation>;
export type AddUserToGroupMutationResult = Apollo.MutationResult<AddUserToGroupMutation>;
export type AddUserToGroupMutationOptions = Apollo.BaseMutationOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>;
export const CreateOrganisationGroupDocument = gql`
    mutation CreateOrganisationGroup($input: CreateOrganisationGroupInput!, $organisationId: String!) {
  createOrganisationGroup(input: $input, organisationId: $organisationId) {
    cognitoGroupName
    createdAt
    createdBy
    description
    groupId
    isActive
    name
    organisationId
    scopes
    updatedAt
  }
}
    `;
export type CreateOrganisationGroupMutationFn = Apollo.MutationFunction<CreateOrganisationGroupMutation, CreateOrganisationGroupMutationVariables>;

/**
 * __useCreateOrganisationGroupMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationGroupMutation, { data, loading, error }] = useCreateOrganisationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useCreateOrganisationGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationGroupMutation, CreateOrganisationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationGroupMutation, CreateOrganisationGroupMutationVariables>(CreateOrganisationGroupDocument, options);
      }
export type CreateOrganisationGroupMutationHookResult = ReturnType<typeof useCreateOrganisationGroupMutation>;
export type CreateOrganisationGroupMutationResult = Apollo.MutationResult<CreateOrganisationGroupMutation>;
export type CreateOrganisationGroupMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationGroupMutation, CreateOrganisationGroupMutationVariables>;
export const CreateIdentityProviderDocument = gql`
    mutation CreateIdentityProvider($organisationId: String!, $input: CreateIdpInput!) {
  createIdentityProvider(organisationId: $organisationId, input: $input) {
    idpId
    attributeMappings {
      internalAttribute
      externalAttribute
      isRequired
    }
    autoCreateUsers
    defaultGroupMappings
    description
    idpType
    metadata
    name
    oidcConfig {
      authorizationEndpoint
      clientId
      clientSecret
      discoveryUrl
      issuer
      jwksUri
      responseMode
      responseType
      scopes
      tokenEndpoint
      userinfoEndpoint
    }
    samlConfig {
      metadataUrl
      metadataXml
    }
  }
}
    `;
export type CreateIdentityProviderMutationFn = Apollo.MutationFunction<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>;

/**
 * __useCreateIdentityProviderMutation__
 *
 * To run a mutation, you first call `useCreateIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdentityProviderMutation, { data, loading, error }] = useCreateIdentityProviderMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>(CreateIdentityProviderDocument, options);
      }
export type CreateIdentityProviderMutationHookResult = ReturnType<typeof useCreateIdentityProviderMutation>;
export type CreateIdentityProviderMutationResult = Apollo.MutationResult<CreateIdentityProviderMutation>;
export type CreateIdentityProviderMutationOptions = Apollo.BaseMutationOptions<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!, $organisationId: String!) {
  createUser(input: $input, organisationId: $organisationId) {
    email
    groupId
    invitationSent
    organisationId
    organisationName
    status
    temporaryPassword
    userId
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteOrganisationGroupDocument = gql`
    mutation DeleteOrganisationGroup($groupId: String!, $organisationId: String!) {
  deleteOrganisationGroup(groupId: $groupId, organisationId: $organisationId) {
    enabled
    message
    username
  }
}
    `;
export type DeleteOrganisationGroupMutationFn = Apollo.MutationFunction<DeleteOrganisationGroupMutation, DeleteOrganisationGroupMutationVariables>;

/**
 * __useDeleteOrganisationGroupMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationGroupMutation, { data, loading, error }] = useDeleteOrganisationGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useDeleteOrganisationGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationGroupMutation, DeleteOrganisationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationGroupMutation, DeleteOrganisationGroupMutationVariables>(DeleteOrganisationGroupDocument, options);
      }
export type DeleteOrganisationGroupMutationHookResult = ReturnType<typeof useDeleteOrganisationGroupMutation>;
export type DeleteOrganisationGroupMutationResult = Apollo.MutationResult<DeleteOrganisationGroupMutation>;
export type DeleteOrganisationGroupMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationGroupMutation, DeleteOrganisationGroupMutationVariables>;
export const DeleteIdentityProviderDocument = gql`
    mutation DeleteIdentityProvider($organisationId: String!, $idpId: String!) {
  deleteIdentityProvider(organisationId: $organisationId, idpId: $idpId) {
    message
    enabled
    username
  }
}
    `;
export type DeleteIdentityProviderMutationFn = Apollo.MutationFunction<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>;

/**
 * __useDeleteIdentityProviderMutation__
 *
 * To run a mutation, you first call `useDeleteIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdentityProviderMutation, { data, loading, error }] = useDeleteIdentityProviderMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      idpId: // value for 'idpId'
 *   },
 * });
 */
export function useDeleteIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>(DeleteIdentityProviderDocument, options);
      }
export type DeleteIdentityProviderMutationHookResult = ReturnType<typeof useDeleteIdentityProviderMutation>;
export type DeleteIdentityProviderMutationResult = Apollo.MutationResult<DeleteIdentityProviderMutation>;
export type DeleteIdentityProviderMutationOptions = Apollo.BaseMutationOptions<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>;
export const CreateOAuthClientDocument = gql`
    mutation CreateOAuthClient($input: CreateOAuthClientInput!, $organisationId: String!) {
  createOauthClient(input: $input, organisationId: $organisationId) {
    allowedGroupIds
    clientId
    createdAt
    createdBy
    description
    ipWhitelist
    isActive
    lastSecretRotation
    name
    updatedAt
    usageNotes
  }
}
    `;
export type CreateOAuthClientMutationFn = Apollo.MutationFunction<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;

/**
 * __useCreateOAuthClientMutation__
 *
 * To run a mutation, you first call `useCreateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthClientMutation, { data, loading, error }] = useCreateOAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useCreateOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>(CreateOAuthClientDocument, options);
      }
export type CreateOAuthClientMutationHookResult = ReturnType<typeof useCreateOAuthClientMutation>;
export type CreateOAuthClientMutationResult = Apollo.MutationResult<CreateOAuthClientMutation>;
export type CreateOAuthClientMutationOptions = Apollo.BaseMutationOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;
export const UpdateOAuthClientDocument = gql`
    mutation UpdateOAuthClient($clientId: String!, $input: UpdateOAuthClientInput!, $organisationId: String!) {
  updateOauthClient(
    clientId: $clientId
    input: $input
    organisationId: $organisationId
  ) {
    allowedGroupIds
    clientId
    createdAt
    createdBy
    description
    ipWhitelist
    isActive
    lastSecretRotation
    name
    scopes
    tags
    updatedAt
    usageNotes
  }
}
    `;
export type UpdateOAuthClientMutationFn = Apollo.MutationFunction<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>;

/**
 * __useUpdateOAuthClientMutation__
 *
 * To run a mutation, you first call `useUpdateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOAuthClientMutation, { data, loading, error }] = useUpdateOAuthClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      input: // value for 'input'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useUpdateOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>(UpdateOAuthClientDocument, options);
      }
export type UpdateOAuthClientMutationHookResult = ReturnType<typeof useUpdateOAuthClientMutation>;
export type UpdateOAuthClientMutationResult = Apollo.MutationResult<UpdateOAuthClientMutation>;
export type UpdateOAuthClientMutationOptions = Apollo.BaseMutationOptions<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>;
export const DeleteOAuthClientDocument = gql`
    mutation deleteOAuthClient($clientId: String!, $organisationId: String!) {
  deleteOauthClient(clientId: $clientId, organisationId: $organisationId) {
    username
    message
    enabled
  }
}
    `;
export type DeleteOAuthClientMutationFn = Apollo.MutationFunction<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;

/**
 * __useDeleteOAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthClientMutation, { data, loading, error }] = useDeleteOAuthClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useDeleteOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>(DeleteOAuthClientDocument, options);
      }
export type DeleteOAuthClientMutationHookResult = ReturnType<typeof useDeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationResult = Apollo.MutationResult<DeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationOptions = Apollo.BaseMutationOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;
export const PerformIdpHealthCheckDocument = gql`
    mutation PerformIdpHealthCheck($organisationId: String!, $idpId: String!) {
  performIdpHealthCheck(organisationId: $organisationId, idpId: $idpId) {
    idpId
    status
    lastChecked
    details
    errors
  }
}
    `;
export type PerformIdpHealthCheckMutationFn = Apollo.MutationFunction<PerformIdpHealthCheckMutation, PerformIdpHealthCheckMutationVariables>;

/**
 * __usePerformIdpHealthCheckMutation__
 *
 * To run a mutation, you first call `usePerformIdpHealthCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformIdpHealthCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performIdpHealthCheckMutation, { data, loading, error }] = usePerformIdpHealthCheckMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      idpId: // value for 'idpId'
 *   },
 * });
 */
export function usePerformIdpHealthCheckMutation(baseOptions?: Apollo.MutationHookOptions<PerformIdpHealthCheckMutation, PerformIdpHealthCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformIdpHealthCheckMutation, PerformIdpHealthCheckMutationVariables>(PerformIdpHealthCheckDocument, options);
      }
export type PerformIdpHealthCheckMutationHookResult = ReturnType<typeof usePerformIdpHealthCheckMutation>;
export type PerformIdpHealthCheckMutationResult = Apollo.MutationResult<PerformIdpHealthCheckMutation>;
export type PerformIdpHealthCheckMutationOptions = Apollo.BaseMutationOptions<PerformIdpHealthCheckMutation, PerformIdpHealthCheckMutationVariables>;
export const RemoveUserFromGroupDocument = gql`
    mutation RemoveUserFromGroup($groupId: String!, $organisationId: String!, $username: String!) {
  removeUserFromGroup(
    groupId: $groupId
    organisationId: $organisationId
    username: $username
  ) {
    enabled
    message
    username
  }
}
    `;
export type RemoveUserFromGroupMutationFn = Apollo.MutationFunction<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;

/**
 * __useRemoveUserFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromGroupMutation, { data, loading, error }] = useRemoveUserFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      organisationId: // value for 'organisationId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useRemoveUserFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(RemoveUserFromGroupDocument, options);
      }
export type RemoveUserFromGroupMutationHookResult = ReturnType<typeof useRemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationResult = Apollo.MutationResult<RemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;
export const RemoveUserFromOrganisationDocument = gql`
    mutation RemoveUserFromOrganisation($organisationId: String!, $username: String!) {
  removeUserFromOrganisation(organisationId: $organisationId, username: $username) {
    message
  }
}
    `;
export type RemoveUserFromOrganisationMutationFn = Apollo.MutationFunction<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>;

/**
 * __useRemoveUserFromOrganisationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganisationMutation, { data, loading, error }] = useRemoveUserFromOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useRemoveUserFromOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>(RemoveUserFromOrganisationDocument, options);
      }
export type RemoveUserFromOrganisationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganisationMutation>;
export type RemoveUserFromOrganisationMutationResult = Apollo.MutationResult<RemoveUserFromOrganisationMutation>;
export type RemoveUserFromOrganisationMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>;
export const UpdateOrganisationGroupDocument = gql`
    mutation UpdateOrganisationGroup($input: UpdateOrganisationGroupInput!, $organisationId: String!, $groupId: String!) {
  updateOrganisationGroup(
    input: $input
    organisationId: $organisationId
    groupId: $groupId
  ) {
    cognitoGroupName
    createdAt
    createdBy
    description
    groupId
    isActive
    name
    organisationId
    scopes
    updatedAt
  }
}
    `;
export type UpdateOrganisationGroupMutationFn = Apollo.MutationFunction<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>;

/**
 * __useUpdateOrganisationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationGroupMutation, { data, loading, error }] = useUpdateOrganisationGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organisationId: // value for 'organisationId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useUpdateOrganisationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>(UpdateOrganisationGroupDocument, options);
      }
export type UpdateOrganisationGroupMutationHookResult = ReturnType<typeof useUpdateOrganisationGroupMutation>;
export type UpdateOrganisationGroupMutationResult = Apollo.MutationResult<UpdateOrganisationGroupMutation>;
export type UpdateOrganisationGroupMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>;
export const UpdateIdentityProviderDocument = gql`
    mutation UpdateIdentityProvider($organisationId: String!, $idpId: String!, $input: UpdateIdpInput!) {
  updateIdentityProvider(
    organisationId: $organisationId
    idpId: $idpId
    input: $input
  ) {
    name
    status
    description
    autoCreateUsers
    defaultGroupMappings
    samlConfig {
      metadataUrl
      metadataXml
    }
    oidcConfig {
      discoveryUrl
      issuer
      authorizationEndpoint
      tokenEndpoint
      userinfoEndpoint
      jwksUri
      clientId
      clientSecret
      scopes
      responseType
      responseMode
    }
    attributeMappings {
      internalAttribute
      externalAttribute
      isRequired
    }
    metadata
  }
}
    `;
export type UpdateIdentityProviderMutationFn = Apollo.MutationFunction<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>;

/**
 * __useUpdateIdentityProviderMutation__
 *
 * To run a mutation, you first call `useUpdateIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdentityProviderMutation, { data, loading, error }] = useUpdateIdentityProviderMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      idpId: // value for 'idpId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>(UpdateIdentityProviderDocument, options);
      }
export type UpdateIdentityProviderMutationHookResult = ReturnType<typeof useUpdateIdentityProviderMutation>;
export type UpdateIdentityProviderMutationResult = Apollo.MutationResult<UpdateIdentityProviderMutation>;
export type UpdateIdentityProviderMutationOptions = Apollo.BaseMutationOptions<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($username: String!, $input: UpdateUserInput!) {
  updateUser(username: $username, input: $input) {
    message
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ListApplicationCertificatesDocument = gql`
    query ListApplicationCertificates($applicationId: String!) {
  listApplicationCertificates(applicationId: $applicationId) {
    certificates {
      certificateType
      fingerprint
      keyId
      status
      validTo
      validFrom
    }
  }
}
    `;

/**
 * __useListApplicationCertificatesQuery__
 *
 * To run a query within a React component, call `useListApplicationCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationCertificatesQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useListApplicationCertificatesQuery(baseOptions: Apollo.QueryHookOptions<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables> & ({ variables: ListApplicationCertificatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>(ListApplicationCertificatesDocument, options);
      }
export function useListApplicationCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>(ListApplicationCertificatesDocument, options);
        }
// @ts-ignore
export function useListApplicationCertificatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>;
export function useListApplicationCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<ListApplicationCertificatesQuery | undefined, ListApplicationCertificatesQueryVariables>;
export function useListApplicationCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>(ListApplicationCertificatesDocument, options);
        }
export type ListApplicationCertificatesQueryHookResult = ReturnType<typeof useListApplicationCertificatesQuery>;
export type ListApplicationCertificatesLazyQueryHookResult = ReturnType<typeof useListApplicationCertificatesLazyQuery>;
export type ListApplicationCertificatesSuspenseQueryHookResult = ReturnType<typeof useListApplicationCertificatesSuspenseQuery>;
export type ListApplicationCertificatesQueryResult = Apollo.QueryResult<ListApplicationCertificatesQuery, ListApplicationCertificatesQueryVariables>;
export const GetGroupByIdDocument = gql`
    query GetGroupById($groupId: String!, $organisationId: String!) {
  organisationGroup(groupId: $groupId, organisationId: $organisationId) {
    cognitoGroupName
    createdAt
    createdBy
    description
    groupId
    isActive
    name
    organisationId
    scopes
    updatedAt
  }
}
    `;

/**
 * __useGetGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupByIdQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables> & ({ variables: GetGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
      }
export function useGetGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
        }
// @ts-ignore
export function useGetGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupByIdQuery, GetGroupByIdQueryVariables>;
export function useGetGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupByIdQuery | undefined, GetGroupByIdQueryVariables>;
export function useGetGroupByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupByIdQuery, GetGroupByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(GetGroupByIdDocument, options);
        }
export type GetGroupByIdQueryHookResult = ReturnType<typeof useGetGroupByIdQuery>;
export type GetGroupByIdLazyQueryHookResult = ReturnType<typeof useGetGroupByIdLazyQuery>;
export type GetGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetGroupByIdSuspenseQuery>;
export type GetGroupByIdQueryResult = Apollo.QueryResult<GetGroupByIdQuery, GetGroupByIdQueryVariables>;
export const GetOrganizationDashboardDocument = gql`
    query GetOrganizationDashboard($organisationId: String!) {
  organisation(organisationId: $organisationId) {
    organisationId
    name
    slug
    status
    description
    createdAt
    updatedAt
    products
    emailDomains
    pmInformation {
      pmId
      pmCode
    }
  }
  organisationUsers(organisationId: $organisationId) {
    totalCount
    users {
      userId
      email
      givenName
      familyName
      status
      groupId
      invitationSent
    }
  }
  oauthClients(organisationId: $organisationId) {
    totalCount
    clients {
      clientId
      name
      isActive
      createdAt
      lastSecretRotation
    }
  }
  organisationGroups(limit: 100, organisationId: $organisationId) {
    totalCount
    groups {
      groupId
      name
      isActive
      createdAt
      scopes
    }
  }
  identityProviders(organisationId: $organisationId) {
    identityProviders {
      idpId
      name
      idpType
      status
      healthCheckStatus
      lastHealthCheck
    }
  }
}
    `;

/**
 * __useGetOrganizationDashboardQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDashboardQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetOrganizationDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables> & ({ variables: GetOrganizationDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>(GetOrganizationDashboardDocument, options);
      }
export function useGetOrganizationDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>(GetOrganizationDashboardDocument, options);
        }
// @ts-ignore
export function useGetOrganizationDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>;
export function useGetOrganizationDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationDashboardQuery | undefined, GetOrganizationDashboardQueryVariables>;
export function useGetOrganizationDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>(GetOrganizationDashboardDocument, options);
        }
export type GetOrganizationDashboardQueryHookResult = ReturnType<typeof useGetOrganizationDashboardQuery>;
export type GetOrganizationDashboardLazyQueryHookResult = ReturnType<typeof useGetOrganizationDashboardLazyQuery>;
export type GetOrganizationDashboardSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationDashboardSuspenseQuery>;
export type GetOrganizationDashboardQueryResult = Apollo.QueryResult<GetOrganizationDashboardQuery, GetOrganizationDashboardQueryVariables>;
export const GetIdentityProviderDocument = gql`
    query GetIdentityProvider($organisationId: String!, $idpId: String!) {
  identityProvider(organisationId: $organisationId, idpId: $idpId) {
    cognitoProviderName
    createdAt
    createdBy
    samlConfig {
      metadataUrl
      ssoUrl
      sloUrl
      entityId
      nameIdFormat
      signRequest
      wantAssertionsSigned
      wantResponseSigned
      x509Certificate
      metadataXml
    }
    healthCheckStatus
    idpId
    idpType
    lastHealthCheck
    name
    status
    updatedAt
    description
  }
}
    `;

/**
 * __useGetIdentityProviderQuery__
 *
 * To run a query within a React component, call `useGetIdentityProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentityProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentityProviderQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      idpId: // value for 'idpId'
 *   },
 * });
 */
export function useGetIdentityProviderQuery(baseOptions: Apollo.QueryHookOptions<GetIdentityProviderQuery, GetIdentityProviderQueryVariables> & ({ variables: GetIdentityProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>(GetIdentityProviderDocument, options);
      }
export function useGetIdentityProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>(GetIdentityProviderDocument, options);
        }
// @ts-ignore
export function useGetIdentityProviderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>): Apollo.UseSuspenseQueryResult<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>;
export function useGetIdentityProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>): Apollo.UseSuspenseQueryResult<GetIdentityProviderQuery | undefined, GetIdentityProviderQueryVariables>;
export function useGetIdentityProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>(GetIdentityProviderDocument, options);
        }
export type GetIdentityProviderQueryHookResult = ReturnType<typeof useGetIdentityProviderQuery>;
export type GetIdentityProviderLazyQueryHookResult = ReturnType<typeof useGetIdentityProviderLazyQuery>;
export type GetIdentityProviderSuspenseQueryHookResult = ReturnType<typeof useGetIdentityProviderSuspenseQuery>;
export type GetIdentityProviderQueryResult = Apollo.QueryResult<GetIdentityProviderQuery, GetIdentityProviderQueryVariables>;
export const GetIdentityProviderSamlConfigurationDataDocument = gql`
    query GetIdentityProviderSamlConfigurationData {
  identityProviderSamlConfigurationData {
    acsUrl
    entityId
  }
}
    `;

/**
 * __useGetIdentityProviderSamlConfigurationDataQuery__
 *
 * To run a query within a React component, call `useGetIdentityProviderSamlConfigurationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentityProviderSamlConfigurationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentityProviderSamlConfigurationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIdentityProviderSamlConfigurationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>(GetIdentityProviderSamlConfigurationDataDocument, options);
      }
export function useGetIdentityProviderSamlConfigurationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>(GetIdentityProviderSamlConfigurationDataDocument, options);
        }
// @ts-ignore
export function useGetIdentityProviderSamlConfigurationDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>;
export function useGetIdentityProviderSamlConfigurationDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetIdentityProviderSamlConfigurationDataQuery | undefined, GetIdentityProviderSamlConfigurationDataQueryVariables>;
export function useGetIdentityProviderSamlConfigurationDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>(GetIdentityProviderSamlConfigurationDataDocument, options);
        }
export type GetIdentityProviderSamlConfigurationDataQueryHookResult = ReturnType<typeof useGetIdentityProviderSamlConfigurationDataQuery>;
export type GetIdentityProviderSamlConfigurationDataLazyQueryHookResult = ReturnType<typeof useGetIdentityProviderSamlConfigurationDataLazyQuery>;
export type GetIdentityProviderSamlConfigurationDataSuspenseQueryHookResult = ReturnType<typeof useGetIdentityProviderSamlConfigurationDataSuspenseQuery>;
export type GetIdentityProviderSamlConfigurationDataQueryResult = Apollo.QueryResult<GetIdentityProviderSamlConfigurationDataQuery, GetIdentityProviderSamlConfigurationDataQueryVariables>;
export const ListIdentityProvidersDocument = gql`
    query ListIdentityProviders($organisationId: String!, $idpType: String, $status: String, $limit: Int) {
  identityProviders(
    organisationId: $organisationId
    idpType: $idpType
    status: $status
    limit: $limit
  ) {
    identityProviders {
      idpId
      name
      idpType
      status
      cognitoProviderName
      description
      attributeMappings {
        internalAttribute
        externalAttribute
        isRequired
      }
      samlConfig {
        metadataUrl
        metadataXml
        ssoUrl
        entityId
        x509Certificate
      }
      oidcConfig {
        discoveryUrl
        issuer
        authorizationEndpoint
        tokenEndpoint
        userinfoEndpoint
        jwksUri
        clientId
        clientSecret
        scopes
        responseType
        responseMode
      }
      lastHealthCheck
      healthCheckStatus
      createdAt
      updatedAt
      createdBy
    }
  }
}
    `;

/**
 * __useListIdentityProvidersQuery__
 *
 * To run a query within a React component, call `useListIdentityProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIdentityProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIdentityProvidersQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      idpType: // value for 'idpType'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListIdentityProvidersQuery(baseOptions: Apollo.QueryHookOptions<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables> & ({ variables: ListIdentityProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>(ListIdentityProvidersDocument, options);
      }
export function useListIdentityProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>(ListIdentityProvidersDocument, options);
        }
// @ts-ignore
export function useListIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>;
export function useListIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<ListIdentityProvidersQuery | undefined, ListIdentityProvidersQueryVariables>;
export function useListIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>(ListIdentityProvidersDocument, options);
        }
export type ListIdentityProvidersQueryHookResult = ReturnType<typeof useListIdentityProvidersQuery>;
export type ListIdentityProvidersLazyQueryHookResult = ReturnType<typeof useListIdentityProvidersLazyQuery>;
export type ListIdentityProvidersSuspenseQueryHookResult = ReturnType<typeof useListIdentityProvidersSuspenseQuery>;
export type ListIdentityProvidersQueryResult = Apollo.QueryResult<ListIdentityProvidersQuery, ListIdentityProvidersQueryVariables>;
export const ListGroupUsersDocument = gql`
    query ListGroupUsers($groupId: String!, $organisationId: String!) {
  groupUsers(groupId: $groupId, organisationId: $organisationId) {
    users {
      email
      groupId
      invitationSent
      organisationId
      organisationName
      status
      temporaryPassword
      userId
    }
  }
}
    `;

/**
 * __useListGroupUsersQuery__
 *
 * To run a query within a React component, call `useListGroupUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupUsersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useListGroupUsersQuery(baseOptions: Apollo.QueryHookOptions<ListGroupUsersQuery, ListGroupUsersQueryVariables> & ({ variables: ListGroupUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGroupUsersQuery, ListGroupUsersQueryVariables>(ListGroupUsersDocument, options);
      }
export function useListGroupUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGroupUsersQuery, ListGroupUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGroupUsersQuery, ListGroupUsersQueryVariables>(ListGroupUsersDocument, options);
        }
// @ts-ignore
export function useListGroupUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListGroupUsersQuery, ListGroupUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListGroupUsersQuery, ListGroupUsersQueryVariables>;
export function useListGroupUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGroupUsersQuery, ListGroupUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListGroupUsersQuery | undefined, ListGroupUsersQueryVariables>;
export function useListGroupUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGroupUsersQuery, ListGroupUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGroupUsersQuery, ListGroupUsersQueryVariables>(ListGroupUsersDocument, options);
        }
export type ListGroupUsersQueryHookResult = ReturnType<typeof useListGroupUsersQuery>;
export type ListGroupUsersLazyQueryHookResult = ReturnType<typeof useListGroupUsersLazyQuery>;
export type ListGroupUsersSuspenseQueryHookResult = ReturnType<typeof useListGroupUsersSuspenseQuery>;
export type ListGroupUsersQueryResult = Apollo.QueryResult<ListGroupUsersQuery, ListGroupUsersQueryVariables>;
export const ListOrganisationGroupsDocument = gql`
    query ListOrganisationGroups($limit: Int! = 100, $organisationId: String!) {
  organisationGroups(limit: $limit, organisationId: $organisationId) {
    groups {
      cognitoGroupName
      createdAt
      createdBy
      description
      groupId
      isActive
      name
      organisationId
      updatedAt
      scopes
    }
    totalCount
  }
}
    `;

/**
 * __useListOrganisationGroupsQuery__
 *
 * To run a query within a React component, call `useListOrganisationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganisationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganisationGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useListOrganisationGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables> & ({ variables: ListOrganisationGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>(ListOrganisationGroupsDocument, options);
      }
export function useListOrganisationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>(ListOrganisationGroupsDocument, options);
        }
// @ts-ignore
export function useListOrganisationGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>;
export function useListOrganisationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrganisationGroupsQuery | undefined, ListOrganisationGroupsQueryVariables>;
export function useListOrganisationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>(ListOrganisationGroupsDocument, options);
        }
export type ListOrganisationGroupsQueryHookResult = ReturnType<typeof useListOrganisationGroupsQuery>;
export type ListOrganisationGroupsLazyQueryHookResult = ReturnType<typeof useListOrganisationGroupsLazyQuery>;
export type ListOrganisationGroupsSuspenseQueryHookResult = ReturnType<typeof useListOrganisationGroupsSuspenseQuery>;
export type ListOrganisationGroupsQueryResult = Apollo.QueryResult<ListOrganisationGroupsQuery, ListOrganisationGroupsQueryVariables>;
export const ListOrganisationUsersDocument = gql`
    query ListOrganisationUsers($organisationId: String!) {
  organisationUsers(organisationId: $organisationId) {
    users {
      email
      givenName
      familyName
      groupId
      threddRoles
      invitationSent
      organisationId
      organisationName
      status
      temporaryPassword
      userId
    }
    totalCount
  }
}
    `;

/**
 * __useListOrganisationUsersQuery__
 *
 * To run a query within a React component, call `useListOrganisationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganisationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganisationUsersQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useListOrganisationUsersQuery(baseOptions: Apollo.QueryHookOptions<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables> & ({ variables: ListOrganisationUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>(ListOrganisationUsersDocument, options);
      }
export function useListOrganisationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>(ListOrganisationUsersDocument, options);
        }
// @ts-ignore
export function useListOrganisationUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>;
export function useListOrganisationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrganisationUsersQuery | undefined, ListOrganisationUsersQueryVariables>;
export function useListOrganisationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>(ListOrganisationUsersDocument, options);
        }
export type ListOrganisationUsersQueryHookResult = ReturnType<typeof useListOrganisationUsersQuery>;
export type ListOrganisationUsersLazyQueryHookResult = ReturnType<typeof useListOrganisationUsersLazyQuery>;
export type ListOrganisationUsersSuspenseQueryHookResult = ReturnType<typeof useListOrganisationUsersSuspenseQuery>;
export type ListOrganisationUsersQueryResult = Apollo.QueryResult<ListOrganisationUsersQuery, ListOrganisationUsersQueryVariables>;
export const GetOAuthClientsDocument = gql`
    query GetOAuthClients($organisationId: String!, $applicationId: String) {
  oauthClients(organisationId: $organisationId, applicationId: $applicationId) {
    nextKey
    totalCount
    clients {
      allowedGroupIds
      clientId
      usageNotes
      updatedAt
      tags
      scopes
      name
      lastSecretRotation
      isActive
      ipWhitelist
      description
      createdBy
      createdAt
      pmId
      issuerId
      internalId
    }
  }
}
    `;

/**
 * __useGetOAuthClientsQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetOAuthClientsQuery(baseOptions: Apollo.QueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables> & ({ variables: GetOAuthClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>(GetOAuthClientsDocument, options);
      }
export function useGetOAuthClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>(GetOAuthClientsDocument, options);
        }
// @ts-ignore
export function useGetOAuthClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>;
export function useGetOAuthClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientsQuery | undefined, GetOAuthClientsQueryVariables>;
export function useGetOAuthClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>(GetOAuthClientsDocument, options);
        }
export type GetOAuthClientsQueryHookResult = ReturnType<typeof useGetOAuthClientsQuery>;
export type GetOAuthClientsLazyQueryHookResult = ReturnType<typeof useGetOAuthClientsLazyQuery>;
export type GetOAuthClientsSuspenseQueryHookResult = ReturnType<typeof useGetOAuthClientsSuspenseQuery>;
export type GetOAuthClientsQueryResult = Apollo.QueryResult<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>;
export const GetOAuthClientDocument = gql`
    query GetOAuthClient($clientId: String!, $organisationId: String!) {
  oauthClient(clientId: $clientId, organisationId: $organisationId) {
    lastSecretRotation
    usageNotes
    allowedGroupIds
    clientId
    createdAt
    createdBy
    ipWhitelist
    description
    isActive
    name
    scopes
    tags
    updatedAt
    clientSecret
    pmId
    issuerId
    internalId
  }
}
    `;

/**
 * __useGetOAuthClientQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetOAuthClientQuery(baseOptions: Apollo.QueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables> & ({ variables: GetOAuthClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
      }
export function useGetOAuthClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
        }
// @ts-ignore
export function useGetOAuthClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientQuery, GetOAuthClientQueryVariables>;
export function useGetOAuthClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientQuery | undefined, GetOAuthClientQueryVariables>;
export function useGetOAuthClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
        }
export type GetOAuthClientQueryHookResult = ReturnType<typeof useGetOAuthClientQuery>;
export type GetOAuthClientLazyQueryHookResult = ReturnType<typeof useGetOAuthClientLazyQuery>;
export type GetOAuthClientSuspenseQueryHookResult = ReturnType<typeof useGetOAuthClientSuspenseQuery>;
export type GetOAuthClientQueryResult = Apollo.QueryResult<GetOAuthClientQuery, GetOAuthClientQueryVariables>;
export const CreateCurrencyDocument = gql`
    mutation CreateCurrency($input: CreateCurrencyInput!) {
  createCurrency(input: $input) {
    code
    name
    providerId
    isActive
    createdBy
  }
}
    `;
export type CreateCurrencyMutationFn = Apollo.MutationFunction<CreateCurrencyMutation, CreateCurrencyMutationVariables>;

/**
 * __useCreateCurrencyMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyMutation, { data, loading, error }] = useCreateCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCurrencyMutation, CreateCurrencyMutationVariables>(CreateCurrencyDocument, options);
      }
export type CreateCurrencyMutationHookResult = ReturnType<typeof useCreateCurrencyMutation>;
export type CreateCurrencyMutationResult = Apollo.MutationResult<CreateCurrencyMutation>;
export type CreateCurrencyMutationOptions = Apollo.BaseMutationOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>;
export const DeleteCurrencyDocument = gql`
    mutation DeleteCurrency($id: String!) {
  deleteCurrency(id: $id) {
    id
    code
    name
    providerId
    isActive
    createdAt
    createdBy
    updatedAt
    updatedBy
    deactivatedAt
    deprecatedAt
    version
  }
}
    `;
export type DeleteCurrencyMutationFn = Apollo.MutationFunction<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;

/**
 * __useDeleteCurrencyMutation__
 *
 * To run a mutation, you first call `useDeleteCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrencyMutation, { data, loading, error }] = useDeleteCurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>(DeleteCurrencyDocument, options);
      }
export type DeleteCurrencyMutationHookResult = ReturnType<typeof useDeleteCurrencyMutation>;
export type DeleteCurrencyMutationResult = Apollo.MutationResult<DeleteCurrencyMutation>;
export type DeleteCurrencyMutationOptions = Apollo.BaseMutationOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;
export const UpdateCurrencyDocument = gql`
    mutation UpdateCurrency($id: String!, $input: UpdateCurrencyInput!) {
  updateCurrency(id: $id, input: $input) {
    name
    providerId
    updatedBy
    version
  }
}
    `;
export type UpdateCurrencyMutationFn = Apollo.MutationFunction<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;

/**
 * __useUpdateCurrencyMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyMutation, { data, loading, error }] = useUpdateCurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>(UpdateCurrencyDocument, options);
      }
export type UpdateCurrencyMutationHookResult = ReturnType<typeof useUpdateCurrencyMutation>;
export type UpdateCurrencyMutationResult = Apollo.MutationResult<UpdateCurrencyMutation>;
export type UpdateCurrencyMutationOptions = Apollo.BaseMutationOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;
export const ListCurrenciesDocument = gql`
    query ListCurrencies {
  currencyList {
    id
    name
    code
    providerId
    isActive
  }
}
    `;

/**
 * __useListCurrenciesQuery__
 *
 * To run a query within a React component, call `useListCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<ListCurrenciesQuery, ListCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCurrenciesQuery, ListCurrenciesQueryVariables>(ListCurrenciesDocument, options);
      }
export function useListCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCurrenciesQuery, ListCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCurrenciesQuery, ListCurrenciesQueryVariables>(ListCurrenciesDocument, options);
        }
// @ts-ignore
export function useListCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCurrenciesQuery, ListCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<ListCurrenciesQuery, ListCurrenciesQueryVariables>;
export function useListCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCurrenciesQuery, ListCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<ListCurrenciesQuery | undefined, ListCurrenciesQueryVariables>;
export function useListCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCurrenciesQuery, ListCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCurrenciesQuery, ListCurrenciesQueryVariables>(ListCurrenciesDocument, options);
        }
export type ListCurrenciesQueryHookResult = ReturnType<typeof useListCurrenciesQuery>;
export type ListCurrenciesLazyQueryHookResult = ReturnType<typeof useListCurrenciesLazyQuery>;
export type ListCurrenciesSuspenseQueryHookResult = ReturnType<typeof useListCurrenciesSuspenseQuery>;
export type ListCurrenciesQueryResult = Apollo.QueryResult<ListCurrenciesQuery, ListCurrenciesQueryVariables>;
export const GetCurrencyDocument = gql`
    query GetCurrency($code: String!) {
  currencyByCode(code: $code) {
    id
    code
    name
    providerId
    isActive
    createdAt
    deactivatedAt
    deprecatedAt
    version
    createdBy
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetCurrencyQuery__
 *
 * To run a query within a React component, call `useGetCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables> & ({ variables: GetCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
      }
export function useGetCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
        }
// @ts-ignore
export function useGetCurrencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrencyQuery, GetCurrencyQueryVariables>;
export function useGetCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrencyQuery | undefined, GetCurrencyQueryVariables>;
export function useGetCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
        }
export type GetCurrencyQueryHookResult = ReturnType<typeof useGetCurrencyQuery>;
export type GetCurrencyLazyQueryHookResult = ReturnType<typeof useGetCurrencyLazyQuery>;
export type GetCurrencySuspenseQueryHookResult = ReturnType<typeof useGetCurrencySuspenseQuery>;
export type GetCurrencyQueryResult = Apollo.QueryResult<GetCurrencyQuery, GetCurrencyQueryVariables>;
export const GetAccountHolderDocument = gql`
    query GetAccountHolder($accountHolderId: String!, $clientId: String!) {
  accountHolder(accountHolderId: $accountHolderId, clientId: $clientId) {
    id
    accountHolderStatus
    accountHolderType
    email
    retailDetails {
      firstName
      middleName
      lastName
    }
  }
}
    `;

/**
 * __useGetAccountHolderQuery__
 *
 * To run a query within a React component, call `useGetAccountHolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountHolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountHolderQuery({
 *   variables: {
 *      accountHolderId: // value for 'accountHolderId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetAccountHolderQuery(baseOptions: Apollo.QueryHookOptions<GetAccountHolderQuery, GetAccountHolderQueryVariables> & ({ variables: GetAccountHolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountHolderQuery, GetAccountHolderQueryVariables>(GetAccountHolderDocument, options);
      }
export function useGetAccountHolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountHolderQuery, GetAccountHolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountHolderQuery, GetAccountHolderQueryVariables>(GetAccountHolderDocument, options);
        }
// @ts-ignore
export function useGetAccountHolderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountHolderQuery, GetAccountHolderQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountHolderQuery, GetAccountHolderQueryVariables>;
export function useGetAccountHolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountHolderQuery, GetAccountHolderQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountHolderQuery | undefined, GetAccountHolderQueryVariables>;
export function useGetAccountHolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountHolderQuery, GetAccountHolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountHolderQuery, GetAccountHolderQueryVariables>(GetAccountHolderDocument, options);
        }
export type GetAccountHolderQueryHookResult = ReturnType<typeof useGetAccountHolderQuery>;
export type GetAccountHolderLazyQueryHookResult = ReturnType<typeof useGetAccountHolderLazyQuery>;
export type GetAccountHolderSuspenseQueryHookResult = ReturnType<typeof useGetAccountHolderSuspenseQuery>;
export type GetAccountHolderQueryResult = Apollo.QueryResult<GetAccountHolderQuery, GetAccountHolderQueryVariables>;
export const CreateLedgerPlaygroundBalanceDocument = gql`
    mutation CreateLedgerPlaygroundBalance($input: CreateLedgerPlaygroundBalance!, $clientId: String!) {
  createLedgerPlaygroundBalance(input: $input, clientId: $clientId) {
    ledgerId
    sessionId
  }
}
    `;
export type CreateLedgerPlaygroundBalanceMutationFn = Apollo.MutationFunction<CreateLedgerPlaygroundBalanceMutation, CreateLedgerPlaygroundBalanceMutationVariables>;

/**
 * __useCreateLedgerPlaygroundBalanceMutation__
 *
 * To run a mutation, you first call `useCreateLedgerPlaygroundBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLedgerPlaygroundBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLedgerPlaygroundBalanceMutation, { data, loading, error }] = useCreateLedgerPlaygroundBalanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useCreateLedgerPlaygroundBalanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateLedgerPlaygroundBalanceMutation, CreateLedgerPlaygroundBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLedgerPlaygroundBalanceMutation, CreateLedgerPlaygroundBalanceMutationVariables>(CreateLedgerPlaygroundBalanceDocument, options);
      }
export type CreateLedgerPlaygroundBalanceMutationHookResult = ReturnType<typeof useCreateLedgerPlaygroundBalanceMutation>;
export type CreateLedgerPlaygroundBalanceMutationResult = Apollo.MutationResult<CreateLedgerPlaygroundBalanceMutation>;
export type CreateLedgerPlaygroundBalanceMutationOptions = Apollo.BaseMutationOptions<CreateLedgerPlaygroundBalanceMutation, CreateLedgerPlaygroundBalanceMutationVariables>;
export const CreateLedgerPlaygroundTransactionDocument = gql`
    mutation CreateLedgerPlaygroundTransaction($input: CreateLedgerPlaygroundTransaction!, $clientId: String!) {
  createLedgerPlaygroundTransaction(input: $input, clientId: $clientId) {
    sessionId
    transactionId
    status
    message
  }
}
    `;
export type CreateLedgerPlaygroundTransactionMutationFn = Apollo.MutationFunction<CreateLedgerPlaygroundTransactionMutation, CreateLedgerPlaygroundTransactionMutationVariables>;

/**
 * __useCreateLedgerPlaygroundTransactionMutation__
 *
 * To run a mutation, you first call `useCreateLedgerPlaygroundTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLedgerPlaygroundTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLedgerPlaygroundTransactionMutation, { data, loading, error }] = useCreateLedgerPlaygroundTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useCreateLedgerPlaygroundTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLedgerPlaygroundTransactionMutation, CreateLedgerPlaygroundTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLedgerPlaygroundTransactionMutation, CreateLedgerPlaygroundTransactionMutationVariables>(CreateLedgerPlaygroundTransactionDocument, options);
      }
export type CreateLedgerPlaygroundTransactionMutationHookResult = ReturnType<typeof useCreateLedgerPlaygroundTransactionMutation>;
export type CreateLedgerPlaygroundTransactionMutationResult = Apollo.MutationResult<CreateLedgerPlaygroundTransactionMutation>;
export type CreateLedgerPlaygroundTransactionMutationOptions = Apollo.BaseMutationOptions<CreateLedgerPlaygroundTransactionMutation, CreateLedgerPlaygroundTransactionMutationVariables>;
export const GetLedgerPlaygroundBalanceListDocument = gql`
    query GetLedgerPlaygroundBalanceList($sessionId: String!, $clientId: String!) {
  ledgerPlaygroundBalanceList(sessionId: $sessionId, clientId: $clientId) {
    accountId
    asset
    availableBalance
    currentBalance
    ledgerId
    ledgerType
    pendingCredit
    pendingDebit
    postedCredit
    postedDebit
  }
}
    `;

/**
 * __useGetLedgerPlaygroundBalanceListQuery__
 *
 * To run a query within a React component, call `useGetLedgerPlaygroundBalanceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerPlaygroundBalanceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerPlaygroundBalanceListQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetLedgerPlaygroundBalanceListQuery(baseOptions: Apollo.QueryHookOptions<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables> & ({ variables: GetLedgerPlaygroundBalanceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>(GetLedgerPlaygroundBalanceListDocument, options);
      }
export function useGetLedgerPlaygroundBalanceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>(GetLedgerPlaygroundBalanceListDocument, options);
        }
// @ts-ignore
export function useGetLedgerPlaygroundBalanceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>;
export function useGetLedgerPlaygroundBalanceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerPlaygroundBalanceListQuery | undefined, GetLedgerPlaygroundBalanceListQueryVariables>;
export function useGetLedgerPlaygroundBalanceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>(GetLedgerPlaygroundBalanceListDocument, options);
        }
export type GetLedgerPlaygroundBalanceListQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundBalanceListQuery>;
export type GetLedgerPlaygroundBalanceListLazyQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundBalanceListLazyQuery>;
export type GetLedgerPlaygroundBalanceListSuspenseQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundBalanceListSuspenseQuery>;
export type GetLedgerPlaygroundBalanceListQueryResult = Apollo.QueryResult<GetLedgerPlaygroundBalanceListQuery, GetLedgerPlaygroundBalanceListQueryVariables>;
export const GetLedgerPlaygroundTransactionDocument = gql`
    query GetLedgerPlaygroundTransaction($input: String!, $clientId: String!) {
  ledgerPlaygroundTransaction(transactionId: $input, clientId: $clientId) {
    transactionId
    accountId
    ledgerId
    processingChannel
    transactionType
    sign
    description
    billing {
      billingAmount
      billingAsset
      transactionAmount
      transactionAsset
      feeAmount
      feeAsset
      cashbackAmount
      cashbackAsset
      settlementAmount
      settlementAsset
      exchangeRate
    }
    status {
      status
      version
      createdAt
      authorisedOn
      processedOn
      description
    }
    externalId
    feeLedgerId
    offsetLedgerId
    instrumentId
    ledgerEntries {
      ledgerId
      ledgerType
      amount
      asset
      sign
      status
      subTransactionId
      timestamp
    }
    subTransactions {
      subTransactionId
      subTransactionType
      amount
      asset
      timestamp
    }
  }
}
    `;

/**
 * __useGetLedgerPlaygroundTransactionQuery__
 *
 * To run a query within a React component, call `useGetLedgerPlaygroundTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerPlaygroundTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerPlaygroundTransactionQuery({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetLedgerPlaygroundTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables> & ({ variables: GetLedgerPlaygroundTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>(GetLedgerPlaygroundTransactionDocument, options);
      }
export function useGetLedgerPlaygroundTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>(GetLedgerPlaygroundTransactionDocument, options);
        }
// @ts-ignore
export function useGetLedgerPlaygroundTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>;
export function useGetLedgerPlaygroundTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerPlaygroundTransactionQuery | undefined, GetLedgerPlaygroundTransactionQueryVariables>;
export function useGetLedgerPlaygroundTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>(GetLedgerPlaygroundTransactionDocument, options);
        }
export type GetLedgerPlaygroundTransactionQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundTransactionQuery>;
export type GetLedgerPlaygroundTransactionLazyQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundTransactionLazyQuery>;
export type GetLedgerPlaygroundTransactionSuspenseQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundTransactionSuspenseQuery>;
export type GetLedgerPlaygroundTransactionQueryResult = Apollo.QueryResult<GetLedgerPlaygroundTransactionQuery, GetLedgerPlaygroundTransactionQueryVariables>;
export const GetLedgerPlaygroundTransactionListDocument = gql`
    query GetLedgerPlaygroundTransactionList($input: String!, $clientId: String!) {
  ledgerPlaygroundTransactionList(sessionId: $input, clientId: $clientId) {
    transactionId
    accountId
    ledgerId
    processingChannel
    transactionType
    sign
    description
    billing {
      billingAmount
      billingAsset
      transactionAmount
      transactionAsset
      feeAmount
      feeAsset
      cashbackAmount
      cashbackAsset
      settlementAmount
      settlementAsset
      exchangeRate
    }
    status {
      status
      version
      createdAt
      authorisedOn
      processedOn
      description
    }
    externalId
    feeLedgerId
    offsetLedgerId
    instrumentId
    ledgerEntries {
      ledgerId
      ledgerType
      amount
      asset
      sign
      status
      subTransactionId
      timestamp
    }
    subTransactions {
      subTransactionId
      subTransactionType
      amount
      asset
      timestamp
    }
  }
}
    `;

/**
 * __useGetLedgerPlaygroundTransactionListQuery__
 *
 * To run a query within a React component, call `useGetLedgerPlaygroundTransactionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerPlaygroundTransactionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerPlaygroundTransactionListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetLedgerPlaygroundTransactionListQuery(baseOptions: Apollo.QueryHookOptions<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables> & ({ variables: GetLedgerPlaygroundTransactionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>(GetLedgerPlaygroundTransactionListDocument, options);
      }
export function useGetLedgerPlaygroundTransactionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>(GetLedgerPlaygroundTransactionListDocument, options);
        }
// @ts-ignore
export function useGetLedgerPlaygroundTransactionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>;
export function useGetLedgerPlaygroundTransactionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerPlaygroundTransactionListQuery | undefined, GetLedgerPlaygroundTransactionListQueryVariables>;
export function useGetLedgerPlaygroundTransactionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>(GetLedgerPlaygroundTransactionListDocument, options);
        }
export type GetLedgerPlaygroundTransactionListQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundTransactionListQuery>;
export type GetLedgerPlaygroundTransactionListLazyQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundTransactionListLazyQuery>;
export type GetLedgerPlaygroundTransactionListSuspenseQueryHookResult = ReturnType<typeof useGetLedgerPlaygroundTransactionListSuspenseQuery>;
export type GetLedgerPlaygroundTransactionListQueryResult = Apollo.QueryResult<GetLedgerPlaygroundTransactionListQuery, GetLedgerPlaygroundTransactionListQueryVariables>;
export const AuditLogRequestInputDocument = gql`
    mutation AuditLogRequestInput($input: AuditLogRequestInput!) {
  createAuditLog(input: $input)
}
    `;
export type AuditLogRequestInputMutationFn = Apollo.MutationFunction<AuditLogRequestInputMutation, AuditLogRequestInputMutationVariables>;

/**
 * __useAuditLogRequestInputMutation__
 *
 * To run a mutation, you first call `useAuditLogRequestInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditLogRequestInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditLogRequestInputMutation, { data, loading, error }] = useAuditLogRequestInputMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditLogRequestInputMutation(baseOptions?: Apollo.MutationHookOptions<AuditLogRequestInputMutation, AuditLogRequestInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuditLogRequestInputMutation, AuditLogRequestInputMutationVariables>(AuditLogRequestInputDocument, options);
      }
export type AuditLogRequestInputMutationHookResult = ReturnType<typeof useAuditLogRequestInputMutation>;
export type AuditLogRequestInputMutationResult = Apollo.MutationResult<AuditLogRequestInputMutation>;
export type AuditLogRequestInputMutationOptions = Apollo.BaseMutationOptions<AuditLogRequestInputMutation, AuditLogRequestInputMutationVariables>;
export const GetLogFilterOptionsDocument = gql`
    query GetLogFilterOptions($field: String!) {
  auditLogLookups(field: $field) {
    items {
      field
      value
    }
  }
}
    `;

/**
 * __useGetLogFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetLogFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogFilterOptionsQuery({
 *   variables: {
 *      field: // value for 'field'
 *   },
 * });
 */
export function useGetLogFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables> & ({ variables: GetLogFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>(GetLogFilterOptionsDocument, options);
      }
export function useGetLogFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>(GetLogFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetLogFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>;
export function useGetLogFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLogFilterOptionsQuery | undefined, GetLogFilterOptionsQueryVariables>;
export function useGetLogFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>(GetLogFilterOptionsDocument, options);
        }
export type GetLogFilterOptionsQueryHookResult = ReturnType<typeof useGetLogFilterOptionsQuery>;
export type GetLogFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetLogFilterOptionsLazyQuery>;
export type GetLogFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetLogFilterOptionsSuspenseQuery>;
export type GetLogFilterOptionsQueryResult = Apollo.QueryResult<GetLogFilterOptionsQuery, GetLogFilterOptionsQueryVariables>;
export const ExportAuditLogsDocument = gql`
    mutation ExportAuditLogs($input: ExportAuditLogsInput!) {
  exportAuditLogs(input: $input) {
    logs {
      id
      timestamp
      user
      email
      section
      region
      note
      details
    }
  }
}
    `;
export type ExportAuditLogsMutationFn = Apollo.MutationFunction<ExportAuditLogsMutation, ExportAuditLogsMutationVariables>;

/**
 * __useExportAuditLogsMutation__
 *
 * To run a mutation, you first call `useExportAuditLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAuditLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAuditLogsMutation, { data, loading, error }] = useExportAuditLogsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAuditLogsMutation(baseOptions?: Apollo.MutationHookOptions<ExportAuditLogsMutation, ExportAuditLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAuditLogsMutation, ExportAuditLogsMutationVariables>(ExportAuditLogsDocument, options);
      }
export type ExportAuditLogsMutationHookResult = ReturnType<typeof useExportAuditLogsMutation>;
export type ExportAuditLogsMutationResult = Apollo.MutationResult<ExportAuditLogsMutation>;
export type ExportAuditLogsMutationOptions = Apollo.BaseMutationOptions<ExportAuditLogsMutation, ExportAuditLogsMutationVariables>;
export const AuditLogsDocument = gql`
    query AuditLogs($startTime: DateTime!, $endTime: DateTime!, $user: String, $email: String, $section: String, $region: String, $lastEvaluatedKey: String, $limit: Int) {
  auditLogs(
    startTime: $startTime
    endTime: $endTime
    user: $user
    email: $email
    section: $section
    region: $region
    lastEvaluatedKey: $lastEvaluatedKey
    limit: $limit
  ) {
    logs {
      id
      timestamp
      user
      email
      section
      region
      note
      details
    }
    lastEvaluatedKey
  }
}
    `;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      user: // value for 'user'
 *      email: // value for 'email'
 *      section: // value for 'section'
 *      region: // value for 'region'
 *      lastEvaluatedKey: // value for 'lastEvaluatedKey'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables> & ({ variables: AuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
      }
export function useAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
// @ts-ignore
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<AuditLogsQuery | undefined, AuditLogsQueryVariables>;
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryHookResult = ReturnType<typeof useAuditLogsLazyQuery>;
export type AuditLogsSuspenseQueryHookResult = ReturnType<typeof useAuditLogsSuspenseQuery>;
export type AuditLogsQueryResult = Apollo.QueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export const FeatureRequestDocument = gql`
    mutation FeatureRequest($input: FeatureRequestInput!) {
  sendFeatureRequest(input: $input)
}
    `;
export type FeatureRequestMutationFn = Apollo.MutationFunction<FeatureRequestMutation, FeatureRequestMutationVariables>;

/**
 * __useFeatureRequestMutation__
 *
 * To run a mutation, you first call `useFeatureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureRequestMutation, { data, loading, error }] = useFeatureRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeatureRequestMutation(baseOptions?: Apollo.MutationHookOptions<FeatureRequestMutation, FeatureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureRequestMutation, FeatureRequestMutationVariables>(FeatureRequestDocument, options);
      }
export type FeatureRequestMutationHookResult = ReturnType<typeof useFeatureRequestMutation>;
export type FeatureRequestMutationResult = Apollo.MutationResult<FeatureRequestMutation>;
export type FeatureRequestMutationOptions = Apollo.BaseMutationOptions<FeatureRequestMutation, FeatureRequestMutationVariables>;
export const SaveUserPmPreferenceDocument = gql`
    mutation saveUserPmPreference($input: SaveUserPmPreferenceInput!) {
  saveUserPmPreference(input: $input) {
    message
  }
}
    `;
export type SaveUserPmPreferenceMutationFn = Apollo.MutationFunction<SaveUserPmPreferenceMutation, SaveUserPmPreferenceMutationVariables>;

/**
 * __useSaveUserPmPreferenceMutation__
 *
 * To run a mutation, you first call `useSaveUserPmPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserPmPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserPmPreferenceMutation, { data, loading, error }] = useSaveUserPmPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserPmPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserPmPreferenceMutation, SaveUserPmPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserPmPreferenceMutation, SaveUserPmPreferenceMutationVariables>(SaveUserPmPreferenceDocument, options);
      }
export type SaveUserPmPreferenceMutationHookResult = ReturnType<typeof useSaveUserPmPreferenceMutation>;
export type SaveUserPmPreferenceMutationResult = Apollo.MutationResult<SaveUserPmPreferenceMutation>;
export type SaveUserPmPreferenceMutationOptions = Apollo.BaseMutationOptions<SaveUserPmPreferenceMutation, SaveUserPmPreferenceMutationVariables>;
export const GetCardsDocument = gql`
    query GetCards($input: SearchCardsInput!) {
  searchCards(input: $input) {
    totalCount
    items {
      firstName
      lastName
      publicToken
      addressLine1
      customerReference
      expiryDate
      currencyCode
      availableBalance
      actualBalance
      cardStatus
      isLive
      cardType
      schemeId
      title
      schemeName
      email
      tel
      mobile
      dateOfBirth
      postCode
      city
      productName
      productId
      panPubt
    }
  }
}
    `;

/**
 * __useGetCardsQuery__
 *
 * To run a query within a React component, call `useGetCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCardsQuery(baseOptions: Apollo.QueryHookOptions<GetCardsQuery, GetCardsQueryVariables> & ({ variables: GetCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, options);
      }
export function useGetCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardsQuery, GetCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, options);
        }
// @ts-ignore
export function useGetCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardsQuery, GetCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardsQuery, GetCardsQueryVariables>;
export function useGetCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardsQuery, GetCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardsQuery | undefined, GetCardsQueryVariables>;
export function useGetCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardsQuery, GetCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, options);
        }
export type GetCardsQueryHookResult = ReturnType<typeof useGetCardsQuery>;
export type GetCardsLazyQueryHookResult = ReturnType<typeof useGetCardsLazyQuery>;
export type GetCardsSuspenseQueryHookResult = ReturnType<typeof useGetCardsSuspenseQuery>;
export type GetCardsQueryResult = Apollo.QueryResult<GetCardsQuery, GetCardsQueryVariables>;
export const GetCardFeesDocument = gql`
    query GetCardFees($publicToken: String!) {
  cardFees(publicToken: $publicToken) {
    authFees {
      group
      numberOfFreeTransactionPerActivation
      smsFee
      processingCode
      partialAllowed
      domesticFee
      domesticFeeRate
      nonDomesticFee
      nonDomesticRate
      domesticMinimumFee
      nonDomesticMinimumFee
      currency
      description
      declineFee
      fxFixed
      fxRate
      thresholdType
      capDomesticFee
      capFxFee
      capNonDomesticFee
      numberOfFreeTransactionPerMonth
    }
    recurringFees {
      feeGroupCode
      note
      partialAllowed
      domesticFee
      domesticFeeRate
      nonDomesticFee
      nonDomesticRate
      domesticMinimumFee
      nonDomesticMinimumFee
      description
      feeStartDate
      feeEndDate
      feeAmount
      lowActivityAmount
      frequency
      frequencyPeriod
      repeat
      repeatPeriod
      recurringFee
    }
    webServiceProductFees {
      product
      partialAllowed
      domesticFee
      domesticFeeRate
      nonDomesticFee
      nonDomesticRate
      domesticMinimumFee
      nonDomesticMinimumFee
      description
    }
    webServiceGroupFees {
      partialAllowed
      processingCode
      description
      domesticFee
      domesticFeeRate
      domesticMinimumFee
      nonDomesticFee
      nonDomesticRate
      nonDomesticMinimumFee
      smsFee
      group
    }
  }
}
    `;

/**
 * __useGetCardFeesQuery__
 *
 * To run a query within a React component, call `useGetCardFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardFeesQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardFeesQuery(baseOptions: Apollo.QueryHookOptions<GetCardFeesQuery, GetCardFeesQueryVariables> & ({ variables: GetCardFeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardFeesQuery, GetCardFeesQueryVariables>(GetCardFeesDocument, options);
      }
export function useGetCardFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardFeesQuery, GetCardFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardFeesQuery, GetCardFeesQueryVariables>(GetCardFeesDocument, options);
        }
// @ts-ignore
export function useGetCardFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardFeesQuery, GetCardFeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardFeesQuery, GetCardFeesQueryVariables>;
export function useGetCardFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardFeesQuery, GetCardFeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardFeesQuery | undefined, GetCardFeesQueryVariables>;
export function useGetCardFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardFeesQuery, GetCardFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardFeesQuery, GetCardFeesQueryVariables>(GetCardFeesDocument, options);
        }
export type GetCardFeesQueryHookResult = ReturnType<typeof useGetCardFeesQuery>;
export type GetCardFeesLazyQueryHookResult = ReturnType<typeof useGetCardFeesLazyQuery>;
export type GetCardFeesSuspenseQueryHookResult = ReturnType<typeof useGetCardFeesSuspenseQuery>;
export type GetCardFeesQueryResult = Apollo.QueryResult<GetCardFeesQuery, GetCardFeesQueryVariables>;
export const GetUsageGroupListDetailsResponseDocument = gql`
    query GetUsageGroupListDetailsResponse($publicToken: String!) {
  usageGroupListDetails(publicToken: $publicToken) {
    groupCode
    groupDescription
    cardAcceptanceMethods {
      variableType
      variableTypeCode
      defaultTicked
      groupCode
      groupDescription
      variableDescription
    }
    transactionTypes {
      variableType
      variableTypeCode
      defaultTicked
      groupCode
      groupDescription
      variableDescription
    }
    verificationChecks {
      variableType
      variableTypeCode
      defaultTicked
      groupCode
      groupDescription
      variableDescription
    }
    misc {
      variableType
      variableTypeCode
      defaultTicked
      groupCode
      groupDescription
      variableDescription
    }
  }
}
    `;

/**
 * __useGetUsageGroupListDetailsResponseQuery__
 *
 * To run a query within a React component, call `useGetUsageGroupListDetailsResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsageGroupListDetailsResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsageGroupListDetailsResponseQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetUsageGroupListDetailsResponseQuery(baseOptions: Apollo.QueryHookOptions<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables> & ({ variables: GetUsageGroupListDetailsResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>(GetUsageGroupListDetailsResponseDocument, options);
      }
export function useGetUsageGroupListDetailsResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>(GetUsageGroupListDetailsResponseDocument, options);
        }
// @ts-ignore
export function useGetUsageGroupListDetailsResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>;
export function useGetUsageGroupListDetailsResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsageGroupListDetailsResponseQuery | undefined, GetUsageGroupListDetailsResponseQueryVariables>;
export function useGetUsageGroupListDetailsResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>(GetUsageGroupListDetailsResponseDocument, options);
        }
export type GetUsageGroupListDetailsResponseQueryHookResult = ReturnType<typeof useGetUsageGroupListDetailsResponseQuery>;
export type GetUsageGroupListDetailsResponseLazyQueryHookResult = ReturnType<typeof useGetUsageGroupListDetailsResponseLazyQuery>;
export type GetUsageGroupListDetailsResponseSuspenseQueryHookResult = ReturnType<typeof useGetUsageGroupListDetailsResponseSuspenseQuery>;
export type GetUsageGroupListDetailsResponseQueryResult = Apollo.QueryResult<GetUsageGroupListDetailsResponseQuery, GetUsageGroupListDetailsResponseQueryVariables>;
export const GetPaymentTokenUsageGroupDetailsDocument = gql`
    query GetPaymentTokenUsageGroupDetails($publicToken: String!, $tokenId: Long!, $groupId: Int!) {
  paymentTokenUsageGroupDetails(
    publicToken: $publicToken
    tokenId: $tokenId
    groupId: $groupId
  ) {
    tokenUsage
    institute
    cvv2Missing
    avsMissing
    walletDecisionsAuth
    walletDecisionsDecline
    walletDeviceMaxScoreAuth
    walletDeviceMaxScoreDecline
    walletAccountMaxScoreAuth
    walletAccountMaxScoreDecline
    minTokensToAuth
    minTokensToDecline
    activateSMS
    activateEmail
    activateCallCentre
    activateAutoCallCentre
    activateWebsiteURL
    activateMobileApp
    activateCallback
    notifySMS
    notifyEmail
    notifyPost
    groupUsageDefaultName
    overrideApproveAuth
    defaultWalletProviderAuthentication
  }
}
    `;

/**
 * __useGetPaymentTokenUsageGroupDetailsQuery__
 *
 * To run a query within a React component, call `useGetPaymentTokenUsageGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentTokenUsageGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentTokenUsageGroupDetailsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      tokenId: // value for 'tokenId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetPaymentTokenUsageGroupDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables> & ({ variables: GetPaymentTokenUsageGroupDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>(GetPaymentTokenUsageGroupDetailsDocument, options);
      }
export function useGetPaymentTokenUsageGroupDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>(GetPaymentTokenUsageGroupDetailsDocument, options);
        }
// @ts-ignore
export function useGetPaymentTokenUsageGroupDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>;
export function useGetPaymentTokenUsageGroupDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentTokenUsageGroupDetailsQuery | undefined, GetPaymentTokenUsageGroupDetailsQueryVariables>;
export function useGetPaymentTokenUsageGroupDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>(GetPaymentTokenUsageGroupDetailsDocument, options);
        }
export type GetPaymentTokenUsageGroupDetailsQueryHookResult = ReturnType<typeof useGetPaymentTokenUsageGroupDetailsQuery>;
export type GetPaymentTokenUsageGroupDetailsLazyQueryHookResult = ReturnType<typeof useGetPaymentTokenUsageGroupDetailsLazyQuery>;
export type GetPaymentTokenUsageGroupDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentTokenUsageGroupDetailsSuspenseQuery>;
export type GetPaymentTokenUsageGroupDetailsQueryResult = Apollo.QueryResult<GetPaymentTokenUsageGroupDetailsQuery, GetPaymentTokenUsageGroupDetailsQueryVariables>;
export const CardAcceptorAllowDisallowListDocument = gql`
    query CardAcceptorAllowDisallowList($publicToken: String!) {
  cardAcceptorAllowDisallowList(publicToken: $publicToken) {
    cardAcceptorAllowList {
      id
      name
      merchantIds
      isConfiguredGroup
    }
    cardAcceptorDisallowList {
      id
      name
      merchantIds
    }
  }
}
    `;

/**
 * __useCardAcceptorAllowDisallowListQuery__
 *
 * To run a query within a React component, call `useCardAcceptorAllowDisallowListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardAcceptorAllowDisallowListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardAcceptorAllowDisallowListQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useCardAcceptorAllowDisallowListQuery(baseOptions: Apollo.QueryHookOptions<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables> & ({ variables: CardAcceptorAllowDisallowListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>(CardAcceptorAllowDisallowListDocument, options);
      }
export function useCardAcceptorAllowDisallowListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>(CardAcceptorAllowDisallowListDocument, options);
        }
// @ts-ignore
export function useCardAcceptorAllowDisallowListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>): Apollo.UseSuspenseQueryResult<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>;
export function useCardAcceptorAllowDisallowListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>): Apollo.UseSuspenseQueryResult<CardAcceptorAllowDisallowListQuery | undefined, CardAcceptorAllowDisallowListQueryVariables>;
export function useCardAcceptorAllowDisallowListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>(CardAcceptorAllowDisallowListDocument, options);
        }
export type CardAcceptorAllowDisallowListQueryHookResult = ReturnType<typeof useCardAcceptorAllowDisallowListQuery>;
export type CardAcceptorAllowDisallowListLazyQueryHookResult = ReturnType<typeof useCardAcceptorAllowDisallowListLazyQuery>;
export type CardAcceptorAllowDisallowListSuspenseQueryHookResult = ReturnType<typeof useCardAcceptorAllowDisallowListSuspenseQuery>;
export type CardAcceptorAllowDisallowListQueryResult = Apollo.QueryResult<CardAcceptorAllowDisallowListQuery, CardAcceptorAllowDisallowListQueryVariables>;
export const GetCardLimitDetailsDocument = gql`
    query GetCardLimitDetails($publicToken: String!) {
  cardLimitDetails(publicToken: $publicToken) {
    availableBalance
    maxAllowableBalance
    currencyCode
    blockedAmount
    cardLimits {
      subGroup
      daily {
        period
        unit
        limit
        frequency
        spent
        transactionCount
      }
      accumulatedPeriod1 {
        period
        unit
        limit
        frequency
        spent
        transactionCount
      }
      accumulatedPeriod2 {
        period
        unit
        limit
        frequency
        spent
        transactionCount
      }
    }
  }
}
    `;

/**
 * __useGetCardLimitDetailsQuery__
 *
 * To run a query within a React component, call `useGetCardLimitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardLimitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardLimitDetailsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardLimitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables> & ({ variables: GetCardLimitDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>(GetCardLimitDetailsDocument, options);
      }
export function useGetCardLimitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>(GetCardLimitDetailsDocument, options);
        }
// @ts-ignore
export function useGetCardLimitDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>;
export function useGetCardLimitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardLimitDetailsQuery | undefined, GetCardLimitDetailsQueryVariables>;
export function useGetCardLimitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>(GetCardLimitDetailsDocument, options);
        }
export type GetCardLimitDetailsQueryHookResult = ReturnType<typeof useGetCardLimitDetailsQuery>;
export type GetCardLimitDetailsLazyQueryHookResult = ReturnType<typeof useGetCardLimitDetailsLazyQuery>;
export type GetCardLimitDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCardLimitDetailsSuspenseQuery>;
export type GetCardLimitDetailsQueryResult = Apollo.QueryResult<GetCardLimitDetailsQuery, GetCardLimitDetailsQueryVariables>;
export const GetCardSpendLimitDetailsByProductDocument = gql`
    query GetCardSpendLimitDetailsByProduct($input: GetCardSpendLimitDetailsByProductInput!) {
  cardSpendLimitDetailsByProduct(input: $input) {
    public_token
    limitsWithCounter {
      category
      limits {
        maximumPerTransaction
        minimumPerTransaction
        dailyLimit
        dailyFrequency
        accumLimit1
        accumFrequency1
        accumPeriod1
        accumLimit2
        accumFrequency2
        accumPeriod2
      }
      counters {
        daily_count
        daily_amount
        accumlimit1_count
        accumlimit1_amount
        accumlimit2_count
        accumlimit2_amount
      }
      subcategories {
        subcategory
        limits {
          maximumPerTransaction
          minimumPerTransaction
          dailyLimit
          dailyFrequency
          accumLimit1
          accumFrequency1
          accumPeriod1
          accumLimit2
          accumFrequency2
          accumPeriod2
        }
        counters {
          daily_count
          daily_amount
          accumlimit1_count
          accumlimit1_amount
          accumlimit2_count
          accumlimit2_amount
        }
      }
    }
  }
}
    `;

/**
 * __useGetCardSpendLimitDetailsByProductQuery__
 *
 * To run a query within a React component, call `useGetCardSpendLimitDetailsByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardSpendLimitDetailsByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardSpendLimitDetailsByProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCardSpendLimitDetailsByProductQuery(baseOptions: Apollo.QueryHookOptions<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables> & ({ variables: GetCardSpendLimitDetailsByProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>(GetCardSpendLimitDetailsByProductDocument, options);
      }
export function useGetCardSpendLimitDetailsByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>(GetCardSpendLimitDetailsByProductDocument, options);
        }
// @ts-ignore
export function useGetCardSpendLimitDetailsByProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>;
export function useGetCardSpendLimitDetailsByProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardSpendLimitDetailsByProductQuery | undefined, GetCardSpendLimitDetailsByProductQueryVariables>;
export function useGetCardSpendLimitDetailsByProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>(GetCardSpendLimitDetailsByProductDocument, options);
        }
export type GetCardSpendLimitDetailsByProductQueryHookResult = ReturnType<typeof useGetCardSpendLimitDetailsByProductQuery>;
export type GetCardSpendLimitDetailsByProductLazyQueryHookResult = ReturnType<typeof useGetCardSpendLimitDetailsByProductLazyQuery>;
export type GetCardSpendLimitDetailsByProductSuspenseQueryHookResult = ReturnType<typeof useGetCardSpendLimitDetailsByProductSuspenseQuery>;
export type GetCardSpendLimitDetailsByProductQueryResult = Apollo.QueryResult<GetCardSpendLimitDetailsByProductQuery, GetCardSpendLimitDetailsByProductQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($productId: Int!) {
  groups(productId: $productId) {
    groupType
    groups {
      id
      code
      description
    }
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables> & ({ variables: GetGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
// @ts-ignore
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery | undefined, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetPublicTokenCardStatusHistoryDocument = gql`
    query GetPublicTokenCardStatusHistory($input: CardStatusHistoryInput!) {
  publicTokenCardStatusHistory(input: $input) {
    items {
      changeDate
      changeNote
      newStatus
      oldStatus
      description
    }
  }
}
    `;

/**
 * __useGetPublicTokenCardStatusHistoryQuery__
 *
 * To run a query within a React component, call `useGetPublicTokenCardStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicTokenCardStatusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicTokenCardStatusHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPublicTokenCardStatusHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables> & ({ variables: GetPublicTokenCardStatusHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>(GetPublicTokenCardStatusHistoryDocument, options);
      }
export function useGetPublicTokenCardStatusHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>(GetPublicTokenCardStatusHistoryDocument, options);
        }
// @ts-ignore
export function useGetPublicTokenCardStatusHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>;
export function useGetPublicTokenCardStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublicTokenCardStatusHistoryQuery | undefined, GetPublicTokenCardStatusHistoryQueryVariables>;
export function useGetPublicTokenCardStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>(GetPublicTokenCardStatusHistoryDocument, options);
        }
export type GetPublicTokenCardStatusHistoryQueryHookResult = ReturnType<typeof useGetPublicTokenCardStatusHistoryQuery>;
export type GetPublicTokenCardStatusHistoryLazyQueryHookResult = ReturnType<typeof useGetPublicTokenCardStatusHistoryLazyQuery>;
export type GetPublicTokenCardStatusHistorySuspenseQueryHookResult = ReturnType<typeof useGetPublicTokenCardStatusHistorySuspenseQuery>;
export type GetPublicTokenCardStatusHistoryQueryResult = Apollo.QueryResult<GetPublicTokenCardStatusHistoryQuery, GetPublicTokenCardStatusHistoryQueryVariables>;
export const GetSingleCardPaymentTokenDetailsDocument = gql`
    query GetSingleCardPaymentTokenDetails($publicToken: String!, $tokenId: Long!) {
  singleCardPaymentTokenDetails(publicToken: $publicToken, tokenId: $tokenId) {
    creatorTokenReference
    cardUsageGroup
    paymentTokenUsageGroup
    walletAccountScore
    walletDeviceScore
    walletReasons
    transactionID
    responseCode
    transactionDate
    cardAcceptorNameLocation
    bnReference
    mtid
    ehiRequestTime
    ehiResponseTime
    activationCode
    activationMethod
    activationStatus
    id
    walletId
    walletProvider
    tokenPan
    statuses {
      tokenisedStatus {
        code
        description
      }
      authorisationStatus {
        code
        description
      }
      authorisationDecision {
        code
        description
      }
      transactionStatus {
        code
        description
      }
      gpsStatusInfo {
        code
        description
      }
    }
    tokenisedDate
    expiryDate
    tokenType
    deviceType
    deviceName
    deviceId
    replacementCount
    oldExpDate
    externalStatusSetBy
    deviceIp
    walletAccountHash
    digitisationReference
    threddDecision
    threddDecisionAt
    termsAndConditions
    merchantName
    linkedToken
    deviceLanguage
    location
    endOfPhoneNumber
    firstname
    lastname
    finalDecisionBy
    panSource
    creator
    txnStatusChanged
    activationCodeExpdate
    creatorPanReference
  }
}
    `;

/**
 * __useGetSingleCardPaymentTokenDetailsQuery__
 *
 * To run a query within a React component, call `useGetSingleCardPaymentTokenDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleCardPaymentTokenDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleCardPaymentTokenDetailsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetSingleCardPaymentTokenDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables> & ({ variables: GetSingleCardPaymentTokenDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>(GetSingleCardPaymentTokenDetailsDocument, options);
      }
export function useGetSingleCardPaymentTokenDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>(GetSingleCardPaymentTokenDetailsDocument, options);
        }
// @ts-ignore
export function useGetSingleCardPaymentTokenDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>;
export function useGetSingleCardPaymentTokenDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleCardPaymentTokenDetailsQuery | undefined, GetSingleCardPaymentTokenDetailsQueryVariables>;
export function useGetSingleCardPaymentTokenDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>(GetSingleCardPaymentTokenDetailsDocument, options);
        }
export type GetSingleCardPaymentTokenDetailsQueryHookResult = ReturnType<typeof useGetSingleCardPaymentTokenDetailsQuery>;
export type GetSingleCardPaymentTokenDetailsLazyQueryHookResult = ReturnType<typeof useGetSingleCardPaymentTokenDetailsLazyQuery>;
export type GetSingleCardPaymentTokenDetailsSuspenseQueryHookResult = ReturnType<typeof useGetSingleCardPaymentTokenDetailsSuspenseQuery>;
export type GetSingleCardPaymentTokenDetailsQueryResult = Apollo.QueryResult<GetSingleCardPaymentTokenDetailsQuery, GetSingleCardPaymentTokenDetailsQueryVariables>;
export const GetCardPosSubLimitsDocument = gql`
    query GetCardPosSubLimits($publicToken: String!) {
  cardPosSubLimits(publicToken: $publicToken) {
    cardPosSubLimits {
      posLimitDescription
      dailyValueLimit
      dailyFrequencyLimit
      maxPerTransaction
      minPerTransaction
      accumulatedValueLimit1
      accumulatedFrequencyLimit1
      accumulatedPeriod1
      accumulatedValueLimit2
      accumulatedFrequencyLimit2
      accumulatedPeriod2
    }
  }
}
    `;

/**
 * __useGetCardPosSubLimitsQuery__
 *
 * To run a query within a React component, call `useGetCardPosSubLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardPosSubLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardPosSubLimitsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardPosSubLimitsQuery(baseOptions: Apollo.QueryHookOptions<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables> & ({ variables: GetCardPosSubLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>(GetCardPosSubLimitsDocument, options);
      }
export function useGetCardPosSubLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>(GetCardPosSubLimitsDocument, options);
        }
// @ts-ignore
export function useGetCardPosSubLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>;
export function useGetCardPosSubLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardPosSubLimitsQuery | undefined, GetCardPosSubLimitsQueryVariables>;
export function useGetCardPosSubLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>(GetCardPosSubLimitsDocument, options);
        }
export type GetCardPosSubLimitsQueryHookResult = ReturnType<typeof useGetCardPosSubLimitsQuery>;
export type GetCardPosSubLimitsLazyQueryHookResult = ReturnType<typeof useGetCardPosSubLimitsLazyQuery>;
export type GetCardPosSubLimitsSuspenseQueryHookResult = ReturnType<typeof useGetCardPosSubLimitsSuspenseQuery>;
export type GetCardPosSubLimitsQueryResult = Apollo.QueryResult<GetCardPosSubLimitsQuery, GetCardPosSubLimitsQueryVariables>;
export const GetLoadSourceResponseDocument = gql`
    query GetLoadSourceResponse($publicToken: String!) {
  loadSourceList(publicToken: $publicToken) {
    cardLoadSources {
      maxPerTransaction
      minPerTransaction
      accumulatedValueLimit1
      accumulatedFrequencyLimit1
      accumulatedPeriod1
      accumulatedValueLimit2
      accumulatedFrequencyLimit2
      accumulatedPeriod2
      dailyValueLimit
      dailyFrequencyLimit
    }
  }
}
    `;

/**
 * __useGetLoadSourceResponseQuery__
 *
 * To run a query within a React component, call `useGetLoadSourceResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoadSourceResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoadSourceResponseQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetLoadSourceResponseQuery(baseOptions: Apollo.QueryHookOptions<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables> & ({ variables: GetLoadSourceResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>(GetLoadSourceResponseDocument, options);
      }
export function useGetLoadSourceResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>(GetLoadSourceResponseDocument, options);
        }
// @ts-ignore
export function useGetLoadSourceResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>): Apollo.UseSuspenseQueryResult<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>;
export function useGetLoadSourceResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>): Apollo.UseSuspenseQueryResult<GetLoadSourceResponseQuery | undefined, GetLoadSourceResponseQueryVariables>;
export function useGetLoadSourceResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>(GetLoadSourceResponseDocument, options);
        }
export type GetLoadSourceResponseQueryHookResult = ReturnType<typeof useGetLoadSourceResponseQuery>;
export type GetLoadSourceResponseLazyQueryHookResult = ReturnType<typeof useGetLoadSourceResponseLazyQuery>;
export type GetLoadSourceResponseSuspenseQueryHookResult = ReturnType<typeof useGetLoadSourceResponseSuspenseQuery>;
export type GetLoadSourceResponseQueryResult = Apollo.QueryResult<GetLoadSourceResponseQuery, GetLoadSourceResponseQueryVariables>;
export const CardBalanceTransferDocument = gql`
    mutation CardBalanceTransfer($publicToken: String!, $transactionType: String!, $amount: Decimal!, $currencyCode: String!, $user: String!, $description: String!, $toPublicToken: String!) {
  balanceTransfer(
    input: {publicToken: $publicToken, balanceTransferRequest: {transactionType: $transactionType, amount: $amount, currencyCode: $currencyCode, user: $user, description: $description, toPublicToken: $toPublicToken}}
  ) {
    transaction {
      transactionType
      transactionId
      amount
      __typename
    }
    balance {
      availableBalance
      cardBalance
      currencyCode
      pendingAmount
      __typename
    }
    __typename
  }
}
    `;
export type CardBalanceTransferMutationFn = Apollo.MutationFunction<CardBalanceTransferMutation, CardBalanceTransferMutationVariables>;

/**
 * __useCardBalanceTransferMutation__
 *
 * To run a mutation, you first call `useCardBalanceTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCardBalanceTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cardBalanceTransferMutation, { data, loading, error }] = useCardBalanceTransferMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      transactionType: // value for 'transactionType'
 *      amount: // value for 'amount'
 *      currencyCode: // value for 'currencyCode'
 *      user: // value for 'user'
 *      description: // value for 'description'
 *      toPublicToken: // value for 'toPublicToken'
 *   },
 * });
 */
export function useCardBalanceTransferMutation(baseOptions?: Apollo.MutationHookOptions<CardBalanceTransferMutation, CardBalanceTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CardBalanceTransferMutation, CardBalanceTransferMutationVariables>(CardBalanceTransferDocument, options);
      }
export type CardBalanceTransferMutationHookResult = ReturnType<typeof useCardBalanceTransferMutation>;
export type CardBalanceTransferMutationResult = Apollo.MutationResult<CardBalanceTransferMutation>;
export type CardBalanceTransferMutationOptions = Apollo.BaseMutationOptions<CardBalanceTransferMutation, CardBalanceTransferMutationVariables>;
export const MfxBalanceTransferDocument = gql`
    mutation MfxBalanceTransfer($input: MfxBalanceTransferInput!) {
  mfxBalanceTransfer(input: $input) {
    issCode
    publicToken
    sysDate
    __typename
  }
}
    `;
export type MfxBalanceTransferMutationFn = Apollo.MutationFunction<MfxBalanceTransferMutation, MfxBalanceTransferMutationVariables>;

/**
 * __useMfxBalanceTransferMutation__
 *
 * To run a mutation, you first call `useMfxBalanceTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfxBalanceTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfxBalanceTransferMutation, { data, loading, error }] = useMfxBalanceTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMfxBalanceTransferMutation(baseOptions?: Apollo.MutationHookOptions<MfxBalanceTransferMutation, MfxBalanceTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfxBalanceTransferMutation, MfxBalanceTransferMutationVariables>(MfxBalanceTransferDocument, options);
      }
export type MfxBalanceTransferMutationHookResult = ReturnType<typeof useMfxBalanceTransferMutation>;
export type MfxBalanceTransferMutationResult = Apollo.MutationResult<MfxBalanceTransferMutation>;
export type MfxBalanceTransferMutationOptions = Apollo.BaseMutationOptions<MfxBalanceTransferMutation, MfxBalanceTransferMutationVariables>;
export const UpdateGroupsDocument = gql`
    mutation UpdateGroups($input: UpdateControlGroupsInput!) {
  updateGroups(input: $input) {
    authFeeGroup
    calendarGroup
    cardLinkageGroup
    fxGroup
    limitsGroup
    mccGroup
    paymentTokenUsageGroup
    recurringFeeGroup
    usageGroup
    webServiceFeeGroup
    limitedNetworkGroup
    cardAcceptorAllowList
    cardAcceptorDisallowList
  }
}
    `;
export type UpdateGroupsMutationFn = Apollo.MutationFunction<UpdateGroupsMutation, UpdateGroupsMutationVariables>;

/**
 * __useUpdateGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupsMutation, { data, loading, error }] = useUpdateGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupsMutation, UpdateGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupsMutation, UpdateGroupsMutationVariables>(UpdateGroupsDocument, options);
      }
export type UpdateGroupsMutationHookResult = ReturnType<typeof useUpdateGroupsMutation>;
export type UpdateGroupsMutationResult = Apollo.MutationResult<UpdateGroupsMutation>;
export type UpdateGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateGroupsMutation, UpdateGroupsMutationVariables>;
export const Update3DsCredentialDetailsDocument = gql`
    mutation Update3DSCredentialDetails($publicToken: String!, $input: Update3DSCredentialInput!) {
  update3dsCredentialDetails(publicToken: $publicToken, input: $input)
}
    `;
export type Update3DsCredentialDetailsMutationFn = Apollo.MutationFunction<Update3DsCredentialDetailsMutation, Update3DsCredentialDetailsMutationVariables>;

/**
 * __useUpdate3DsCredentialDetailsMutation__
 *
 * To run a mutation, you first call `useUpdate3DsCredentialDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate3DsCredentialDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [update3DsCredentialDetailsMutation, { data, loading, error }] = useUpdate3DsCredentialDetailsMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdate3DsCredentialDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Update3DsCredentialDetailsMutation, Update3DsCredentialDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update3DsCredentialDetailsMutation, Update3DsCredentialDetailsMutationVariables>(Update3DsCredentialDetailsDocument, options);
      }
export type Update3DsCredentialDetailsMutationHookResult = ReturnType<typeof useUpdate3DsCredentialDetailsMutation>;
export type Update3DsCredentialDetailsMutationResult = Apollo.MutationResult<Update3DsCredentialDetailsMutation>;
export type Update3DsCredentialDetailsMutationOptions = Apollo.BaseMutationOptions<Update3DsCredentialDetailsMutation, Update3DsCredentialDetailsMutationVariables>;
export const UpdateCardDocument = gql`
    mutation UpdateCard($input: UpdateCardInput!) {
  updateCard(input: $input)
}
    `;
export type UpdateCardMutationFn = Apollo.MutationFunction<UpdateCardMutation, UpdateCardMutationVariables>;

/**
 * __useUpdateCardMutation__
 *
 * To run a mutation, you first call `useUpdateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardMutation, { data, loading, error }] = useUpdateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardMutation, UpdateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardMutation, UpdateCardMutationVariables>(UpdateCardDocument, options);
      }
export type UpdateCardMutationHookResult = ReturnType<typeof useUpdateCardMutation>;
export type UpdateCardMutationResult = Apollo.MutationResult<UpdateCardMutation>;
export type UpdateCardMutationOptions = Apollo.BaseMutationOptions<UpdateCardMutation, UpdateCardMutationVariables>;
export const ChangeCardStatusDocument = gql`
    mutation ChangeCardStatus($input: ChangeCardStatusInput!) {
  changeCardStatus(input: $input) {
    status
  }
}
    `;
export type ChangeCardStatusMutationFn = Apollo.MutationFunction<ChangeCardStatusMutation, ChangeCardStatusMutationVariables>;

/**
 * __useChangeCardStatusMutation__
 *
 * To run a mutation, you first call `useChangeCardStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCardStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCardStatusMutation, { data, loading, error }] = useChangeCardStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCardStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCardStatusMutation, ChangeCardStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCardStatusMutation, ChangeCardStatusMutationVariables>(ChangeCardStatusDocument, options);
      }
export type ChangeCardStatusMutationHookResult = ReturnType<typeof useChangeCardStatusMutation>;
export type ChangeCardStatusMutationResult = Apollo.MutationResult<ChangeCardStatusMutation>;
export type ChangeCardStatusMutationOptions = Apollo.BaseMutationOptions<ChangeCardStatusMutation, ChangeCardStatusMutationVariables>;
export const UnblockCvvDocument = gql`
    mutation unblockCVV($publicToken: String!, $cvvUnblockInput: CvvUnblockInput!) {
  unblockCvv(publicToken: $publicToken, input: $cvvUnblockInput)
}
    `;
export type UnblockCvvMutationFn = Apollo.MutationFunction<UnblockCvvMutation, UnblockCvvMutationVariables>;

/**
 * __useUnblockCvvMutation__
 *
 * To run a mutation, you first call `useUnblockCvvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockCvvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockCvvMutation, { data, loading, error }] = useUnblockCvvMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      cvvUnblockInput: // value for 'cvvUnblockInput'
 *   },
 * });
 */
export function useUnblockCvvMutation(baseOptions?: Apollo.MutationHookOptions<UnblockCvvMutation, UnblockCvvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockCvvMutation, UnblockCvvMutationVariables>(UnblockCvvDocument, options);
      }
export type UnblockCvvMutationHookResult = ReturnType<typeof useUnblockCvvMutation>;
export type UnblockCvvMutationResult = Apollo.MutationResult<UnblockCvvMutation>;
export type UnblockCvvMutationOptions = Apollo.BaseMutationOptions<UnblockCvvMutation, UnblockCvvMutationVariables>;
export const UnblockOfflinePinDocument = gql`
    mutation unblockOfflinePIN($publicToken: String!, $pinUnblockInput: PinUnblockInput!) {
  unblockOfflinePin(publicToken: $publicToken, input: $pinUnblockInput)
}
    `;
export type UnblockOfflinePinMutationFn = Apollo.MutationFunction<UnblockOfflinePinMutation, UnblockOfflinePinMutationVariables>;

/**
 * __useUnblockOfflinePinMutation__
 *
 * To run a mutation, you first call `useUnblockOfflinePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockOfflinePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockOfflinePinMutation, { data, loading, error }] = useUnblockOfflinePinMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      pinUnblockInput: // value for 'pinUnblockInput'
 *   },
 * });
 */
export function useUnblockOfflinePinMutation(baseOptions?: Apollo.MutationHookOptions<UnblockOfflinePinMutation, UnblockOfflinePinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockOfflinePinMutation, UnblockOfflinePinMutationVariables>(UnblockOfflinePinDocument, options);
      }
export type UnblockOfflinePinMutationHookResult = ReturnType<typeof useUnblockOfflinePinMutation>;
export type UnblockOfflinePinMutationResult = Apollo.MutationResult<UnblockOfflinePinMutation>;
export type UnblockOfflinePinMutationOptions = Apollo.BaseMutationOptions<UnblockOfflinePinMutation, UnblockOfflinePinMutationVariables>;
export const UnblockOnlinePinDocument = gql`
    mutation UnblockOnlinePIN($publicToken: String!, $pinUnblockInput: PinUnblockInput!) {
  unblockOnlinePin(publicToken: $publicToken, input: $pinUnblockInput)
}
    `;
export type UnblockOnlinePinMutationFn = Apollo.MutationFunction<UnblockOnlinePinMutation, UnblockOnlinePinMutationVariables>;

/**
 * __useUnblockOnlinePinMutation__
 *
 * To run a mutation, you first call `useUnblockOnlinePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockOnlinePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockOnlinePinMutation, { data, loading, error }] = useUnblockOnlinePinMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      pinUnblockInput: // value for 'pinUnblockInput'
 *   },
 * });
 */
export function useUnblockOnlinePinMutation(baseOptions?: Apollo.MutationHookOptions<UnblockOnlinePinMutation, UnblockOnlinePinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockOnlinePinMutation, UnblockOnlinePinMutationVariables>(UnblockOnlinePinDocument, options);
      }
export type UnblockOnlinePinMutationHookResult = ReturnType<typeof useUnblockOnlinePinMutation>;
export type UnblockOnlinePinMutationResult = Apollo.MutationResult<UnblockOnlinePinMutation>;
export type UnblockOnlinePinMutationOptions = Apollo.BaseMutationOptions<UnblockOnlinePinMutation, UnblockOnlinePinMutationVariables>;
export const GetCardCvvStatusDocument = gql`
    query GetCardCVVStatus($publicToken: String!) {
  cardCvvStatus(publicToken: $publicToken) {
    remainingTries
  }
}
    `;

/**
 * __useGetCardCvvStatusQuery__
 *
 * To run a query within a React component, call `useGetCardCvvStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardCvvStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardCvvStatusQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardCvvStatusQuery(baseOptions: Apollo.QueryHookOptions<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables> & ({ variables: GetCardCvvStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>(GetCardCvvStatusDocument, options);
      }
export function useGetCardCvvStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>(GetCardCvvStatusDocument, options);
        }
// @ts-ignore
export function useGetCardCvvStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>;
export function useGetCardCvvStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardCvvStatusQuery | undefined, GetCardCvvStatusQueryVariables>;
export function useGetCardCvvStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>(GetCardCvvStatusDocument, options);
        }
export type GetCardCvvStatusQueryHookResult = ReturnType<typeof useGetCardCvvStatusQuery>;
export type GetCardCvvStatusLazyQueryHookResult = ReturnType<typeof useGetCardCvvStatusLazyQuery>;
export type GetCardCvvStatusSuspenseQueryHookResult = ReturnType<typeof useGetCardCvvStatusSuspenseQuery>;
export type GetCardCvvStatusQueryResult = Apollo.QueryResult<GetCardCvvStatusQuery, GetCardCvvStatusQueryVariables>;
export const GetCardOnlinePinStatusDocument = gql`
    query GetCardOnlinePINStatus($publicToken: String!) {
  cardOnlinePinStatus(publicToken: $publicToken) {
    remainingTries
    remainingOfflineTries
  }
}
    `;

/**
 * __useGetCardOnlinePinStatusQuery__
 *
 * To run a query within a React component, call `useGetCardOnlinePinStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardOnlinePinStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardOnlinePinStatusQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardOnlinePinStatusQuery(baseOptions: Apollo.QueryHookOptions<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables> & ({ variables: GetCardOnlinePinStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>(GetCardOnlinePinStatusDocument, options);
      }
export function useGetCardOnlinePinStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>(GetCardOnlinePinStatusDocument, options);
        }
// @ts-ignore
export function useGetCardOnlinePinStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>;
export function useGetCardOnlinePinStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardOnlinePinStatusQuery | undefined, GetCardOnlinePinStatusQueryVariables>;
export function useGetCardOnlinePinStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>(GetCardOnlinePinStatusDocument, options);
        }
export type GetCardOnlinePinStatusQueryHookResult = ReturnType<typeof useGetCardOnlinePinStatusQuery>;
export type GetCardOnlinePinStatusLazyQueryHookResult = ReturnType<typeof useGetCardOnlinePinStatusLazyQuery>;
export type GetCardOnlinePinStatusSuspenseQueryHookResult = ReturnType<typeof useGetCardOnlinePinStatusSuspenseQuery>;
export type GetCardOnlinePinStatusQueryResult = Apollo.QueryResult<GetCardOnlinePinStatusQuery, GetCardOnlinePinStatusQueryVariables>;
export const GetCurrencyConversionRatesDocument = gql`
    query GetCurrencyConversionRates($input: CurConRateInput!) {
  currencyConversionRates(input: $input) {
    conversionRate
  }
}
    `;

/**
 * __useGetCurrencyConversionRatesQuery__
 *
 * To run a query within a React component, call `useGetCurrencyConversionRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyConversionRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyConversionRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCurrencyConversionRatesQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables> & ({ variables: GetCurrencyConversionRatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>(GetCurrencyConversionRatesDocument, options);
      }
export function useGetCurrencyConversionRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>(GetCurrencyConversionRatesDocument, options);
        }
// @ts-ignore
export function useGetCurrencyConversionRatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>;
export function useGetCurrencyConversionRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrencyConversionRatesQuery | undefined, GetCurrencyConversionRatesQueryVariables>;
export function useGetCurrencyConversionRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>(GetCurrencyConversionRatesDocument, options);
        }
export type GetCurrencyConversionRatesQueryHookResult = ReturnType<typeof useGetCurrencyConversionRatesQuery>;
export type GetCurrencyConversionRatesLazyQueryHookResult = ReturnType<typeof useGetCurrencyConversionRatesLazyQuery>;
export type GetCurrencyConversionRatesSuspenseQueryHookResult = ReturnType<typeof useGetCurrencyConversionRatesSuspenseQuery>;
export type GetCurrencyConversionRatesQueryResult = Apollo.QueryResult<GetCurrencyConversionRatesQuery, GetCurrencyConversionRatesQueryVariables>;
export const MfxWalletTransferDocument = gql`
    mutation MfxWalletTransfer($input: MfxWalletTransferInput!) {
  mfxWalletTransfer(input: $input) {
    sourceWalletTransaction {
      transactionId
      amount
      currencyCode
      publicToken
      actualBalance
      blockedAmount
      availableBalance
    }
    destinationWalletTransaction {
      transactionId
      amount
      currencyCode
      publicToken
      actualBalance
      blockedAmount
      availableBalance
      __typename
    }
    __typename
  }
}
    `;
export type MfxWalletTransferMutationFn = Apollo.MutationFunction<MfxWalletTransferMutation, MfxWalletTransferMutationVariables>;

/**
 * __useMfxWalletTransferMutation__
 *
 * To run a mutation, you first call `useMfxWalletTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfxWalletTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfxWalletTransferMutation, { data, loading, error }] = useMfxWalletTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMfxWalletTransferMutation(baseOptions?: Apollo.MutationHookOptions<MfxWalletTransferMutation, MfxWalletTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfxWalletTransferMutation, MfxWalletTransferMutationVariables>(MfxWalletTransferDocument, options);
      }
export type MfxWalletTransferMutationHookResult = ReturnType<typeof useMfxWalletTransferMutation>;
export type MfxWalletTransferMutationResult = Apollo.MutationResult<MfxWalletTransferMutation>;
export type MfxWalletTransferMutationOptions = Apollo.BaseMutationOptions<MfxWalletTransferMutation, MfxWalletTransferMutationVariables>;
export const GetPaymentInstructionDocument = gql`
    query GetPaymentInstruction($id: String!, $clientId: String!) {
  getPaymentInstruction(id: $id, clientId: $clientId) {
    id
    status
    paymentInstruction {
      effectiveEntryDate
      transactionDate
      transactionType
      transactionSpeed
      standardEntryClassCode
      paymentAuthorizationDetails
      originator {
        name
        accountNumber
        routingCode
        reference
      }
      recipient {
        name
        accountNumber
        routingCode
        reference
        accountType
      }
      asset {
        monetary {
          amount
          currencyCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaymentInstructionQuery__
 *
 * To run a query within a React component, call `useGetPaymentInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInstructionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetPaymentInstructionQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables> & ({ variables: GetPaymentInstructionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>(GetPaymentInstructionDocument, options);
      }
export function useGetPaymentInstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>(GetPaymentInstructionDocument, options);
        }
// @ts-ignore
export function useGetPaymentInstructionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>;
export function useGetPaymentInstructionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentInstructionQuery | undefined, GetPaymentInstructionQueryVariables>;
export function useGetPaymentInstructionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>(GetPaymentInstructionDocument, options);
        }
export type GetPaymentInstructionQueryHookResult = ReturnType<typeof useGetPaymentInstructionQuery>;
export type GetPaymentInstructionLazyQueryHookResult = ReturnType<typeof useGetPaymentInstructionLazyQuery>;
export type GetPaymentInstructionSuspenseQueryHookResult = ReturnType<typeof useGetPaymentInstructionSuspenseQuery>;
export type GetPaymentInstructionQueryResult = Apollo.QueryResult<GetPaymentInstructionQuery, GetPaymentInstructionQueryVariables>;
export const ListPaymentInstructionsDocument = gql`
    query ListPaymentInstructions($input: ListACHPaymentInstructionsInput, $clientId: String!) {
  listPaymentInstructions(input: $input, clientId: $clientId) {
    id
    status
    paymentInstruction {
      transactionDate
      effectiveEntryDate
      transactionType
      transactionSpeed
      paymentAuthorizationDetails
      recipient {
        name
        reference
        accountType
        accountNumber
      }
      originator {
        name
        accountNumber
      }
      asset {
        monetary {
          amount
          currencyCode
        }
      }
    }
  }
}
    `;

/**
 * __useListPaymentInstructionsQuery__
 *
 * To run a query within a React component, call `useListPaymentInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentInstructionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useListPaymentInstructionsQuery(baseOptions: Apollo.QueryHookOptions<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables> & ({ variables: ListPaymentInstructionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>(ListPaymentInstructionsDocument, options);
      }
export function useListPaymentInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>(ListPaymentInstructionsDocument, options);
        }
// @ts-ignore
export function useListPaymentInstructionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>;
export function useListPaymentInstructionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListPaymentInstructionsQuery | undefined, ListPaymentInstructionsQueryVariables>;
export function useListPaymentInstructionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>(ListPaymentInstructionsDocument, options);
        }
export type ListPaymentInstructionsQueryHookResult = ReturnType<typeof useListPaymentInstructionsQuery>;
export type ListPaymentInstructionsLazyQueryHookResult = ReturnType<typeof useListPaymentInstructionsLazyQuery>;
export type ListPaymentInstructionsSuspenseQueryHookResult = ReturnType<typeof useListPaymentInstructionsSuspenseQuery>;
export type ListPaymentInstructionsQueryResult = Apollo.QueryResult<ListPaymentInstructionsQuery, ListPaymentInstructionsQueryVariables>;
export const DecodingPds0146Document = gql`
    query DecodingPDS0146($input: String!, $networkId: Int!) {
  decodingPDS0146(input: $input, networkId: $networkId) {
    item
    value
  }
}
    `;

/**
 * __useDecodingPds0146Query__
 *
 * To run a query within a React component, call `useDecodingPds0146Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingPds0146Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingPds0146Query({
 *   variables: {
 *      input: // value for 'input'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useDecodingPds0146Query(baseOptions: Apollo.QueryHookOptions<DecodingPds0146Query, DecodingPds0146QueryVariables> & ({ variables: DecodingPds0146QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingPds0146Query, DecodingPds0146QueryVariables>(DecodingPds0146Document, options);
      }
export function useDecodingPds0146LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingPds0146Query, DecodingPds0146QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingPds0146Query, DecodingPds0146QueryVariables>(DecodingPds0146Document, options);
        }
// @ts-ignore
export function useDecodingPds0146SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingPds0146Query, DecodingPds0146QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0146Query, DecodingPds0146QueryVariables>;
export function useDecodingPds0146SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0146Query, DecodingPds0146QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0146Query | undefined, DecodingPds0146QueryVariables>;
export function useDecodingPds0146SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0146Query, DecodingPds0146QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingPds0146Query, DecodingPds0146QueryVariables>(DecodingPds0146Document, options);
        }
export type DecodingPds0146QueryHookResult = ReturnType<typeof useDecodingPds0146Query>;
export type DecodingPds0146LazyQueryHookResult = ReturnType<typeof useDecodingPds0146LazyQuery>;
export type DecodingPds0146SuspenseQueryHookResult = ReturnType<typeof useDecodingPds0146SuspenseQuery>;
export type DecodingPds0146QueryResult = Apollo.QueryResult<DecodingPds0146Query, DecodingPds0146QueryVariables>;
export const DecodingDe061Document = gql`
    query decodingDE061($input: String!, $networkId: Int!) {
  decodingDE061(input: $input, networkId: $networkId) {
    additionalInformation
    description
    position
    value
  }
}
    `;

/**
 * __useDecodingDe061Query__
 *
 * To run a query within a React component, call `useDecodingDe061Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingDe061Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingDe061Query({
 *   variables: {
 *      input: // value for 'input'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useDecodingDe061Query(baseOptions: Apollo.QueryHookOptions<DecodingDe061Query, DecodingDe061QueryVariables> & ({ variables: DecodingDe061QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingDe061Query, DecodingDe061QueryVariables>(DecodingDe061Document, options);
      }
export function useDecodingDe061LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingDe061Query, DecodingDe061QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingDe061Query, DecodingDe061QueryVariables>(DecodingDe061Document, options);
        }
// @ts-ignore
export function useDecodingDe061SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingDe061Query, DecodingDe061QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe061Query, DecodingDe061QueryVariables>;
export function useDecodingDe061SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe061Query, DecodingDe061QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe061Query | undefined, DecodingDe061QueryVariables>;
export function useDecodingDe061SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe061Query, DecodingDe061QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingDe061Query, DecodingDe061QueryVariables>(DecodingDe061Document, options);
        }
export type DecodingDe061QueryHookResult = ReturnType<typeof useDecodingDe061Query>;
export type DecodingDe061LazyQueryHookResult = ReturnType<typeof useDecodingDe061LazyQuery>;
export type DecodingDe061SuspenseQueryHookResult = ReturnType<typeof useDecodingDe061SuspenseQuery>;
export type DecodingDe061QueryResult = Apollo.QueryResult<DecodingDe061Query, DecodingDe061QueryVariables>;
export const DecodingDe60Document = gql`
    query decodingDE60($input: String!) {
  decodingDE60(input: $input) {
    additionalInformation
    description
    position
    value
  }
}
    `;

/**
 * __useDecodingDe60Query__
 *
 * To run a query within a React component, call `useDecodingDe60Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingDe60Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingDe60Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecodingDe60Query(baseOptions: Apollo.QueryHookOptions<DecodingDe60Query, DecodingDe60QueryVariables> & ({ variables: DecodingDe60QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingDe60Query, DecodingDe60QueryVariables>(DecodingDe60Document, options);
      }
export function useDecodingDe60LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingDe60Query, DecodingDe60QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingDe60Query, DecodingDe60QueryVariables>(DecodingDe60Document, options);
        }
// @ts-ignore
export function useDecodingDe60SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingDe60Query, DecodingDe60QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe60Query, DecodingDe60QueryVariables>;
export function useDecodingDe60SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe60Query, DecodingDe60QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe60Query | undefined, DecodingDe60QueryVariables>;
export function useDecodingDe60SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe60Query, DecodingDe60QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingDe60Query, DecodingDe60QueryVariables>(DecodingDe60Document, options);
        }
export type DecodingDe60QueryHookResult = ReturnType<typeof useDecodingDe60Query>;
export type DecodingDe60LazyQueryHookResult = ReturnType<typeof useDecodingDe60LazyQuery>;
export type DecodingDe60SuspenseQueryHookResult = ReturnType<typeof useDecodingDe60SuspenseQuery>;
export type DecodingDe60QueryResult = Apollo.QueryResult<DecodingDe60Query, DecodingDe60QueryVariables>;
export const DecodingDe022Document = gql`
    query DecodingDE022($de022: String!, $mTID: String!, $networkId: Int!, $transactionTypeDescriptions: String!) {
  decodingDE022(
    de022: $de022
    mtid: $mTID
    networkId: $networkId
    transactionTypeDescription: $transactionTypeDescriptions
  ) {
    value
    description
    position
    __typename
  }
}
    `;

/**
 * __useDecodingDe022Query__
 *
 * To run a query within a React component, call `useDecodingDe022Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingDe022Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingDe022Query({
 *   variables: {
 *      de022: // value for 'de022'
 *      mTID: // value for 'mTID'
 *      networkId: // value for 'networkId'
 *      transactionTypeDescriptions: // value for 'transactionTypeDescriptions'
 *   },
 * });
 */
export function useDecodingDe022Query(baseOptions: Apollo.QueryHookOptions<DecodingDe022Query, DecodingDe022QueryVariables> & ({ variables: DecodingDe022QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingDe022Query, DecodingDe022QueryVariables>(DecodingDe022Document, options);
      }
export function useDecodingDe022LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingDe022Query, DecodingDe022QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingDe022Query, DecodingDe022QueryVariables>(DecodingDe022Document, options);
        }
// @ts-ignore
export function useDecodingDe022SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingDe022Query, DecodingDe022QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe022Query, DecodingDe022QueryVariables>;
export function useDecodingDe022SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe022Query, DecodingDe022QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe022Query | undefined, DecodingDe022QueryVariables>;
export function useDecodingDe022SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe022Query, DecodingDe022QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingDe022Query, DecodingDe022QueryVariables>(DecodingDe022Document, options);
        }
export type DecodingDe022QueryHookResult = ReturnType<typeof useDecodingDe022Query>;
export type DecodingDe022LazyQueryHookResult = ReturnType<typeof useDecodingDe022LazyQuery>;
export type DecodingDe022SuspenseQueryHookResult = ReturnType<typeof useDecodingDe022SuspenseQuery>;
export type DecodingDe022QueryResult = Apollo.QueryResult<DecodingDe022Query, DecodingDe022QueryVariables>;
export const DecodingDe048Document = gql`
    query decodingDE048($de048: String!, $mtid: String!, $networkId: Int!, $transactionType: String!) {
  decodingDE048(
    de048: $de048
    mtid: $mtid
    networkId: $networkId
    transactionType: $transactionType
  ) {
    btnPds0146IsVisible
    pds0146
    btnPds0158IsVisible
    pds0158
    btnPds0159IsVisible
    pds0159
    btnPds0043IsVisible
    pds0043
    heading
    additionalDataDecoded {
      item
      value
    }
    additionalDataDecodedMc {
      totalLength
      tcc
      additionalDataDecoded {
        pdsmc
        item
        value
        subElements {
          item
          value
          subElements {
            item
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDecodingDe048Query__
 *
 * To run a query within a React component, call `useDecodingDe048Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingDe048Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingDe048Query({
 *   variables: {
 *      de048: // value for 'de048'
 *      mtid: // value for 'mtid'
 *      networkId: // value for 'networkId'
 *      transactionType: // value for 'transactionType'
 *   },
 * });
 */
export function useDecodingDe048Query(baseOptions: Apollo.QueryHookOptions<DecodingDe048Query, DecodingDe048QueryVariables> & ({ variables: DecodingDe048QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingDe048Query, DecodingDe048QueryVariables>(DecodingDe048Document, options);
      }
export function useDecodingDe048LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingDe048Query, DecodingDe048QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingDe048Query, DecodingDe048QueryVariables>(DecodingDe048Document, options);
        }
// @ts-ignore
export function useDecodingDe048SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingDe048Query, DecodingDe048QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe048Query, DecodingDe048QueryVariables>;
export function useDecodingDe048SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe048Query, DecodingDe048QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe048Query | undefined, DecodingDe048QueryVariables>;
export function useDecodingDe048SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe048Query, DecodingDe048QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingDe048Query, DecodingDe048QueryVariables>(DecodingDe048Document, options);
        }
export type DecodingDe048QueryHookResult = ReturnType<typeof useDecodingDe048Query>;
export type DecodingDe048LazyQueryHookResult = ReturnType<typeof useDecodingDe048LazyQuery>;
export type DecodingDe048SuspenseQueryHookResult = ReturnType<typeof useDecodingDe048SuspenseQuery>;
export type DecodingDe048QueryResult = Apollo.QueryResult<DecodingDe048Query, DecodingDe048QueryVariables>;
export const DecodingPds0043Document = gql`
    query DecodingPDS0043($pds0043: String!) {
  decodingPDS0043(input: $pds0043) {
    item
    value
  }
}
    `;

/**
 * __useDecodingPds0043Query__
 *
 * To run a query within a React component, call `useDecodingPds0043Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingPds0043Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingPds0043Query({
 *   variables: {
 *      pds0043: // value for 'pds0043'
 *   },
 * });
 */
export function useDecodingPds0043Query(baseOptions: Apollo.QueryHookOptions<DecodingPds0043Query, DecodingPds0043QueryVariables> & ({ variables: DecodingPds0043QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingPds0043Query, DecodingPds0043QueryVariables>(DecodingPds0043Document, options);
      }
export function useDecodingPds0043LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingPds0043Query, DecodingPds0043QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingPds0043Query, DecodingPds0043QueryVariables>(DecodingPds0043Document, options);
        }
// @ts-ignore
export function useDecodingPds0043SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingPds0043Query, DecodingPds0043QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0043Query, DecodingPds0043QueryVariables>;
export function useDecodingPds0043SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0043Query, DecodingPds0043QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0043Query | undefined, DecodingPds0043QueryVariables>;
export function useDecodingPds0043SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0043Query, DecodingPds0043QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingPds0043Query, DecodingPds0043QueryVariables>(DecodingPds0043Document, options);
        }
export type DecodingPds0043QueryHookResult = ReturnType<typeof useDecodingPds0043Query>;
export type DecodingPds0043LazyQueryHookResult = ReturnType<typeof useDecodingPds0043LazyQuery>;
export type DecodingPds0043SuspenseQueryHookResult = ReturnType<typeof useDecodingPds0043SuspenseQuery>;
export type DecodingPds0043QueryResult = Apollo.QueryResult<DecodingPds0043Query, DecodingPds0043QueryVariables>;
export const DecodingPds0158Document = gql`
    query DecodingPDS0158($pds0158: String!) {
  decodingPDS0158(input: $pds0158) {
    item
    value
  }
}
    `;

/**
 * __useDecodingPds0158Query__
 *
 * To run a query within a React component, call `useDecodingPds0158Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingPds0158Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingPds0158Query({
 *   variables: {
 *      pds0158: // value for 'pds0158'
 *   },
 * });
 */
export function useDecodingPds0158Query(baseOptions: Apollo.QueryHookOptions<DecodingPds0158Query, DecodingPds0158QueryVariables> & ({ variables: DecodingPds0158QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingPds0158Query, DecodingPds0158QueryVariables>(DecodingPds0158Document, options);
      }
export function useDecodingPds0158LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingPds0158Query, DecodingPds0158QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingPds0158Query, DecodingPds0158QueryVariables>(DecodingPds0158Document, options);
        }
// @ts-ignore
export function useDecodingPds0158SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingPds0158Query, DecodingPds0158QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0158Query, DecodingPds0158QueryVariables>;
export function useDecodingPds0158SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0158Query, DecodingPds0158QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0158Query | undefined, DecodingPds0158QueryVariables>;
export function useDecodingPds0158SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0158Query, DecodingPds0158QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingPds0158Query, DecodingPds0158QueryVariables>(DecodingPds0158Document, options);
        }
export type DecodingPds0158QueryHookResult = ReturnType<typeof useDecodingPds0158Query>;
export type DecodingPds0158LazyQueryHookResult = ReturnType<typeof useDecodingPds0158LazyQuery>;
export type DecodingPds0158SuspenseQueryHookResult = ReturnType<typeof useDecodingPds0158SuspenseQuery>;
export type DecodingPds0158QueryResult = Apollo.QueryResult<DecodingPds0158Query, DecodingPds0158QueryVariables>;
export const DecodingPds0159Document = gql`
    query DecodingPDS0159($pds0159: String!) {
  decodingPDS0159(input: $pds0159) {
    item
    value
  }
}
    `;

/**
 * __useDecodingPds0159Query__
 *
 * To run a query within a React component, call `useDecodingPds0159Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingPds0159Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingPds0159Query({
 *   variables: {
 *      pds0159: // value for 'pds0159'
 *   },
 * });
 */
export function useDecodingPds0159Query(baseOptions: Apollo.QueryHookOptions<DecodingPds0159Query, DecodingPds0159QueryVariables> & ({ variables: DecodingPds0159QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingPds0159Query, DecodingPds0159QueryVariables>(DecodingPds0159Document, options);
      }
export function useDecodingPds0159LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingPds0159Query, DecodingPds0159QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingPds0159Query, DecodingPds0159QueryVariables>(DecodingPds0159Document, options);
        }
// @ts-ignore
export function useDecodingPds0159SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingPds0159Query, DecodingPds0159QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0159Query, DecodingPds0159QueryVariables>;
export function useDecodingPds0159SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0159Query, DecodingPds0159QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingPds0159Query | undefined, DecodingPds0159QueryVariables>;
export function useDecodingPds0159SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingPds0159Query, DecodingPds0159QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingPds0159Query, DecodingPds0159QueryVariables>(DecodingPds0159Document, options);
        }
export type DecodingPds0159QueryHookResult = ReturnType<typeof useDecodingPds0159Query>;
export type DecodingPds0159LazyQueryHookResult = ReturnType<typeof useDecodingPds0159LazyQuery>;
export type DecodingPds0159SuspenseQueryHookResult = ReturnType<typeof useDecodingPds0159SuspenseQuery>;
export type DecodingPds0159QueryResult = Apollo.QueryResult<DecodingPds0159Query, DecodingPds0159QueryVariables>;
export const DecodeCvrDocument = gql`
    query DecodeCVR($cvrData: String!, $networkId: Int!) {
  decodingCVR(cvrData: $cvrData, networkId: $networkId) {
    item
    value
    cvrDetails {
      item
      value
    }
  }
}
    `;

/**
 * __useDecodeCvrQuery__
 *
 * To run a query within a React component, call `useDecodeCvrQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecodeCvrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodeCvrQuery({
 *   variables: {
 *      cvrData: // value for 'cvrData'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useDecodeCvrQuery(baseOptions: Apollo.QueryHookOptions<DecodeCvrQuery, DecodeCvrQueryVariables> & ({ variables: DecodeCvrQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodeCvrQuery, DecodeCvrQueryVariables>(DecodeCvrDocument, options);
      }
export function useDecodeCvrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodeCvrQuery, DecodeCvrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodeCvrQuery, DecodeCvrQueryVariables>(DecodeCvrDocument, options);
        }
// @ts-ignore
export function useDecodeCvrSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodeCvrQuery, DecodeCvrQueryVariables>): Apollo.UseSuspenseQueryResult<DecodeCvrQuery, DecodeCvrQueryVariables>;
export function useDecodeCvrSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeCvrQuery, DecodeCvrQueryVariables>): Apollo.UseSuspenseQueryResult<DecodeCvrQuery | undefined, DecodeCvrQueryVariables>;
export function useDecodeCvrSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeCvrQuery, DecodeCvrQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodeCvrQuery, DecodeCvrQueryVariables>(DecodeCvrDocument, options);
        }
export type DecodeCvrQueryHookResult = ReturnType<typeof useDecodeCvrQuery>;
export type DecodeCvrLazyQueryHookResult = ReturnType<typeof useDecodeCvrLazyQuery>;
export type DecodeCvrSuspenseQueryHookResult = ReturnType<typeof useDecodeCvrSuspenseQuery>;
export type DecodeCvrQueryResult = Apollo.QueryResult<DecodeCvrQuery, DecodeCvrQueryVariables>;
export const DecodeDe055Document = gql`
    query DecodeDe055($iccData: String!, $networkId: Int!) {
  decodeDe055(iccData: $iccData, networkId: $networkId) {
    pds
    pdsDescription
    pdsHexa
    pdsValue
    subfieldValue
    subLevelPDS {
      pds
      pdsDescription
      pdsHexa
      pdsValue
    }
  }
}
    `;

/**
 * __useDecodeDe055Query__
 *
 * To run a query within a React component, call `useDecodeDe055Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodeDe055Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodeDe055Query({
 *   variables: {
 *      iccData: // value for 'iccData'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useDecodeDe055Query(baseOptions: Apollo.QueryHookOptions<DecodeDe055Query, DecodeDe055QueryVariables> & ({ variables: DecodeDe055QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodeDe055Query, DecodeDe055QueryVariables>(DecodeDe055Document, options);
      }
export function useDecodeDe055LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodeDe055Query, DecodeDe055QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodeDe055Query, DecodeDe055QueryVariables>(DecodeDe055Document, options);
        }
// @ts-ignore
export function useDecodeDe055SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodeDe055Query, DecodeDe055QueryVariables>): Apollo.UseSuspenseQueryResult<DecodeDe055Query, DecodeDe055QueryVariables>;
export function useDecodeDe055SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeDe055Query, DecodeDe055QueryVariables>): Apollo.UseSuspenseQueryResult<DecodeDe055Query | undefined, DecodeDe055QueryVariables>;
export function useDecodeDe055SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeDe055Query, DecodeDe055QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodeDe055Query, DecodeDe055QueryVariables>(DecodeDe055Document, options);
        }
export type DecodeDe055QueryHookResult = ReturnType<typeof useDecodeDe055Query>;
export type DecodeDe055LazyQueryHookResult = ReturnType<typeof useDecodeDe055LazyQuery>;
export type DecodeDe055SuspenseQueryHookResult = ReturnType<typeof useDecodeDe055SuspenseQuery>;
export type DecodeDe055QueryResult = Apollo.QueryResult<DecodeDe055Query, DecodeDe055QueryVariables>;
export const DecodeDe055ForPresentmentDocument = gql`
    query DecodeDe055ForPresentment($iccData: String!, $networkId: Int!) {
  decodeDe055ForPresentment(iccData: $iccData, networkId: $networkId) {
    pds
    pdsDescription
    pdsHexa
    pdsValue
    subfieldValue
    subLevelPDS {
      pds
      pdsDescription
      pdsHexa
      pdsValue
    }
  }
}
    `;

/**
 * __useDecodeDe055ForPresentmentQuery__
 *
 * To run a query within a React component, call `useDecodeDe055ForPresentmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecodeDe055ForPresentmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodeDe055ForPresentmentQuery({
 *   variables: {
 *      iccData: // value for 'iccData'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useDecodeDe055ForPresentmentQuery(baseOptions: Apollo.QueryHookOptions<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables> & ({ variables: DecodeDe055ForPresentmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>(DecodeDe055ForPresentmentDocument, options);
      }
export function useDecodeDe055ForPresentmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>(DecodeDe055ForPresentmentDocument, options);
        }
// @ts-ignore
export function useDecodeDe055ForPresentmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>): Apollo.UseSuspenseQueryResult<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>;
export function useDecodeDe055ForPresentmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>): Apollo.UseSuspenseQueryResult<DecodeDe055ForPresentmentQuery | undefined, DecodeDe055ForPresentmentQueryVariables>;
export function useDecodeDe055ForPresentmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>(DecodeDe055ForPresentmentDocument, options);
        }
export type DecodeDe055ForPresentmentQueryHookResult = ReturnType<typeof useDecodeDe055ForPresentmentQuery>;
export type DecodeDe055ForPresentmentLazyQueryHookResult = ReturnType<typeof useDecodeDe055ForPresentmentLazyQuery>;
export type DecodeDe055ForPresentmentSuspenseQueryHookResult = ReturnType<typeof useDecodeDe055ForPresentmentSuspenseQuery>;
export type DecodeDe055ForPresentmentQueryResult = Apollo.QueryResult<DecodeDe055ForPresentmentQuery, DecodeDe055ForPresentmentQueryVariables>;
export const DecodingDe025Document = gql`
    query decodingDE025($input: String!) {
  decodingDE025(input: $input) {
    value
    description
    __typename
  }
}
    `;

/**
 * __useDecodingDe025Query__
 *
 * To run a query within a React component, call `useDecodingDe025Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingDe025Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingDe025Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecodingDe025Query(baseOptions: Apollo.QueryHookOptions<DecodingDe025Query, DecodingDe025QueryVariables> & ({ variables: DecodingDe025QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingDe025Query, DecodingDe025QueryVariables>(DecodingDe025Document, options);
      }
export function useDecodingDe025LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingDe025Query, DecodingDe025QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingDe025Query, DecodingDe025QueryVariables>(DecodingDe025Document, options);
        }
// @ts-ignore
export function useDecodingDe025SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingDe025Query, DecodingDe025QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe025Query, DecodingDe025QueryVariables>;
export function useDecodingDe025SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe025Query, DecodingDe025QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe025Query | undefined, DecodingDe025QueryVariables>;
export function useDecodingDe025SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe025Query, DecodingDe025QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingDe025Query, DecodingDe025QueryVariables>(DecodingDe025Document, options);
        }
export type DecodingDe025QueryHookResult = ReturnType<typeof useDecodingDe025Query>;
export type DecodingDe025LazyQueryHookResult = ReturnType<typeof useDecodingDe025LazyQuery>;
export type DecodingDe025SuspenseQueryHookResult = ReturnType<typeof useDecodingDe025SuspenseQuery>;
export type DecodingDe025QueryResult = Apollo.QueryResult<DecodingDe025Query, DecodingDe025QueryVariables>;
export const CreateAuthReversalTransactionDocument = gql`
    mutation CreateAuthReversalTransaction($transactionId: String!, $input: AuthReversalRequestInput!) {
  createAuthReversalTransaction(transactionId: $transactionId, input: $input) {
    transactionId
  }
}
    `;
export type CreateAuthReversalTransactionMutationFn = Apollo.MutationFunction<CreateAuthReversalTransactionMutation, CreateAuthReversalTransactionMutationVariables>;

/**
 * __useCreateAuthReversalTransactionMutation__
 *
 * To run a mutation, you first call `useCreateAuthReversalTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthReversalTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthReversalTransactionMutation, { data, loading, error }] = useCreateAuthReversalTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthReversalTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthReversalTransactionMutation, CreateAuthReversalTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthReversalTransactionMutation, CreateAuthReversalTransactionMutationVariables>(CreateAuthReversalTransactionDocument, options);
      }
export type CreateAuthReversalTransactionMutationHookResult = ReturnType<typeof useCreateAuthReversalTransactionMutation>;
export type CreateAuthReversalTransactionMutationResult = Apollo.MutationResult<CreateAuthReversalTransactionMutation>;
export type CreateAuthReversalTransactionMutationOptions = Apollo.BaseMutationOptions<CreateAuthReversalTransactionMutation, CreateAuthReversalTransactionMutationVariables>;
export const UnblockCardDocument = gql`
    mutation UnblockCard($publicToken: String!, $input: UnblockCardInput!) {
  unblockCard(publicToken: $publicToken, input: $input)
}
    `;
export type UnblockCardMutationFn = Apollo.MutationFunction<UnblockCardMutation, UnblockCardMutationVariables>;

/**
 * __useUnblockCardMutation__
 *
 * To run a mutation, you first call `useUnblockCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockCardMutation, { data, loading, error }] = useUnblockCardMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnblockCardMutation(baseOptions?: Apollo.MutationHookOptions<UnblockCardMutation, UnblockCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnblockCardMutation, UnblockCardMutationVariables>(UnblockCardDocument, options);
      }
export type UnblockCardMutationHookResult = ReturnType<typeof useUnblockCardMutation>;
export type UnblockCardMutationResult = Apollo.MutationResult<UnblockCardMutation>;
export type UnblockCardMutationOptions = Apollo.BaseMutationOptions<UnblockCardMutation, UnblockCardMutationVariables>;
export const SendToEhiDocument = gql`
    mutation sendToEhi($transactionId: String!) {
  ehiResend(transactionId: $transactionId) {
    resendMessage
  }
}
    `;
export type SendToEhiMutationFn = Apollo.MutationFunction<SendToEhiMutation, SendToEhiMutationVariables>;

/**
 * __useSendToEhiMutation__
 *
 * To run a mutation, you first call `useSendToEhiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendToEhiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendToEhiMutation, { data, loading, error }] = useSendToEhiMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useSendToEhiMutation(baseOptions?: Apollo.MutationHookOptions<SendToEhiMutation, SendToEhiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendToEhiMutation, SendToEhiMutationVariables>(SendToEhiDocument, options);
      }
export type SendToEhiMutationHookResult = ReturnType<typeof useSendToEhiMutation>;
export type SendToEhiMutationResult = Apollo.MutationResult<SendToEhiMutation>;
export type SendToEhiMutationOptions = Apollo.BaseMutationOptions<SendToEhiMutation, SendToEhiMutationVariables>;
export const GetEhiAcknowledgementDocument = gql`
    query getEhiAcknowledgement($transactionId: String!) {
  ehiAcknowledgement(transactionId: $transactionId) {
    resendToEhi
  }
}
    `;

/**
 * __useGetEhiAcknowledgementQuery__
 *
 * To run a query within a React component, call `useGetEhiAcknowledgementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEhiAcknowledgementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEhiAcknowledgementQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetEhiAcknowledgementQuery(baseOptions: Apollo.QueryHookOptions<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables> & ({ variables: GetEhiAcknowledgementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>(GetEhiAcknowledgementDocument, options);
      }
export function useGetEhiAcknowledgementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>(GetEhiAcknowledgementDocument, options);
        }
// @ts-ignore
export function useGetEhiAcknowledgementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>): Apollo.UseSuspenseQueryResult<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>;
export function useGetEhiAcknowledgementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>): Apollo.UseSuspenseQueryResult<GetEhiAcknowledgementQuery | undefined, GetEhiAcknowledgementQueryVariables>;
export function useGetEhiAcknowledgementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>(GetEhiAcknowledgementDocument, options);
        }
export type GetEhiAcknowledgementQueryHookResult = ReturnType<typeof useGetEhiAcknowledgementQuery>;
export type GetEhiAcknowledgementLazyQueryHookResult = ReturnType<typeof useGetEhiAcknowledgementLazyQuery>;
export type GetEhiAcknowledgementSuspenseQueryHookResult = ReturnType<typeof useGetEhiAcknowledgementSuspenseQuery>;
export type GetEhiAcknowledgementQueryResult = Apollo.QueryResult<GetEhiAcknowledgementQuery, GetEhiAcknowledgementQueryVariables>;
export const UpdateVisaFileMaintenanceDocument = gql`
    mutation updateVisaFileMaintenance($input: VisaFileMaintenanceInput!, $publicToken: String!) {
  updateVisaFileMaintenance(input: $input, publicToken: $publicToken) {
    visaFileData {
      requestData {
        transmissionDateTime
        retrievalReferenceNumber
        updatedBy
        updateReason
        systemTraceAuditNumber
        fileUpdateCode
        requestFileName
      }
      responseData {
        responseDateTime
        responseCode
        responseResult
        fileUpdateCode
        responseFileName
        transmissionDateTime
        retrievalReferenceNumber
      }
    }
  }
}
    `;
export type UpdateVisaFileMaintenanceMutationFn = Apollo.MutationFunction<UpdateVisaFileMaintenanceMutation, UpdateVisaFileMaintenanceMutationVariables>;

/**
 * __useUpdateVisaFileMaintenanceMutation__
 *
 * To run a mutation, you first call `useUpdateVisaFileMaintenanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisaFileMaintenanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisaFileMaintenanceMutation, { data, loading, error }] = useUpdateVisaFileMaintenanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useUpdateVisaFileMaintenanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisaFileMaintenanceMutation, UpdateVisaFileMaintenanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisaFileMaintenanceMutation, UpdateVisaFileMaintenanceMutationVariables>(UpdateVisaFileMaintenanceDocument, options);
      }
export type UpdateVisaFileMaintenanceMutationHookResult = ReturnType<typeof useUpdateVisaFileMaintenanceMutation>;
export type UpdateVisaFileMaintenanceMutationResult = Apollo.MutationResult<UpdateVisaFileMaintenanceMutation>;
export type UpdateVisaFileMaintenanceMutationOptions = Apollo.BaseMutationOptions<UpdateVisaFileMaintenanceMutation, UpdateVisaFileMaintenanceMutationVariables>;
export const DecodingDe063Document = gql`
    query decodingDE063($input: String!) {
  decodingDE063(input: $input) {
    position
    value
    description
    additionalInformation
    __typename
  }
}
    `;

/**
 * __useDecodingDe063Query__
 *
 * To run a query within a React component, call `useDecodingDe063Query` and pass it any options that fit your needs.
 * When your component renders, `useDecodingDe063Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodingDe063Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecodingDe063Query(baseOptions: Apollo.QueryHookOptions<DecodingDe063Query, DecodingDe063QueryVariables> & ({ variables: DecodingDe063QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodingDe063Query, DecodingDe063QueryVariables>(DecodingDe063Document, options);
      }
export function useDecodingDe063LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodingDe063Query, DecodingDe063QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodingDe063Query, DecodingDe063QueryVariables>(DecodingDe063Document, options);
        }
// @ts-ignore
export function useDecodingDe063SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodingDe063Query, DecodingDe063QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe063Query, DecodingDe063QueryVariables>;
export function useDecodingDe063SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe063Query, DecodingDe063QueryVariables>): Apollo.UseSuspenseQueryResult<DecodingDe063Query | undefined, DecodingDe063QueryVariables>;
export function useDecodingDe063SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodingDe063Query, DecodingDe063QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodingDe063Query, DecodingDe063QueryVariables>(DecodingDe063Document, options);
        }
export type DecodingDe063QueryHookResult = ReturnType<typeof useDecodingDe063Query>;
export type DecodingDe063LazyQueryHookResult = ReturnType<typeof useDecodingDe063LazyQuery>;
export type DecodingDe063SuspenseQueryHookResult = ReturnType<typeof useDecodingDe063SuspenseQuery>;
export type DecodingDe063QueryResult = Apollo.QueryResult<DecodingDe063Query, DecodingDe063QueryVariables>;
export const GetLifecycleTransactionsDocument = gql`
    query GetLifecycleTransactions($traceIdLifeCycle: String!) {
  transactionsDetails(traceIdLifeCycle: $traceIdLifeCycle) {
    recordId
    pubToken
    traceIdLifeCycle
    transactionId
    transactionType
    transactionStatus
    transactionAmount
    transactionCurrency
    transactionDate
    billingAmount
    billingCurrency
    processingCode
    responseStatus
    merchantCategoryCode
    dateExpiry
    posEntryMode
    retrievalReference
    cardAcceptorIdentificationCode
    cardAcceptorNameLocation
    aid
    fid
    cardAcceptorTerminalIdentification
    additionalData
    settlementAmount
    settlementCurrency
    authorisationCode
    additionalAmounts
    posData
    tillTime
    paymentTokenId
    note
    availableBalance
    blockedAmount
    fees
    stan
    messageType
    iccData
    gpsPosData
    adviceReasonData
    additionalResponseData
    avsStreet
    avsPostcode
    networkData
    acquirerReferenceData
    transactionOriginatingInstitution
    merchant {
      city
      contact
      county
      name
      nameOther
      networkId
      postcode
      region
      street
      taxId
      telephone
      url
    }
    transactionFees {
      domesticFixedFee
      domesticRateFee
      fxFixedFee
      fxRateFee
      nonDomesticFixedFee
      nonDomesticRateFee
    }
  }
}
    `;

/**
 * __useGetLifecycleTransactionsQuery__
 *
 * To run a query within a React component, call `useGetLifecycleTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifecycleTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifecycleTransactionsQuery({
 *   variables: {
 *      traceIdLifeCycle: // value for 'traceIdLifeCycle'
 *   },
 * });
 */
export function useGetLifecycleTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables> & ({ variables: GetLifecycleTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>(GetLifecycleTransactionsDocument, options);
      }
export function useGetLifecycleTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>(GetLifecycleTransactionsDocument, options);
        }
// @ts-ignore
export function useGetLifecycleTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>;
export function useGetLifecycleTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLifecycleTransactionsQuery | undefined, GetLifecycleTransactionsQueryVariables>;
export function useGetLifecycleTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>(GetLifecycleTransactionsDocument, options);
        }
export type GetLifecycleTransactionsQueryHookResult = ReturnType<typeof useGetLifecycleTransactionsQuery>;
export type GetLifecycleTransactionsLazyQueryHookResult = ReturnType<typeof useGetLifecycleTransactionsLazyQuery>;
export type GetLifecycleTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetLifecycleTransactionsSuspenseQuery>;
export type GetLifecycleTransactionsQueryResult = Apollo.QueryResult<GetLifecycleTransactionsQuery, GetLifecycleTransactionsQueryVariables>;
export const ListProductsDocument = gql`
    query ListProducts {
  getProducts {
    count
    pageToken
    products {
      productId
      productName
      rangeLowLimit
      rangeHighLimit
    }
  }
}
    `;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListProductsQuery(baseOptions?: Apollo.QueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
      }
export function useListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
// @ts-ignore
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProductsQuery, ListProductsQueryVariables>;
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProductsQuery | undefined, ListProductsQueryVariables>;
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>;
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>;
export type ListProductsSuspenseQueryHookResult = ReturnType<typeof useListProductsSuspenseQuery>;
export type ListProductsQueryResult = Apollo.QueryResult<ListProductsQuery, ListProductsQueryVariables>;
export const CreateWebhookDocument = gql`
    mutation CreateWebhook($webhookInput: WebhookRequestInput!) {
  createWebhook(input: $webhookInput) {
    status
    response {
      webhookId
      webhookStatus
      message
      errorCode
    }
  }
}
    `;
export type CreateWebhookMutationFn = Apollo.MutationFunction<CreateWebhookMutation, CreateWebhookMutationVariables>;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      webhookInput: // value for 'webhookInput'
 *   },
 * });
 */
export function useCreateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookMutation, CreateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookMutation, CreateWebhookMutationVariables>(CreateWebhookDocument, options);
      }
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
export type CreateWebhookMutationResult = Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<CreateWebhookMutation, CreateWebhookMutationVariables>;
export const UpdateWebhookDocument = gql`
    mutation UpdateWebhook($webhookId: String!, $updateWebhookRequestInput: UpdateWebhookRequestInput!) {
  updateWebhookDetails(webhookId: $webhookId, input: $updateWebhookRequestInput) {
    status
    response {
      webhookId
      webhookStatus
      message
      errorCode
    }
  }
}
    `;
export type UpdateWebhookMutationFn = Apollo.MutationFunction<UpdateWebhookMutation, UpdateWebhookMutationVariables>;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      webhookId: // value for 'webhookId'
 *      updateWebhookRequestInput: // value for 'updateWebhookRequestInput'
 *   },
 * });
 */
export function useUpdateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookMutation, UpdateWebhookMutationVariables>(UpdateWebhookDocument, options);
      }
export type UpdateWebhookMutationHookResult = ReturnType<typeof useUpdateWebhookMutation>;
export type UpdateWebhookMutationResult = Apollo.MutationResult<UpdateWebhookMutation>;
export type UpdateWebhookMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>;
export const UpdateWebhookStatusDocument = gql`
    mutation UpdateWebhookStatus($input: UpdateWebhookStatusInput!, $webhookId: String!) {
  updateWebhookStatus(input: $input, webhookId: $webhookId) {
    status
  }
}
    `;
export type UpdateWebhookStatusMutationFn = Apollo.MutationFunction<UpdateWebhookStatusMutation, UpdateWebhookStatusMutationVariables>;

/**
 * __useUpdateWebhookStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookStatusMutation, { data, loading, error }] = useUpdateWebhookStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *      webhookId: // value for 'webhookId'
 *   },
 * });
 */
export function useUpdateWebhookStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookStatusMutation, UpdateWebhookStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookStatusMutation, UpdateWebhookStatusMutationVariables>(UpdateWebhookStatusDocument, options);
      }
export type UpdateWebhookStatusMutationHookResult = ReturnType<typeof useUpdateWebhookStatusMutation>;
export type UpdateWebhookStatusMutationResult = Apollo.MutationResult<UpdateWebhookStatusMutation>;
export type UpdateWebhookStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookStatusMutation, UpdateWebhookStatusMutationVariables>;
export const GetWebhookEventsDocument = gql`
    query GetWebhookEvents {
  webhookEvents {
    status
    response
  }
}
    `;

/**
 * __useGetWebhookEventsQuery__
 *
 * To run a query within a React component, call `useGetWebhookEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebhookEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
      }
export function useGetWebhookEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
        }
// @ts-ignore
export function useGetWebhookEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>;
export function useGetWebhookEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEventsQuery | undefined, GetWebhookEventsQueryVariables>;
export function useGetWebhookEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>(GetWebhookEventsDocument, options);
        }
export type GetWebhookEventsQueryHookResult = ReturnType<typeof useGetWebhookEventsQuery>;
export type GetWebhookEventsLazyQueryHookResult = ReturnType<typeof useGetWebhookEventsLazyQuery>;
export type GetWebhookEventsSuspenseQueryHookResult = ReturnType<typeof useGetWebhookEventsSuspenseQuery>;
export type GetWebhookEventsQueryResult = Apollo.QueryResult<GetWebhookEventsQuery, GetWebhookEventsQueryVariables>;
export const PingWebhookDocument = gql`
    query pingWebhook($webhookId: String!) {
  pingWebhook(webhookId: $webhookId) {
    status
    response {
      webhookId
      healthStatus
    }
    __typename
  }
}
    `;

/**
 * __usePingWebhookQuery__
 *
 * To run a query within a React component, call `usePingWebhookQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingWebhookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingWebhookQuery({
 *   variables: {
 *      webhookId: // value for 'webhookId'
 *   },
 * });
 */
export function usePingWebhookQuery(baseOptions: Apollo.QueryHookOptions<PingWebhookQuery, PingWebhookQueryVariables> & ({ variables: PingWebhookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingWebhookQuery, PingWebhookQueryVariables>(PingWebhookDocument, options);
      }
export function usePingWebhookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingWebhookQuery, PingWebhookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingWebhookQuery, PingWebhookQueryVariables>(PingWebhookDocument, options);
        }
// @ts-ignore
export function usePingWebhookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PingWebhookQuery, PingWebhookQueryVariables>): Apollo.UseSuspenseQueryResult<PingWebhookQuery, PingWebhookQueryVariables>;
export function usePingWebhookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingWebhookQuery, PingWebhookQueryVariables>): Apollo.UseSuspenseQueryResult<PingWebhookQuery | undefined, PingWebhookQueryVariables>;
export function usePingWebhookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingWebhookQuery, PingWebhookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PingWebhookQuery, PingWebhookQueryVariables>(PingWebhookDocument, options);
        }
export type PingWebhookQueryHookResult = ReturnType<typeof usePingWebhookQuery>;
export type PingWebhookLazyQueryHookResult = ReturnType<typeof usePingWebhookLazyQuery>;
export type PingWebhookSuspenseQueryHookResult = ReturnType<typeof usePingWebhookSuspenseQuery>;
export type PingWebhookQueryResult = Apollo.QueryResult<PingWebhookQuery, PingWebhookQueryVariables>;
export const ListWebhooksDocument = gql`
    query ListWebhooks($input: ListWebhooksInput!) {
  listWebhooks(input: $input) {
    response {
      endpointsCount
      items {
        config {
          customHeaders
          url
        }
        createdTime
        customHeaders
        events
        lastModifiedTime
        productId
        url
        webhookId
        webhookStatus
      }
      pageNumber
      pageSize
      totalCount
      totalPages
    }
    status
  }
}
    `;

/**
 * __useListWebhooksQuery__
 *
 * To run a query within a React component, call `useListWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhooksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListWebhooksQuery(baseOptions: Apollo.QueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables> & ({ variables: ListWebhooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
      }
export function useListWebhooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
        }
// @ts-ignore
export function useListWebhooksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>): Apollo.UseSuspenseQueryResult<ListWebhooksQuery, ListWebhooksQueryVariables>;
export function useListWebhooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>): Apollo.UseSuspenseQueryResult<ListWebhooksQuery | undefined, ListWebhooksQueryVariables>;
export function useListWebhooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
        }
export type ListWebhooksQueryHookResult = ReturnType<typeof useListWebhooksQuery>;
export type ListWebhooksLazyQueryHookResult = ReturnType<typeof useListWebhooksLazyQuery>;
export type ListWebhooksSuspenseQueryHookResult = ReturnType<typeof useListWebhooksSuspenseQuery>;
export type ListWebhooksQueryResult = Apollo.QueryResult<ListWebhooksQuery, ListWebhooksQueryVariables>;
export const BalanceAdjustmentForBlockedAmountDocument = gql`
    mutation BalanceAdjustmentForBlockedAmount($input: UpdateBlockedAmountInput!) {
  balanceAjustmentForBlockedAmt(input: $input) {
    transaction {
      transactionType
      transactionId
      amount
      currencyCode
    }
    balance {
      cardBalance
      currencyCode
      pendingAmount
    }
  }
}
    `;
export type BalanceAdjustmentForBlockedAmountMutationFn = Apollo.MutationFunction<BalanceAdjustmentForBlockedAmountMutation, BalanceAdjustmentForBlockedAmountMutationVariables>;

/**
 * __useBalanceAdjustmentForBlockedAmountMutation__
 *
 * To run a mutation, you first call `useBalanceAdjustmentForBlockedAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBalanceAdjustmentForBlockedAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [balanceAdjustmentForBlockedAmountMutation, { data, loading, error }] = useBalanceAdjustmentForBlockedAmountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBalanceAdjustmentForBlockedAmountMutation(baseOptions?: Apollo.MutationHookOptions<BalanceAdjustmentForBlockedAmountMutation, BalanceAdjustmentForBlockedAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BalanceAdjustmentForBlockedAmountMutation, BalanceAdjustmentForBlockedAmountMutationVariables>(BalanceAdjustmentForBlockedAmountDocument, options);
      }
export type BalanceAdjustmentForBlockedAmountMutationHookResult = ReturnType<typeof useBalanceAdjustmentForBlockedAmountMutation>;
export type BalanceAdjustmentForBlockedAmountMutationResult = Apollo.MutationResult<BalanceAdjustmentForBlockedAmountMutation>;
export type BalanceAdjustmentForBlockedAmountMutationOptions = Apollo.BaseMutationOptions<BalanceAdjustmentForBlockedAmountMutation, BalanceAdjustmentForBlockedAmountMutationVariables>;
export const CardBalanceAdjustmentDocument = gql`
    mutation CardBalanceAdjustment($input: LoadUnloadCardInput!) {
  loadUnloadCard(input: $input) {
    transaction {
      transactionType
      transactionId
      amount
      __typename
    }
    balance {
      availableBalance
      cardBalance
      currencyCode
      pendingAmount
      __typename
    }
    __typename
  }
}
    `;
export type CardBalanceAdjustmentMutationFn = Apollo.MutationFunction<CardBalanceAdjustmentMutation, CardBalanceAdjustmentMutationVariables>;

/**
 * __useCardBalanceAdjustmentMutation__
 *
 * To run a mutation, you first call `useCardBalanceAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCardBalanceAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cardBalanceAdjustmentMutation, { data, loading, error }] = useCardBalanceAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCardBalanceAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<CardBalanceAdjustmentMutation, CardBalanceAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CardBalanceAdjustmentMutation, CardBalanceAdjustmentMutationVariables>(CardBalanceAdjustmentDocument, options);
      }
export type CardBalanceAdjustmentMutationHookResult = ReturnType<typeof useCardBalanceAdjustmentMutation>;
export type CardBalanceAdjustmentMutationResult = Apollo.MutationResult<CardBalanceAdjustmentMutation>;
export type CardBalanceAdjustmentMutationOptions = Apollo.BaseMutationOptions<CardBalanceAdjustmentMutation, CardBalanceAdjustmentMutationVariables>;
export const ChangePaymentTokenStatusDocument = gql`
    mutation ChangePaymentTokenStatus($newStatus: String!, $publicToken: String!, $tokenId: Long!, $description: String!, $updatedBy: String!) {
  changePaymentTokenStatus(
    input: {newStatus: $newStatus, publicToken: $publicToken, tokenId: $tokenId, description: $description, updatedBy: $updatedBy}
  ) {
    comment
    status
  }
}
    `;
export type ChangePaymentTokenStatusMutationFn = Apollo.MutationFunction<ChangePaymentTokenStatusMutation, ChangePaymentTokenStatusMutationVariables>;

/**
 * __useChangePaymentTokenStatusMutation__
 *
 * To run a mutation, you first call `useChangePaymentTokenStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePaymentTokenStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePaymentTokenStatusMutation, { data, loading, error }] = useChangePaymentTokenStatusMutation({
 *   variables: {
 *      newStatus: // value for 'newStatus'
 *      publicToken: // value for 'publicToken'
 *      tokenId: // value for 'tokenId'
 *      description: // value for 'description'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useChangePaymentTokenStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangePaymentTokenStatusMutation, ChangePaymentTokenStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePaymentTokenStatusMutation, ChangePaymentTokenStatusMutationVariables>(ChangePaymentTokenStatusDocument, options);
      }
export type ChangePaymentTokenStatusMutationHookResult = ReturnType<typeof useChangePaymentTokenStatusMutation>;
export type ChangePaymentTokenStatusMutationResult = Apollo.MutationResult<ChangePaymentTokenStatusMutation>;
export type ChangePaymentTokenStatusMutationOptions = Apollo.BaseMutationOptions<ChangePaymentTokenStatusMutation, ChangePaymentTokenStatusMutationVariables>;
export const MfxBalanceAdjustmentDocument = gql`
    mutation MfxBalanceAdjustment($input: MfxBalanceAdjInput!) {
  mfxBalanceAdjustment(input: $input) {
    transaction {
      transactionType
      transactionId
      amount
    }
    balance {
      availableBalance
      cardBalance
      pendingAmount
      currencyCode
    }
  }
}
    `;
export type MfxBalanceAdjustmentMutationFn = Apollo.MutationFunction<MfxBalanceAdjustmentMutation, MfxBalanceAdjustmentMutationVariables>;

/**
 * __useMfxBalanceAdjustmentMutation__
 *
 * To run a mutation, you first call `useMfxBalanceAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfxBalanceAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfxBalanceAdjustmentMutation, { data, loading, error }] = useMfxBalanceAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMfxBalanceAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<MfxBalanceAdjustmentMutation, MfxBalanceAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfxBalanceAdjustmentMutation, MfxBalanceAdjustmentMutationVariables>(MfxBalanceAdjustmentDocument, options);
      }
export type MfxBalanceAdjustmentMutationHookResult = ReturnType<typeof useMfxBalanceAdjustmentMutation>;
export type MfxBalanceAdjustmentMutationResult = Apollo.MutationResult<MfxBalanceAdjustmentMutation>;
export type MfxBalanceAdjustmentMutationOptions = Apollo.BaseMutationOptions<MfxBalanceAdjustmentMutation, MfxBalanceAdjustmentMutationVariables>;
export const MfxLoadCardDocument = gql`
    mutation MfxLoadCard($loadCardInput: MfxLoadCardInput!) {
  mfxLoadCard(input: $loadCardInput) {
    issCode
    publicToken
    sysDate
    actionCode
    __typename
  }
}
    `;
export type MfxLoadCardMutationFn = Apollo.MutationFunction<MfxLoadCardMutation, MfxLoadCardMutationVariables>;

/**
 * __useMfxLoadCardMutation__
 *
 * To run a mutation, you first call `useMfxLoadCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfxLoadCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfxLoadCardMutation, { data, loading, error }] = useMfxLoadCardMutation({
 *   variables: {
 *      loadCardInput: // value for 'loadCardInput'
 *   },
 * });
 */
export function useMfxLoadCardMutation(baseOptions?: Apollo.MutationHookOptions<MfxLoadCardMutation, MfxLoadCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfxLoadCardMutation, MfxLoadCardMutationVariables>(MfxLoadCardDocument, options);
      }
export type MfxLoadCardMutationHookResult = ReturnType<typeof useMfxLoadCardMutation>;
export type MfxLoadCardMutationResult = Apollo.MutationResult<MfxLoadCardMutation>;
export type MfxLoadCardMutationOptions = Apollo.BaseMutationOptions<MfxLoadCardMutation, MfxLoadCardMutationVariables>;
export const MfxUnloadCardDocument = gql`
    mutation MfxUnloadCard($unLoadCardInput: MfxUnloadCardInput!) {
  mfxUnloadCard(input: $unLoadCardInput) {
    issCode
    publicToken
    sysDate
    __typename
  }
}
    `;
export type MfxUnloadCardMutationFn = Apollo.MutationFunction<MfxUnloadCardMutation, MfxUnloadCardMutationVariables>;

/**
 * __useMfxUnloadCardMutation__
 *
 * To run a mutation, you first call `useMfxUnloadCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfxUnloadCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfxUnloadCardMutation, { data, loading, error }] = useMfxUnloadCardMutation({
 *   variables: {
 *      unLoadCardInput: // value for 'unLoadCardInput'
 *   },
 * });
 */
export function useMfxUnloadCardMutation(baseOptions?: Apollo.MutationHookOptions<MfxUnloadCardMutation, MfxUnloadCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfxUnloadCardMutation, MfxUnloadCardMutationVariables>(MfxUnloadCardDocument, options);
      }
export type MfxUnloadCardMutationHookResult = ReturnType<typeof useMfxUnloadCardMutation>;
export type MfxUnloadCardMutationResult = Apollo.MutationResult<MfxUnloadCardMutation>;
export type MfxUnloadCardMutationOptions = Apollo.BaseMutationOptions<MfxUnloadCardMutation, MfxUnloadCardMutationVariables>;
export const Get3dsCredentialsListDocument = gql`
    query Get3dsCredentialsList($publicToken: String!) {
  _dsCredentialsList(publicToken: $publicToken) {
    type
    value
    kbaQuestion
  }
}
    `;

/**
 * __useGet3dsCredentialsListQuery__
 *
 * To run a query within a React component, call `useGet3dsCredentialsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet3dsCredentialsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet3dsCredentialsListQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGet3dsCredentialsListQuery(baseOptions: Apollo.QueryHookOptions<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables> & ({ variables: Get3dsCredentialsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>(Get3dsCredentialsListDocument, options);
      }
export function useGet3dsCredentialsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>(Get3dsCredentialsListDocument, options);
        }
// @ts-ignore
export function useGet3dsCredentialsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>): Apollo.UseSuspenseQueryResult<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>;
export function useGet3dsCredentialsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>): Apollo.UseSuspenseQueryResult<Get3dsCredentialsListQuery | undefined, Get3dsCredentialsListQueryVariables>;
export function useGet3dsCredentialsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>(Get3dsCredentialsListDocument, options);
        }
export type Get3dsCredentialsListQueryHookResult = ReturnType<typeof useGet3dsCredentialsListQuery>;
export type Get3dsCredentialsListLazyQueryHookResult = ReturnType<typeof useGet3dsCredentialsListLazyQuery>;
export type Get3dsCredentialsListSuspenseQueryHookResult = ReturnType<typeof useGet3dsCredentialsListSuspenseQuery>;
export type Get3dsCredentialsListQueryResult = Apollo.QueryResult<Get3dsCredentialsListQuery, Get3dsCredentialsListQueryVariables>;
export const GetCardStatusesDocument = gql`
    query GetCardStatuses {
  allCardStatuses {
    code
    description
    isEditableByProgramManager
  }
}
    `;

/**
 * __useGetCardStatusesQuery__
 *
 * To run a query within a React component, call `useGetCardStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCardStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetCardStatusesQuery, GetCardStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardStatusesQuery, GetCardStatusesQueryVariables>(GetCardStatusesDocument, options);
      }
export function useGetCardStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardStatusesQuery, GetCardStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardStatusesQuery, GetCardStatusesQueryVariables>(GetCardStatusesDocument, options);
        }
// @ts-ignore
export function useGetCardStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardStatusesQuery, GetCardStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardStatusesQuery, GetCardStatusesQueryVariables>;
export function useGetCardStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardStatusesQuery, GetCardStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardStatusesQuery | undefined, GetCardStatusesQueryVariables>;
export function useGetCardStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardStatusesQuery, GetCardStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardStatusesQuery, GetCardStatusesQueryVariables>(GetCardStatusesDocument, options);
        }
export type GetCardStatusesQueryHookResult = ReturnType<typeof useGetCardStatusesQuery>;
export type GetCardStatusesLazyQueryHookResult = ReturnType<typeof useGetCardStatusesLazyQuery>;
export type GetCardStatusesSuspenseQueryHookResult = ReturnType<typeof useGetCardStatusesSuspenseQuery>;
export type GetCardStatusesQueryResult = Apollo.QueryResult<GetCardStatusesQuery, GetCardStatusesQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  allCountries {
    alphaCode
    numericCode
    countryCode
    countryName
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
// @ts-ignore
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesQuery | undefined, GetCountriesQueryVariables>;
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const AllCurrenciesDocument = gql`
    query allCurrencies {
  allCurrencyCodes {
    description
    code
  }
}
    `;

/**
 * __useAllCurrenciesQuery__
 *
 * To run a query within a React component, call `useAllCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCurrenciesQuery, AllCurrenciesQueryVariables>(AllCurrenciesDocument, options);
      }
export function useAllCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCurrenciesQuery, AllCurrenciesQueryVariables>(AllCurrenciesDocument, options);
        }
// @ts-ignore
export function useAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCurrenciesQuery, AllCurrenciesQueryVariables>;
export function useAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCurrenciesQuery | undefined, AllCurrenciesQueryVariables>;
export function useAllCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCurrenciesQuery, AllCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCurrenciesQuery, AllCurrenciesQueryVariables>(AllCurrenciesDocument, options);
        }
export type AllCurrenciesQueryHookResult = ReturnType<typeof useAllCurrenciesQuery>;
export type AllCurrenciesLazyQueryHookResult = ReturnType<typeof useAllCurrenciesLazyQuery>;
export type AllCurrenciesSuspenseQueryHookResult = ReturnType<typeof useAllCurrenciesSuspenseQuery>;
export type AllCurrenciesQueryResult = Apollo.QueryResult<AllCurrenciesQuery, AllCurrenciesQueryVariables>;
export const GetProcessingCodesDocument = gql`
    query GetProcessingCodes {
  allProcessingCodes {
    code
    description
  }
}
    `;

/**
 * __useGetProcessingCodesQuery__
 *
 * To run a query within a React component, call `useGetProcessingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessingCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessingCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProcessingCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>(GetProcessingCodesDocument, options);
      }
export function useGetProcessingCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>(GetProcessingCodesDocument, options);
        }
// @ts-ignore
export function useGetProcessingCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>;
export function useGetProcessingCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProcessingCodesQuery | undefined, GetProcessingCodesQueryVariables>;
export function useGetProcessingCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>(GetProcessingCodesDocument, options);
        }
export type GetProcessingCodesQueryHookResult = ReturnType<typeof useGetProcessingCodesQuery>;
export type GetProcessingCodesLazyQueryHookResult = ReturnType<typeof useGetProcessingCodesLazyQuery>;
export type GetProcessingCodesSuspenseQueryHookResult = ReturnType<typeof useGetProcessingCodesSuspenseQuery>;
export type GetProcessingCodesQueryResult = Apollo.QueryResult<GetProcessingCodesQuery, GetProcessingCodesQueryVariables>;
export const GetRegionsDocument = gql`
    query GetRegions {
  allRegions {
    regionName
    regionId
    regionDescription
    defaultRegion
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
// @ts-ignore
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionsQuery | undefined, GetRegionsQueryVariables>;
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetTransactionStatusesDocument = gql`
    query GetTransactionStatuses {
  allTransactionStatus {
    code
    description
  }
}
    `;

/**
 * __useGetTransactionStatusesQuery__
 *
 * To run a query within a React component, call `useGetTransactionStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>(GetTransactionStatusesDocument, options);
      }
export function useGetTransactionStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>(GetTransactionStatusesDocument, options);
        }
// @ts-ignore
export function useGetTransactionStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>;
export function useGetTransactionStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionStatusesQuery | undefined, GetTransactionStatusesQueryVariables>;
export function useGetTransactionStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>(GetTransactionStatusesDocument, options);
        }
export type GetTransactionStatusesQueryHookResult = ReturnType<typeof useGetTransactionStatusesQuery>;
export type GetTransactionStatusesLazyQueryHookResult = ReturnType<typeof useGetTransactionStatusesLazyQuery>;
export type GetTransactionStatusesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionStatusesSuspenseQuery>;
export type GetTransactionStatusesQueryResult = Apollo.QueryResult<GetTransactionStatusesQuery, GetTransactionStatusesQueryVariables>;
export const GetTransactionTypesDocument = gql`
    query GetTransactionTypes {
  allTransactionTypes {
    code
    description
  }
}
    `;

/**
 * __useGetTransactionTypesQuery__
 *
 * To run a query within a React component, call `useGetTransactionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
      }
export function useGetTransactionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
        }
// @ts-ignore
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>;
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionTypesQuery | undefined, GetTransactionTypesQueryVariables>;
export function useGetTransactionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>(GetTransactionTypesDocument, options);
        }
export type GetTransactionTypesQueryHookResult = ReturnType<typeof useGetTransactionTypesQuery>;
export type GetTransactionTypesLazyQueryHookResult = ReturnType<typeof useGetTransactionTypesLazyQuery>;
export type GetTransactionTypesSuspenseQueryHookResult = ReturnType<typeof useGetTransactionTypesSuspenseQuery>;
export type GetTransactionTypesQueryResult = Apollo.QueryResult<GetTransactionTypesQuery, GetTransactionTypesQueryVariables>;
export const GetCardDocument = gql`
    query GetCard($publicToken: String!) {
  cardByPublicToken(publicToken: $publicToken) {
    networkSharingOptOut
    panPubt
    balance {
      availableBalance
      cardBalance
      currencyCode
      pendingAmount
    }
    cardDetails {
      customerReference
      expiryDate
      fullNameOnCard
      maskedPan
      startDate
      activationDate
      gpsExpiryDate
    }
    cardHolder {
      dateOfBirth
      email
      firstName
      lastName
      middleName
      mobile
      title
    }
    cardProduct {
      product
      productShortName
      scheme
      productName
      networkId
      ehiMode
    }
    cardType
    childCards
    controlGroups {
      authFeeGroup
      calendarGroup
      cardLinkageGroup
      fxGroup
      limitsGroup
      mccGroup
      paymentTokenUsageGroup
      recurringFeeGroup
      usageGroup
      webServiceFeeGroup
      cardAcceptorAllowList
      cardAcceptorDisallowList
      limitedNetworkGroup
    }
    credentials {
      configuration
      defaultCredentials {
        id
        type
        value
      }
      fallbackCredentials {
        id
        type
        value
      }
    }
    parentCard
    siblingCards
    status
    cardStatusCode
    cardStatusDescription
    isMultiFx
    isMfxPrimary
    publicToken
    address {
      addressLine1
      addressLine2
      addressLine3
      city
      country
      county
      postCode
      state
    }
    designId
  }
}
    `;

/**
 * __useGetCardQuery__
 *
 * To run a query within a React component, call `useGetCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardQuery(baseOptions: Apollo.QueryHookOptions<GetCardQuery, GetCardQueryVariables> & ({ variables: GetCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
      }
export function useGetCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
        }
// @ts-ignore
export function useGetCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardQuery, GetCardQueryVariables>;
export function useGetCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardQuery | undefined, GetCardQueryVariables>;
export function useGetCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
        }
export type GetCardQueryHookResult = ReturnType<typeof useGetCardQuery>;
export type GetCardLazyQueryHookResult = ReturnType<typeof useGetCardLazyQuery>;
export type GetCardSuspenseQueryHookResult = ReturnType<typeof useGetCardSuspenseQuery>;
export type GetCardQueryResult = Apollo.QueryResult<GetCardQuery, GetCardQueryVariables>;
export const GetCardGroupLimitDetailsDocument = gql`
    query GetCardGroupLimitDetails($publicToken: String!) {
  cardGroupLimitDetails(publicToken: $publicToken) {
    groupCode
    groupName
    maxAllowableBalance
    cardGroupLimits {
      dailyValueLimit
      dailyFrequencyLimit
      maxPerTransaction
      minPerTransaction
      accumulatedValueLimit1
      accumulatedFrequencyLimit1
      accumulatedPeriod1
      accumulatedValueLimit2
      accumulatedFrequencyLimit2
      accumulatedPeriod2
      subGroup
    }
  }
}
    `;

/**
 * __useGetCardGroupLimitDetailsQuery__
 *
 * To run a query within a React component, call `useGetCardGroupLimitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardGroupLimitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardGroupLimitDetailsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardGroupLimitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables> & ({ variables: GetCardGroupLimitDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>(GetCardGroupLimitDetailsDocument, options);
      }
export function useGetCardGroupLimitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>(GetCardGroupLimitDetailsDocument, options);
        }
// @ts-ignore
export function useGetCardGroupLimitDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>;
export function useGetCardGroupLimitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardGroupLimitDetailsQuery | undefined, GetCardGroupLimitDetailsQueryVariables>;
export function useGetCardGroupLimitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>(GetCardGroupLimitDetailsDocument, options);
        }
export type GetCardGroupLimitDetailsQueryHookResult = ReturnType<typeof useGetCardGroupLimitDetailsQuery>;
export type GetCardGroupLimitDetailsLazyQueryHookResult = ReturnType<typeof useGetCardGroupLimitDetailsLazyQuery>;
export type GetCardGroupLimitDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCardGroupLimitDetailsSuspenseQuery>;
export type GetCardGroupLimitDetailsQueryResult = Apollo.QueryResult<GetCardGroupLimitDetailsQuery, GetCardGroupLimitDetailsQueryVariables>;
export const GetCardNetworkTypeDocument = gql`
    query GetCardNetworkType {
  cardNetworkType {
    value
    description
  }
}
    `;

/**
 * __useGetCardNetworkTypeQuery__
 *
 * To run a query within a React component, call `useGetCardNetworkTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardNetworkTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardNetworkTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCardNetworkTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>(GetCardNetworkTypeDocument, options);
      }
export function useGetCardNetworkTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>(GetCardNetworkTypeDocument, options);
        }
// @ts-ignore
export function useGetCardNetworkTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>;
export function useGetCardNetworkTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardNetworkTypeQuery | undefined, GetCardNetworkTypeQueryVariables>;
export function useGetCardNetworkTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>(GetCardNetworkTypeDocument, options);
        }
export type GetCardNetworkTypeQueryHookResult = ReturnType<typeof useGetCardNetworkTypeQuery>;
export type GetCardNetworkTypeLazyQueryHookResult = ReturnType<typeof useGetCardNetworkTypeLazyQuery>;
export type GetCardNetworkTypeSuspenseQueryHookResult = ReturnType<typeof useGetCardNetworkTypeSuspenseQuery>;
export type GetCardNetworkTypeQueryResult = Apollo.QueryResult<GetCardNetworkTypeQuery, GetCardNetworkTypeQueryVariables>;
export const GetCardPaymentTokenDetailsDocument = gql`
    query GetCardPaymentTokenDetails($publicToken: String!) {
  cardPaymentTokenList(publicToken: $publicToken) {
    id
    creatorTokenReference
    cardUsageGroup
    activationMethod
    walletId
    walletProvider
    walletReasons
    activationCode
    tokenPan
    statuses {
      tokenisedStatus {
        code
        description
      }
      authorisationStatus {
        code
        description
      }
      authorisationDecision {
        code
        description
      }
      transactionStatus {
        code
        description
      }
      gpsStatusInfo {
        code
        description
      }
    }
    tokenisedDate
    threddDecisionAt
    expiryDate
    tokenType
    deviceType
    deviceName
    merchantName
    linkedToken
    deviceLanguage
    location
    endOfPhoneNumber
    firstname
    lastname
    finalDecisionBy
    panSource
    creator
    txnStatusChanged
    activationCodeExpdate
    creatorPanReference
  }
}
    `;

/**
 * __useGetCardPaymentTokenDetailsQuery__
 *
 * To run a query within a React component, call `useGetCardPaymentTokenDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardPaymentTokenDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardPaymentTokenDetailsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetCardPaymentTokenDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables> & ({ variables: GetCardPaymentTokenDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>(GetCardPaymentTokenDetailsDocument, options);
      }
export function useGetCardPaymentTokenDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>(GetCardPaymentTokenDetailsDocument, options);
        }
// @ts-ignore
export function useGetCardPaymentTokenDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>;
export function useGetCardPaymentTokenDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardPaymentTokenDetailsQuery | undefined, GetCardPaymentTokenDetailsQueryVariables>;
export function useGetCardPaymentTokenDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>(GetCardPaymentTokenDetailsDocument, options);
        }
export type GetCardPaymentTokenDetailsQueryHookResult = ReturnType<typeof useGetCardPaymentTokenDetailsQuery>;
export type GetCardPaymentTokenDetailsLazyQueryHookResult = ReturnType<typeof useGetCardPaymentTokenDetailsLazyQuery>;
export type GetCardPaymentTokenDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCardPaymentTokenDetailsSuspenseQuery>;
export type GetCardPaymentTokenDetailsQueryResult = Apollo.QueryResult<GetCardPaymentTokenDetailsQuery, GetCardPaymentTokenDetailsQueryVariables>;
export const GetCardTypeDocument = gql`
    query GetCardType {
  cardType {
    value
    description
  }
}
    `;

/**
 * __useGetCardTypeQuery__
 *
 * To run a query within a React component, call `useGetCardTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCardTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetCardTypeQuery, GetCardTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardTypeQuery, GetCardTypeQueryVariables>(GetCardTypeDocument, options);
      }
export function useGetCardTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardTypeQuery, GetCardTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardTypeQuery, GetCardTypeQueryVariables>(GetCardTypeDocument, options);
        }
// @ts-ignore
export function useGetCardTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardTypeQuery, GetCardTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardTypeQuery, GetCardTypeQueryVariables>;
export function useGetCardTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardTypeQuery, GetCardTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCardTypeQuery | undefined, GetCardTypeQueryVariables>;
export function useGetCardTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardTypeQuery, GetCardTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardTypeQuery, GetCardTypeQueryVariables>(GetCardTypeDocument, options);
        }
export type GetCardTypeQueryHookResult = ReturnType<typeof useGetCardTypeQuery>;
export type GetCardTypeLazyQueryHookResult = ReturnType<typeof useGetCardTypeLazyQuery>;
export type GetCardTypeSuspenseQueryHookResult = ReturnType<typeof useGetCardTypeSuspenseQuery>;
export type GetCardTypeQueryResult = Apollo.QueryResult<GetCardTypeQuery, GetCardTypeQueryVariables>;
export const DecodeOrangeFlowDocument = gql`
    query DecodeOrangeFlow($input: String!) {
  decodingOrangeFlow(input: $input) {
    reason
    offset
    meaning
  }
}
    `;

/**
 * __useDecodeOrangeFlowQuery__
 *
 * To run a query within a React component, call `useDecodeOrangeFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecodeOrangeFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecodeOrangeFlowQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecodeOrangeFlowQuery(baseOptions: Apollo.QueryHookOptions<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables> & ({ variables: DecodeOrangeFlowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>(DecodeOrangeFlowDocument, options);
      }
export function useDecodeOrangeFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>(DecodeOrangeFlowDocument, options);
        }
// @ts-ignore
export function useDecodeOrangeFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>): Apollo.UseSuspenseQueryResult<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>;
export function useDecodeOrangeFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>): Apollo.UseSuspenseQueryResult<DecodeOrangeFlowQuery | undefined, DecodeOrangeFlowQueryVariables>;
export function useDecodeOrangeFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>(DecodeOrangeFlowDocument, options);
        }
export type DecodeOrangeFlowQueryHookResult = ReturnType<typeof useDecodeOrangeFlowQuery>;
export type DecodeOrangeFlowLazyQueryHookResult = ReturnType<typeof useDecodeOrangeFlowLazyQuery>;
export type DecodeOrangeFlowSuspenseQueryHookResult = ReturnType<typeof useDecodeOrangeFlowSuspenseQuery>;
export type DecodeOrangeFlowQueryResult = Apollo.QueryResult<DecodeOrangeFlowQuery, DecodeOrangeFlowQueryVariables>;
export const GetPortalTransactionsDocument = gql`
    query GetPortalTransactions($skip: Int!, $take: Int!, $input: GetPortalTransactionsInput!) {
  portalTransactions(skip: $skip, take: $take, input: $input) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      title
      lifeCycleId
      fees {
        fixedFee
        rateFee
        fxPadding
        mccPadding
      }
      cardNetwork
      note
      transactionCountry
      id
      description
      dateTime
      type {
        code
        description
      }
      status {
        code
        description
      }
      amount {
        billingValue
        billingValueWithDirection
        billingCurrency
        transactionValue
        transactionCurrency
        availableBalance
        actualBalance
        billingCurrencyNumericCode
        blockedAmount
      }
      isMfx
      productId
      processingCode
      recordId
      pubToken
      paymentMethod
      paymentTokenId
      productName
      systemTraceAuditNumber
      transactionLink
      panToken
      pant
      panPubt
      customerReference
      traceIdLifeCycle
      merchantCategoryCode
      ehiMode
      merchant {
        city
        contact
        county
        name
        nameOther
        networkId
        postcode
        region
        street
        taxId
        telephone
        url
      }
    }
  }
}
    `;

/**
 * __useGetPortalTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPortalTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalTransactionsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPortalTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables> & ({ variables: GetPortalTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>(GetPortalTransactionsDocument, options);
      }
export function useGetPortalTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>(GetPortalTransactionsDocument, options);
        }
// @ts-ignore
export function useGetPortalTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>;
export function useGetPortalTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPortalTransactionsQuery | undefined, GetPortalTransactionsQueryVariables>;
export function useGetPortalTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>(GetPortalTransactionsDocument, options);
        }
export type GetPortalTransactionsQueryHookResult = ReturnType<typeof useGetPortalTransactionsQuery>;
export type GetPortalTransactionsLazyQueryHookResult = ReturnType<typeof useGetPortalTransactionsLazyQuery>;
export type GetPortalTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetPortalTransactionsSuspenseQuery>;
export type GetPortalTransactionsQueryResult = Apollo.QueryResult<GetPortalTransactionsQuery, GetPortalTransactionsQueryVariables>;
export const GetSingleTransactionDocument = gql`
    query GetSingleTransaction($transactionId: Long!) {
  singleTransaction(transactionId: $transactionId) {
    description
    panPubt
    panReport
    billingCurrencyNumericCode
    isMfx
    pds146Value
    customerReference
    recordId
    pubToken
    traceIdLifeCycle
    transactionId
    transactionType
    transactionStatus
    transactionAmount
    transactionFees {
      domesticFixedFee
      domesticRateFee
      fxFixedFee
      fxRateFee
      nonDomesticFixedFee
      nonDomesticRateFee
    }
    transactionCurrency
    transactionDate
    billingAmount
    billingAmountWithDirection
    billingCurrency
    processingCode
    responseStatus
    merchantCategoryCode
    dateExpiry
    merchantCategoryDescription
    posEntry {
      code
      codeDescription {
        position
        value
        bitPositionDescription
        description
      }
    }
    networkReferenceId
    retrievalReference
    cardAcceptorIdentificationCode
    cardAcceptorNameLocation
    aid
    fid
    cardAcceptorTerminalIdentification
    additionalData
    settlementAmount
    settlementCurrency
    authorisationCode
    additionalAmounts
    posData
    tillTime
    paymentMethod
    paymentTokenId
    productName
    ehiMode
    note
    availableBalance
    blockedAmount
    fixedFee
    surchargeFee
    stan
    messageType
    iccData
    gpsPosData
    adviceReasonData
    additionalResponseData
    avsCardResponse {
      streetAddressDigits
      postcodeDigits
      postcodeResult
      addressResult
      avsResponse
    }
    networkData
    networkId
    acquirerReferenceData
    transactionOriginatingInstitution
    rateFee
    fxPadding
    mccPadding
    feeType
    feeProcessingCode
    settlementIndicator
    interchangeAmountFee
    currencyCodeFee
    interchangeAmountFeeSettlement
    currencyCodeFeeSettlement
    functionCode
    additionalAuthorisationDataDgn
    transactionDestinationIic
    recapNumber
    currencyCode
    responseReason
    responseStatusDescription
    requestTime
    responseSource
    responseTime
    recapDate
    diffInReqResp
    merchant {
      city
      contact
      county
      countyCode
      name
      nameOther
      networkId
      postcode
      region
      street
      taxId
      telephone
      url
    }
    pos {
      cardholderAuthenticationEntity1
      cardholderAuthenticationEntity2
      cardholderAuthenticationEntity3
      cardholderAuthenticationEntity4
      cardholderAuthenticationMethod1
      cardholderAuthenticationMethod2
      cardholderAuthenticationMethod3
      cardholderAuthenticationMethod4
      cardholderPresent
      cardInput
      cardPresent
      chipFallback
      fraudIndicator
      secure3DAuthenticationMethod
      securityCardholderToMerchant
      instantFundingNetwork
      instantFundingThredd
      scaExempt
      scaAssessment
      scaKnowledgeTest
      scaPossessionTest
      scaBiometricTest
      threddDetectedScaExemption
      cardDeviceFormFactor
      acquirerExemptScaIndicator
      authenticationAmountAndCurrencyComparisonResult
      merchantCardholderInitiatedIndicator
      merchantInitiatedTransactionTypeIndicator
      originalTransactionScaExemptIndicator
      originalTransactionScaAssessmentResult
      originalTransactionStatusValue
      extendedAuthorizationIndicator
    }
    posCapabilities {
      attended
      cardCapture
      cardholderAuthentication
      cardInput
      cardOutput
      environment
      partialApproval
      pinCapture
      purchaseAmountOnlyApproval
      terminalOutput
      terminalType
    }
    decodedAdditionalAmount {
      occurence
      accountType {
        encodedData
        decodedDataString
      }
      amount {
        encodedData
        decodedDataString
      }
      amountType {
        encodedData
        decodedDataString
      }
      currencyCode {
        encodedData
        decodedDataString
      }
      transactionType {
        encodedData
        decodedDataString
      }
    }
    decodedAdditionalResponseData {
      description
      value
    }
    posConditionCode
    avsStreet
    avsPostcode
    visaFleet {
      fleetData {
        typeOfPurchase
        serviceType
        fuelType
        expandedFuelType
        unitOfMeasure
        quantity
        unitCost
        grossFuelPrice
        netFuelPrice
        grossNonFuelPrice
        netNonFuelPrice
        nonFuelProductCode1
        nonFuelProductCode2
        nonFuelProductCode3
        nonFuelProductCode4
        nonFuelProductCode5
        nonFuelProductCode6
        nonFuelProductCode7
        nonFuelProductCode8
      }
      promptData {
        odometerReading
        visaFleetServiceId
        fleetWorkOrderNumber
        fleetEmployeeNumber
        fleetTrailerNumber
      }
      evData {
        chargingPowerOutputCapacity
        chargingReasonCode
        maximumPowerDispensed
        connectorType
        totalTimePluggedIn
        totalChargingTime
        startTimeOfCharge
        finishTimeOfCharge
        estimatedKmMilesAdded
        estimatedKmMilesAvailable
        carbonFootprint
      }
      invoiceLineItem {
        itemSequenceNumber
        itemDescription
        productCode
        commodityCode
        quantity
        unitOfMeasure
        unitCost
        discountPerLineItem
        lineItemTotal
        vatTaxAmount
        vatRate
      }
    }
  }
}
    `;

/**
 * __useGetSingleTransactionQuery__
 *
 * To run a query within a React component, call `useGetSingleTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleTransactionQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetSingleTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetSingleTransactionQuery, GetSingleTransactionQueryVariables> & ({ variables: GetSingleTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>(GetSingleTransactionDocument, options);
      }
export function useGetSingleTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>(GetSingleTransactionDocument, options);
        }
// @ts-ignore
export function useGetSingleTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>;
export function useGetSingleTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSingleTransactionQuery | undefined, GetSingleTransactionQueryVariables>;
export function useGetSingleTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>(GetSingleTransactionDocument, options);
        }
export type GetSingleTransactionQueryHookResult = ReturnType<typeof useGetSingleTransactionQuery>;
export type GetSingleTransactionLazyQueryHookResult = ReturnType<typeof useGetSingleTransactionLazyQuery>;
export type GetSingleTransactionSuspenseQueryHookResult = ReturnType<typeof useGetSingleTransactionSuspenseQuery>;
export type GetSingleTransactionQueryResult = Apollo.QueryResult<GetSingleTransactionQuery, GetSingleTransactionQueryVariables>;
export const GetTransactionFilterOptionsDocument = gql`
    query GetTransactionFilterOptions {
  cardNetworkType {
    value
    description
  }
  allTransactionStatus {
    code
    description
  }
  allTransactionTypes {
    code
    description
  }
  allProcessingCodes {
    code
    description
  }
}
    `;

/**
 * __useGetTransactionFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransactionFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>(GetTransactionFilterOptionsDocument, options);
      }
export function useGetTransactionFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>(GetTransactionFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetTransactionFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>;
export function useGetTransactionFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionFilterOptionsQuery | undefined, GetTransactionFilterOptionsQueryVariables>;
export function useGetTransactionFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>(GetTransactionFilterOptionsDocument, options);
        }
export type GetTransactionFilterOptionsQueryHookResult = ReturnType<typeof useGetTransactionFilterOptionsQuery>;
export type GetTransactionFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetTransactionFilterOptionsLazyQuery>;
export type GetTransactionFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionFilterOptionsSuspenseQuery>;
export type GetTransactionFilterOptionsQueryResult = Apollo.QueryResult<GetTransactionFilterOptionsQuery, GetTransactionFilterOptionsQueryVariables>;
export const GetTransactionsDocument = gql`
    query GetTransactions($skip: Int!, $take: Int!, $input: GetTransactionsInput!) {
  transactions(skip: $skip, take: $take, input: $input) {
    totalCount
    items {
      title
      customerReference
      lifeCycleId
      fees {
        fixedFee
        rateFee
        fxPadding
        mccPadding
      }
      cardNetwork
      note
      transactionCountry
      id
      description
      dateTime
      type {
        code
        description
      }
      status {
        code
        description
      }
      amount {
        billingCurrencyNumericCode
        billingValue
        billingValueWithDirection
        billingCurrency
        transactionValue
        transactionCurrency
        availableBalance
        actualBalance
        blockedAmount
      }
      isMfx
      productId
      processingCode
      recordId
      pubToken
      paymentMethod
      paymentTokenId
      productName
      systemTraceAuditNumber
      transactionLink
      pant
      panPubt
      traceIdLifeCycle
      merchantCategoryCode
      merchant {
        name
        city
        county
      }
    }
  }
}
    `;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables> & ({ variables: GetTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
// @ts-ignore
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransactionsQuery | undefined, GetTransactionsQueryVariables>;
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = Apollo.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const GetWalletDetailsDocument = gql`
    query GetWalletDetails($publicToken: String!) {
  walletDetails(publicToken: $publicToken) {
    isAutoTransfer
    wallets {
      publicToken
      isMfxPrimary
      balanceDetails {
        cardBalance
        currencyCode
        availableBalance
        pendingAmount
      }
    }
  }
}
    `;

/**
 * __useGetWalletDetailsQuery__
 *
 * To run a query within a React component, call `useGetWalletDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletDetailsQuery({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *   },
 * });
 */
export function useGetWalletDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables> & ({ variables: GetWalletDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>(GetWalletDetailsDocument, options);
      }
export function useGetWalletDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>(GetWalletDetailsDocument, options);
        }
// @ts-ignore
export function useGetWalletDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>;
export function useGetWalletDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWalletDetailsQuery | undefined, GetWalletDetailsQueryVariables>;
export function useGetWalletDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>(GetWalletDetailsDocument, options);
        }
export type GetWalletDetailsQueryHookResult = ReturnType<typeof useGetWalletDetailsQuery>;
export type GetWalletDetailsLazyQueryHookResult = ReturnType<typeof useGetWalletDetailsLazyQuery>;
export type GetWalletDetailsSuspenseQueryHookResult = ReturnType<typeof useGetWalletDetailsSuspenseQuery>;
export type GetWalletDetailsQueryResult = Apollo.QueryResult<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>;


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ACHAssetInput: AchAssetInput;
  ACHAssetResponse: ResolverTypeWrapper<AchAssetResponse>;
  ACHMonetaryUnitInput: AchMonetaryUnitInput;
  ACHMonetaryUnitResponse: ResolverTypeWrapper<AchMonetaryUnitResponse>;
  ACHOriginatorInput: AchOriginatorInput;
  ACHOriginatorResponse: ResolverTypeWrapper<AchOriginatorResponse>;
  ACHPaymentInstruction: ResolverTypeWrapper<AchPaymentInstruction>;
  ACHPaymentInstructionInput: AchPaymentInstructionInput;
  ACHPaymentInstructionResponse: ResolverTypeWrapper<AchPaymentInstructionResponse>;
  ACHRecipientInput: AchRecipientInput;
  ACHRecipientResponse: ResolverTypeWrapper<AchRecipientResponse>;
  AcceptorInput: AcceptorInput;
  Account: ResolverTypeWrapper<Account>;
  AccountCategory: AccountCategory;
  AccountHolder: ResolverTypeWrapper<AccountHolder>;
  AccountHolderCommercialDetails: ResolverTypeWrapper<AccountHolderCommercialDetails>;
  AccountHolderCommercialDetailsInput: AccountHolderCommercialDetailsInput;
  AccountHolderConfigurationInput: AccountHolderConfigurationInput;
  AccountHolderDeceasedData: ResolverTypeWrapper<AccountHolderDeceasedData>;
  AccountHolderDeceasedDataInput: AccountHolderDeceasedDataInput;
  AccountHolderInput: AccountHolderInput;
  AccountHolderNumberGenerationPolicyGroupInput: AccountHolderNumberGenerationPolicyGroupInput;
  AccountHolderNumberGenerationPolicyInput: AccountHolderNumberGenerationPolicyInput;
  AccountHolderRetailDetails: ResolverTypeWrapper<AccountHolderRetailDetails>;
  AccountHolderRetailDetailsInput: AccountHolderRetailDetailsInput;
  AccountHolderSCRAData: ResolverTypeWrapper<AccountHolderScraData>;
  AccountHolderSCRADataInput: AccountHolderScraDataInput;
  AccountHolderStatus: AccountHolderStatus;
  AccountHolderType: AccountHolderType;
  AccountInput: AccountInput;
  AccountNumberGenerationPolicyGroupInput: AccountNumberGenerationPolicyGroupInput;
  AccountStatus: AccountStatus;
  AccountUpdateInput: AccountUpdateInput;
  AccountV2: ResolverTypeWrapper<AccountV2>;
  ActivateKeyInput: ActivateKeyInput;
  ActivateKeyResponse: ResolverTypeWrapper<ActivateKeyResponse>;
  AddSubscriptionsInnerResponse: ResolverTypeWrapper<AddSubscriptionsInnerResponse>;
  AddSubscriptionsResponse: ResolverTypeWrapper<AddSubscriptionsResponse>;
  AddWebhookSubscriptionsInput: AddWebhookSubscriptionsInput;
  AdditionalAmount: ResolverTypeWrapper<AdditionalAmount>;
  AdditionalDataDecodResponse: ResolverTypeWrapper<AdditionalDataDecodResponse>;
  AdditionalDataDecodeMC: ResolverTypeWrapper<AdditionalDataDecodeMc>;
  AdditionalDataDecoded: ResolverTypeWrapper<AdditionalDataDecoded>;
  AdditionalDetail: ResolverTypeWrapper<AdditionalDetail>;
  AdditionalResponseData: ResolverTypeWrapper<AdditionalResponseData>;
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  AddressType: AddressType;
  AddressUpdateInput: AddressUpdateInput;
  AddressUpdateRequestInput: AddressUpdateRequestInput;
  AddressV2: ResolverTypeWrapper<AddressV2>;
  Algorithm: Algorithm;
  AllocationOrderOption: AllocationOrderOption;
  ApexAddress: ResolverTypeWrapper<ApexAddress>;
  ApplicationInput: ApplicationInput;
  ApplicationMessageResponse: ResolverTypeWrapper<ApplicationMessageResponse>;
  ApplicationResponse: ResolverTypeWrapper<ApplicationResponse>;
  AssignPermissionToGroupInput: AssignPermissionToGroupInput;
  AtmWithdrawalInternationalPolicyGroupInput: AtmWithdrawalInternationalPolicyGroupInput;
  AtmWithdrawalInternationalPolicyInput: AtmWithdrawalInternationalPolicyInput;
  AttributeMapping: ResolverTypeWrapper<AttributeMapping>;
  AttributeMappingInput: AttributeMappingInput;
  AuditFields: ResolverTypeWrapper<AuditFields>;
  AuditLog: ResolverTypeWrapper<AuditLog>;
  AuditLogFieldValuePair: ResolverTypeWrapper<AuditLogFieldValuePair>;
  AuditLogLookupTableResponse: ResolverTypeWrapper<AuditLogLookupTableResponse>;
  AuditLogRequestInput: AuditLogRequestInput;
  AuditLogsExportResponse: ResolverTypeWrapper<AuditLogsExportResponse>;
  AuditLogsResponse: ResolverTypeWrapper<AuditLogsResponse>;
  AuthFees: ResolverTypeWrapper<AuthFees>;
  AuthProvider: AuthProvider;
  AuthReversalRequestInput: AuthReversalRequestInput;
  AuthReversalResponse: ResolverTypeWrapper<AuthReversalResponse>;
  AuthorisationDecision: ResolverTypeWrapper<AuthorisationDecision>;
  AuthorisationStatus: ResolverTypeWrapper<AuthorisationStatus>;
  Authorisor: ResolverTypeWrapper<Authorisor>;
  AuthorisorType: AuthorisorType;
  AvsCardResponse: ResolverTypeWrapper<AvsCardResponse>;
  BalanceLimit: BalanceLimit;
  BalanceLimitDecider: BalanceLimitDecider;
  BalanceResponse: ResolverTypeWrapper<BalanceResponse>;
  BalanceTransferInput: BalanceTransferInput;
  BaseConfigurationInput: BaseConfigurationInput;
  BaseConfigurationPolicyGroupInput: BaseConfigurationPolicyGroupInput;
  BaseConfigurationPolicyInput: BaseConfigurationPolicyInput;
  BaseVerificationConfigurationInput: BaseVerificationConfigurationInput;
  BinRange: ResolverTypeWrapper<BinRange>;
  BinRangeInput: BinRangeInput;
  BlockedCurrenciesConfigurationInput: BlockedCurrenciesConfigurationInput;
  BlockedCurrenciesPolicyGroupInput: BlockedCurrenciesPolicyGroupInput;
  BlockedCurrenciesPolicyInput: BlockedCurrenciesPolicyInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BreachType: BreachType;
  BucketConfigurationInput: BucketConfigurationInput;
  BucketID: BucketId;
  BucketOrderOption: BucketOrderOption;
  BypassedAuthorisationVerificationConfigurationInput: BypassedAuthorisationVerificationConfigurationInput;
  BypassedAuthorisationVerificationPolicyGroupInput: BypassedAuthorisationVerificationPolicyGroupInput;
  BypassedAuthorisationVerificationPolicyInput: BypassedAuthorisationVerificationPolicyInput;
  CLAddress: ResolverTypeWrapper<ClAddress>;
  CLAddressInput: ClAddressInput;
  CVRDecodedResponse: ResolverTypeWrapper<CvrDecodedResponse>;
  CVV2CVC2ConfigurationInput: Cvv2Cvc2ConfigurationInput;
  CVV2PolicyGroupInput: Cvv2PolicyGroupInput;
  CVV2PolicyInput: Cvv2PolicyInput;
  CVVCardNotPresentConfigurationInput: CvvCardNotPresentConfigurationInput;
  CalendarGroupResponse: ResolverTypeWrapper<CalendarGroupResponse>;
  CapAsset: ResolverTypeWrapper<CapAsset>;
  CapMonetaryUnit: ResolverTypeWrapper<CapMonetaryUnit>;
  CardAcceptanceMethods: ResolverTypeWrapper<CardAcceptanceMethods>;
  CardAcceptorDetailResponse: ResolverTypeWrapper<CardAcceptorDetailResponse>;
  CardAcceptorDetailResponseWithResolver: ResolverTypeWrapper<CardAcceptorDetailResponseWithResolver>;
  CardAcceptorPolicyConfigInput: CardAcceptorPolicyConfigInput;
  CardAcceptorPolicyGroupInput: CardAcceptorPolicyGroupInput;
  CardAcceptorPolicyInput: CardAcceptorPolicyInput;
  CardAcceptorsResponse: ResolverTypeWrapper<CardAcceptorsResponse>;
  CardActionUsers: ResolverTypeWrapper<CardActionUsers>;
  CardActions: ResolverTypeWrapper<CardActions>;
  CardDetails: ResolverTypeWrapper<CardDetails>;
  CardFeeResponse: ResolverTypeWrapper<CardFeeResponse>;
  CardGroupLimits: ResolverTypeWrapper<CardGroupLimits>;
  CardHistoryResponse: ResolverTypeWrapper<CardHistoryResponse>;
  CardHolder: ResolverTypeWrapper<CardHolder>;
  CardHolderUpdateRequestInput: CardHolderUpdateRequestInput;
  CardLimits: ResolverTypeWrapper<CardLimits>;
  CardLimitsSub: ResolverTypeWrapper<CardLimitsSub>;
  CardLoadSourcesResponse: ResolverTypeWrapper<CardLoadSourcesResponse>;
  CardMccDetailResponse: ResolverTypeWrapper<CardMccDetailResponse>;
  CardMetaHistoryInput: CardMetaHistoryInput;
  CardMetaHistoryResponse: ResolverTypeWrapper<CardMetaHistoryResponse>;
  CardNetworkType: ResolverTypeWrapper<CardNetworkType>;
  CardNotPresentConfigurationInput: CardNotPresentConfigurationInput;
  CardNotPresentVerificationConfigurationInput: CardNotPresentVerificationConfigurationInput;
  CardPinStatusResponse: ResolverTypeWrapper<CardPinStatusResponse>;
  CardPosSubLimitsResponse: ResolverTypeWrapper<CardPosSubLimitsResponse>;
  CardPresentConfigurationInput: CardPresentConfigurationInput;
  CardProduct: ResolverTypeWrapper<CardProduct>;
  CardSpendLimitByProductResponse: ResolverTypeWrapper<CardSpendLimitByProductResponse>;
  CardStatus: ResolverTypeWrapper<CardStatus>;
  CardStatusCode: CardStatusCode;
  CardStatusCodeNumeric: CardStatusCodeNumeric;
  CardStatusHistoryInput: CardStatusHistoryInput;
  CardStatusResponse: ResolverTypeWrapper<CardStatusResponse>;
  CardType: CardType;
  CardVerificationMethod: CardVerificationMethod;
  CardsResponse: ResolverTypeWrapper<CardsResponse>;
  Certificate: ResolverTypeWrapper<Certificate>;
  CertificateMessageResponse: ResolverTypeWrapper<CertificateMessageResponse>;
  CertificateStatus: CertificateStatus;
  CertificateType: CertificateType;
  ChangeCardStatusInput: ChangeCardStatusInput;
  ChangePaymentTokenStatusInput: ChangePaymentTokenStatusInput;
  Channel: ResolverTypeWrapper<Channel>;
  ChannelInput: ChannelInput;
  ChannelSourceType: ChannelSourceType;
  ChannelType: ChannelType;
  ClearCacheResponse: ResolverTypeWrapper<ClearCacheResponse>;
  Client: ResolverTypeWrapper<Client>;
  ClientAuthMethod: ClientAuthMethod;
  ClientGroupInput: ClientGroupInput;
  ClientInput: ClientInput;
  ClientSpace: ResolverTypeWrapper<ClientSpace>;
  ClientStatus: ClientStatus;
  CodeDescription: ResolverTypeWrapper<CodeDescription>;
  CollectionSegmentInfo: ResolverTypeWrapper<CollectionSegmentInfo>;
  Company: ResolverTypeWrapper<Company>;
  CompanyInput: CompanyInput;
  CompanyStatus: CompanyStatus;
  CompanyType: CompanyType;
  Component: ResolverTypeWrapper<Component>;
  Condition: Condition;
  ConditionOperator: ConditionOperator;
  ConnectionServiceLatestBuildNumber: ResolverTypeWrapper<ConnectionServiceLatestBuildNumber>;
  ConnectionType: ConnectionType;
  ContactlessConfigurationInput: ContactlessConfigurationInput;
  ContactlessDomesticPolicyGroupInput: ContactlessDomesticPolicyGroupInput;
  ContactlessDomesticPolicyInput: ContactlessDomesticPolicyInput;
  ContactlessInternationalPolicyGroupInput: ContactlessInternationalPolicyGroupInput;
  ContactlessInternationalPolicyInput: ContactlessInternationalPolicyInput;
  ContactlessPolicyConfigurationInput: ContactlessPolicyConfigurationInput;
  ContactlessPolicyGroupInput: ContactlessPolicyGroupInput;
  ContactlessPolicyInput: ContactlessPolicyInput;
  ControlGroups: ResolverTypeWrapper<ControlGroups>;
  ControlGroupsInput: ControlGroupsInput;
  ControlGroupsSub: ResolverTypeWrapper<ControlGroupsSub>;
  Counters: ResolverTypeWrapper<Counters>;
  Country: ResolverTypeWrapper<Country>;
  CountryCurrencyCode: ResolverTypeWrapper<CountryCurrencyCode>;
  CountryCurrencyCodeInput: CountryCurrencyCodeInput;
  CreateACHPaymentInstructionInput: CreateAchPaymentInstructionInput;
  CreateAccountByProductInput: CreateAccountByProductInput;
  CreateAccountHolderInput: CreateAccountHolderInput;
  CreateAccountInput: CreateAccountInput;
  CreateAccountWorkflowInput: CreateAccountWorkflowInput;
  CreateAddressInput: CreateAddressInput;
  CreateAddressV2Input: CreateAddressV2Input;
  CreateCertificateIssuerInput: CreateCertificateIssuerInput;
  CreateClientSpaceInput: CreateClientSpaceInput;
  CreateCompanyInput: CreateCompanyInput;
  CreateCurrencyInput: CreateCurrencyInput;
  CreateCustomerWorkflowInput: CreateCustomerWorkflowInput;
  CreateFeatureFlagResponse: ResolverTypeWrapper<CreateFeatureFlagResponse>;
  CreateGroupRequest: CreateGroupRequest;
  CreateIdpInput: CreateIdpInput;
  CreateKmsBinRangeInput: CreateKmsBinRangeInput;
  CreateKmsBinRangeResponse: ResolverTypeWrapper<CreateKmsBinRangeResponse>;
  CreateLedgerInput: CreateLedgerInput;
  CreateLedgerInputV2: CreateLedgerInputV2;
  CreateLedgerPlaygroundBalance: CreateLedgerPlaygroundBalance;
  CreateLedgerPlaygroundBalanceResponse: ResolverTypeWrapper<CreateLedgerPlaygroundBalanceResponse>;
  CreateLedgerPlaygroundTransaction: CreateLedgerPlaygroundTransaction;
  CreateLedgerPlaygroundTransactionResponse: ResolverTypeWrapper<CreateLedgerPlaygroundTransactionResponse>;
  CreateOAuthClientInput: CreateOAuthClientInput;
  CreateOidcConfigInput: CreateOidcConfigInput;
  CreateOrganisationGroupInput: CreateOrganisationGroupInput;
  CreateOrganisationInput: CreateOrganisationInput;
  CreatePaymentNetworkConfigInput: CreatePaymentNetworkConfigInput;
  CreatePermissionInput: CreatePermissionInput;
  CreatePolicyV2Input: CreatePolicyV2Input;
  CreateSamlConfigInput: CreateSamlConfigInput;
  CreateServiceRequest: CreateServiceRequest;
  CreateTransactionResponse: ResolverTypeWrapper<CreateTransactionResponse>;
  CreateTransactionStatus: CreateTransactionStatus;
  CreateTransactionWorkflowInput: CreateTransactionWorkflowInput;
  CreateUserInput: CreateUserInput;
  CredentialConfigurationResponse: ResolverTypeWrapper<CredentialConfigurationResponse>;
  CredentialResponse: ResolverTypeWrapper<CredentialResponse>;
  CreditCyclingConfigurationInput: CreditCyclingConfigurationInput;
  CreditCyclingConfigurationPolicyInput: CreditCyclingConfigurationPolicyInput;
  CreditCyclingPolicyGroupInput: CreditCyclingPolicyGroupInput;
  CurConRateInput: CurConRateInput;
  CurConRateResponse: ResolverTypeWrapper<CurConRateResponse>;
  Currency: ResolverTypeWrapper<Currency>;
  CurrencyCode: ResolverTypeWrapper<CurrencyCode>;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerAddress: ResolverTypeWrapper<CustomerAddress>;
  CustomerAddressInput: CustomerAddressInput;
  CustomerInput: CustomerInput;
  CustomerPhoneNumbers: ResolverTypeWrapper<CustomerPhoneNumbers>;
  CustomerStatus: CustomerStatus;
  CvvUnblockInput: CvvUnblockInput;
  DateOfBirth: ResolverTypeWrapper<DateOfBirth>;
  DateOfBirthInput: DateOfBirthInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DeactivateKeyInput: DeactivateKeyInput;
  DeactivateKeyResponse: ResolverTypeWrapper<DeactivateKeyResponse>;
  Decimal: ResolverTypeWrapper<Scalars['Decimal']['output']>;
  DecimalAsFloat: ResolverTypeWrapper<Scalars['DecimalAsFloat']['output']>;
  DefaultMastercardSignOnParams: ResolverTypeWrapper<DefaultMastercardSignOnParams>;
  DeleteAccountHolderInput: DeleteAccountHolderInput;
  DeleteAccountInput: DeleteAccountInput;
  DeleteAddressInput: DeleteAddressInput;
  DeleteAddressV2Input: DeleteAddressV2Input;
  DeleteFeatureFlagResponse: ResolverTypeWrapper<DeleteFeatureFlagResponse>;
  DeleteProductKeyLinkInput: DeleteProductKeyLinkInput;
  DeleteProductKeyLinkResponse: ResolverTypeWrapper<DeleteProductKeyLinkResponse>;
  DeleteSubscriptionResponse: ResolverTypeWrapper<DeleteSubscriptionResponse>;
  DeploymentStatusResponse: ResolverTypeWrapper<DeploymentStatusResponse>;
  DiscoverSignOnParams: ResolverTypeWrapper<DiscoverSignOnParams>;
  DiscoverSignOnParamsInput: DiscoverSignOnParamsInput;
  EhiAcknowledgementResponse: ResolverTypeWrapper<EhiAcknowledgementResponse>;
  EhiResendResponse: ResolverTypeWrapper<EhiResendResponse>;
  Email: ResolverTypeWrapper<Email>;
  EmailInput: EmailInput;
  Emv: ResolverTypeWrapper<Emv>;
  EvaluateFeatureFlagResponse: ResolverTypeWrapper<EvaluateFeatureFlagResponse>;
  EventSubscriptionItem: ResolverTypeWrapper<EventSubscriptionItem>;
  ExchangedTokenResponse: ResolverTypeWrapper<ExchangedTokenResponse>;
  ExpiryPeriodAction: ExpiryPeriodAction;
  ExpiryPolicyConfigurationInput: ExpiryPolicyConfigurationInput;
  ExpiryPolicyGroupInput: ExpiryPolicyGroupInput;
  ExpiryPolicyInput: ExpiryPolicyInput;
  ExportAuditLogsInput: ExportAuditLogsInput;
  ExportKeyInput: ExportKeyInput;
  ExportKeyResponse: ResolverTypeWrapper<ExportKeyResponse>;
  ExtendExpiryDateInput: ExtendExpiryDateInput;
  ExtendExpiryDateResponse: ResolverTypeWrapper<ExtendExpiryDateResponse>;
  FeatureContextInput: FeatureContextInput;
  FeatureFlag: ResolverTypeWrapper<FeatureFlag>;
  FeatureFlagEntry: ResolverTypeWrapper<FeatureFlagEntry>;
  FeatureFlagMetadata: ResolverTypeWrapper<FeatureFlagMetadata>;
  FeatureFlagRequestInput: FeatureFlagRequestInput;
  FeatureFlagStatus: ResolverTypeWrapper<FeatureFlagStatus>;
  FeatureRequestInput: FeatureRequestInput;
  FieldMask: FieldMask;
  FieldMaskInput: FieldMaskInput;
  Filter: Filter;
  FilterCondition: FilterCondition;
  FinancialProduct: ResolverTypeWrapper<FinancialProduct>;
  FinancialProductInput: FinancialProductInput;
  FlagData: ResolverTypeWrapper<FlagData>;
  FlagDataConfigInput: FlagDataConfigInput;
  FlagDataInput: FlagDataInput;
  FlagsResponse: ResolverTypeWrapper<FlagsResponse>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FundsInput: FundsInput;
  FxGroupResponse: ResolverTypeWrapper<FxGroupResponse>;
  FxRates: ResolverTypeWrapper<FxRates>;
  GenerateKeyInput: GenerateKeyInput;
  GenerationOption: GenerationOption;
  GenericVerificationConfigurationInput: GenericVerificationConfigurationInput;
  GetApplicationCertificatePemResponse: ResolverTypeWrapper<GetApplicationCertificatePemResponse>;
  GetCardGroupLimitDetailResponse: ResolverTypeWrapper<GetCardGroupLimitDetailResponse>;
  GetCardImageResponse: ResolverTypeWrapper<GetCardImageResponse>;
  GetCardLimitResponse: ResolverTypeWrapper<GetCardLimitResponse>;
  GetCardMCCResponse: ResolverTypeWrapper<GetCardMccResponse>;
  GetCardPaymentTokenDetailsResponse: ResolverTypeWrapper<GetCardPaymentTokenDetailsResponse>;
  GetCardPaymentTokenDevicesResponse: ResolverTypeWrapper<GetCardPaymentTokenDevicesResponse>;
  GetCardResponse: ResolverTypeWrapper<GetCardResponse>;
  GetCardSpendLimitDetailsByProductInput: GetCardSpendLimitDetailsByProductInput;
  GetKeyByKeyIdResponse: ResolverTypeWrapper<GetKeyByKeyIdResponse>;
  GetLedgerOffsetPositionInput: GetLedgerOffsetPositionInput;
  GetLedgerOffsetPositionResponse: ResolverTypeWrapper<GetLedgerOffsetPositionResponse>;
  GetLoadSourceResponse: ResolverTypeWrapper<GetLoadSourceResponse>;
  GetOauthClientResponse: ResolverTypeWrapper<GetOauthClientResponse>;
  GetPaymentTokenUsageGroupDetailsResponse: ResolverTypeWrapper<GetPaymentTokenUsageGroupDetailsResponse>;
  GetPingWebhook: ResolverTypeWrapper<GetPingWebhook>;
  GetPortalTransactionsInput: GetPortalTransactionsInput;
  GetSingleTransactionResponse: ResolverTypeWrapper<GetSingleTransactionResponse>;
  GetTransactionsInput: GetTransactionsInput;
  GetTransactionsResponse: ResolverTypeWrapper<GetTransactionsResponse>;
  GetUsageGroupListDetailsResponse: ResolverTypeWrapper<GetUsageGroupListDetailsResponse>;
  GetWalletResponse: ResolverTypeWrapper<GetWalletResponse>;
  GpsStatusInfo: ResolverTypeWrapper<GpsStatusInfo>;
  GroupDetails: ResolverTypeWrapper<GroupDetails>;
  GroupPermissionsResponse: ResolverTypeWrapper<GroupPermissionsResponse>;
  GroupResponse: ResolverTypeWrapper<GroupResponse>;
  GroupStatus: GroupStatus;
  GroupType: GroupType;
  GroupsResponse: ResolverTypeWrapper<GroupsResponse>;
  HealthCheckFlagging: ResolverTypeWrapper<HealthCheckFlagging>;
  HealthCheckSource: ResolverTypeWrapper<HealthCheckSource>;
  HealthcheckResponse: ResolverTypeWrapper<HealthcheckResponse>;
  HistoryResponse: ResolverTypeWrapper<HistoryResponse>;
  HmacSecretResponse: ResolverTypeWrapper<HmacSecretResponse>;
  IccDataDecoded: ResolverTypeWrapper<IccDataDecoded>;
  IdentityProvider: ResolverTypeWrapper<IdentityProvider>;
  IdentityProviderSamlConfigData: ResolverTypeWrapper<IdentityProviderSamlConfigData>;
  IdpHealthCheckResponse: ResolverTypeWrapper<IdpHealthCheckResponse>;
  IdpStatus: IdpStatus;
  IdpType: IdpType;
  ImportKeyInput: ImportKeyInput;
  ImportParametersResponse: ResolverTypeWrapper<ImportParametersResponse>;
  InstrumentForm: InstrumentForm;
  InstrumentFormConfigurationInput: InstrumentFormConfigurationInput;
  InstrumentFormPolicyGroupInput: InstrumentFormPolicyGroupInput;
  InstrumentFormPolicyInput: InstrumentFormPolicyInput;
  InstrumentMCCGroupConfigurationInput: InstrumentMccGroupConfigurationInput;
  InstrumentMCCGroupPolicyGroupInput: InstrumentMccGroupPolicyGroupInput;
  InstrumentMCCGroupPolicyInput: InstrumentMccGroupPolicyInput;
  InstrumentProduct: ResolverTypeWrapper<InstrumentProduct>;
  InstrumentProductInput: InstrumentProductInput;
  InstrumentProvisioningConfigurationInput: InstrumentProvisioningConfigurationInput;
  InstrumentProvisioningPolicyGroupInput: InstrumentProvisioningPolicyGroupInput;
  InstrumentProvisioningPolicyInput: InstrumentProvisioningPolicyInput;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InternalAttributeMappingType: InternalAttributeMappingType;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  KeyResponse: ResolverTypeWrapper<KeyResponse>;
  KeyValuePairInput: KeyValuePairInput;
  KmsBinRangeInput: KmsBinRangeInput;
  KmsBinRangeResponse: ResolverTypeWrapper<KmsBinRangeResponse>;
  Ledger: ResolverTypeWrapper<Ledger>;
  LedgerBalance: ResolverTypeWrapper<LedgerBalance>;
  LedgerConfig: ResolverTypeWrapper<LedgerConfig>;
  LedgerConfigInput: LedgerConfigInput;
  LedgerConfiguration: ResolverTypeWrapper<LedgerConfiguration>;
  LedgerConfigurationInput: LedgerConfigurationInput;
  LedgerConfigurationInputBTP: LedgerConfigurationInputBtp;
  LedgerCreationPolicyGroupInput: LedgerCreationPolicyGroupInput;
  LedgerCreationPolicyInput: LedgerCreationPolicyInput;
  LedgerInput: LedgerInput;
  LedgerLoadLimit: ResolverTypeWrapper<LedgerLoadLimit>;
  LedgerLoadLimitInput: LedgerLoadLimitInput;
  LedgerLoadLimits: ResolverTypeWrapper<LedgerLoadLimits>;
  LedgerLoadLimitsInput: LedgerLoadLimitsInput;
  LedgerLoadLimitsPolicyConfigurationInput: LedgerLoadLimitsPolicyConfigurationInput;
  LedgerLoadLimitsPolicyGroupInput: LedgerLoadLimitsPolicyGroupInput;
  LedgerLoadLimitsPolicyInput: LedgerLoadLimitsPolicyInput;
  LedgerPlaygroundBalance: ResolverTypeWrapper<LedgerPlaygroundBalance>;
  LedgerPlaygroundSubtransaction: ResolverTypeWrapper<LedgerPlaygroundSubtransaction>;
  LedgerPlaygroundTransaction: ResolverTypeWrapper<LedgerPlaygroundTransaction>;
  LedgerPlaygroundTransactionBilling: ResolverTypeWrapper<LedgerPlaygroundTransactionBilling>;
  LedgerPlaygroundTransactionLedgerEntry: ResolverTypeWrapper<LedgerPlaygroundTransactionLedgerEntry>;
  LedgerPlaygroundTransactionSign: LedgerPlaygroundTransactionSign;
  LedgerPlaygroundTransactionStatus: ResolverTypeWrapper<LedgerPlaygroundTransactionStatus>;
  LedgerPlaygroundTransactionType: LedgerPlaygroundTransactionType;
  LedgerStatus: LedgerStatus;
  LedgerType: LedgerType;
  LedgerTypeInput: LedgerTypeInput;
  LedgerUpdateInput: LedgerUpdateInput;
  LedgerV2: ResolverTypeWrapper<LedgerV2>;
  LimitCategory: ResolverTypeWrapper<LimitCategory>;
  LimitConfigurationInput: LimitConfigurationInput;
  LimitPropertyInput: LimitPropertyInput;
  LimitResetMode: LimitResetMode;
  LimitedNetworkGroupResponse: ResolverTypeWrapper<LimitedNetworkGroupResponse>;
  LineOfCredit: ResolverTypeWrapper<LineOfCredit>;
  LineOfCreditInput: LineOfCreditInput;
  LineOfCreditV2: ResolverTypeWrapper<LineOfCreditV2>;
  LinkKeyToProductInput: LinkKeyToProductInput;
  LinkKeyToProductResponse: ResolverTypeWrapper<LinkKeyToProductResponse>;
  LinkageGroupResponse: ResolverTypeWrapper<LinkageGroupResponse>;
  ListACHPaymentInstructionsInput: ListAchPaymentInstructionsInput;
  ListAccountHoldersInput: ListAccountHoldersInput;
  ListAccountHoldersResponse: ResolverTypeWrapper<ListAccountHoldersResponse>;
  ListAccountsInput: ListAccountsInput;
  ListAccountsResponse: ResolverTypeWrapper<ListAccountsResponse>;
  ListAccountsV2Input: ListAccountsV2Input;
  ListAddressesInput: ListAddressesInput;
  ListAddressesResponse: ResolverTypeWrapper<ListAddressesResponse>;
  ListAddressesResponseV2: ResolverTypeWrapper<ListAddressesResponseV2>;
  ListAddressesV2Input: ListAddressesV2Input;
  ListApplicationCertificatesResponse: ResolverTypeWrapper<ListApplicationCertificatesResponse>;
  ListApplicationsResponse: ResolverTypeWrapper<ListApplicationsResponse>;
  ListCompaniesInput: ListCompaniesInput;
  ListCompaniesResponse: ResolverTypeWrapper<ListCompaniesResponse>;
  ListIdentityProvidersResponse: ResolverTypeWrapper<ListIdentityProvidersResponse>;
  ListKeysResponse: ResolverTypeWrapper<ListKeysResponse>;
  ListKmsBinRangesInput: ListKmsBinRangesInput;
  ListKmsBinRangesResponse: ResolverTypeWrapper<ListKmsBinRangesResponse>;
  ListLedgersInput: ListLedgersInput;
  ListLedgersInputV2: ListLedgersInputV2;
  ListLedgersResponse: ResolverTypeWrapper<ListLedgersResponse>;
  ListOAuthClientsResponse: ResolverTypeWrapper<ListOAuthClientsResponse>;
  ListOrganisationGroupsResponse: ResolverTypeWrapper<ListOrganisationGroupsResponse>;
  ListOrganisationsResponse: ResolverTypeWrapper<ListOrganisationsResponse>;
  ListPermissionsResponse: ResolverTypeWrapper<ListPermissionsResponse>;
  ListProductsResponse: ResolverTypeWrapper<ListProductsResponse>;
  ListSubscriptionsInnerResponse: ResolverTypeWrapper<ListSubscriptionsInnerResponse>;
  ListSubscriptionsResponse: ResolverTypeWrapper<ListSubscriptionsResponse>;
  ListTransactionsInput: ListTransactionsInput;
  ListTransactionsResponse: ResolverTypeWrapper<ListTransactionsResponse>;
  ListWebhooksInput: ListWebhooksInput;
  ListWebhooksResponse: ResolverTypeWrapper<ListWebhooksResponse>;
  LoadFundsInput: LoadFundsInput;
  LoadLimit: ResolverTypeWrapper<LoadLimit>;
  LoadLimitInput: LoadLimitInput;
  LoadLimitInputBTP: LoadLimitInputBtp;
  LoadLimits: ResolverTypeWrapper<LoadLimits>;
  LoadLimitsInput: LoadLimitsInput;
  LoadUnloadCardInput: LoadUnloadCardInput;
  LoadUnloadCardRequestInput: LoadUnloadCardRequestInput;
  LoadUnloadCardResponse: ResolverTypeWrapper<LoadUnloadCardResponse>;
  LogicalOperator: LogicalOperator;
  Long: ResolverTypeWrapper<Scalars['Long']['output']>;
  MFAInput: MfaInput;
  MFAResponse: ResolverTypeWrapper<MfaResponse>;
  MFXCardType: ResolverTypeWrapper<MfxCardType>;
  MNESignOnParams: ResolverTypeWrapper<MneSignOnParams>;
  MNESignOnParamsInput: MneSignOnParamsInput;
  MastercardSignOnParams: ResolverTypeWrapper<MastercardSignOnParams>;
  MastercardSignOnParamsInput: MastercardSignOnParamsInput;
  MaximumLoadLimitInput: MaximumLoadLimitInput;
  Merchant: ResolverTypeWrapper<Merchant>;
  MerchantCategoryCode: ResolverTypeWrapper<MerchantCategoryCode>;
  MerchantCategoryCodeGroupInput: MerchantCategoryCodeGroupInput;
  MerchantCategoryCodeInput: MerchantCategoryCodeInput;
  MessageResponse: ResolverTypeWrapper<MessageResponse>;
  Metadata: ResolverTypeWrapper<Metadata>;
  MetadataInput: MetadataInput;
  MfxBalanceAdjInput: MfxBalanceAdjInput;
  MfxBalanceAdjRequestInput: MfxBalanceAdjRequestInput;
  MfxBalanceTransferInput: MfxBalanceTransferInput;
  MfxCardTranResponse: ResolverTypeWrapper<MfxCardTranResponse>;
  MfxCardWalletTrnsfrDetailResponse: ResolverTypeWrapper<MfxCardWalletTrnsfrDetailResponse>;
  MfxCardWalletTrnsfrResponse: ResolverTypeWrapper<MfxCardWalletTrnsfrResponse>;
  MfxLoadCardInput: MfxLoadCardInput;
  MfxUnloadCardInput: MfxUnloadCardInput;
  MfxWalletTransferInput: MfxWalletTransferInput;
  MfxWalletTransferRequestInput: MfxWalletTransferRequestInput;
  Misc: ResolverTypeWrapper<Misc>;
  ModesOfUse: ModesOfUse;
  Mutation: ResolverTypeWrapper<{}>;
  NetworkSignOnParamsResponse: ResolverTypeWrapper<NetworkSignOnParamsResponse>;
  NetworkType: NetworkType;
  NumberingType: NumberingType;
  OAuthClient: ResolverTypeWrapper<OAuthClient>;
  OAuthClientCreatedResponse: ResolverTypeWrapper<OAuthClientCreatedResponse>;
  OffsetLedger: ResolverTypeWrapper<OffsetLedger>;
  OffsetLedgerInput: OffsetLedgerInput;
  OffsetLedgerType: OffsetLedgerType;
  OidcConfig: ResolverTypeWrapper<OidcConfig>;
  OnlineEcomDomesticPolicyGroupInput: OnlineEcomDomesticPolicyGroupInput;
  OnlineEcomDomesticPolicyInput: OnlineEcomDomesticPolicyInput;
  OnlineEcomInternationalPolicyGroupInput: OnlineEcomInternationalPolicyGroupInput;
  OnlineEcomInternationalPolicyInput: OnlineEcomInternationalPolicyInput;
  OrangeFlowReason: ResolverTypeWrapper<OrangeFlowReason>;
  Organisation: ResolverTypeWrapper<Organisation>;
  OrganisationEmailDomainResponse: ResolverTypeWrapper<OrganisationEmailDomainResponse>;
  OrganisationGroup: ResolverTypeWrapper<OrganisationGroup>;
  OrganisationStatus: OrganisationStatus;
  PANRequestInput: PanRequestInput;
  PANResponse: ResolverTypeWrapper<PanResponse>;
  PMInformation: ResolverTypeWrapper<PmInformation>;
  PMInformationInput: PmInformationInput;
  POSDataDecoded: ResolverTypeWrapper<PosDataDecoded>;
  PanFinderValueType: PanFinderValueType;
  PartialAuthorisationControlPolicyConfigurationInput: PartialAuthorisationControlPolicyConfigurationInput;
  PartialAuthorisationControlPolicyGroupInput: PartialAuthorisationControlPolicyGroupInput;
  PartialAuthorisationControlPolicyInput: PartialAuthorisationControlPolicyInput;
  PastDueAmount: ResolverTypeWrapper<PastDueAmount>;
  PastDueAmountInput: PastDueAmountInput;
  PastDueAmountV2: ResolverTypeWrapper<PastDueAmountV2>;
  PaymentAllocationConfigurationInput: PaymentAllocationConfigurationInput;
  PaymentNetworkConfigResponse: ResolverTypeWrapper<PaymentNetworkConfigResponse>;
  PaymentTokenStatus: ResolverTypeWrapper<PaymentTokenStatus>;
  PaymentTokenStatusResponse: ResolverTypeWrapper<PaymentTokenStatusResponse>;
  PaymentTokenUsageRuleDetail: ResolverTypeWrapper<PaymentTokenUsageRuleDetail>;
  PaymentTokenUsageRuleGroupResponse: ResolverTypeWrapper<PaymentTokenUsageRuleGroupResponse>;
  Permission: ResolverTypeWrapper<Permission>;
  PermissionRiskLevel: PermissionRiskLevel;
  PhoneContactPriority: PhoneContactPriority;
  PhoneNumber: ResolverTypeWrapper<PhoneNumber>;
  PhoneNumberInput: PhoneNumberInput;
  PhoneNumbers: ResolverTypeWrapper<PhoneNumbers>;
  PhoneNumbersInput: PhoneNumbersInput;
  PhysicalConfigurationInput: PhysicalConfigurationInput;
  PinConfigurationInput: PinConfigurationInput;
  PinConfigurationPolicyInput: PinConfigurationPolicyInput;
  PinUnblockInput: PinUnblockInput;
  PingWebhookDetailResponse: ResolverTypeWrapper<PingWebhookDetailResponse>;
  PolicyConfiguration: ResolverTypeWrapper<PolicyConfiguration>;
  PolicyConfigurationInput: PolicyConfigurationInput;
  PolicyGroup: ResolverTypeWrapper<PolicyGroup>;
  PolicyGroupInput: PolicyGroupInput;
  PolicyStatus: PolicyStatus;
  PolicyV2: ResolverTypeWrapper<PolicyV2>;
  PortalTransactionsCollectionSegment: ResolverTypeWrapper<PortalTransactionsCollectionSegment>;
  Pos: ResolverTypeWrapper<Pos>;
  PosCapabilities: ResolverTypeWrapper<PosCapabilities>;
  PosEntry: ResolverTypeWrapper<PosEntry>;
  PosMerchantDomesticPolicyGroupInput: PosMerchantDomesticPolicyGroupInput;
  PosMerchantDomesticPolicyInput: PosMerchantDomesticPolicyInput;
  PosMerchantInternationalPolicyGroupInput: PosMerchantInternationalPolicyGroupInput;
  PosMerchantInternationalPolicyInput: PosMerchantInternationalPolicyInput;
  PosSubLimitsResult: ResolverTypeWrapper<PosSubLimitsResult>;
  Priority: Priority;
  ProcessingCode: ResolverTypeWrapper<ProcessingCode>;
  ProductCategory: ProductCategory;
  ProductLimits: ResolverTypeWrapper<ProductLimits>;
  ProductResponse: ResolverTypeWrapper<ProductResponse>;
  ProductScope: ProductScope;
  ProductStatus: ProductStatus;
  ProgramManagerProductBasic: ResolverTypeWrapper<ProgramManagerProductBasic>;
  ProxyRequestInput: ProxyRequestInput;
  ProxyResponse: ResolverTypeWrapper<ProxyResponse>;
  PublicTokenCardHistoryCollectionSegment: ResolverTypeWrapper<PublicTokenCardHistoryCollectionSegment>;
  PublicTokenCardHistoryInput: PublicTokenCardHistoryInput;
  PublicTokenCardStatusHistoryCollectionSegment: ResolverTypeWrapper<PublicTokenCardStatusHistoryCollectionSegment>;
  PublicTokenMetaHistoryCollectionSegment: ResolverTypeWrapper<PublicTokenMetaHistoryCollectionSegment>;
  Query: ResolverTypeWrapper<{}>;
  RecurringFees: ResolverTypeWrapper<RecurringFees>;
  Regions: ResolverTypeWrapper<Regions>;
  RejectionRule: RejectionRule;
  ResendNotificationItem: ResolverTypeWrapper<ResendNotificationItem>;
  ResendNotificationsInnerResponse: ResolverTypeWrapper<ResendNotificationsInnerResponse>;
  ResendNotificationsInput: ResendNotificationsInput;
  ResendNotificationsResponse: ResolverTypeWrapper<ResendNotificationsResponse>;
  RevokeCertificateInput: RevokeCertificateInput;
  RotateSecretResponse: ResolverTypeWrapper<RotateSecretResponse>;
  Rule: Rule;
  SamlConfig: ResolverTypeWrapper<SamlConfig>;
  SaveUserPmPreferenceInput: SaveUserPmPreferenceInput;
  SearchCardHistoryInput: SearchCardHistoryInput;
  SearchCardsCollectionSegment: ResolverTypeWrapper<SearchCardsCollectionSegment>;
  SearchCardsInput: SearchCardsInput;
  SearchPolicyV2Input: SearchPolicyV2Input;
  SegmentInput: SegmentInput;
  SelfSelectPINInput: SelfSelectPinInput;
  SelfSelectRule: SelfSelectRule;
  ServiceHealthCheck: ResolverTypeWrapper<ServiceHealthCheck>;
  ServiceResponse: ResolverTypeWrapper<ServiceResponse>;
  Sign: Sign;
  SingleFlagData: ResolverTypeWrapper<SingleFlagData>;
  SpendLimitInput: SpendLimitInput;
  SplitKmsBinRangeInput: SplitKmsBinRangeInput;
  SplitKmsBinRangeResponse: ResolverTypeWrapper<SplitKmsBinRangeResponse>;
  Status: Status;
  StatusResponse: ResolverTypeWrapper<StatusResponse>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Subcategories: ResolverTypeWrapper<Subcategories>;
  SupplierAndVersionResponse: ResolverTypeWrapper<SupplierAndVersionResponse>;
  SystemChannel: ResolverTypeWrapper<SystemChannel>;
  SystemChannelInput: SystemChannelInput;
  SystemChannelSourceType: SystemChannelSourceType;
  TRCTransactionType: TrcTransactionType;
  Task: ResolverTypeWrapper<Task>;
  TimestampInput: TimestampInput;
  TokenCacheStats: ResolverTypeWrapper<TokenCacheStats>;
  TokenisationStatus: ResolverTypeWrapper<TokenisationStatus>;
  TransStatus: ResolverTypeWrapper<TransStatus>;
  Transaction: ResolverTypeWrapper<Transaction>;
  TransactionAmount: ResolverTypeWrapper<TransactionAmount>;
  TransactionAuthorisationMethod: TransactionAuthorisationMethod;
  TransactionDetailResponse: ResolverTypeWrapper<TransactionDetailResponse>;
  TransactionFees: ResolverTypeWrapper<TransactionFees>;
  TransactionFeesResponse: ResolverTypeWrapper<TransactionFeesResponse>;
  TransactionReasonCode: ResolverTypeWrapper<TransactionReasonCode>;
  TransactionReasonCodeInput: TransactionReasonCodeInput;
  TransactionResponse: ResolverTypeWrapper<TransactionResponse>;
  TransactionStatus: ResolverTypeWrapper<TransactionStatus>;
  TransactionSubType: TransactionSubType;
  TransactionType: ResolverTypeWrapper<TransactionType>;
  TransactionTypeBTP: TransactionTypeBtp;
  TransactionTypeEnum: TransactionTypeEnum;
  TransactionTypes: ResolverTypeWrapper<TransactionTypes>;
  TransactionWorkflowSign: TransactionWorkflowSign;
  TransactionsCollectionSegment: ResolverTypeWrapper<TransactionsCollectionSegment>;
  TransactionsRequestInput: TransactionsRequestInput;
  TransactionsSortByField: TransactionsSortByField;
  TrustChain: ResolverTypeWrapper<TrustChain>;
  TrustChainResponse: ResolverTypeWrapper<TrustChainResponse>;
  TypeValue: ResolverTypeWrapper<TypeValue>;
  UnblockCardInput: UnblockCardInput;
  UndeliveredNotificationItem: ResolverTypeWrapper<UndeliveredNotificationItem>;
  UndeliveredNotificationsInnerResponse: ResolverTypeWrapper<UndeliveredNotificationsInnerResponse>;
  UndeliveredNotificationsResponse: ResolverTypeWrapper<UndeliveredNotificationsResponse>;
  UnloadFundsInput: UnloadFundsInput;
  Update3DSCredentialInput: Update3DsCredentialInput;
  UpdateAccountHolderInput: UpdateAccountHolderInput;
  UpdateAccountInput: UpdateAccountInput;
  UpdateAccountWorkflowInput: UpdateAccountWorkflowInput;
  UpdateAddressInput: UpdateAddressInput;
  UpdateAddressV2Input: UpdateAddressV2Input;
  UpdateBlockedAmountInput: UpdateBlockedAmountInput;
  UpdateBlockedAmountRequestInput: UpdateBlockedAmountRequestInput;
  UpdateCardInput: UpdateCardInput;
  UpdateCardRequestInput: UpdateCardRequestInput;
  UpdateCompanyInput: UpdateCompanyInput;
  UpdateControlGroupsInput: UpdateControlGroupsInput;
  UpdateCurrencyInput: UpdateCurrencyInput;
  UpdateCustomerWorkflowInput: UpdateCustomerWorkflowInput;
  UpdateFeatureFlagConfig: UpdateFeatureFlagConfig;
  UpdateFeatureFlagRequest: UpdateFeatureFlagRequest;
  UpdateFeatureFlagResponse: ResolverTypeWrapper<UpdateFeatureFlagResponse>;
  UpdateGroupRequest: UpdateGroupRequest;
  UpdateIdpInput: UpdateIdpInput;
  UpdateLedgerInput: UpdateLedgerInput;
  UpdateLedgerInputV2: UpdateLedgerInputV2;
  UpdateMetadataInput: UpdateMetadataInput;
  UpdateOAuthClientInput: UpdateOAuthClientInput;
  UpdateOrganisationGroupInput: UpdateOrganisationGroupInput;
  UpdateOrganisationInput: UpdateOrganisationInput;
  UpdatePaymentNetworkConfigInput: UpdatePaymentNetworkConfigInput;
  UpdatePermissionInput: UpdatePermissionInput;
  UpdatePolicyV2Input: UpdatePolicyV2Input;
  UpdateServiceRequest: UpdateServiceRequest;
  UpdateUserInput: UpdateUserInput;
  UpdateUserStatusInput: UpdateUserStatusInput;
  UpdateWebhookRequestInput: UpdateWebhookRequestInput;
  UpdateWebhookStatusInput: UpdateWebhookStatusInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  User: ResolverTypeWrapper<User>;
  UserListResponse: ResolverTypeWrapper<UserListResponse>;
  VerificationChecks: ResolverTypeWrapper<VerificationChecks>;
  VisaFileMaintenance: ResolverTypeWrapper<VisaFileMaintenance>;
  VisaFileMaintenanceInput: VisaFileMaintenanceInput;
  VisaFileMaintenanceResponse: ResolverTypeWrapper<VisaFileMaintenanceResponse>;
  VisaFileRequest: ResolverTypeWrapper<VisaFileRequest>;
  VisaFileResponse: ResolverTypeWrapper<VisaFileResponse>;
  VisaFleet: ResolverTypeWrapper<VisaFleet>;
  VisaFleetEvData: ResolverTypeWrapper<VisaFleetEvData>;
  VisaFleetFleetData: ResolverTypeWrapper<VisaFleetFleetData>;
  VisaFleetInvoiceLineItem: ResolverTypeWrapper<VisaFleetInvoiceLineItem>;
  VisaFleetPromptData: ResolverTypeWrapper<VisaFleetPromptData>;
  VisaSignOnParams: ResolverTypeWrapper<VisaSignOnParams>;
  VisaSignOnParamsInput: VisaSignOnParamsInput;
  WalletDetails: ResolverTypeWrapper<WalletDetails>;
  WebServiceGroupFees: ResolverTypeWrapper<WebServiceGroupFees>;
  WebServiceProductFees: ResolverTypeWrapper<WebServiceProductFees>;
  WebhookConfig: WebhookConfig;
  WebhookConfigResponse: ResolverTypeWrapper<WebhookConfigResponse>;
  WebhookDetailsResponse: ResolverTypeWrapper<WebhookDetailsResponse>;
  WebhookDtlResponse: ResolverTypeWrapper<WebhookDtlResponse>;
  WebhookEventsResponse: ResolverTypeWrapper<WebhookEventsResponse>;
  WebhookInnerResponse: ResolverTypeWrapper<WebhookInnerResponse>;
  WebhookItemResponse: ResolverTypeWrapper<WebhookItemResponse>;
  WebhookListDataResponse: ResolverTypeWrapper<WebhookListDataResponse>;
  WebhookRequestInput: WebhookRequestInput;
  WebhookResponse: ResolverTypeWrapper<WebhookResponse>;
  WeekDay: ResolverTypeWrapper<WeekDay>;
  WorkflowsName: ResolverTypeWrapper<WorkflowsName>;
  WorkflowsNamesResponse: ResolverTypeWrapper<WorkflowsNamesResponse>;
  WsBalanceTransferResponse: ResolverTypeWrapper<WsBalanceTransferResponse>;
  WsLoadCardResponse: ResolverTypeWrapper<WsLoadCardResponse>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ACHAssetInput: AchAssetInput;
  ACHAssetResponse: AchAssetResponse;
  ACHMonetaryUnitInput: AchMonetaryUnitInput;
  ACHMonetaryUnitResponse: AchMonetaryUnitResponse;
  ACHOriginatorInput: AchOriginatorInput;
  ACHOriginatorResponse: AchOriginatorResponse;
  ACHPaymentInstruction: AchPaymentInstruction;
  ACHPaymentInstructionInput: AchPaymentInstructionInput;
  ACHPaymentInstructionResponse: AchPaymentInstructionResponse;
  ACHRecipientInput: AchRecipientInput;
  ACHRecipientResponse: AchRecipientResponse;
  AcceptorInput: AcceptorInput;
  Account: Account;
  AccountHolder: AccountHolder;
  AccountHolderCommercialDetails: AccountHolderCommercialDetails;
  AccountHolderCommercialDetailsInput: AccountHolderCommercialDetailsInput;
  AccountHolderConfigurationInput: AccountHolderConfigurationInput;
  AccountHolderDeceasedData: AccountHolderDeceasedData;
  AccountHolderDeceasedDataInput: AccountHolderDeceasedDataInput;
  AccountHolderInput: AccountHolderInput;
  AccountHolderNumberGenerationPolicyGroupInput: AccountHolderNumberGenerationPolicyGroupInput;
  AccountHolderNumberGenerationPolicyInput: AccountHolderNumberGenerationPolicyInput;
  AccountHolderRetailDetails: AccountHolderRetailDetails;
  AccountHolderRetailDetailsInput: AccountHolderRetailDetailsInput;
  AccountHolderSCRAData: AccountHolderScraData;
  AccountHolderSCRADataInput: AccountHolderScraDataInput;
  AccountInput: AccountInput;
  AccountNumberGenerationPolicyGroupInput: AccountNumberGenerationPolicyGroupInput;
  AccountUpdateInput: AccountUpdateInput;
  AccountV2: AccountV2;
  ActivateKeyInput: ActivateKeyInput;
  ActivateKeyResponse: ActivateKeyResponse;
  AddSubscriptionsInnerResponse: AddSubscriptionsInnerResponse;
  AddSubscriptionsResponse: AddSubscriptionsResponse;
  AddWebhookSubscriptionsInput: AddWebhookSubscriptionsInput;
  AdditionalAmount: AdditionalAmount;
  AdditionalDataDecodResponse: AdditionalDataDecodResponse;
  AdditionalDataDecodeMC: AdditionalDataDecodeMc;
  AdditionalDataDecoded: AdditionalDataDecoded;
  AdditionalDetail: AdditionalDetail;
  AdditionalResponseData: AdditionalResponseData;
  Address: Address;
  AddressInput: AddressInput;
  AddressUpdateInput: AddressUpdateInput;
  AddressUpdateRequestInput: AddressUpdateRequestInput;
  AddressV2: AddressV2;
  ApexAddress: ApexAddress;
  ApplicationInput: ApplicationInput;
  ApplicationMessageResponse: ApplicationMessageResponse;
  ApplicationResponse: ApplicationResponse;
  AssignPermissionToGroupInput: AssignPermissionToGroupInput;
  AtmWithdrawalInternationalPolicyGroupInput: AtmWithdrawalInternationalPolicyGroupInput;
  AtmWithdrawalInternationalPolicyInput: AtmWithdrawalInternationalPolicyInput;
  AttributeMapping: AttributeMapping;
  AttributeMappingInput: AttributeMappingInput;
  AuditFields: AuditFields;
  AuditLog: AuditLog;
  AuditLogFieldValuePair: AuditLogFieldValuePair;
  AuditLogLookupTableResponse: AuditLogLookupTableResponse;
  AuditLogRequestInput: AuditLogRequestInput;
  AuditLogsExportResponse: AuditLogsExportResponse;
  AuditLogsResponse: AuditLogsResponse;
  AuthFees: AuthFees;
  AuthReversalRequestInput: AuthReversalRequestInput;
  AuthReversalResponse: AuthReversalResponse;
  AuthorisationDecision: AuthorisationDecision;
  AuthorisationStatus: AuthorisationStatus;
  Authorisor: Authorisor;
  AvsCardResponse: AvsCardResponse;
  BalanceLimit: BalanceLimit;
  BalanceResponse: BalanceResponse;
  BalanceTransferInput: BalanceTransferInput;
  BaseConfigurationInput: BaseConfigurationInput;
  BaseConfigurationPolicyGroupInput: BaseConfigurationPolicyGroupInput;
  BaseConfigurationPolicyInput: BaseConfigurationPolicyInput;
  BaseVerificationConfigurationInput: BaseVerificationConfigurationInput;
  BinRange: BinRange;
  BinRangeInput: BinRangeInput;
  BlockedCurrenciesConfigurationInput: BlockedCurrenciesConfigurationInput;
  BlockedCurrenciesPolicyGroupInput: BlockedCurrenciesPolicyGroupInput;
  BlockedCurrenciesPolicyInput: BlockedCurrenciesPolicyInput;
  Boolean: Scalars['Boolean']['output'];
  BucketConfigurationInput: BucketConfigurationInput;
  BypassedAuthorisationVerificationConfigurationInput: BypassedAuthorisationVerificationConfigurationInput;
  BypassedAuthorisationVerificationPolicyGroupInput: BypassedAuthorisationVerificationPolicyGroupInput;
  BypassedAuthorisationVerificationPolicyInput: BypassedAuthorisationVerificationPolicyInput;
  CLAddress: ClAddress;
  CLAddressInput: ClAddressInput;
  CVRDecodedResponse: CvrDecodedResponse;
  CVV2CVC2ConfigurationInput: Cvv2Cvc2ConfigurationInput;
  CVV2PolicyGroupInput: Cvv2PolicyGroupInput;
  CVV2PolicyInput: Cvv2PolicyInput;
  CVVCardNotPresentConfigurationInput: CvvCardNotPresentConfigurationInput;
  CalendarGroupResponse: CalendarGroupResponse;
  CapAsset: CapAsset;
  CapMonetaryUnit: CapMonetaryUnit;
  CardAcceptanceMethods: CardAcceptanceMethods;
  CardAcceptorDetailResponse: CardAcceptorDetailResponse;
  CardAcceptorDetailResponseWithResolver: CardAcceptorDetailResponseWithResolver;
  CardAcceptorPolicyConfigInput: CardAcceptorPolicyConfigInput;
  CardAcceptorPolicyGroupInput: CardAcceptorPolicyGroupInput;
  CardAcceptorPolicyInput: CardAcceptorPolicyInput;
  CardAcceptorsResponse: CardAcceptorsResponse;
  CardActionUsers: CardActionUsers;
  CardActions: CardActions;
  CardDetails: CardDetails;
  CardFeeResponse: CardFeeResponse;
  CardGroupLimits: CardGroupLimits;
  CardHistoryResponse: CardHistoryResponse;
  CardHolder: CardHolder;
  CardHolderUpdateRequestInput: CardHolderUpdateRequestInput;
  CardLimits: CardLimits;
  CardLimitsSub: CardLimitsSub;
  CardLoadSourcesResponse: CardLoadSourcesResponse;
  CardMccDetailResponse: CardMccDetailResponse;
  CardMetaHistoryInput: CardMetaHistoryInput;
  CardMetaHistoryResponse: CardMetaHistoryResponse;
  CardNetworkType: CardNetworkType;
  CardNotPresentConfigurationInput: CardNotPresentConfigurationInput;
  CardNotPresentVerificationConfigurationInput: CardNotPresentVerificationConfigurationInput;
  CardPinStatusResponse: CardPinStatusResponse;
  CardPosSubLimitsResponse: CardPosSubLimitsResponse;
  CardPresentConfigurationInput: CardPresentConfigurationInput;
  CardProduct: CardProduct;
  CardSpendLimitByProductResponse: CardSpendLimitByProductResponse;
  CardStatus: CardStatus;
  CardStatusHistoryInput: CardStatusHistoryInput;
  CardStatusResponse: CardStatusResponse;
  CardsResponse: CardsResponse;
  Certificate: Certificate;
  CertificateMessageResponse: CertificateMessageResponse;
  ChangeCardStatusInput: ChangeCardStatusInput;
  ChangePaymentTokenStatusInput: ChangePaymentTokenStatusInput;
  Channel: Channel;
  ChannelInput: ChannelInput;
  ClearCacheResponse: ClearCacheResponse;
  Client: Client;
  ClientGroupInput: ClientGroupInput;
  ClientInput: ClientInput;
  ClientSpace: ClientSpace;
  CodeDescription: CodeDescription;
  CollectionSegmentInfo: CollectionSegmentInfo;
  Company: Company;
  CompanyInput: CompanyInput;
  Component: Component;
  Condition: Condition;
  ConnectionServiceLatestBuildNumber: ConnectionServiceLatestBuildNumber;
  ContactlessConfigurationInput: ContactlessConfigurationInput;
  ContactlessDomesticPolicyGroupInput: ContactlessDomesticPolicyGroupInput;
  ContactlessDomesticPolicyInput: ContactlessDomesticPolicyInput;
  ContactlessInternationalPolicyGroupInput: ContactlessInternationalPolicyGroupInput;
  ContactlessInternationalPolicyInput: ContactlessInternationalPolicyInput;
  ContactlessPolicyConfigurationInput: ContactlessPolicyConfigurationInput;
  ContactlessPolicyGroupInput: ContactlessPolicyGroupInput;
  ContactlessPolicyInput: ContactlessPolicyInput;
  ControlGroups: ControlGroups;
  ControlGroupsInput: ControlGroupsInput;
  ControlGroupsSub: ControlGroupsSub;
  Counters: Counters;
  Country: Country;
  CountryCurrencyCode: CountryCurrencyCode;
  CountryCurrencyCodeInput: CountryCurrencyCodeInput;
  CreateACHPaymentInstructionInput: CreateAchPaymentInstructionInput;
  CreateAccountByProductInput: CreateAccountByProductInput;
  CreateAccountHolderInput: CreateAccountHolderInput;
  CreateAccountInput: CreateAccountInput;
  CreateAccountWorkflowInput: CreateAccountWorkflowInput;
  CreateAddressInput: CreateAddressInput;
  CreateAddressV2Input: CreateAddressV2Input;
  CreateCertificateIssuerInput: CreateCertificateIssuerInput;
  CreateClientSpaceInput: CreateClientSpaceInput;
  CreateCompanyInput: CreateCompanyInput;
  CreateCurrencyInput: CreateCurrencyInput;
  CreateCustomerWorkflowInput: CreateCustomerWorkflowInput;
  CreateFeatureFlagResponse: CreateFeatureFlagResponse;
  CreateGroupRequest: CreateGroupRequest;
  CreateIdpInput: CreateIdpInput;
  CreateKmsBinRangeInput: CreateKmsBinRangeInput;
  CreateKmsBinRangeResponse: CreateKmsBinRangeResponse;
  CreateLedgerInput: CreateLedgerInput;
  CreateLedgerInputV2: CreateLedgerInputV2;
  CreateLedgerPlaygroundBalance: CreateLedgerPlaygroundBalance;
  CreateLedgerPlaygroundBalanceResponse: CreateLedgerPlaygroundBalanceResponse;
  CreateLedgerPlaygroundTransaction: CreateLedgerPlaygroundTransaction;
  CreateLedgerPlaygroundTransactionResponse: CreateLedgerPlaygroundTransactionResponse;
  CreateOAuthClientInput: CreateOAuthClientInput;
  CreateOidcConfigInput: CreateOidcConfigInput;
  CreateOrganisationGroupInput: CreateOrganisationGroupInput;
  CreateOrganisationInput: CreateOrganisationInput;
  CreatePaymentNetworkConfigInput: CreatePaymentNetworkConfigInput;
  CreatePermissionInput: CreatePermissionInput;
  CreatePolicyV2Input: CreatePolicyV2Input;
  CreateSamlConfigInput: CreateSamlConfigInput;
  CreateServiceRequest: CreateServiceRequest;
  CreateTransactionResponse: CreateTransactionResponse;
  CreateTransactionWorkflowInput: CreateTransactionWorkflowInput;
  CreateUserInput: CreateUserInput;
  CredentialConfigurationResponse: CredentialConfigurationResponse;
  CredentialResponse: CredentialResponse;
  CreditCyclingConfigurationInput: CreditCyclingConfigurationInput;
  CreditCyclingConfigurationPolicyInput: CreditCyclingConfigurationPolicyInput;
  CreditCyclingPolicyGroupInput: CreditCyclingPolicyGroupInput;
  CurConRateInput: CurConRateInput;
  CurConRateResponse: CurConRateResponse;
  Currency: Currency;
  CurrencyCode: CurrencyCode;
  Customer: Customer;
  CustomerAddress: CustomerAddress;
  CustomerAddressInput: CustomerAddressInput;
  CustomerInput: CustomerInput;
  CustomerPhoneNumbers: CustomerPhoneNumbers;
  CvvUnblockInput: CvvUnblockInput;
  DateOfBirth: DateOfBirth;
  DateOfBirthInput: DateOfBirthInput;
  DateTime: Scalars['DateTime']['output'];
  DeactivateKeyInput: DeactivateKeyInput;
  DeactivateKeyResponse: DeactivateKeyResponse;
  Decimal: Scalars['Decimal']['output'];
  DecimalAsFloat: Scalars['DecimalAsFloat']['output'];
  DefaultMastercardSignOnParams: DefaultMastercardSignOnParams;
  DeleteAccountHolderInput: DeleteAccountHolderInput;
  DeleteAccountInput: DeleteAccountInput;
  DeleteAddressInput: DeleteAddressInput;
  DeleteAddressV2Input: DeleteAddressV2Input;
  DeleteFeatureFlagResponse: DeleteFeatureFlagResponse;
  DeleteProductKeyLinkInput: DeleteProductKeyLinkInput;
  DeleteProductKeyLinkResponse: DeleteProductKeyLinkResponse;
  DeleteSubscriptionResponse: DeleteSubscriptionResponse;
  DeploymentStatusResponse: DeploymentStatusResponse;
  DiscoverSignOnParams: DiscoverSignOnParams;
  DiscoverSignOnParamsInput: DiscoverSignOnParamsInput;
  EhiAcknowledgementResponse: EhiAcknowledgementResponse;
  EhiResendResponse: EhiResendResponse;
  Email: Email;
  EmailInput: EmailInput;
  Emv: Emv;
  EvaluateFeatureFlagResponse: EvaluateFeatureFlagResponse;
  EventSubscriptionItem: EventSubscriptionItem;
  ExchangedTokenResponse: ExchangedTokenResponse;
  ExpiryPolicyConfigurationInput: ExpiryPolicyConfigurationInput;
  ExpiryPolicyGroupInput: ExpiryPolicyGroupInput;
  ExpiryPolicyInput: ExpiryPolicyInput;
  ExportAuditLogsInput: ExportAuditLogsInput;
  ExportKeyInput: ExportKeyInput;
  ExportKeyResponse: ExportKeyResponse;
  ExtendExpiryDateInput: ExtendExpiryDateInput;
  ExtendExpiryDateResponse: ExtendExpiryDateResponse;
  FeatureContextInput: FeatureContextInput;
  FeatureFlag: FeatureFlag;
  FeatureFlagEntry: FeatureFlagEntry;
  FeatureFlagMetadata: FeatureFlagMetadata;
  FeatureFlagRequestInput: FeatureFlagRequestInput;
  FeatureFlagStatus: FeatureFlagStatus;
  FeatureRequestInput: FeatureRequestInput;
  FieldMask: FieldMask;
  FieldMaskInput: FieldMaskInput;
  Filter: Filter;
  FilterCondition: FilterCondition;
  FinancialProduct: FinancialProduct;
  FinancialProductInput: FinancialProductInput;
  FlagData: FlagData;
  FlagDataConfigInput: FlagDataConfigInput;
  FlagDataInput: FlagDataInput;
  FlagsResponse: FlagsResponse;
  Float: Scalars['Float']['output'];
  FundsInput: FundsInput;
  FxGroupResponse: FxGroupResponse;
  FxRates: FxRates;
  GenerateKeyInput: GenerateKeyInput;
  GenericVerificationConfigurationInput: GenericVerificationConfigurationInput;
  GetApplicationCertificatePemResponse: GetApplicationCertificatePemResponse;
  GetCardGroupLimitDetailResponse: GetCardGroupLimitDetailResponse;
  GetCardImageResponse: GetCardImageResponse;
  GetCardLimitResponse: GetCardLimitResponse;
  GetCardMCCResponse: GetCardMccResponse;
  GetCardPaymentTokenDetailsResponse: GetCardPaymentTokenDetailsResponse;
  GetCardPaymentTokenDevicesResponse: GetCardPaymentTokenDevicesResponse;
  GetCardResponse: GetCardResponse;
  GetCardSpendLimitDetailsByProductInput: GetCardSpendLimitDetailsByProductInput;
  GetKeyByKeyIdResponse: GetKeyByKeyIdResponse;
  GetLedgerOffsetPositionInput: GetLedgerOffsetPositionInput;
  GetLedgerOffsetPositionResponse: GetLedgerOffsetPositionResponse;
  GetLoadSourceResponse: GetLoadSourceResponse;
  GetOauthClientResponse: GetOauthClientResponse;
  GetPaymentTokenUsageGroupDetailsResponse: GetPaymentTokenUsageGroupDetailsResponse;
  GetPingWebhook: GetPingWebhook;
  GetPortalTransactionsInput: GetPortalTransactionsInput;
  GetSingleTransactionResponse: GetSingleTransactionResponse;
  GetTransactionsInput: GetTransactionsInput;
  GetTransactionsResponse: GetTransactionsResponse;
  GetUsageGroupListDetailsResponse: GetUsageGroupListDetailsResponse;
  GetWalletResponse: GetWalletResponse;
  GpsStatusInfo: GpsStatusInfo;
  GroupDetails: GroupDetails;
  GroupPermissionsResponse: GroupPermissionsResponse;
  GroupResponse: GroupResponse;
  GroupsResponse: GroupsResponse;
  HealthCheckFlagging: HealthCheckFlagging;
  HealthCheckSource: HealthCheckSource;
  HealthcheckResponse: HealthcheckResponse;
  HistoryResponse: HistoryResponse;
  HmacSecretResponse: HmacSecretResponse;
  IccDataDecoded: IccDataDecoded;
  IdentityProvider: IdentityProvider;
  IdentityProviderSamlConfigData: IdentityProviderSamlConfigData;
  IdpHealthCheckResponse: IdpHealthCheckResponse;
  ImportKeyInput: ImportKeyInput;
  ImportParametersResponse: ImportParametersResponse;
  InstrumentFormConfigurationInput: InstrumentFormConfigurationInput;
  InstrumentFormPolicyGroupInput: InstrumentFormPolicyGroupInput;
  InstrumentFormPolicyInput: InstrumentFormPolicyInput;
  InstrumentMCCGroupConfigurationInput: InstrumentMccGroupConfigurationInput;
  InstrumentMCCGroupPolicyGroupInput: InstrumentMccGroupPolicyGroupInput;
  InstrumentMCCGroupPolicyInput: InstrumentMccGroupPolicyInput;
  InstrumentProduct: InstrumentProduct;
  InstrumentProductInput: InstrumentProductInput;
  InstrumentProvisioningConfigurationInput: InstrumentProvisioningConfigurationInput;
  InstrumentProvisioningPolicyGroupInput: InstrumentProvisioningPolicyGroupInput;
  InstrumentProvisioningPolicyInput: InstrumentProvisioningPolicyInput;
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  KeyResponse: KeyResponse;
  KeyValuePairInput: KeyValuePairInput;
  KmsBinRangeInput: KmsBinRangeInput;
  KmsBinRangeResponse: KmsBinRangeResponse;
  Ledger: Ledger;
  LedgerBalance: LedgerBalance;
  LedgerConfig: LedgerConfig;
  LedgerConfigInput: LedgerConfigInput;
  LedgerConfiguration: LedgerConfiguration;
  LedgerConfigurationInput: LedgerConfigurationInput;
  LedgerConfigurationInputBTP: LedgerConfigurationInputBtp;
  LedgerCreationPolicyGroupInput: LedgerCreationPolicyGroupInput;
  LedgerCreationPolicyInput: LedgerCreationPolicyInput;
  LedgerInput: LedgerInput;
  LedgerLoadLimit: LedgerLoadLimit;
  LedgerLoadLimitInput: LedgerLoadLimitInput;
  LedgerLoadLimits: LedgerLoadLimits;
  LedgerLoadLimitsInput: LedgerLoadLimitsInput;
  LedgerLoadLimitsPolicyConfigurationInput: LedgerLoadLimitsPolicyConfigurationInput;
  LedgerLoadLimitsPolicyGroupInput: LedgerLoadLimitsPolicyGroupInput;
  LedgerLoadLimitsPolicyInput: LedgerLoadLimitsPolicyInput;
  LedgerPlaygroundBalance: LedgerPlaygroundBalance;
  LedgerPlaygroundSubtransaction: LedgerPlaygroundSubtransaction;
  LedgerPlaygroundTransaction: LedgerPlaygroundTransaction;
  LedgerPlaygroundTransactionBilling: LedgerPlaygroundTransactionBilling;
  LedgerPlaygroundTransactionLedgerEntry: LedgerPlaygroundTransactionLedgerEntry;
  LedgerPlaygroundTransactionStatus: LedgerPlaygroundTransactionStatus;
  LedgerUpdateInput: LedgerUpdateInput;
  LedgerV2: LedgerV2;
  LimitCategory: LimitCategory;
  LimitConfigurationInput: LimitConfigurationInput;
  LimitPropertyInput: LimitPropertyInput;
  LimitedNetworkGroupResponse: LimitedNetworkGroupResponse;
  LineOfCredit: LineOfCredit;
  LineOfCreditInput: LineOfCreditInput;
  LineOfCreditV2: LineOfCreditV2;
  LinkKeyToProductInput: LinkKeyToProductInput;
  LinkKeyToProductResponse: LinkKeyToProductResponse;
  LinkageGroupResponse: LinkageGroupResponse;
  ListACHPaymentInstructionsInput: ListAchPaymentInstructionsInput;
  ListAccountHoldersInput: ListAccountHoldersInput;
  ListAccountHoldersResponse: ListAccountHoldersResponse;
  ListAccountsInput: ListAccountsInput;
  ListAccountsResponse: ListAccountsResponse;
  ListAccountsV2Input: ListAccountsV2Input;
  ListAddressesInput: ListAddressesInput;
  ListAddressesResponse: ListAddressesResponse;
  ListAddressesResponseV2: ListAddressesResponseV2;
  ListAddressesV2Input: ListAddressesV2Input;
  ListApplicationCertificatesResponse: ListApplicationCertificatesResponse;
  ListApplicationsResponse: ListApplicationsResponse;
  ListCompaniesInput: ListCompaniesInput;
  ListCompaniesResponse: ListCompaniesResponse;
  ListIdentityProvidersResponse: ListIdentityProvidersResponse;
  ListKeysResponse: ListKeysResponse;
  ListKmsBinRangesInput: ListKmsBinRangesInput;
  ListKmsBinRangesResponse: ListKmsBinRangesResponse;
  ListLedgersInput: ListLedgersInput;
  ListLedgersInputV2: ListLedgersInputV2;
  ListLedgersResponse: ListLedgersResponse;
  ListOAuthClientsResponse: ListOAuthClientsResponse;
  ListOrganisationGroupsResponse: ListOrganisationGroupsResponse;
  ListOrganisationsResponse: ListOrganisationsResponse;
  ListPermissionsResponse: ListPermissionsResponse;
  ListProductsResponse: ListProductsResponse;
  ListSubscriptionsInnerResponse: ListSubscriptionsInnerResponse;
  ListSubscriptionsResponse: ListSubscriptionsResponse;
  ListTransactionsInput: ListTransactionsInput;
  ListTransactionsResponse: ListTransactionsResponse;
  ListWebhooksInput: ListWebhooksInput;
  ListWebhooksResponse: ListWebhooksResponse;
  LoadFundsInput: LoadFundsInput;
  LoadLimit: LoadLimit;
  LoadLimitInput: LoadLimitInput;
  LoadLimitInputBTP: LoadLimitInputBtp;
  LoadLimits: LoadLimits;
  LoadLimitsInput: LoadLimitsInput;
  LoadUnloadCardInput: LoadUnloadCardInput;
  LoadUnloadCardRequestInput: LoadUnloadCardRequestInput;
  LoadUnloadCardResponse: LoadUnloadCardResponse;
  Long: Scalars['Long']['output'];
  MFAInput: MfaInput;
  MFAResponse: MfaResponse;
  MFXCardType: MfxCardType;
  MNESignOnParams: MneSignOnParams;
  MNESignOnParamsInput: MneSignOnParamsInput;
  MastercardSignOnParams: MastercardSignOnParams;
  MastercardSignOnParamsInput: MastercardSignOnParamsInput;
  MaximumLoadLimitInput: MaximumLoadLimitInput;
  Merchant: Merchant;
  MerchantCategoryCode: MerchantCategoryCode;
  MerchantCategoryCodeGroupInput: MerchantCategoryCodeGroupInput;
  MerchantCategoryCodeInput: MerchantCategoryCodeInput;
  MessageResponse: MessageResponse;
  Metadata: Metadata;
  MetadataInput: MetadataInput;
  MfxBalanceAdjInput: MfxBalanceAdjInput;
  MfxBalanceAdjRequestInput: MfxBalanceAdjRequestInput;
  MfxBalanceTransferInput: MfxBalanceTransferInput;
  MfxCardTranResponse: MfxCardTranResponse;
  MfxCardWalletTrnsfrDetailResponse: MfxCardWalletTrnsfrDetailResponse;
  MfxCardWalletTrnsfrResponse: MfxCardWalletTrnsfrResponse;
  MfxLoadCardInput: MfxLoadCardInput;
  MfxUnloadCardInput: MfxUnloadCardInput;
  MfxWalletTransferInput: MfxWalletTransferInput;
  MfxWalletTransferRequestInput: MfxWalletTransferRequestInput;
  Misc: Misc;
  ModesOfUse: ModesOfUse;
  Mutation: {};
  NetworkSignOnParamsResponse: NetworkSignOnParamsResponse;
  OAuthClient: OAuthClient;
  OAuthClientCreatedResponse: OAuthClientCreatedResponse;
  OffsetLedger: OffsetLedger;
  OffsetLedgerInput: OffsetLedgerInput;
  OidcConfig: OidcConfig;
  OnlineEcomDomesticPolicyGroupInput: OnlineEcomDomesticPolicyGroupInput;
  OnlineEcomDomesticPolicyInput: OnlineEcomDomesticPolicyInput;
  OnlineEcomInternationalPolicyGroupInput: OnlineEcomInternationalPolicyGroupInput;
  OnlineEcomInternationalPolicyInput: OnlineEcomInternationalPolicyInput;
  OrangeFlowReason: OrangeFlowReason;
  Organisation: Organisation;
  OrganisationEmailDomainResponse: OrganisationEmailDomainResponse;
  OrganisationGroup: OrganisationGroup;
  PANRequestInput: PanRequestInput;
  PANResponse: PanResponse;
  PMInformation: PmInformation;
  PMInformationInput: PmInformationInput;
  POSDataDecoded: PosDataDecoded;
  PartialAuthorisationControlPolicyConfigurationInput: PartialAuthorisationControlPolicyConfigurationInput;
  PartialAuthorisationControlPolicyGroupInput: PartialAuthorisationControlPolicyGroupInput;
  PartialAuthorisationControlPolicyInput: PartialAuthorisationControlPolicyInput;
  PastDueAmount: PastDueAmount;
  PastDueAmountInput: PastDueAmountInput;
  PastDueAmountV2: PastDueAmountV2;
  PaymentAllocationConfigurationInput: PaymentAllocationConfigurationInput;
  PaymentNetworkConfigResponse: PaymentNetworkConfigResponse;
  PaymentTokenStatus: PaymentTokenStatus;
  PaymentTokenStatusResponse: PaymentTokenStatusResponse;
  PaymentTokenUsageRuleDetail: PaymentTokenUsageRuleDetail;
  PaymentTokenUsageRuleGroupResponse: PaymentTokenUsageRuleGroupResponse;
  Permission: Permission;
  PhoneNumber: PhoneNumber;
  PhoneNumberInput: PhoneNumberInput;
  PhoneNumbers: PhoneNumbers;
  PhoneNumbersInput: PhoneNumbersInput;
  PhysicalConfigurationInput: PhysicalConfigurationInput;
  PinConfigurationInput: PinConfigurationInput;
  PinConfigurationPolicyInput: PinConfigurationPolicyInput;
  PinUnblockInput: PinUnblockInput;
  PingWebhookDetailResponse: PingWebhookDetailResponse;
  PolicyConfiguration: PolicyConfiguration;
  PolicyConfigurationInput: PolicyConfigurationInput;
  PolicyGroup: PolicyGroup;
  PolicyGroupInput: PolicyGroupInput;
  PolicyV2: PolicyV2;
  PortalTransactionsCollectionSegment: PortalTransactionsCollectionSegment;
  Pos: Pos;
  PosCapabilities: PosCapabilities;
  PosEntry: PosEntry;
  PosMerchantDomesticPolicyGroupInput: PosMerchantDomesticPolicyGroupInput;
  PosMerchantDomesticPolicyInput: PosMerchantDomesticPolicyInput;
  PosMerchantInternationalPolicyGroupInput: PosMerchantInternationalPolicyGroupInput;
  PosMerchantInternationalPolicyInput: PosMerchantInternationalPolicyInput;
  PosSubLimitsResult: PosSubLimitsResult;
  ProcessingCode: ProcessingCode;
  ProductLimits: ProductLimits;
  ProductResponse: ProductResponse;
  ProgramManagerProductBasic: ProgramManagerProductBasic;
  ProxyRequestInput: ProxyRequestInput;
  ProxyResponse: ProxyResponse;
  PublicTokenCardHistoryCollectionSegment: PublicTokenCardHistoryCollectionSegment;
  PublicTokenCardHistoryInput: PublicTokenCardHistoryInput;
  PublicTokenCardStatusHistoryCollectionSegment: PublicTokenCardStatusHistoryCollectionSegment;
  PublicTokenMetaHistoryCollectionSegment: PublicTokenMetaHistoryCollectionSegment;
  Query: {};
  RecurringFees: RecurringFees;
  Regions: Regions;
  ResendNotificationItem: ResendNotificationItem;
  ResendNotificationsInnerResponse: ResendNotificationsInnerResponse;
  ResendNotificationsInput: ResendNotificationsInput;
  ResendNotificationsResponse: ResendNotificationsResponse;
  RevokeCertificateInput: RevokeCertificateInput;
  RotateSecretResponse: RotateSecretResponse;
  Rule: Rule;
  SamlConfig: SamlConfig;
  SaveUserPmPreferenceInput: SaveUserPmPreferenceInput;
  SearchCardHistoryInput: SearchCardHistoryInput;
  SearchCardsCollectionSegment: SearchCardsCollectionSegment;
  SearchCardsInput: SearchCardsInput;
  SearchPolicyV2Input: SearchPolicyV2Input;
  SegmentInput: SegmentInput;
  SelfSelectPINInput: SelfSelectPinInput;
  ServiceHealthCheck: ServiceHealthCheck;
  ServiceResponse: ServiceResponse;
  SingleFlagData: SingleFlagData;
  SpendLimitInput: SpendLimitInput;
  SplitKmsBinRangeInput: SplitKmsBinRangeInput;
  SplitKmsBinRangeResponse: SplitKmsBinRangeResponse;
  StatusResponse: StatusResponse;
  String: Scalars['String']['output'];
  Subcategories: Subcategories;
  SupplierAndVersionResponse: SupplierAndVersionResponse;
  SystemChannel: SystemChannel;
  SystemChannelInput: SystemChannelInput;
  Task: Task;
  TimestampInput: TimestampInput;
  TokenCacheStats: TokenCacheStats;
  TokenisationStatus: TokenisationStatus;
  TransStatus: TransStatus;
  Transaction: Transaction;
  TransactionAmount: TransactionAmount;
  TransactionDetailResponse: TransactionDetailResponse;
  TransactionFees: TransactionFees;
  TransactionFeesResponse: TransactionFeesResponse;
  TransactionReasonCode: TransactionReasonCode;
  TransactionReasonCodeInput: TransactionReasonCodeInput;
  TransactionResponse: TransactionResponse;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  TransactionTypes: TransactionTypes;
  TransactionsCollectionSegment: TransactionsCollectionSegment;
  TransactionsRequestInput: TransactionsRequestInput;
  TrustChain: TrustChain;
  TrustChainResponse: TrustChainResponse;
  TypeValue: TypeValue;
  UnblockCardInput: UnblockCardInput;
  UndeliveredNotificationItem: UndeliveredNotificationItem;
  UndeliveredNotificationsInnerResponse: UndeliveredNotificationsInnerResponse;
  UndeliveredNotificationsResponse: UndeliveredNotificationsResponse;
  UnloadFundsInput: UnloadFundsInput;
  Update3DSCredentialInput: Update3DsCredentialInput;
  UpdateAccountHolderInput: UpdateAccountHolderInput;
  UpdateAccountInput: UpdateAccountInput;
  UpdateAccountWorkflowInput: UpdateAccountWorkflowInput;
  UpdateAddressInput: UpdateAddressInput;
  UpdateAddressV2Input: UpdateAddressV2Input;
  UpdateBlockedAmountInput: UpdateBlockedAmountInput;
  UpdateBlockedAmountRequestInput: UpdateBlockedAmountRequestInput;
  UpdateCardInput: UpdateCardInput;
  UpdateCardRequestInput: UpdateCardRequestInput;
  UpdateCompanyInput: UpdateCompanyInput;
  UpdateControlGroupsInput: UpdateControlGroupsInput;
  UpdateCurrencyInput: UpdateCurrencyInput;
  UpdateCustomerWorkflowInput: UpdateCustomerWorkflowInput;
  UpdateFeatureFlagConfig: UpdateFeatureFlagConfig;
  UpdateFeatureFlagRequest: UpdateFeatureFlagRequest;
  UpdateFeatureFlagResponse: UpdateFeatureFlagResponse;
  UpdateGroupRequest: UpdateGroupRequest;
  UpdateIdpInput: UpdateIdpInput;
  UpdateLedgerInput: UpdateLedgerInput;
  UpdateLedgerInputV2: UpdateLedgerInputV2;
  UpdateMetadataInput: UpdateMetadataInput;
  UpdateOAuthClientInput: UpdateOAuthClientInput;
  UpdateOrganisationGroupInput: UpdateOrganisationGroupInput;
  UpdateOrganisationInput: UpdateOrganisationInput;
  UpdatePaymentNetworkConfigInput: UpdatePaymentNetworkConfigInput;
  UpdatePermissionInput: UpdatePermissionInput;
  UpdatePolicyV2Input: UpdatePolicyV2Input;
  UpdateServiceRequest: UpdateServiceRequest;
  UpdateUserInput: UpdateUserInput;
  UpdateUserStatusInput: UpdateUserStatusInput;
  UpdateWebhookRequestInput: UpdateWebhookRequestInput;
  UpdateWebhookStatusInput: UpdateWebhookStatusInput;
  Upload: Scalars['Upload']['output'];
  User: User;
  UserListResponse: UserListResponse;
  VerificationChecks: VerificationChecks;
  VisaFileMaintenance: VisaFileMaintenance;
  VisaFileMaintenanceInput: VisaFileMaintenanceInput;
  VisaFileMaintenanceResponse: VisaFileMaintenanceResponse;
  VisaFileRequest: VisaFileRequest;
  VisaFileResponse: VisaFileResponse;
  VisaFleet: VisaFleet;
  VisaFleetEvData: VisaFleetEvData;
  VisaFleetFleetData: VisaFleetFleetData;
  VisaFleetInvoiceLineItem: VisaFleetInvoiceLineItem;
  VisaFleetPromptData: VisaFleetPromptData;
  VisaSignOnParams: VisaSignOnParams;
  VisaSignOnParamsInput: VisaSignOnParamsInput;
  WalletDetails: WalletDetails;
  WebServiceGroupFees: WebServiceGroupFees;
  WebServiceProductFees: WebServiceProductFees;
  WebhookConfig: WebhookConfig;
  WebhookConfigResponse: WebhookConfigResponse;
  WebhookDetailsResponse: WebhookDetailsResponse;
  WebhookDtlResponse: WebhookDtlResponse;
  WebhookEventsResponse: WebhookEventsResponse;
  WebhookInnerResponse: WebhookInnerResponse;
  WebhookItemResponse: WebhookItemResponse;
  WebhookListDataResponse: WebhookListDataResponse;
  WebhookRequestInput: WebhookRequestInput;
  WebhookResponse: WebhookResponse;
  WeekDay: WeekDay;
  WorkflowsName: WorkflowsName;
  WorkflowsNamesResponse: WorkflowsNamesResponse;
  WsBalanceTransferResponse: WsBalanceTransferResponse;
  WsLoadCardResponse: WsLoadCardResponse;
};

export type IsAuthenticatedDirectiveArgs = { };

export type IsAuthenticatedDirectiveResolver<Result, Parent, ContextType = any, Args = IsAuthenticatedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AchAssetResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHAssetResponse'] = ResolversParentTypes['ACHAssetResponse']> = {
  monetary?: Resolver<ResolversTypes['ACHMonetaryUnitResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AchMonetaryUnitResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHMonetaryUnitResponse'] = ResolversParentTypes['ACHMonetaryUnitResponse']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AchOriginatorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHOriginatorResponse'] = ResolversParentTypes['ACHOriginatorResponse']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routingCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AchPaymentInstructionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHPaymentInstruction'] = ResolversParentTypes['ACHPaymentInstruction']> = {
  asset?: Resolver<ResolversTypes['ACHAssetResponse'], ParentType, ContextType>;
  effectiveEntryDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originator?: Resolver<ResolversTypes['ACHOriginatorResponse'], ParentType, ContextType>;
  paymentAuthorizationDetails?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['ACHRecipientResponse'], ParentType, ContextType>;
  standardEntryClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionSpeed?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AchPaymentInstructionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHPaymentInstructionResponse'] = ResolversParentTypes['ACHPaymentInstructionResponse']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentInstruction?: Resolver<ResolversTypes['ACHPaymentInstruction'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AchRecipientResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ACHRecipientResponse'] = ResolversParentTypes['ACHRecipientResponse']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routingCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']> = {
  accountHolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeCardsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<AccountActiveCardsCountArgs, 'clientId'>>;
  auditFields?: Resolver<Maybe<ResolversTypes['AuditFields']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['AccountCategory']>, ParentType, ContextType>;
  clientAssignedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ledgerBalances?: Resolver<Maybe<Array<ResolversTypes['LedgerBalance']>>, ParentType, ContextType>;
  lineOfCredit?: Resolver<Maybe<ResolversTypes['LineOfCredit']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['AccountStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountHolderResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountHolder'] = ResolversParentTypes['AccountHolder']> = {
  accountHolderDeceasedData?: Resolver<Maybe<ResolversTypes['AccountHolderDeceasedData']>, ParentType, ContextType>;
  accountHolderScraData?: Resolver<Maybe<ResolversTypes['AccountHolderSCRAData']>, ParentType, ContextType>;
  accountHolderStatus?: Resolver<Maybe<ResolversTypes['AccountHolderStatus']>, ParentType, ContextType>;
  accountHolderType?: Resolver<Maybe<ResolversTypes['AccountHolderType']>, ParentType, ContextType>;
  clientAssignedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commercialDetails?: Resolver<Maybe<ResolversTypes['AccountHolderCommercialDetails']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Maybe<ResolversTypes['PhoneNumbers']>, ParentType, ContextType>;
  retailDetails?: Resolver<Maybe<ResolversTypes['AccountHolderRetailDetails']>, ParentType, ContextType>;
  subClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountHolderCommercialDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountHolderCommercialDetails'] = ResolversParentTypes['AccountHolderCommercialDetails']> = {
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountHolderDeceasedDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountHolderDeceasedData'] = ResolversParentTypes['AccountHolderDeceasedData']> = {
  dateDeceasedVerified?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfDeath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deathMasterId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleteNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  editNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountHolderRetailDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountHolderRetailDetails'] = ResolversParentTypes['AccountHolderRetailDetails']> = {
  dateOfBirth?: Resolver<Maybe<ResolversTypes['DateOfBirth']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountHolderScraDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountHolderSCRAData'] = ResolversParentTypes['AccountHolderSCRAData']> = {
  deleteNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  editNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scraActiveDutyEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scraActiveDutyOrdersReceived?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scraActiveDutyStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scraMilitaryBranch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scraRequestBenefitsDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scraVerificationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountV2'] = ResolversParentTypes['AccountV2']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeCardsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<AccountV2ActiveCardsCountArgs, 'clientId'>>;
  clientAssignedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundingType?: Resolver<Maybe<ResolversTypes['AccountCategory']>, ParentType, ContextType>;
  ledgers?: Resolver<Maybe<Array<ResolversTypes['LedgerV2']>>, ParentType, ContextType>;
  lineOfCredit?: Resolver<Maybe<ResolversTypes['LineOfCreditV2']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateKeyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateKeyResponse'] = ResolversParentTypes['ActivateKeyResponse']> = {
  key?: Resolver<Maybe<ResolversTypes['KeyResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSubscriptionsInnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSubscriptionsInnerResponse'] = ResolversParentTypes['AddSubscriptionsInnerResponse']> = {
  responseStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSubscriptionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSubscriptionsResponse'] = ResolversParentTypes['AddSubscriptionsResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['AddSubscriptionsInnerResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalAmount'] = ResolversParentTypes['AdditionalAmount']> = {
  accountType?: Resolver<ResolversTypes['TypeValue'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['TypeValue'], ParentType, ContextType>;
  amountType?: Resolver<ResolversTypes['TypeValue'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['TypeValue'], ParentType, ContextType>;
  occurence?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TypeValue'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalDataDecodResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalDataDecodResponse'] = ResolversParentTypes['AdditionalDataDecodResponse']> = {
  additionalDataDecoded?: Resolver<Maybe<Array<ResolversTypes['AdditionalDataDecoded']>>, ParentType, ContextType>;
  additionalDataDecodedMc?: Resolver<Maybe<ResolversTypes['AdditionalDataDecodeMC']>, ParentType, ContextType>;
  btnPds0043IsVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  btnPds0146IsVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  btnPds0158IsVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  btnPds0159IsVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  heading?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pds0043?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pds0146?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pds0158?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pds0159?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalDataDecodeMcResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalDataDecodeMC'] = ResolversParentTypes['AdditionalDataDecodeMC']> = {
  additionalDataDecoded?: Resolver<Maybe<Array<ResolversTypes['AdditionalDataDecoded']>>, ParentType, ContextType>;
  tcc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalLength?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalDataDecodedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalDataDecoded'] = ResolversParentTypes['AdditionalDataDecoded']> = {
  item?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pdsmc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subElements?: Resolver<Maybe<Array<ResolversTypes['AdditionalDataDecoded']>>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalDetail'] = ResolversParentTypes['AdditionalDetail']> = {
  acquirerForwarderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorisationExpiryDateUtc?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  authorisationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardDeviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkResultsSent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkResultsSentLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCodeFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCodeFeeSettlement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dccIndicator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emv?: Resolver<Maybe<ResolversTypes['Emv']>, ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  instantFundingGps?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  instantFundingNetwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  interchangeAmountFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  interchangeAmountFeeSettlement?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  loadedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchingTransactionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType>;
  multiPartCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  multiPartNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  multiPartTransaction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  multiPartTransactionFinal?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pos?: Resolver<Maybe<ResolversTypes['Pos']>, ParentType, ContextType>;
  posCapabilities?: Resolver<Maybe<ResolversTypes['PosCapabilities']>, ParentType, ContextType>;
  preAuthorisationDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  psdScaExempt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdditionalResponseDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalResponseData'] = ResolversParentTypes['AdditionalResponseData']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  accountHolderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLine1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressType?: Resolver<ResolversTypes['AddressType'], ParentType, ContextType>;
  auditFields?: Resolver<Maybe<ResolversTypes['AuditFields']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressV2'] = ResolversParentTypes['AddressV2']> = {
  addressId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AddressType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApexAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApexAddress'] = ResolversParentTypes['ApexAddress']> = {
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationMessageResponse'] = ResolversParentTypes['ApplicationMessageResponse']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationResponse'] = ResolversParentTypes['ApplicationResponse']> = {
  appId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttributeMappingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttributeMapping'] = ResolversParentTypes['AttributeMapping']> = {
  externalAttribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internalAttribute?: Resolver<ResolversTypes['InternalAttributeMappingType'], ParentType, ContextType>;
  isRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditFields'] = ResolversParentTypes['AuditFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLog'] = ResolversParentTypes['AuditLog']> = {
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  correlationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  section?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditLogFieldValuePairResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogFieldValuePair'] = ResolversParentTypes['AuditLogFieldValuePair']> = {
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditLogLookupTableResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogLookupTableResponse'] = ResolversParentTypes['AuditLogLookupTableResponse']> = {
  items?: Resolver<Array<ResolversTypes['AuditLogFieldValuePair']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditLogsExportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogsExportResponse'] = ResolversParentTypes['AuditLogsExportResponse']> = {
  logs?: Resolver<Array<ResolversTypes['AuditLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditLogsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogsResponse'] = ResolversParentTypes['AuditLogsResponse']> = {
  lastEvaluatedKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logs?: Resolver<Array<ResolversTypes['AuditLog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthFees'] = ResolversParentTypes['AuthFees']> = {
  capDomesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  capFxFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  capNonDomesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declineFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticFeeRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  fxFixed?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonDomesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  numberOfFreeTransactionPerActivation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfFreeTransactionPerMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  partialAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  processingCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smsFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  thresholdType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthReversalResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthReversalResponse'] = ResolversParentTypes['AuthReversalResponse']> = {
  transactionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorisationDecisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorisationDecision'] = ResolversParentTypes['AuthorisationDecision']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorisationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorisationStatus'] = ResolversParentTypes['AuthorisationStatus']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorisorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Authorisor'] = ResolversParentTypes['Authorisor']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['AuthorisorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvsCardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvsCardResponse'] = ResolversParentTypes['AvsCardResponse']> = {
  addressResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avsResponse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcodeDigits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcodeResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetAddressDigits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalanceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceResponse'] = ResolversParentTypes['BalanceResponse']> = {
  availableBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  cardBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BinRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BinRange'] = ResolversParentTypes['BinRange']> = {
  binId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  binMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  binMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CLAddress'] = ResolversParentTypes['CLAddress']> = {
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countyCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CvrDecodedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CVRDecodedResponse'] = ResolversParentTypes['CVRDecodedResponse']> = {
  cvrDetails?: Resolver<Maybe<Array<ResolversTypes['CVRDecodedResponse']>>, ParentType, ContextType>;
  item?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CalendarGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalendarGroupResponse'] = ResolversParentTypes['CalendarGroupResponse']> = {
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weekDay?: Resolver<Maybe<Array<ResolversTypes['WeekDay']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CapAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CapAsset'] = ResolversParentTypes['CapAsset']> = {
  monetary?: Resolver<Maybe<ResolversTypes['CapMonetaryUnit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CapMonetaryUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['CapMonetaryUnit'] = ResolversParentTypes['CapMonetaryUnit']> = {
  amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardAcceptanceMethodsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardAcceptanceMethods'] = ResolversParentTypes['CardAcceptanceMethods']> = {
  defaultTicked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardAcceptorDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardAcceptorDetailResponse'] = ResolversParentTypes['CardAcceptorDetailResponse']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isConfiguredGroup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  merchantIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardAcceptorDetailResponseWithResolverResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardAcceptorDetailResponseWithResolver'] = ResolversParentTypes['CardAcceptorDetailResponseWithResolver']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isConfiguredGroup?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  merchantIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardAcceptorsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardAcceptorsResponse'] = ResolversParentTypes['CardAcceptorsResponse']> = {
  cardAcceptorAllowList?: Resolver<Maybe<Array<ResolversTypes['CardAcceptorDetailResponse']>>, ParentType, ContextType>;
  cardAcceptorDisallowList?: Resolver<Maybe<Array<ResolversTypes['CardAcceptorDetailResponse']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardActionUsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardActionUsers'] = ResolversParentTypes['CardActionUsers']> = {
  userCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardActionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardActions'] = ResolversParentTypes['CardActions']> = {
  actionCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  actionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardDetails'] = ResolversParentTypes['CardDetails']> = {
  activationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clearPan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvv?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullNameOnCard?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gpsExpiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maskedPan?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardFeeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardFeeResponse'] = ResolversParentTypes['CardFeeResponse']> = {
  authFees?: Resolver<Array<ResolversTypes['AuthFees']>, ParentType, ContextType>;
  recurringFees?: Resolver<Array<ResolversTypes['RecurringFees']>, ParentType, ContextType>;
  webServiceGroupFees?: Resolver<Array<ResolversTypes['WebServiceGroupFees']>, ParentType, ContextType>;
  webServiceProductFees?: Resolver<Array<ResolversTypes['WebServiceProductFees']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardGroupLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardGroupLimits'] = ResolversParentTypes['CardGroupLimits']> = {
  accumulatedFrequencyLimit1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accumulatedFrequencyLimit2?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accumulatedPeriod1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accumulatedPeriod2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accumulatedValueLimit1?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  accumulatedValueLimit2?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dailyFrequencyLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dailyValueLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxAllowableBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  maxPerTransaction?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minPerTransaction?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  subGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardHistoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardHistoryResponse'] = ResolversParentTypes['CardHistoryResponse']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardHolderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardHolder'] = ResolversParentTypes['CardHolder']> = {
  dateOfBirth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardLimits'] = ResolversParentTypes['CardLimits']> = {
  accumulatedPeriod1?: Resolver<Maybe<ResolversTypes['CardLimitsSub']>, ParentType, ContextType>;
  accumulatedPeriod2?: Resolver<Maybe<ResolversTypes['CardLimitsSub']>, ParentType, ContextType>;
  daily?: Resolver<Maybe<ResolversTypes['CardLimitsSub']>, ParentType, ContextType>;
  subGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardLimitsSubResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardLimitsSub'] = ResolversParentTypes['CardLimitsSub']> = {
  frequency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  period?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  spent?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  transactionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardLoadSourcesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardLoadSourcesResponse'] = ResolversParentTypes['CardLoadSourcesResponse']> = {
  accumulatedFrequencyLimit1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accumulatedFrequencyLimit2?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  accumulatedPeriod1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accumulatedPeriod2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accumulatedValueLimit1?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  accumulatedValueLimit2?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dailyFrequencyLimit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dailyValueLimit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loadSrcDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxPerTransaction?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minPerTransaction?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  subGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardMccDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardMccDetailResponse'] = ResolversParentTypes['CardMccDetailResponse']> = {
  mccCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mccHigh?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mccLow?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardMetaHistoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardMetaHistoryResponse'] = ResolversParentTypes['CardMetaHistoryResponse']> = {
  activity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  changeDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardNetworkTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardNetworkType'] = ResolversParentTypes['CardNetworkType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardPinStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardPinStatusResponse'] = ResolversParentTypes['CardPinStatusResponse']> = {
  remainingOfflineTries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainingTries?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardPosSubLimitsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardPosSubLimitsResponse'] = ResolversParentTypes['CardPosSubLimitsResponse']> = {
  cardPosSubLimits?: Resolver<Maybe<Array<ResolversTypes['PosSubLimitsResult']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardProduct'] = ResolversParentTypes['CardProduct']> = {
  ehiMode?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  networkId?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productShortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subBinHigh?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subBinLow?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardSpendLimitByProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardSpendLimitByProductResponse'] = ResolversParentTypes['CardSpendLimitByProductResponse']> = {
  limitsWithCounter?: Resolver<Maybe<Array<ResolversTypes['LimitCategory']>>, ParentType, ContextType>;
  public_token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardStatus'] = ResolversParentTypes['CardStatus']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isEditableByProgramManager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardStatusResponse'] = ResolversParentTypes['CardStatusResponse']> = {
  cardStatusCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardStatusDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardsResponse'] = ResolversParentTypes['CardsResponse']> = {
  actualBalance?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableBalance?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  cardStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endPointBase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panPubt?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  programManagerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicToken?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  schemeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  schemeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Certificate'] = ResolversParentTypes['Certificate']> = {
  certificateType?: Resolver<ResolversTypes['CertificateType'], ParentType, ContextType>;
  fingerprint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  keyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CertificateStatus'], ParentType, ContextType>;
  validFrom?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  validTo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificateMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificateMessageResponse'] = ResolversParentTypes['CertificateMessageResponse']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Channel'] = ResolversParentTypes['Channel']> = {
  channelType?: Resolver<Maybe<ResolversTypes['ChannelType']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectionRule?: Resolver<Maybe<ResolversTypes['RejectionRule']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['ChannelSourceType']>, ParentType, ContextType>;
  transactionDescriptionText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClearCacheResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClearCacheResponse'] = ResolversParentTypes['ClearCacheResponse']> = {
  exchangedTokensCleared?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subjectTokensCleared?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Client'] = ResolversParentTypes['Client']> = {
  addresses?: Resolver<Array<ResolversTypes['CLAddress']>, ParentType, ContextType>;
  brandName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  contactName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emails?: Resolver<Array<ResolversTypes['Email']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institutionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  institutionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Array<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  programManagerCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  programManagerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportingCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportingCutoffTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportingTimezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rulesType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ClientStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientSpaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientSpace'] = ResolversParentTypes['ClientSpace']> = {
  accountEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awsAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awsRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deploymentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pmId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  provisionedProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whaleAccount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  writeRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeDescriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CodeDescription'] = ResolversParentTypes['CodeDescription']> = {
  bitPositionDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CollectionSegmentInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CollectionSegmentInfo'] = ResolversParentTypes['CollectionSegmentInfo']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = {
  auditFields?: Resolver<Maybe<ResolversTypes['AuditFields']>, ParentType, ContextType>;
  companyStatus?: Resolver<Maybe<ResolversTypes['CompanyStatus']>, ParentType, ContextType>;
  companyType?: Resolver<Maybe<ResolversTypes['CompanyType']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  industryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentCompanyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ComponentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Component'] = ResolversParentTypes['Component']> = {
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitedNetworkGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionServiceLatestBuildNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionServiceLatestBuildNumber'] = ResolversParentTypes['ConnectionServiceLatestBuildNumber']> = {
  connectionServiceLatestBuildNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlGroupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlGroups'] = ResolversParentTypes['ControlGroups']> = {
  authFeeGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  calendarGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cardAcceptorAllowList?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cardAcceptorDisallowList?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cardLinkageGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  fxGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  limitedNetworkGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  limitsGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  mccGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  paymentTokenUsageGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  recurringFeeGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  usageGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  webServiceFeeGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ControlGroupsSubResolvers<ContextType = any, ParentType extends ResolversParentTypes['ControlGroupsSub'] = ResolversParentTypes['ControlGroupsSub']> = {
  authFeeGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  calendarGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cardAcceptorAllowList?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cardAcceptorDisallowList?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cardLinkageGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  fxGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  limitedNetworkGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  limitsGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  mccGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  paymentTokenUsageGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  recurringFeeGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  usageGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  webServiceFeeGroup?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountersResolvers<ContextType = any, ParentType extends ResolversParentTypes['Counters'] = ResolversParentTypes['Counters']> = {
  accumlimit1_amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  accumlimit1_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accumlimit2_amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  accumlimit2_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daily_amount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  daily_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = {
  alphaCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numericCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryCurrencyCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryCurrencyCode'] = ResolversParentTypes['CountryCurrencyCode']> = {
  alpha2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alpha3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alphaCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyExponent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numeric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numericCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warningBulletinRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFeatureFlagResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFeatureFlagResponse'] = ResolversParentTypes['CreateFeatureFlagResponse']> = {
  deploymentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flagName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateKmsBinRangeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateKmsBinRangeResponse'] = ResolversParentTypes['CreateKmsBinRangeResponse']> = {
  product?: Resolver<Maybe<ResolversTypes['ProductResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateLedgerPlaygroundBalanceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateLedgerPlaygroundBalanceResponse'] = ResolversParentTypes['CreateLedgerPlaygroundBalanceResponse']> = {
  ledgerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateLedgerPlaygroundTransactionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateLedgerPlaygroundTransactionResponse'] = ResolversParentTypes['CreateLedgerPlaygroundTransactionResponse']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTransactionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTransactionResponse'] = ResolversParentTypes['CreateTransactionResponse']> = {
  declineReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CreateTransactionStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CredentialConfigurationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CredentialConfigurationResponse'] = ResolversParentTypes['CredentialConfigurationResponse']> = {
  configuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultCredentials?: Resolver<Maybe<Array<ResolversTypes['CredentialResponse']>>, ParentType, ContextType>;
  fallbackCredentials?: Resolver<Maybe<ResolversTypes['CredentialResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CredentialResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CredentialResponse'] = ResolversParentTypes['CredentialResponse']> = {
  credentialType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  kbaQuestion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurConRateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurConRateResponse'] = ResolversParentTypes['CurConRateResponse']> = {
  conversionRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Currency'] = ResolversParentTypes['Currency']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deprecatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrencyCode'] = ResolversParentTypes['CurrencyCode']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  accountHolderDeceasedData?: Resolver<Maybe<ResolversTypes['AccountHolderDeceasedData']>, ParentType, ContextType>;
  accountHolderScraData?: Resolver<Maybe<ResolversTypes['AccountHolderSCRAData']>, ParentType, ContextType>;
  addresses?: Resolver<Maybe<Array<ResolversTypes['CustomerAddress']>>, ParentType, ContextType>;
  clientAssignedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerType?: Resolver<Maybe<ResolversTypes['AccountHolderType']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Maybe<ResolversTypes['CustomerPhoneNumbers']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CustomerStatus']>, ParentType, ContextType>;
  subClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerAddress'] = ResolversParentTypes['CustomerAddress']> = {
  addressId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLine2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  houseNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AddressType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerPhoneNumbersResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerPhoneNumbers'] = ResolversParentTypes['CustomerPhoneNumbers']> = {
  home?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryContact?: Resolver<ResolversTypes['PhoneContactPriority'], ParentType, ContextType>;
  secondaryContact?: Resolver<Maybe<ResolversTypes['PhoneContactPriority']>, ParentType, ContextType>;
  work?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DateOfBirthResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateOfBirth'] = ResolversParentTypes['DateOfBirth']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeactivateKeyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateKeyResponse'] = ResolversParentTypes['DeactivateKeyResponse']> = {
  key?: Resolver<Maybe<ResolversTypes['KeyResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Decimal'], any> {
  name: 'Decimal';
}

export interface DecimalAsFloatScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DecimalAsFloat'], any> {
  name: 'DecimalAsFloat';
}

export type DefaultMastercardSignOnParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DefaultMastercardSignOnParams'] = ResolversParentTypes['DefaultMastercardSignOnParams']> = {
  acquirerOrIssuerIndicator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressDataIndicator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  forwardingInstitutionIdentificationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupSignOnId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageSecurityCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinBlockFormatCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinEncryptionTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinKeyIndexNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinSecurityTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFeatureFlagResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteFeatureFlagResponse'] = ResolversParentTypes['DeleteFeatureFlagResponse']> = {
  deploymentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flagName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteProductKeyLinkResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteProductKeyLinkResponse'] = ResolversParentTypes['DeleteProductKeyLinkResponse']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSubscriptionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSubscriptionResponse'] = ResolversParentTypes['DeleteSubscriptionResponse']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeploymentStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeploymentStatusResponse'] = ResolversParentTypes['DeploymentStatusResponse']> = {
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscoverSignOnParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscoverSignOnParams'] = ResolversParentTypes['DiscoverSignOnParams']> = {
  transactionDestinationInstitutionIdentificationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionOriginatorInstitutionIdentificationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EhiAcknowledgementResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EhiAcknowledgementResponse'] = ResolversParentTypes['EhiAcknowledgementResponse']> = {
  resendToEhi?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EhiResendResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EhiResendResponse'] = ResolversParentTypes['EhiResendResponse']> = {
  resendMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Email'] = ResolversParentTypes['Email']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmvResolvers<ContextType = any, ParentType extends ResolversParentTypes['Emv'] = ResolversParentTypes['Emv']> = {
  applicationTransactionCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cardholderVerificationCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cardholderVerificationResult?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  terminalCapabilities?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terminalType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EvaluateFeatureFlagResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvaluateFeatureFlagResponse'] = ResolversParentTypes['EvaluateFeatureFlagResponse']> = {
  flags?: Resolver<Array<ResolversTypes['FeatureFlagEntry']>, ParentType, ContextType>;
  missingFlags?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventSubscriptionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventSubscriptionItem'] = ResolversParentTypes['EventSubscriptionItem']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExchangedTokenResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExchangedTokenResponse'] = ResolversParentTypes['ExchangedTokenResponse']> = {
  cached?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  exchangedToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pmCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExportKeyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExportKeyResponse'] = ResolversParentTypes['ExportKeyResponse']> = {
  exportedKeyCheckValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyExchangeKeyArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wrappedKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtendExpiryDateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtendExpiryDateResponse'] = ResolversParentTypes['ExtendExpiryDateResponse']> = {
  gpsExpirationDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureFlag'] = ResolversParentTypes['FeatureFlag']> = {
  flagData?: Resolver<Maybe<ResolversTypes['FlagData']>, ParentType, ContextType>;
  flagName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureFlagEntry'] = ResolversParentTypes['FeatureFlagEntry']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FeatureFlagStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureFlagMetadata'] = ResolversParentTypes['FeatureFlagMetadata']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureFlagStatus'] = ResolversParentTypes['FeatureFlagStatus']> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['FeatureFlagMetadata']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialProduct'] = ResolversParentTypes['FinancialProduct']> = {
  activeEnd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeStart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ledgers?: Resolver<Array<ResolversTypes['LedgerConfiguration']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['ProductScope']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProductStatus']>, ParentType, ContextType>;
  subClientIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlagDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlagData'] = ResolversParentTypes['FlagData']> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['Metadata']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FlagsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FlagsResponse'] = ResolversParentTypes['FlagsResponse']> = {
  flags?: Resolver<Maybe<Array<ResolversTypes['FeatureFlag']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FxGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FxGroupResponse'] = ResolversParentTypes['FxGroupResponse']> = {
  fxRates?: Resolver<Maybe<Array<ResolversTypes['FxRates']>>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FxRatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['FxRates'] = ResolversParentTypes['FxRates']> = {
  buy?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  destinationCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fxDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mid?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  rateSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sell?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  sourceCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetApplicationCertificatePemResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetApplicationCertificatePemResponse'] = ResolversParentTypes['GetApplicationCertificatePemResponse']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardGroupLimitDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardGroupLimitDetailResponse'] = ResolversParentTypes['GetCardGroupLimitDetailResponse']> = {
  cardGroupLimits?: Resolver<Maybe<Array<ResolversTypes['CardGroupLimits']>>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxAllowableBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardImageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardImageResponse'] = ResolversParentTypes['GetCardImageResponse']> = {
  image?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardLimitResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardLimitResponse'] = ResolversParentTypes['GetCardLimitResponse']> = {
  availableBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  blockedAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  cardLimits?: Resolver<Maybe<Array<ResolversTypes['CardLimits']>>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxAllowableBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardMccResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardMCCResponse'] = ResolversParentTypes['GetCardMCCResponse']> = {
  mccAllowList?: Resolver<Maybe<Array<ResolversTypes['CardMccDetailResponse']>>, ParentType, ContextType>;
  mccDisallowList?: Resolver<Maybe<Array<ResolversTypes['CardMccDetailResponse']>>, ParentType, ContextType>;
  mccGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardPaymentTokenDetailsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardPaymentTokenDetailsResponse'] = ResolversParentTypes['GetCardPaymentTokenDetailsResponse']> = {
  activationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activationCodeExpdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bnReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardAcceptorNameLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardUsageGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorPanReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorTokenReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  digitisationReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ehiRequestTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ehiResponseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endOfPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalStatusSetBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finalDecisionBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mtid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldExpDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panSourceDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentTokenUsageGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replacementCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statuses?: Resolver<Maybe<ResolversTypes['PaymentTokenStatus']>, ParentType, ContextType>;
  termsAndConditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threddDecision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threddDecisionAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenPan?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  tokenType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenisedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionID?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  txnStatusChanged?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletAccountHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletAccountScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  walletDeviceScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  walletId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletProvider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletReasons?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardPaymentTokenDevicesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardPaymentTokenDevicesResponse'] = ResolversParentTypes['GetCardPaymentTokenDevicesResponse']> = {
  bindDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gpsId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  gpsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  paymentSchemeStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCardResponse'] = ResolversParentTypes['GetCardResponse']> = {
  address?: Resolver<Maybe<ResolversTypes['ApexAddress']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['BalanceResponse']>, ParentType, ContextType>;
  cardDetails?: Resolver<Maybe<ResolversTypes['CardDetails']>, ParentType, ContextType>;
  cardHolder?: Resolver<Maybe<ResolversTypes['CardHolder']>, ParentType, ContextType>;
  cardProduct?: Resolver<Maybe<ResolversTypes['CardProduct']>, ParentType, ContextType>;
  cardStatusCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardStatusDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardType?: Resolver<ResolversTypes['CardType'], ParentType, ContextType>;
  childCards?: Resolver<Maybe<Array<ResolversTypes['Long']>>, ParentType, ContextType>;
  controlGroups?: Resolver<Maybe<ResolversTypes['ControlGroupsSub']>, ParentType, ContextType>;
  credentials?: Resolver<Maybe<ResolversTypes['CredentialConfigurationResponse']>, ParentType, ContextType>;
  designId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freetext1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freetext2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fulfilment?: Resolver<Maybe<ResolversTypes['ApexAddress']>, ParentType, ContextType>;
  isMfxPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMultiFx?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isoLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  networkSharingOptOut?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panPubt?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentCard?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  siblingCards?: Resolver<Maybe<Array<ResolversTypes['Long']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CardStatusCodeNumeric'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetKeyByKeyIdResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetKeyByKeyIdResponse'] = ResolversParentTypes['GetKeyByKeyIdResponse']> = {
  key?: Resolver<Maybe<ResolversTypes['KeyResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetLedgerOffsetPositionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetLedgerOffsetPositionResponse'] = ResolversParentTypes['GetLedgerOffsetPositionResponse']> = {
  asset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  closingPosition?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ledgerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  netChange?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  openingPosition?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetLoadSourceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetLoadSourceResponse'] = ResolversParentTypes['GetLoadSourceResponse']> = {
  cardLoadSources?: Resolver<Maybe<Array<ResolversTypes['CardLoadSourcesResponse']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOauthClientResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOauthClientResponse'] = ResolversParentTypes['GetOauthClientResponse']> = {
  allowedGroupIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  allowedScopes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  applicationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cognitoClientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ipWhitelist?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSecretRotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pmId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usageNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetPaymentTokenUsageGroupDetailsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetPaymentTokenUsageGroupDetailsResponse'] = ResolversParentTypes['GetPaymentTokenUsageGroupDetailsResponse']> = {
  activateAutoCallCentre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activateCallCentre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activateCallback?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  activateEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  activateMobileApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activateSMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  activateWebsiteURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avsMissing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvv2Missing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultWalletProviderAuthentication?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupUsageDefaultName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  institute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minTokensToAuth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minTokensToDecline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notifyEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notifyPost?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notifySMS?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  overrideApproveAuth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tokenUsage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletAccountMaxScoreAuth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletAccountMaxScoreDecline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletDecisionsAuth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletDecisionsDecline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletDeviceMaxScoreAuth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletDeviceMaxScoreDecline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetPingWebhookResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetPingWebhook'] = ResolversParentTypes['GetPingWebhook']> = {
  response?: Resolver<Maybe<ResolversTypes['PingWebhookDetailResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSingleTransactionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSingleTransactionResponse'] = ResolversParentTypes['GetSingleTransactionResponse']> = {
  acquirerReferenceData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalAmounts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalAuthorisationDataDgn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalAuthorizationDataDgn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalResponseData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adviceReasonData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorisationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableBalance?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  avsCardResponse?: Resolver<Maybe<ResolversTypes['AvsCardResponse']>, ParentType, ContextType>;
  avsPostcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avsStreet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  billingAmountWithDirection?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  billingCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCurrencyNumericCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockedAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  cardAcceptorIdentificationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardAcceptorNameLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardAcceptorTerminalIdentification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCodeFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCodeFeeSettlement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateExpiry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decodedAdditionalAmount?: Resolver<Maybe<Array<ResolversTypes['AdditionalAmount']>>, ParentType, ContextType>;
  decodedAdditionalResponseData?: Resolver<Maybe<Array<ResolversTypes['AdditionalResponseData']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  diffInReqResp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ehiMode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  feeProcessingCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fixedFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  functionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fxPadding?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  gpsPosData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iccData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interchangeAmountFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interchangeAmountFeeSettlement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isMfx?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mccPadding?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType>;
  merchantCategoryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantCategoryDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageReasonData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  networkData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  networkId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  networkReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panPubt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panReport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentTokenId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pds146Value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pos?: Resolver<Maybe<ResolversTypes['Pos']>, ParentType, ContextType>;
  posCapabilities?: Resolver<Maybe<ResolversTypes['PosCapabilities']>, ParentType, ContextType>;
  posConditionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posEntry?: Resolver<Maybe<ResolversTypes['PosEntry']>, ParentType, ContextType>;
  posEntryMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processingCode?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  recapDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recapNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  requestTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseSource?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseStatusDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retrievalReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  settlementCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surchargeFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tillTime?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  traceIdLifeCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  transactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionDestinationIic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionDestrinationIic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionFees?: Resolver<Maybe<ResolversTypes['TransactionFeesResponse']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  transactionOriginatingInstitution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visaFleet?: Resolver<Maybe<ResolversTypes['VisaFleet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetTransactionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetTransactionsResponse'] = ResolversParentTypes['GetTransactionsResponse']> = {
  acquirerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalDetail?: Resolver<Maybe<ResolversTypes['AdditionalDetail']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['TransactionAmount'], ParentType, ContextType>;
  billingCurrencyNumericCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardNetwork?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ehiMode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endPointBase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['TransactionFees'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  isMfx?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lifeCycleId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lifecycleId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType>;
  merchantCategoryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panPubt?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  panToken?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  pant?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentTokenId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  processingCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  programId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  programName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubToken?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  recordId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  schemeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  systemTraceAuditNumber?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  traceIdLifeCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionLink?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TransactionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetUsageGroupListDetailsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetUsageGroupListDetailsResponse'] = ResolversParentTypes['GetUsageGroupListDetailsResponse']> = {
  cardAcceptanceMethods?: Resolver<Maybe<Array<ResolversTypes['CardAcceptanceMethods']>>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  misc?: Resolver<Maybe<Array<ResolversTypes['Misc']>>, ParentType, ContextType>;
  transactionTypes?: Resolver<Maybe<Array<ResolversTypes['TransactionTypes']>>, ParentType, ContextType>;
  verificationChecks?: Resolver<Maybe<Array<ResolversTypes['VerificationChecks']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetWalletResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetWalletResponse'] = ResolversParentTypes['GetWalletResponse']> = {
  isAutoTransfer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  wallets?: Resolver<Array<ResolversTypes['WalletDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GpsStatusInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GpsStatusInfo'] = ResolversParentTypes['GpsStatusInfo']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupDetails'] = ResolversParentTypes['GroupDetails']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupPermissionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupPermissionsResponse'] = ResolversParentTypes['GroupPermissionsResponse']> = {
  permissions?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupResponse'] = ResolversParentTypes['GroupResponse']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isUpdating?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pk?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  services?: Resolver<Maybe<Array<ResolversTypes['ServiceResponse']>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupsResponse'] = ResolversParentTypes['GroupsResponse']> = {
  groupType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['GroupDetails']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HealthCheckFlaggingResolvers<ContextType = any, ParentType extends ResolversParentTypes['HealthCheckFlagging'] = ResolversParentTypes['HealthCheckFlagging']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HealthCheckSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['HealthCheckSource'] = ResolversParentTypes['HealthCheckSource']> = {
  environment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  services?: Resolver<Array<ResolversTypes['ServiceHealthCheck']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HealthcheckResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HealthcheckResponse'] = ResolversParentTypes['HealthcheckResponse']> = {
  allServices?: Resolver<Array<ResolversTypes['ServiceHealthCheck']>, ParentType, ContextType>;
  overallStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sources?: Resolver<Array<ResolversTypes['HealthCheckSource']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoryResponse'] = ResolversParentTypes['HistoryResponse']> = {
  changeDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  changeNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HmacSecretResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HmacSecretResponse'] = ResolversParentTypes['HmacSecretResponse']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastRotatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IccDataDecodedResolvers<ContextType = any, ParentType extends ResolversParentTypes['IccDataDecoded'] = ResolversParentTypes['IccDataDecoded']> = {
  pds?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdsDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdsHexa?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdsValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subLevelPDS?: Resolver<Maybe<Array<ResolversTypes['IccDataDecoded']>>, ParentType, ContextType>;
  subfieldValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityProvider'] = ResolversParentTypes['IdentityProvider']> = {
  attributeMappings?: Resolver<Array<ResolversTypes['AttributeMapping']>, ParentType, ContextType>;
  autoCreateUsers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cognitoProviderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultGroupMappings?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  healthCheckStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  idpId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  idpType?: Resolver<ResolversTypes['IdpType'], ParentType, ContextType>;
  lastHealthCheck?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  oidcConfig?: Resolver<ResolversTypes['OidcConfig'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  samlConfig?: Resolver<ResolversTypes['SamlConfig'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IdpStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdentityProviderSamlConfigDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentityProviderSamlConfigData'] = ResolversParentTypes['IdentityProviderSamlConfigData']> = {
  acsUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IdpHealthCheckResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdpHealthCheckResponse'] = ResolversParentTypes['IdpHealthCheckResponse']> = {
  details?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  idpId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastChecked?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportParametersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportParametersResponse'] = ResolversParentTypes['ImportParametersResponse']> = {
  importToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parametersValidUntilTimestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wrappingKeyAlgorithm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wrappingKeyCertificate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wrappingKeyCertificateChain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InstrumentProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['InstrumentProduct'] = ResolversParentTypes['InstrumentProduct']> = {
  activeEnd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeStart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apexProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  binRangeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryOfIssue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schemeMembershipId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['ProductScope']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ProductStatus']>, ParentType, ContextType>;
  subClientIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type KeyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyResponse'] = ResolversParentTypes['KeyResponse']> = {
  active?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyAlgorithm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyModesOfUse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyUsageType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tr31Type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KmsBinRangeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['KmsBinRangeResponse'] = ResolversParentTypes['KmsBinRangeResponse']> = {
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rangeHighLimit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rangeLowLimit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Ledger'] = ResolversParentTypes['Ledger']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auditFields?: Resolver<Maybe<ResolversTypes['AuditFields']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['LedgerBalance']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['LedgerStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['LedgerTypeInput']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerBalance'] = ResolversParentTypes['LedgerBalance']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currentBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ledgerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingCredit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pendingDebit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postedCredit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postedDebit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerConfig'] = ResolversParentTypes['LedgerConfig']> = {
  autoCreate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  financialProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentProductIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  loadLimits?: Resolver<Maybe<ResolversTypes['LedgerLoadLimits']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerConfiguration'] = ResolversParentTypes['LedgerConfiguration']> = {
  autoCreate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentProductIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  loadLimits?: Resolver<Maybe<ResolversTypes['LoadLimits']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerLoadLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerLoadLimit'] = ResolversParentTypes['LedgerLoadLimit']> = {
  max?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerLoadLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerLoadLimits'] = ResolversParentTypes['LedgerLoadLimits']> = {
  annually?: Resolver<Maybe<ResolversTypes['LedgerLoadLimit']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['LedgerLoadLimit']>, ParentType, ContextType>;
  daily?: Resolver<Maybe<ResolversTypes['LedgerLoadLimit']>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<ResolversTypes['LedgerLoadLimit']>, ParentType, ContextType>;
  single?: Resolver<Maybe<ResolversTypes['LedgerLoadLimit']>, ParentType, ContextType>;
  weekly?: Resolver<Maybe<ResolversTypes['LedgerLoadLimit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerPlaygroundBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerPlaygroundBalance'] = ResolversParentTypes['LedgerPlaygroundBalance']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentBalance?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ledgerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ledgerType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingCredit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingDebit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postedCredit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postedDebit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerPlaygroundSubtransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerPlaygroundSubtransaction'] = ResolversParentTypes['LedgerPlaygroundSubtransaction']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subTransactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subTransactionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerPlaygroundTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerPlaygroundTransaction'] = ResolversParentTypes['LedgerPlaygroundTransaction']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billing?: Resolver<ResolversTypes['LedgerPlaygroundTransactionBilling'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeLedgerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ledgerEntries?: Resolver<Maybe<Array<ResolversTypes['LedgerPlaygroundTransactionLedgerEntry']>>, ParentType, ContextType>;
  ledgerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  offsetLedgerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processingChannel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sign?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LedgerPlaygroundTransactionStatus'], ParentType, ContextType>;
  subTransactions?: Resolver<Maybe<Array<ResolversTypes['LedgerPlaygroundSubtransaction']>>, ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerPlaygroundTransactionBillingResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerPlaygroundTransactionBilling'] = ResolversParentTypes['LedgerPlaygroundTransactionBilling']> = {
  billingAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billingAsset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cashbackAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cashbackAsset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exchangeRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeAsset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementAsset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionAsset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerPlaygroundTransactionLedgerEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerPlaygroundTransactionLedgerEntry'] = ResolversParentTypes['LedgerPlaygroundTransactionLedgerEntry']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ledgerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ledgerType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sign?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subTransactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerPlaygroundTransactionStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerPlaygroundTransactionStatus'] = ResolversParentTypes['LedgerPlaygroundTransactionStatus']> = {
  authorisedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processedOn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LedgerV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['LedgerV2'] = ResolversParentTypes['LedgerV2']> = {
  asset?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availableBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ledgerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitCategory'] = ResolversParentTypes['LimitCategory']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  counters?: Resolver<Maybe<ResolversTypes['Counters']>, ParentType, ContextType>;
  limits?: Resolver<Maybe<ResolversTypes['ProductLimits']>, ParentType, ContextType>;
  subcategories?: Resolver<Maybe<Array<ResolversTypes['Subcategories']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LimitedNetworkGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LimitedNetworkGroupResponse'] = ResolversParentTypes['LimitedNetworkGroupResponse']> = {
  component?: Resolver<Maybe<Array<ResolversTypes['Component']>>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineOfCreditResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineOfCredit'] = ResolversParentTypes['LineOfCredit']> = {
  cashAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cashLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cycleDay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cycleMinPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nextCycleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextDueDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldestPd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pastDueAmounts?: Resolver<Maybe<Array<ResolversTypes['PastDueAmount']>>, ParentType, ContextType>;
  preApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pricingTier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainingMinPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPastDue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineOfCreditV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['LineOfCreditV2'] = ResolversParentTypes['LineOfCreditV2']> = {
  cashAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cashLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cycleDay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cycleMinPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nextCycleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextDueDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldestPd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pastDueAmounts?: Resolver<Maybe<Array<ResolversTypes['PastDueAmountV2']>>, ParentType, ContextType>;
  preApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pricingTier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainingMinPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPastDue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkKeyToProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkKeyToProductResponse'] = ResolversParentTypes['LinkKeyToProductResponse']> = {
  keyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkageGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkageGroupResponse'] = ResolversParentTypes['LinkageGroupResponse']> = {
  dailyTransferMaxLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  groupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  institutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnBalWithPrimaryBit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shareBalWithPrimaryBit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shareVelocityLimitsBit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  singleTransferMaxLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sweepRemainingFundsToPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unlimitedTransfers?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAccountHoldersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListAccountHoldersResponse'] = ResolversParentTypes['ListAccountHoldersResponse']> = {
  accountHolders?: Resolver<Maybe<Array<ResolversTypes['AccountHolder']>>, ParentType, ContextType>;
  nextPageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAccountsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListAccountsResponse'] = ResolversParentTypes['ListAccountsResponse']> = {
  accounts?: Resolver<Maybe<Array<ResolversTypes['Account']>>, ParentType, ContextType>;
  nextPageToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAddressesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListAddressesResponse'] = ResolversParentTypes['ListAddressesResponse']> = {
  addresses?: Resolver<Maybe<Array<ResolversTypes['Address']>>, ParentType, ContextType>;
  nextPageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListAddressesResponseV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ListAddressesResponseV2'] = ResolversParentTypes['ListAddressesResponseV2']> = {
  addresses?: Resolver<Maybe<Array<ResolversTypes['AddressV2']>>, ParentType, ContextType>;
  nextPageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListApplicationCertificatesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListApplicationCertificatesResponse'] = ResolversParentTypes['ListApplicationCertificatesResponse']> = {
  certificates?: Resolver<Array<ResolversTypes['Certificate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListApplicationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListApplicationsResponse'] = ResolversParentTypes['ListApplicationsResponse']> = {
  applications?: Resolver<Array<ResolversTypes['ApplicationResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListCompaniesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListCompaniesResponse'] = ResolversParentTypes['ListCompaniesResponse']> = {
  companies?: Resolver<Maybe<Array<ResolversTypes['Company']>>, ParentType, ContextType>;
  nextPageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListIdentityProvidersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListIdentityProvidersResponse'] = ResolversParentTypes['ListIdentityProvidersResponse']> = {
  identityProviders?: Resolver<Array<ResolversTypes['IdentityProvider']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListKeysResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListKeysResponse'] = ResolversParentTypes['ListKeysResponse']> = {
  count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<ResolversTypes['KeyResponse']>>, ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListKmsBinRangesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListKmsBinRangesResponse'] = ResolversParentTypes['ListKmsBinRangesResponse']> = {
  binRanges?: Resolver<Maybe<Array<ResolversTypes['KmsBinRangeResponse']>>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListLedgersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListLedgersResponse'] = ResolversParentTypes['ListLedgersResponse']> = {
  ledgers?: Resolver<Maybe<Array<ResolversTypes['Ledger']>>, ParentType, ContextType>;
  nextPageToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListOAuthClientsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListOAuthClientsResponse'] = ResolversParentTypes['ListOAuthClientsResponse']> = {
  clients?: Resolver<Array<ResolversTypes['OAuthClient']>, ParentType, ContextType>;
  nextKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListOrganisationGroupsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListOrganisationGroupsResponse'] = ResolversParentTypes['ListOrganisationGroupsResponse']> = {
  groups?: Resolver<Array<ResolversTypes['OrganisationGroup']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListOrganisationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListOrganisationsResponse'] = ResolversParentTypes['ListOrganisationsResponse']> = {
  organisations?: Resolver<Array<ResolversTypes['Organisation']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListPermissionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListPermissionsResponse'] = ResolversParentTypes['ListPermissionsResponse']> = {
  permissions?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListProductsResponse'] = ResolversParentTypes['ListProductsResponse']> = {
  count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['ProductResponse']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListSubscriptionsInnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListSubscriptionsInnerResponse'] = ResolversParentTypes['ListSubscriptionsInnerResponse']> = {
  content?: Resolver<Maybe<Array<ResolversTypes['EventSubscriptionItem']>>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListSubscriptionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListSubscriptionsResponse'] = ResolversParentTypes['ListSubscriptionsResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['ListSubscriptionsInnerResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListTransactionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListTransactionsResponse'] = ResolversParentTypes['ListTransactionsResponse']> = {
  nextPageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<ResolversTypes['Transaction']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListWebhooksResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListWebhooksResponse'] = ResolversParentTypes['ListWebhooksResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['WebhookListDataResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoadLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoadLimit'] = ResolversParentTypes['LoadLimit']> = {
  max?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoadLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoadLimits'] = ResolversParentTypes['LoadLimits']> = {
  annually?: Resolver<Maybe<ResolversTypes['LoadLimit']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['LoadLimit']>, ParentType, ContextType>;
  daily?: Resolver<Maybe<ResolversTypes['LoadLimit']>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<ResolversTypes['LoadLimit']>, ParentType, ContextType>;
  single?: Resolver<Maybe<ResolversTypes['LoadLimit']>, ParentType, ContextType>;
  weekly?: Resolver<Maybe<ResolversTypes['LoadLimit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoadUnloadCardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoadUnloadCardResponse'] = ResolversParentTypes['LoadUnloadCardResponse']> = {
  balance?: Resolver<Maybe<ResolversTypes['BalanceResponse']>, ParentType, ContextType>;
  transaction?: Resolver<Maybe<Array<ResolversTypes['TransactionResponse']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Long'], any> {
  name: 'Long';
}

export type MfaResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MFAResponse'] = ResolversParentTypes['MFAResponse']> = {
  expiresAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isValid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MfxCardTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MFXCardType'] = ResolversParentTypes['MFXCardType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MneSignOnParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MNESignOnParams'] = ResolversParentTypes['MNESignOnParams']> = {
  messageSecurityCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MastercardSignOnParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MastercardSignOnParams'] = ResolversParentTypes['MastercardSignOnParams']> = {
  acquirerOrIssuerIndicator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressDataIndicator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  forwardingInstitutionIdentificationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupSignOnId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageSecurityCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinBlockFormatCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinEncryptionTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinKeyIndexNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pinSecurityTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MerchantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Merchant'] = ResolversParentTypes['Merchant']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  networkId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MerchantCategoryCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCategoryCode'] = ResolversParentTypes['MerchantCategoryCode']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lower?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  upper?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageResponse'] = ResolversParentTypes['MessageResponse']> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['Metadata'] = ResolversParentTypes['Metadata']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jiraTicket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rolloutPlan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MfxCardTranResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfxCardTranResponse'] = ResolversParentTypes['MfxCardTranResponse']> = {
  balance?: Resolver<Maybe<ResolversTypes['BalanceResponse']>, ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['TransactionResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MfxCardWalletTrnsfrDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfxCardWalletTrnsfrDetailResponse'] = ResolversParentTypes['MfxCardWalletTrnsfrDetailResponse']> = {
  actualBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  blockedAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MfxCardWalletTrnsfrResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MfxCardWalletTrnsfrResponse'] = ResolversParentTypes['MfxCardWalletTrnsfrResponse']> = {
  destinationWalletTransaction?: Resolver<Maybe<ResolversTypes['MfxCardWalletTrnsfrDetailResponse']>, ParentType, ContextType>;
  sourceWalletTransaction?: Resolver<Maybe<ResolversTypes['MfxCardWalletTrnsfrDetailResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MiscResolvers<ContextType = any, ParentType extends ResolversParentTypes['Misc'] = ResolversParentTypes['Misc']> = {
  defaultTicked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  activateKey?: Resolver<Maybe<ResolversTypes['ActivateKeyResponse']>, ParentType, ContextType, RequireFields<MutationActivateKeyArgs, 'input'>>;
  addCardHistoryNote?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAddCardHistoryNoteArgs, 'note' | 'publicToken'>>;
  addUserToGroup?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationAddUserToGroupArgs, 'groupId' | 'organisationId' | 'username'>>;
  addUserToOrganisation?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationAddUserToOrganisationArgs, 'organisationId' | 'username'>>;
  addWebhookSubscriptions?: Resolver<Maybe<ResolversTypes['AddSubscriptionsResponse']>, ParentType, ContextType, RequireFields<MutationAddWebhookSubscriptionsArgs, 'input' | 'webhookId'>>;
  assignPermissionToGroup?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationAssignPermissionToGroupArgs, 'groupId' | 'input' | 'organisationId'>>;
  balanceAjustmentForBlockedAmt?: Resolver<Maybe<ResolversTypes['LoadUnloadCardResponse']>, ParentType, ContextType, RequireFields<MutationBalanceAjustmentForBlockedAmtArgs, 'input'>>;
  balanceTransfer?: Resolver<Maybe<ResolversTypes['LoadUnloadCardResponse']>, ParentType, ContextType, RequireFields<MutationBalanceTransferArgs, 'input'>>;
  bulkCreateCountryCurrencyCode?: Resolver<Maybe<Array<ResolversTypes['CountryCurrencyCode']>>, ParentType, ContextType, RequireFields<MutationBulkCreateCountryCurrencyCodeArgs, 'input'>>;
  cancelPaymentInstruction?: Resolver<Maybe<ResolversTypes['ACHPaymentInstructionResponse']>, ParentType, ContextType, RequireFields<MutationCancelPaymentInstructionArgs, 'clientId' | 'id'>>;
  changeCardStatus?: Resolver<Maybe<ResolversTypes['StatusResponse']>, ParentType, ContextType, RequireFields<MutationChangeCardStatusArgs, 'input'>>;
  changePaymentTokenStatus?: Resolver<Maybe<ResolversTypes['PaymentTokenStatusResponse']>, ParentType, ContextType, RequireFields<MutationChangePaymentTokenStatusArgs, 'input'>>;
  clearTokenCache?: Resolver<Maybe<ResolversTypes['ClearCacheResponse']>, ParentType, ContextType>;
  createAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<MutationCreateAccountArgs, 'clientId' | 'input'>>;
  createAccountByProduct?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<MutationCreateAccountByProductArgs, 'clientId' | 'input'>>;
  createAccountHolder?: Resolver<Maybe<ResolversTypes['AccountHolder']>, ParentType, ContextType, RequireFields<MutationCreateAccountHolderArgs, 'clientId' | 'input'>>;
  createAccountHolderWorkflow?: Resolver<Maybe<ResolversTypes['AccountHolder']>, ParentType, ContextType, RequireFields<MutationCreateAccountHolderWorkflowArgs, 'clientId' | 'input'>>;
  createAccountWorkflow?: Resolver<Maybe<ResolversTypes['AccountV2']>, ParentType, ContextType, RequireFields<MutationCreateAccountWorkflowArgs, 'clientId' | 'input'>>;
  createAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<MutationCreateAddressArgs, 'clientId' | 'input'>>;
  createAddressV2Workflow?: Resolver<Maybe<ResolversTypes['AddressV2']>, ParentType, ContextType, RequireFields<MutationCreateAddressV2WorkflowArgs, 'clientId' | 'input'>>;
  createAddressWorkflow?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<MutationCreateAddressWorkflowArgs, 'clientId' | 'input'>>;
  createApplication?: Resolver<Maybe<ResolversTypes['ApplicationMessageResponse']>, ParentType, ContextType, RequireFields<MutationCreateApplicationArgs, 'input'>>;
  createApplicationCertificate?: Resolver<Maybe<ResolversTypes['CertificateMessageResponse']>, ParentType, ContextType, RequireFields<MutationCreateApplicationCertificateArgs, 'applicationId' | 'input'>>;
  createAuditLog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCreateAuditLogArgs, 'input'>>;
  createAuthReversalTransaction?: Resolver<Maybe<ResolversTypes['AuthReversalResponse']>, ParentType, ContextType, RequireFields<MutationCreateAuthReversalTransactionArgs, 'input' | 'transactionId'>>;
  createBinRange?: Resolver<Maybe<ResolversTypes['BinRange']>, ParentType, ContextType, RequireFields<MutationCreateBinRangeArgs, 'input'>>;
  createChannel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType, RequireFields<MutationCreateChannelArgs, 'input'>>;
  createChannelV2?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType, RequireFields<MutationCreateChannelV2Args, 'input'>>;
  createClient?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<MutationCreateClientArgs, 'input'>>;
  createClientSpace?: Resolver<Maybe<ResolversTypes['ClientSpace']>, ParentType, ContextType, RequireFields<MutationCreateClientSpaceArgs, 'input'>>;
  createCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationCreateCompanyArgs, 'clientId' | 'input'>>;
  createCompanyWorkflow?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationCreateCompanyWorkflowArgs, 'clientId' | 'input'>>;
  createCountryCurrencyCode?: Resolver<Maybe<ResolversTypes['CountryCurrencyCode']>, ParentType, ContextType, RequireFields<MutationCreateCountryCurrencyCodeArgs, 'input'>>;
  createCurrency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<MutationCreateCurrencyArgs, 'input'>>;
  createCustomerWorkflow?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<MutationCreateCustomerWorkflowArgs, 'clientId' | 'input'>>;
  createFinancialProduct?: Resolver<Maybe<ResolversTypes['FinancialProduct']>, ParentType, ContextType, RequireFields<MutationCreateFinancialProductArgs, 'input'>>;
  createFlag?: Resolver<Maybe<ResolversTypes['CreateFeatureFlagResponse']>, ParentType, ContextType, RequireFields<MutationCreateFlagArgs, 'input'>>;
  createGroup?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<MutationCreateGroupArgs, 'input'>>;
  createIdentityProvider?: Resolver<Maybe<ResolversTypes['IdentityProvider']>, ParentType, ContextType, RequireFields<MutationCreateIdentityProviderArgs, 'input' | 'organisationId'>>;
  createInstrumentProduct?: Resolver<Maybe<ResolversTypes['InstrumentProduct']>, ParentType, ContextType, RequireFields<MutationCreateInstrumentProductArgs, 'input'>>;
  createKmsBinRange?: Resolver<Maybe<ResolversTypes['CreateKmsBinRangeResponse']>, ParentType, ContextType, RequireFields<MutationCreateKmsBinRangeArgs, 'input'>>;
  createLedger?: Resolver<Maybe<ResolversTypes['Ledger']>, ParentType, ContextType, RequireFields<MutationCreateLedgerArgs, 'clientId' | 'input'>>;
  createLedgerConfiguration?: Resolver<Maybe<ResolversTypes['LedgerConfig']>, ParentType, ContextType, RequireFields<MutationCreateLedgerConfigurationArgs, 'input'>>;
  createLedgerPlaygroundBalance?: Resolver<Maybe<ResolversTypes['CreateLedgerPlaygroundBalanceResponse']>, ParentType, ContextType, RequireFields<MutationCreateLedgerPlaygroundBalanceArgs, 'clientId' | 'input'>>;
  createLedgerPlaygroundTransaction?: Resolver<Maybe<ResolversTypes['CreateLedgerPlaygroundTransactionResponse']>, ParentType, ContextType, RequireFields<MutationCreateLedgerPlaygroundTransactionArgs, 'clientId' | 'input'>>;
  createLedgerWorkflow?: Resolver<Maybe<ResolversTypes['LedgerV2']>, ParentType, ContextType, RequireFields<MutationCreateLedgerWorkflowArgs, 'accountId' | 'clientId' | 'input'>>;
  createMerchantCategoryCode?: Resolver<Maybe<ResolversTypes['MerchantCategoryCode']>, ParentType, ContextType, RequireFields<MutationCreateMerchantCategoryCodeArgs, 'input'>>;
  createOauthClient?: Resolver<Maybe<ResolversTypes['OAuthClientCreatedResponse']>, ParentType, ContextType, RequireFields<MutationCreateOauthClientArgs, 'input' | 'organisationId'>>;
  createOrganisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType, RequireFields<MutationCreateOrganisationArgs, 'input'>>;
  createOrganisationGroup?: Resolver<Maybe<ResolversTypes['OrganisationGroup']>, ParentType, ContextType, RequireFields<MutationCreateOrganisationGroupArgs, 'input' | 'organisationId'>>;
  createPaymentInstruction?: Resolver<Maybe<ResolversTypes['ACHPaymentInstructionResponse']>, ParentType, ContextType, RequireFields<MutationCreatePaymentInstructionArgs, 'clientId' | 'input'>>;
  createPaymentNetworkConfig?: Resolver<Maybe<ResolversTypes['PaymentNetworkConfigResponse']>, ParentType, ContextType, RequireFields<MutationCreatePaymentNetworkConfigArgs, 'input'>>;
  createPermission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType, RequireFields<MutationCreatePermissionArgs, 'input'>>;
  createPolicyGroup?: Resolver<Maybe<ResolversTypes['PolicyGroup']>, ParentType, ContextType, RequireFields<MutationCreatePolicyGroupArgs, 'input'>>;
  createPolicyV2?: Resolver<Maybe<ResolversTypes['PolicyV2']>, ParentType, ContextType, RequireFields<MutationCreatePolicyV2Args, 'input'>>;
  createService?: Resolver<Maybe<ResolversTypes['ServiceResponse']>, ParentType, ContextType, RequireFields<MutationCreateServiceArgs, 'input'>>;
  createSystemChannel?: Resolver<Maybe<ResolversTypes['SystemChannel']>, ParentType, ContextType, RequireFields<MutationCreateSystemChannelArgs, 'input'>>;
  createTransactionReasonCode?: Resolver<Maybe<ResolversTypes['TransactionReasonCode']>, ParentType, ContextType, RequireFields<MutationCreateTransactionReasonCodeArgs, 'input'>>;
  createTransactionWorkflow?: Resolver<Maybe<ResolversTypes['CreateTransactionResponse']>, ParentType, ContextType, RequireFields<MutationCreateTransactionWorkflowArgs, 'clientId' | 'input'>>;
  createUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input' | 'organisationId'>>;
  createWebhook?: Resolver<Maybe<ResolversTypes['WebhookResponse']>, ParentType, ContextType, RequireFields<MutationCreateWebhookArgs, 'input'>>;
  deactivateKey?: Resolver<Maybe<ResolversTypes['DeactivateKeyResponse']>, ParentType, ContextType, RequireFields<MutationDeactivateKeyArgs, 'input'>>;
  deleteAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<MutationDeleteAccountArgs, 'clientId' | 'input'>>;
  deleteAccountHolder?: Resolver<Maybe<ResolversTypes['AccountHolder']>, ParentType, ContextType, RequireFields<MutationDeleteAccountHolderArgs, 'clientId' | 'input'>>;
  deleteAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<MutationDeleteAddressArgs, 'clientId' | 'input'>>;
  deleteAddressV2?: Resolver<Maybe<ResolversTypes['AddressV2']>, ParentType, ContextType, RequireFields<MutationDeleteAddressV2Args, 'clientId' | 'input'>>;
  deleteCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationDeleteCompanyArgs, 'clientId' | 'companyId'>>;
  deleteCurrency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<MutationDeleteCurrencyArgs, 'id'>>;
  deleteFeatureFlag?: Resolver<Maybe<ResolversTypes['DeleteFeatureFlagResponse']>, ParentType, ContextType, RequireFields<MutationDeleteFeatureFlagArgs, 'flagName'>>;
  deleteGroup?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<MutationDeleteGroupArgs, 'PK'>>;
  deleteIdentityProvider?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationDeleteIdentityProviderArgs, 'idpId' | 'organisationId'>>;
  deleteOauthClient?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationDeleteOauthClientArgs, 'clientId' | 'organisationId'>>;
  deleteOrganisation?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationDeleteOrganisationArgs, 'organisationId'>>;
  deleteOrganisationGroup?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationDeleteOrganisationGroupArgs, 'groupId' | 'organisationId'>>;
  deletePaymentNetworkConfig?: Resolver<Maybe<ResolversTypes['PaymentNetworkConfigResponse']>, ParentType, ContextType, RequireFields<MutationDeletePaymentNetworkConfigArgs, 'PK'>>;
  deletePolicyGroup?: Resolver<Maybe<ResolversTypes['PolicyGroup']>, ParentType, ContextType, RequireFields<MutationDeletePolicyGroupArgs, 'id'>>;
  deletePolicyV2?: Resolver<Maybe<ResolversTypes['PolicyV2']>, ParentType, ContextType, RequireFields<MutationDeletePolicyV2Args, 'id'>>;
  deleteProductKeyLink?: Resolver<Maybe<ResolversTypes['DeleteProductKeyLinkResponse']>, ParentType, ContextType, RequireFields<MutationDeleteProductKeyLinkArgs, 'input'>>;
  deleteService?: Resolver<Maybe<ResolversTypes['ServiceResponse']>, ParentType, ContextType, RequireFields<MutationDeleteServiceArgs, 'PK'>>;
  deleteSystemChannel?: Resolver<Maybe<ResolversTypes['SystemChannel']>, ParentType, ContextType, RequireFields<MutationDeleteSystemChannelArgs, 'id'>>;
  deleteTransactionReasonCode?: Resolver<Maybe<ResolversTypes['TransactionReasonCode']>, ParentType, ContextType, RequireFields<MutationDeleteTransactionReasonCodeArgs, 'id'>>;
  deleteWebhookSubscription?: Resolver<Maybe<ResolversTypes['DeleteSubscriptionResponse']>, ParentType, ContextType, RequireFields<MutationDeleteWebhookSubscriptionArgs, 'eventCode' | 'webhookId'>>;
  ehiResend?: Resolver<Maybe<ResolversTypes['EhiResendResponse']>, ParentType, ContextType, RequireFields<MutationEhiResendArgs, 'transactionId'>>;
  evaluateFeatureFlags?: Resolver<Maybe<ResolversTypes['EvaluateFeatureFlagResponse']>, ParentType, ContextType, RequireFields<MutationEvaluateFeatureFlagsArgs, 'input'>>;
  exportAuditLogs?: Resolver<Maybe<ResolversTypes['AuditLogsExportResponse']>, ParentType, ContextType, RequireFields<MutationExportAuditLogsArgs, 'input'>>;
  exportKey?: Resolver<Maybe<ResolversTypes['ExportKeyResponse']>, ParentType, ContextType, RequireFields<MutationExportKeyArgs, 'input'>>;
  generateKey?: Resolver<Maybe<ResolversTypes['KeyResponse']>, ParentType, ContextType, RequireFields<MutationGenerateKeyArgs, 'input'>>;
  importKey?: Resolver<Maybe<ResolversTypes['KeyResponse']>, ParentType, ContextType, RequireFields<MutationImportKeyArgs, 'input'>>;
  linkKeyToProduct?: Resolver<Maybe<ResolversTypes['LinkKeyToProductResponse']>, ParentType, ContextType, RequireFields<MutationLinkKeyToProductArgs, 'input'>>;
  loadFunds?: Resolver<Maybe<ResolversTypes['CreateTransactionResponse']>, ParentType, ContextType, RequireFields<MutationLoadFundsArgs, 'clientId' | 'input'>>;
  loadUnloadCard?: Resolver<Maybe<ResolversTypes['LoadUnloadCardResponse']>, ParentType, ContextType, RequireFields<MutationLoadUnloadCardArgs, 'input'>>;
  mfaInitiate?: Resolver<Maybe<ResolversTypes['MFAResponse']>, ParentType, ContextType, RequireFields<MutationMfaInitiateArgs, 'input'>>;
  mfaVerify?: Resolver<Maybe<ResolversTypes['MFAResponse']>, ParentType, ContextType, RequireFields<MutationMfaVerifyArgs, 'input'>>;
  mfxBalanceAdjustment?: Resolver<Maybe<ResolversTypes['MfxCardTranResponse']>, ParentType, ContextType, RequireFields<MutationMfxBalanceAdjustmentArgs, 'input'>>;
  mfxBalanceTransfer?: Resolver<Maybe<ResolversTypes['WsBalanceTransferResponse']>, ParentType, ContextType, RequireFields<MutationMfxBalanceTransferArgs, 'input'>>;
  mfxLoadCard?: Resolver<Maybe<ResolversTypes['WsLoadCardResponse']>, ParentType, ContextType, RequireFields<MutationMfxLoadCardArgs, 'input'>>;
  mfxUnloadCard?: Resolver<Maybe<ResolversTypes['WsLoadCardResponse']>, ParentType, ContextType, RequireFields<MutationMfxUnloadCardArgs, 'input'>>;
  mfxWalletTransfer?: Resolver<Maybe<ResolversTypes['MfxCardWalletTrnsfrResponse']>, ParentType, ContextType, RequireFields<MutationMfxWalletTransferArgs, 'input'>>;
  performIdpHealthCheck?: Resolver<Maybe<ResolversTypes['IdpHealthCheckResponse']>, ParentType, ContextType, RequireFields<MutationPerformIdpHealthCheckArgs, 'idpId' | 'organisationId'>>;
  proxyRequest?: Resolver<Maybe<ResolversTypes['ProxyResponse']>, ParentType, ContextType, RequireFields<MutationProxyRequestArgs, 'input'>>;
  removePermissionFromGroup?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationRemovePermissionFromGroupArgs, 'groupId' | 'organisationId' | 'permissionId'>>;
  removeUserFromGroup?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationRemoveUserFromGroupArgs, 'groupId' | 'organisationId' | 'username'>>;
  removeUserFromOrganisation?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationRemoveUserFromOrganisationArgs, 'organisationId' | 'username'>>;
  resendNotifications?: Resolver<Maybe<ResolversTypes['ResendNotificationsResponse']>, ParentType, ContextType, RequireFields<MutationResendNotificationsArgs, 'input' | 'webhookId'>>;
  resendUserInvitation?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationResendUserInvitationArgs, 'organisationId' | 'username'>>;
  revokeApplicationCertificate?: Resolver<Maybe<ResolversTypes['CertificateMessageResponse']>, ParentType, ContextType, RequireFields<MutationRevokeApplicationCertificateArgs, 'applicationId' | 'input' | 'kid'>>;
  rotateOauthClientSecret?: Resolver<Maybe<ResolversTypes['RotateSecretResponse']>, ParentType, ContextType, RequireFields<MutationRotateOauthClientSecretArgs, 'clientId' | 'organisationId'>>;
  saveUserPmPreference?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationSaveUserPmPreferenceArgs, 'input'>>;
  sendFeatureRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendFeatureRequestArgs, 'input'>>;
  setExtendExpiryDate?: Resolver<Maybe<ResolversTypes['ExtendExpiryDateResponse']>, ParentType, ContextType, RequireFields<MutationSetExtendExpiryDateArgs, 'input'>>;
  splitKmsBinRange?: Resolver<Maybe<ResolversTypes['SplitKmsBinRangeResponse']>, ParentType, ContextType, RequireFields<MutationSplitKmsBinRangeArgs, 'input'>>;
  unblockCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnblockCardArgs, 'input' | 'publicToken'>>;
  unblockCvv?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnblockCvvArgs, 'input' | 'publicToken'>>;
  unblockOfflinePin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnblockOfflinePinArgs, 'input' | 'publicToken'>>;
  unblockOnlinePin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUnblockOnlinePinArgs, 'input' | 'publicToken'>>;
  unloadFunds?: Resolver<Maybe<ResolversTypes['CreateTransactionResponse']>, ParentType, ContextType, RequireFields<MutationUnloadFundsArgs, 'clientId' | 'input'>>;
  update3dsCredentialDetails?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdate3dsCredentialDetailsArgs, 'input' | 'publicToken'>>;
  updateAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<MutationUpdateAccountArgs, 'clientId' | 'input'>>;
  updateAccountHolder?: Resolver<Maybe<ResolversTypes['AccountHolder']>, ParentType, ContextType, RequireFields<MutationUpdateAccountHolderArgs, 'clientId' | 'input'>>;
  updateAccountWorkflow?: Resolver<Maybe<ResolversTypes['AccountV2']>, ParentType, ContextType, RequireFields<MutationUpdateAccountWorkflowArgs, 'clientId' | 'input'>>;
  updateAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<MutationUpdateAddressArgs, 'clientId' | 'input'>>;
  updateAddressV2Workflow?: Resolver<Maybe<ResolversTypes['AddressV2']>, ParentType, ContextType, RequireFields<MutationUpdateAddressV2WorkflowArgs, 'clientId' | 'input'>>;
  updateAddressWorkflow?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<MutationUpdateAddressWorkflowArgs, 'clientId' | 'input'>>;
  updateApplication?: Resolver<Maybe<ResolversTypes['ApplicationMessageResponse']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationArgs, 'applicationId' | 'input'>>;
  updateCard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateCardArgs, 'input'>>;
  updateChannel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType, RequireFields<MutationUpdateChannelArgs, 'id' | 'input'>>;
  updateClient?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<MutationUpdateClientArgs, 'id' | 'input'>>;
  updateCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyArgs, 'clientId' | 'input'>>;
  updateCompanyWorkflow?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyWorkflowArgs, 'clientId' | 'input'>>;
  updateCurrency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<MutationUpdateCurrencyArgs, 'id' | 'input'>>;
  updateCustomerWorkflow?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<MutationUpdateCustomerWorkflowArgs, 'clientId' | 'input'>>;
  updateFeatureFlag?: Resolver<Maybe<ResolversTypes['UpdateFeatureFlagResponse']>, ParentType, ContextType, RequireFields<MutationUpdateFeatureFlagArgs, 'input'>>;
  updateFinancialProduct?: Resolver<Maybe<ResolversTypes['FinancialProduct']>, ParentType, ContextType, RequireFields<MutationUpdateFinancialProductArgs, 'id' | 'input'>>;
  updateFinancialProductV2?: Resolver<Maybe<ResolversTypes['FinancialProduct']>, ParentType, ContextType, RequireFields<MutationUpdateFinancialProductV2Args, 'id' | 'input'>>;
  updateGroup?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<MutationUpdateGroupArgs, 'PK' | 'input'>>;
  updateGroupedServices?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<MutationUpdateGroupedServicesArgs, 'PK'>>;
  updateGroups?: Resolver<Maybe<ResolversTypes['ControlGroups']>, ParentType, ContextType, RequireFields<MutationUpdateGroupsArgs, 'input'>>;
  updateIdentityProvider?: Resolver<Maybe<ResolversTypes['IdentityProvider']>, ParentType, ContextType, RequireFields<MutationUpdateIdentityProviderArgs, 'idpId' | 'input' | 'organisationId'>>;
  updateInstrumentProduct?: Resolver<Maybe<ResolversTypes['InstrumentProduct']>, ParentType, ContextType, RequireFields<MutationUpdateInstrumentProductArgs, 'id' | 'input'>>;
  updateLedger?: Resolver<Maybe<ResolversTypes['Ledger']>, ParentType, ContextType, RequireFields<MutationUpdateLedgerArgs, 'clientId' | 'input'>>;
  updateLedgerConfiguration?: Resolver<Maybe<ResolversTypes['LedgerConfig']>, ParentType, ContextType, RequireFields<MutationUpdateLedgerConfigurationArgs, 'id' | 'input'>>;
  updateLedgerWorkflow?: Resolver<Maybe<ResolversTypes['LedgerV2']>, ParentType, ContextType, RequireFields<MutationUpdateLedgerWorkflowArgs, 'accountId' | 'clientId' | 'input' | 'ledgerId'>>;
  updateOauthClient?: Resolver<Maybe<ResolversTypes['OAuthClient']>, ParentType, ContextType, RequireFields<MutationUpdateOauthClientArgs, 'clientId' | 'input' | 'organisationId'>>;
  updateOrganisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType, RequireFields<MutationUpdateOrganisationArgs, 'input' | 'organisationId'>>;
  updateOrganisationGroup?: Resolver<Maybe<ResolversTypes['OrganisationGroup']>, ParentType, ContextType, RequireFields<MutationUpdateOrganisationGroupArgs, 'groupId' | 'input' | 'organisationId'>>;
  updatePaymentNetworkConfig?: Resolver<Maybe<ResolversTypes['PaymentNetworkConfigResponse']>, ParentType, ContextType, RequireFields<MutationUpdatePaymentNetworkConfigArgs, 'PK' | 'input'>>;
  updatePermission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType, RequireFields<MutationUpdatePermissionArgs, 'input' | 'permissionId'>>;
  updatePolicyGroup?: Resolver<Maybe<ResolversTypes['PolicyGroup']>, ParentType, ContextType, RequireFields<MutationUpdatePolicyGroupArgs, 'id' | 'input'>>;
  updatePolicyV2?: Resolver<Maybe<ResolversTypes['PolicyV2']>, ParentType, ContextType, RequireFields<MutationUpdatePolicyV2Args, 'id' | 'input'>>;
  updateService?: Resolver<Maybe<ResolversTypes['ServiceResponse']>, ParentType, ContextType, RequireFields<MutationUpdateServiceArgs, 'PK' | 'input'>>;
  updateSystemChannel?: Resolver<Maybe<ResolversTypes['SystemChannel']>, ParentType, ContextType, RequireFields<MutationUpdateSystemChannelArgs, 'id' | 'input'>>;
  updateTransactionReasonCode?: Resolver<Maybe<ResolversTypes['TransactionReasonCode']>, ParentType, ContextType, RequireFields<MutationUpdateTransactionReasonCodeArgs, 'id' | 'input'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input' | 'username'>>;
  updateUserStatus?: Resolver<Maybe<ResolversTypes['MessageResponse']>, ParentType, ContextType, RequireFields<MutationUpdateUserStatusArgs, 'input' | 'username'>>;
  updateVisaFileMaintenance?: Resolver<Maybe<ResolversTypes['VisaFileMaintenanceResponse']>, ParentType, ContextType, RequireFields<MutationUpdateVisaFileMaintenanceArgs, 'input' | 'publicToken'>>;
  updateWebhookDetails?: Resolver<Maybe<ResolversTypes['WebhookResponse']>, ParentType, ContextType, RequireFields<MutationUpdateWebhookDetailsArgs, 'input' | 'webhookId'>>;
  updateWebhookStatus?: Resolver<Maybe<ResolversTypes['WebhookResponse']>, ParentType, ContextType, RequireFields<MutationUpdateWebhookStatusArgs, 'input' | 'webhookId'>>;
};

export type NetworkSignOnParamsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetworkSignOnParamsResponse'] = ResolversParentTypes['NetworkSignOnParamsResponse']> = {
  discoverSignOnParams?: Resolver<Maybe<ResolversTypes['DiscoverSignOnParams']>, ParentType, ContextType>;
  mastercardSignOnParams?: Resolver<Maybe<ResolversTypes['DefaultMastercardSignOnParams']>, ParentType, ContextType>;
  mneSignOnParams?: Resolver<Maybe<ResolversTypes['MNESignOnParams']>, ParentType, ContextType>;
  visaSignOnParams?: Resolver<Maybe<ResolversTypes['VisaSignOnParams']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OAuthClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['OAuthClient'] = ResolversParentTypes['OAuthClient']> = {
  allowedGroupIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  allowedScopes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  applicationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cognitoClientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ipWhitelist?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSecretRotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pmId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usageNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OAuthClientCreatedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OAuthClientCreatedResponse'] = ResolversParentTypes['OAuthClientCreatedResponse']> = {
  allowedGroupIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  allowedScopes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  applicationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cognitoClientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  internalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ipWhitelist?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastSecretRotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pmId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usageNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OffsetLedgerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OffsetLedger'] = ResolversParentTypes['OffsetLedger']> = {
  channelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offsetLedgerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offsetLedgerType?: Resolver<Maybe<ResolversTypes['OffsetLedgerType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OidcConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['OidcConfig'] = ResolversParentTypes['OidcConfig']> = {
  authorizationEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discoveryUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jwksUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scopes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tokenEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userinfoEndpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrangeFlowReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrangeFlowReason'] = ResolversParentTypes['OrangeFlowReason']> = {
  meaning?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganisationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organisation'] = ResolversParentTypes['Organisation']> = {
  authProvider?: Resolver<ResolversTypes['AuthProvider'], ParentType, ContextType>;
  clientAuthMethod?: Resolver<ResolversTypes['ClientAuthMethod'], ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitoGroupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  connection?: Resolver<ResolversTypes['ConnectionType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailDomains?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  identityProviderConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  internalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  metadata?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pmInformation?: Resolver<Array<ResolversTypes['PMInformation']>, ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrganisationStatus'], ParentType, ContextType>;
  subClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganisationEmailDomainResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganisationEmailDomainResponse'] = ResolversParentTypes['OrganisationEmailDomainResponse']> = {
  authProvider?: Resolver<ResolversTypes['AuthProvider'], ParentType, ContextType>;
  emailDomains?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  identityProviderConfig?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganisationGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganisationGroup'] = ResolversParentTypes['OrganisationGroup']> = {
  cognitoGroupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PanResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PANResponse'] = ResolversParentTypes['PANResponse']> = {
  clearPan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panPubToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PmInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PMInformation'] = ResolversParentTypes['PMInformation']> = {
  pmCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pmId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosDataDecodedResolvers<ContextType = any, ParentType extends ResolversParentTypes['POSDataDecoded'] = ResolversParentTypes['POSDataDecoded']> = {
  additionalInformation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastDueAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PastDueAmount'] = ResolversParentTypes['PastDueAmount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pastDue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PastDueAmountV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PastDueAmountV2'] = ResolversParentTypes['PastDueAmountV2']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pastDue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentNetworkConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentNetworkConfigResponse'] = ResolversParentTypes['PaymentNetworkConfigResponse']> = {
  caCertificatePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificatePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hostIps?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  maintenanceMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['NetworkType'], ParentType, ContextType>;
  pk?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  privateKeyPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentTokenStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentTokenStatus'] = ResolversParentTypes['PaymentTokenStatus']> = {
  authorisationDecision?: Resolver<ResolversTypes['AuthorisationDecision'], ParentType, ContextType>;
  authorisationStatus?: Resolver<ResolversTypes['AuthorisationStatus'], ParentType, ContextType>;
  gpsStatusInfo?: Resolver<ResolversTypes['GpsStatusInfo'], ParentType, ContextType>;
  tokenisedStatus?: Resolver<ResolversTypes['TokenisationStatus'], ParentType, ContextType>;
  transactionStatus?: Resolver<ResolversTypes['TransStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentTokenStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentTokenStatusResponse'] = ResolversParentTypes['PaymentTokenStatusResponse']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentTokenUsageRuleDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentTokenUsageRuleDetail'] = ResolversParentTypes['PaymentTokenUsageRuleDetail']> = {
  defaultTicked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentTokenUsageRuleGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentTokenUsageRuleGroupResponse'] = ResolversParentTypes['PaymentTokenUsageRuleGroupResponse']> = {
  cardAcceptanceMethods?: Resolver<Array<ResolversTypes['PaymentTokenUsageRuleDetail']>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  misc?: Resolver<Array<ResolversTypes['PaymentTokenUsageRuleDetail']>, ParentType, ContextType>;
  transactionTypes?: Resolver<Array<ResolversTypes['PaymentTokenUsageRuleDetail']>, ParentType, ContextType>;
  verificationChecks?: Resolver<Array<ResolversTypes['PaymentTokenUsageRuleDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Permission'] = ResolversParentTypes['Permission']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dependencies?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  riskLevel?: Resolver<ResolversTypes['PermissionRiskLevel'], ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumber'] = ResolversParentTypes['PhoneNumber']> = {
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneNumbersResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumbers'] = ResolversParentTypes['PhoneNumbers']> = {
  home?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryContact?: Resolver<Maybe<ResolversTypes['PhoneContactPriority']>, ParentType, ContextType>;
  secondaryContact?: Resolver<Maybe<ResolversTypes['PhoneContactPriority']>, ParentType, ContextType>;
  work?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PingWebhookDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PingWebhookDetailResponse'] = ResolversParentTypes['PingWebhookDetailResponse']> = {
  healthStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyConfiguration'] = ResolversParentTypes['PolicyConfiguration']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isChangeable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nullable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  valueType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyGroup'] = ResolversParentTypes['PolicyGroup']> = {
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  financialProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  policies?: Resolver<Maybe<Array<ResolversTypes['PolicyConfiguration']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PolicyStatus']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PolicyV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['PolicyV2'] = ResolversParentTypes['PolicyV2']> = {
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isChangeable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nullable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortalTransactionsCollectionSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortalTransactionsCollectionSegment'] = ResolversParentTypes['PortalTransactionsCollectionSegment']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['GetTransactionsResponse']>>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['CollectionSegmentInfo']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosResolvers<ContextType = any, ParentType extends ResolversParentTypes['Pos'] = ResolversParentTypes['Pos']> = {
  acquirerExemptScaIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticationAmountAndCurrencyComparisonResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardDeviceFormFactor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardPresent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationEntity1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationEntity2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationEntity3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationEntity4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationMethod1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationMethod2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationMethod3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthenticationMethod4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderPresent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chipFallback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extendedAuthorizationIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fraudIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instantFundingNetwork?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instantFundingThredd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantCardholderInitiatedIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantInitiatedTransactionTypeIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalTransactionScaAssessmentResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalTransactionScaExemptIndicator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalTransactionStatusValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaAssessment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaBiometricTest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaExempt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaKnowledgeTest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaPossessionTest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure3DAuthenticationMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityCardholderToMerchant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threddDetectedScaExemption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosCapabilitiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PosCapabilities'] = ResolversParentTypes['PosCapabilities']> = {
  attended?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardCapture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardInput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardOutput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardholderAuthentication?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  environment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partialApproval?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pinCapture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchaseAmountOnlyApproval?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terminalOutput?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terminalType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PosEntry'] = ResolversParentTypes['PosEntry']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  codeDescription?: Resolver<Maybe<Array<ResolversTypes['CodeDescription']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosSubLimitsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PosSubLimitsResult'] = ResolversParentTypes['PosSubLimitsResult']> = {
  accumulatedFrequencyLimit1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accumulatedFrequencyLimit2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accumulatedPeriod1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accumulatedPeriod2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accumulatedValueLimit1?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  accumulatedValueLimit2?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  dailyFrequencyLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dailyValueLimit?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  maxPerTransaction?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  minPerTransaction?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  posLimitDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessingCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessingCode'] = ResolversParentTypes['ProcessingCode']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductLimitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductLimits'] = ResolversParentTypes['ProductLimits']> = {
  accumFrequency1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accumFrequency2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accumLimit1?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  accumLimit2?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  accumPeriod1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  accumPeriod2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dailyFrequency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dailyLimit?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  maximumPerTransaction?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  minimumPerTransaction?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductResponse'] = ResolversParentTypes['ProductResponse']> = {
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rangeHighLimit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rangeLowLimit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProgramManagerProductBasicResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProgramManagerProductBasic'] = ResolversParentTypes['ProgramManagerProductBasic']> = {
  accountCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ehiMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProxyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProxyResponse'] = ResolversParentTypes['ProxyResponse']> = {
  body?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  headers?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  requestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicTokenCardHistoryCollectionSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicTokenCardHistoryCollectionSegment'] = ResolversParentTypes['PublicTokenCardHistoryCollectionSegment']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['CardHistoryResponse']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CollectionSegmentInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicTokenCardStatusHistoryCollectionSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicTokenCardStatusHistoryCollectionSegment'] = ResolversParentTypes['PublicTokenCardStatusHistoryCollectionSegment']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['HistoryResponse']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CollectionSegmentInfo'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicTokenMetaHistoryCollectionSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicTokenMetaHistoryCollectionSegment'] = ResolversParentTypes['PublicTokenMetaHistoryCollectionSegment']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['CardMetaHistoryResponse']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CollectionSegmentInfo'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _dsCredentialsList?: Resolver<Maybe<Array<ResolversTypes['CredentialResponse']>>, ParentType, ContextType, RequireFields<Query_DsCredentialsListArgs, 'publicToken'>>;
  _dsVersionAndSupplier?: Resolver<Maybe<ResolversTypes['SupplierAndVersionResponse']>, ParentType, ContextType, RequireFields<Query_DsVersionAndSupplierArgs, 'publicToken'>>;
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType, RequireFields<QueryAccountArgs, 'accountId' | 'clientId'>>;
  accountHolder?: Resolver<Maybe<ResolversTypes['AccountHolder']>, ParentType, ContextType, RequireFields<QueryAccountHolderArgs, 'accountHolderId' | 'clientId'>>;
  accountHolderWorkflow?: Resolver<Maybe<ResolversTypes['AccountHolder']>, ParentType, ContextType, RequireFields<QueryAccountHolderWorkflowArgs, 'accountHolderId' | 'clientId'>>;
  accounts?: Resolver<Maybe<ResolversTypes['ListAccountsResponse']>, ParentType, ContextType, RequireFields<QueryAccountsArgs, 'clientId' | 'input'>>;
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType, RequireFields<QueryAddressArgs, 'clientId' | 'id'>>;
  addressV2?: Resolver<Maybe<ResolversTypes['AddressV2']>, ParentType, ContextType, RequireFields<QueryAddressV2Args, 'addressId' | 'clientId'>>;
  allCardActionUsers?: Resolver<Maybe<Array<ResolversTypes['CardActionUsers']>>, ParentType, ContextType>;
  allCardActions?: Resolver<Maybe<Array<ResolversTypes['CardActions']>>, ParentType, ContextType>;
  allCardStatuses?: Resolver<Maybe<Array<ResolversTypes['CardStatus']>>, ParentType, ContextType>;
  allCountries?: Resolver<Maybe<Array<ResolversTypes['Country']>>, ParentType, ContextType>;
  allCurrencyCodes?: Resolver<Maybe<Array<ResolversTypes['CurrencyCode']>>, ParentType, ContextType>;
  allFeatureFlags?: Resolver<Maybe<ResolversTypes['FlagsResponse']>, ParentType, ContextType, RequireFields<QueryAllFeatureFlagsArgs, 'betaTester' | 'clientId' | 'clientType' | 'filterFlags' | 'region' | 'userType'>>;
  allProcessingCodes?: Resolver<Maybe<Array<ResolversTypes['ProcessingCode']>>, ParentType, ContextType>;
  allRegions?: Resolver<Maybe<Array<ResolversTypes['Regions']>>, ParentType, ContextType>;
  allTransactionStatus?: Resolver<Maybe<Array<ResolversTypes['TransactionStatus']>>, ParentType, ContextType>;
  allTransactionTypes?: Resolver<Maybe<Array<ResolversTypes['TransactionType']>>, ParentType, ContextType>;
  auditLogLookups?: Resolver<Maybe<ResolversTypes['AuditLogLookupTableResponse']>, ParentType, ContextType, RequireFields<QueryAuditLogLookupsArgs, 'field'>>;
  auditLogs?: Resolver<Maybe<ResolversTypes['AuditLogsResponse']>, ParentType, ContextType, RequireFields<QueryAuditLogsArgs, 'companyId' | 'correlationId' | 'email' | 'endTime' | 'lastEvaluatedKey' | 'limit' | 'region' | 'section' | 'startTime' | 'user'>>;
  authorisors?: Resolver<Maybe<Array<ResolversTypes['Authorisor']>>, ParentType, ContextType>;
  binRange?: Resolver<Maybe<ResolversTypes['BinRange']>, ParentType, ContextType, RequireFields<QueryBinRangeArgs, 'id'>>;
  binRangeList?: Resolver<Maybe<Array<ResolversTypes['BinRange']>>, ParentType, ContextType, RequireFields<QueryBinRangeListArgs, 'input'>>;
  cardAcceptorAllowDisallowList?: Resolver<Maybe<ResolversTypes['CardAcceptorsResponse']>, ParentType, ContextType, RequireFields<QueryCardAcceptorAllowDisallowListArgs, 'publicToken'>>;
  cardByPublicToken?: Resolver<Maybe<ResolversTypes['GetCardResponse']>, ParentType, ContextType, RequireFields<QueryCardByPublicTokenArgs, 'publicToken'>>;
  cardCvvStatus?: Resolver<Maybe<ResolversTypes['CardPinStatusResponse']>, ParentType, ContextType, RequireFields<QueryCardCvvStatusArgs, 'publicToken'>>;
  cardFees?: Resolver<Maybe<ResolversTypes['CardFeeResponse']>, ParentType, ContextType, RequireFields<QueryCardFeesArgs, 'publicToken'>>;
  cardGroupLimitDetails?: Resolver<Maybe<ResolversTypes['GetCardGroupLimitDetailResponse']>, ParentType, ContextType, RequireFields<QueryCardGroupLimitDetailsArgs, 'publicToken'>>;
  cardImageByPublicToken?: Resolver<Maybe<ResolversTypes['GetCardImageResponse']>, ParentType, ContextType, RequireFields<QueryCardImageByPublicTokenArgs, 'publicToken'>>;
  cardLimitDetails?: Resolver<Maybe<ResolversTypes['GetCardLimitResponse']>, ParentType, ContextType, RequireFields<QueryCardLimitDetailsArgs, 'publicToken'>>;
  cardNetworkType?: Resolver<Maybe<Array<ResolversTypes['CardNetworkType']>>, ParentType, ContextType>;
  cardOnlinePinStatus?: Resolver<Maybe<ResolversTypes['CardPinStatusResponse']>, ParentType, ContextType, RequireFields<QueryCardOnlinePinStatusArgs, 'publicToken'>>;
  cardPaymentTokenDevices?: Resolver<Maybe<Array<ResolversTypes['GetCardPaymentTokenDevicesResponse']>>, ParentType, ContextType, RequireFields<QueryCardPaymentTokenDevicesArgs, 'paymentTokenId' | 'tokenId'>>;
  cardPaymentTokenList?: Resolver<Maybe<Array<ResolversTypes['GetCardPaymentTokenDetailsResponse']>>, ParentType, ContextType, RequireFields<QueryCardPaymentTokenListArgs, 'publicToken'>>;
  cardPosSubLimits?: Resolver<Maybe<ResolversTypes['CardPosSubLimitsResponse']>, ParentType, ContextType, RequireFields<QueryCardPosSubLimitsArgs, 'publicToken'>>;
  cardSpendLimitDetailsByProduct?: Resolver<Maybe<ResolversTypes['CardSpendLimitByProductResponse']>, ParentType, ContextType, RequireFields<QueryCardSpendLimitDetailsByProductArgs, 'input'>>;
  cardStatus?: Resolver<Maybe<ResolversTypes['CardStatusResponse']>, ParentType, ContextType, RequireFields<QueryCardStatusArgs, 'publicToken'>>;
  cardType?: Resolver<Maybe<Array<ResolversTypes['MFXCardType']>>, ParentType, ContextType>;
  cardsAcceptorList?: Resolver<Maybe<Array<ResolversTypes['CardAcceptorDetailResponseWithResolver']>>, ParentType, ContextType, RequireFields<QueryCardsAcceptorListArgs, 'publicToken'>>;
  cardsDisallowList?: Resolver<Maybe<Array<ResolversTypes['CardAcceptorDetailResponseWithResolver']>>, ParentType, ContextType, RequireFields<QueryCardsDisallowListArgs, 'publicToken'>>;
  channel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType, RequireFields<QueryChannelArgs, 'id'>>;
  channelList?: Resolver<Maybe<Array<ResolversTypes['Channel']>>, ParentType, ContextType, RequireFields<QueryChannelListArgs, 'input'>>;
  clientSpacesList?: Resolver<Maybe<Array<ResolversTypes['ClientSpace']>>, ParentType, ContextType>;
  companies?: Resolver<Maybe<ResolversTypes['ListCompaniesResponse']>, ParentType, ContextType, RequireFields<QueryCompaniesArgs, 'clientId' | 'input'>>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<QueryCompanyArgs, 'clientId' | 'companyId'>>;
  connectionServiceLatestBuildNumber?: Resolver<Maybe<ResolversTypes['ConnectionServiceLatestBuildNumber']>, ParentType, ContextType>;
  countryCurrencyCodeList?: Resolver<Maybe<Array<ResolversTypes['CountryCurrencyCode']>>, ParentType, ContextType, RequireFields<QueryCountryCurrencyCodeListArgs, 'input'>>;
  currencyByCode?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<QueryCurrencyByCodeArgs, 'code'>>;
  currencyById?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType, RequireFields<QueryCurrencyByIdArgs, 'id'>>;
  currencyConversionRates?: Resolver<Maybe<ResolversTypes['CurConRateResponse']>, ParentType, ContextType, RequireFields<QueryCurrencyConversionRatesArgs, 'input'>>;
  currencyList?: Resolver<Maybe<Array<ResolversTypes['Currency']>>, ParentType, ContextType>;
  customerWorkflow?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<QueryCustomerWorkflowArgs, 'clientId' | 'customerId'>>;
  decodeDe055?: Resolver<Maybe<Array<ResolversTypes['IccDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodeDe055Args, 'iccData' | 'networkId'>>;
  decodeDe055ForPresentment?: Resolver<Maybe<Array<ResolversTypes['IccDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodeDe055ForPresentmentArgs, 'iccData' | 'networkId'>>;
  decodingCVR?: Resolver<Maybe<Array<ResolversTypes['CVRDecodedResponse']>>, ParentType, ContextType, RequireFields<QueryDecodingCvrArgs, 'cvrData' | 'networkId'>>;
  decodingDE022?: Resolver<Maybe<Array<ResolversTypes['POSDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingDe022Args, 'networkId' | 'transactionTypeDescription'>>;
  decodingDE025?: Resolver<Maybe<ResolversTypes['POSDataDecoded']>, ParentType, ContextType, RequireFields<QueryDecodingDe025Args, 'input'>>;
  decodingDE048?: Resolver<Maybe<ResolversTypes['AdditionalDataDecodResponse']>, ParentType, ContextType, RequireFields<QueryDecodingDe048Args, 'de048' | 'transactionType'>>;
  decodingDE061?: Resolver<Maybe<Array<ResolversTypes['POSDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingDe061Args, 'input' | 'networkId'>>;
  decodingDE063?: Resolver<Maybe<Array<ResolversTypes['POSDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingDe063Args, 'input'>>;
  decodingDE60?: Resolver<Maybe<Array<ResolversTypes['POSDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingDe60Args, 'input'>>;
  decodingOrangeFlow?: Resolver<Maybe<Array<ResolversTypes['OrangeFlowReason']>>, ParentType, ContextType, RequireFields<QueryDecodingOrangeFlowArgs, 'input'>>;
  decodingPDS0043?: Resolver<Maybe<ResolversTypes['AdditionalDataDecoded']>, ParentType, ContextType, RequireFields<QueryDecodingPds0043Args, 'input'>>;
  decodingPDS0146?: Resolver<Maybe<Array<ResolversTypes['AdditionalDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingPds0146Args, 'input' | 'networkId'>>;
  decodingPDS0158?: Resolver<Maybe<Array<ResolversTypes['AdditionalDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingPds0158Args, 'input'>>;
  decodingPDS0159?: Resolver<Maybe<Array<ResolversTypes['AdditionalDataDecoded']>>, ParentType, ContextType, RequireFields<QueryDecodingPds0159Args, 'input'>>;
  dummyAccount?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>;
  ehiAcknowledgement?: Resolver<Maybe<ResolversTypes['EhiAcknowledgementResponse']>, ParentType, ContextType, RequireFields<QueryEhiAcknowledgementArgs, 'transactionId'>>;
  financialProduct?: Resolver<Maybe<ResolversTypes['FinancialProduct']>, ParentType, ContextType, RequireFields<QueryFinancialProductArgs, 'clientId' | 'id'>>;
  financialProductList?: Resolver<Maybe<Array<ResolversTypes['FinancialProduct']>>, ParentType, ContextType, RequireFields<QueryFinancialProductListArgs, 'input'>>;
  flaggingHealthCheck?: Resolver<Maybe<ResolversTypes['HealthCheckFlagging']>, ParentType, ContextType>;
  getAccount?: Resolver<Maybe<ResolversTypes['AccountV2']>, ParentType, ContextType, RequireFields<QueryGetAccountArgs, 'accountId' | 'clientId'>>;
  getApplication?: Resolver<Maybe<ResolversTypes['ApplicationResponse']>, ParentType, ContextType, RequireFields<QueryGetApplicationArgs, 'applicationId'>>;
  getApplicationCertificatePem?: Resolver<Maybe<ResolversTypes['GetApplicationCertificatePemResponse']>, ParentType, ContextType, RequireFields<QueryGetApplicationCertificatePemArgs, 'applicationId' | 'kid'>>;
  getExchangedToken?: Resolver<Maybe<ResolversTypes['ExchangedTokenResponse']>, ParentType, ContextType>;
  getGroupCalendarDetails?: Resolver<Maybe<ResolversTypes['CalendarGroupResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupCalendarDetailsArgs, 'publicToken'>>;
  getGroupFxDetails?: Resolver<Maybe<ResolversTypes['FxGroupResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupFxDetailsArgs, 'publicToken'>>;
  getGroupLimitedNetworkDetails?: Resolver<Maybe<ResolversTypes['LimitedNetworkGroupResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupLimitedNetworkDetailsArgs, 'publicToken'>>;
  getGroupLinkageDetails?: Resolver<Maybe<ResolversTypes['LinkageGroupResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupLinkageDetailsArgs, 'publicToken'>>;
  getKeyByKeyId?: Resolver<Maybe<ResolversTypes['GetKeyByKeyIdResponse']>, ParentType, ContextType, RequireFields<QueryGetKeyByKeyIdArgs, 'keyId'>>;
  getKeys?: Resolver<Maybe<ResolversTypes['ListKeysResponse']>, ParentType, ContextType, RequireFields<QueryGetKeysArgs, 'checkValue' | 'keyReference' | 'keyType' | 'pageSize' | 'pageToken'>>;
  getKeysByProductId?: Resolver<Maybe<Array<ResolversTypes['KeyResponse']>>, ParentType, ContextType, RequireFields<QueryGetKeysByProductIdArgs, 'productId'>>;
  getLedger?: Resolver<Maybe<ResolversTypes['LedgerV2']>, ParentType, ContextType, RequireFields<QueryGetLedgerArgs, 'accountId' | 'clientId' | 'ledgerId'>>;
  getLedgerById?: Resolver<Maybe<ResolversTypes['Ledger']>, ParentType, ContextType, RequireFields<QueryGetLedgerByIdArgs, 'clientId' | 'ledgerId'>>;
  getLedgerOffsetPosition?: Resolver<Maybe<ResolversTypes['GetLedgerOffsetPositionResponse']>, ParentType, ContextType, RequireFields<QueryGetLedgerOffsetPositionArgs, 'input'>>;
  getOrganisationsByEmailDomain?: Resolver<Maybe<Array<ResolversTypes['OrganisationEmailDomainResponse']>>, ParentType, ContextType, RequireFields<QueryGetOrganisationsByEmailDomainArgs, 'emailDomain'>>;
  getParametersForImport?: Resolver<Maybe<ResolversTypes['ImportParametersResponse']>, ParentType, ContextType, RequireFields<QueryGetParametersForImportArgs, 'keyMaterialType' | 'wrappingKeyAlgorithm'>>;
  getPaymentInstruction?: Resolver<Maybe<ResolversTypes['ACHPaymentInstructionResponse']>, ParentType, ContextType, RequireFields<QueryGetPaymentInstructionArgs, 'clientId' | 'id'>>;
  getProducts?: Resolver<Maybe<ResolversTypes['ListProductsResponse']>, ParentType, ContextType, RequireFields<QueryGetProductsArgs, 'pageSize' | 'pageToken'>>;
  getProductsByKey?: Resolver<Maybe<Array<ResolversTypes['ProductResponse']>>, ParentType, ContextType, RequireFields<QueryGetProductsByKeyArgs, 'keyId'>>;
  getTrustChain?: Resolver<Maybe<ResolversTypes['TrustChainResponse']>, ParentType, ContextType, RequireFields<QueryGetTrustChainArgs, 'caType'>>;
  getWebhookDetails?: Resolver<Maybe<ResolversTypes['WebhookDetailsResponse']>, ParentType, ContextType, RequireFields<QueryGetWebhookDetailsArgs, 'webhookId'>>;
  group?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<QueryGroupArgs, 'PK'>>;
  groupPermissions?: Resolver<Maybe<ResolversTypes['GroupPermissionsResponse']>, ParentType, ContextType, RequireFields<QueryGroupPermissionsArgs, 'groupId' | 'organisationId'>>;
  groupUsers?: Resolver<Maybe<ResolversTypes['UserListResponse']>, ParentType, ContextType, RequireFields<QueryGroupUsersArgs, 'groupId' | 'organisationId'>>;
  groups?: Resolver<Maybe<Array<ResolversTypes['GroupsResponse']>>, ParentType, ContextType, RequireFields<QueryGroupsArgs, 'productId'>>;
  healthcheck?: Resolver<Maybe<ResolversTypes['HealthcheckResponse']>, ParentType, ContextType>;
  hmacSecret?: Resolver<Maybe<ResolversTypes['HmacSecretResponse']>, ParentType, ContextType, RequireFields<QueryHmacSecretArgs, 'organisationId'>>;
  hmacSecretRotate?: Resolver<Maybe<ResolversTypes['HmacSecretResponse']>, ParentType, ContextType, RequireFields<QueryHmacSecretRotateArgs, 'organisationId'>>;
  identityProvider?: Resolver<Maybe<ResolversTypes['IdentityProvider']>, ParentType, ContextType, RequireFields<QueryIdentityProviderArgs, 'idpId' | 'organisationId'>>;
  identityProviderSamlConfigurationData?: Resolver<Maybe<ResolversTypes['IdentityProviderSamlConfigData']>, ParentType, ContextType>;
  identityProviders?: Resolver<Maybe<ResolversTypes['ListIdentityProvidersResponse']>, ParentType, ContextType, RequireFields<QueryIdentityProvidersArgs, 'idpType' | 'limit' | 'organisationId' | 'status'>>;
  instrumentProduct?: Resolver<Maybe<ResolversTypes['InstrumentProduct']>, ParentType, ContextType, RequireFields<QueryInstrumentProductArgs, 'clientId' | 'id'>>;
  instrumentProductList?: Resolver<Maybe<Array<ResolversTypes['InstrumentProduct']>>, ParentType, ContextType, RequireFields<QueryInstrumentProductListArgs, 'input'>>;
  instrumentProductPolicies?: Resolver<Maybe<Array<ResolversTypes['PolicyConfiguration']>>, ParentType, ContextType, RequireFields<QueryInstrumentProductPoliciesArgs, 'id'>>;
  latestAppconfigDeploymentStatus?: Resolver<Maybe<ResolversTypes['DeploymentStatusResponse']>, ParentType, ContextType>;
  ledgerConfigurationList?: Resolver<Maybe<Array<ResolversTypes['LedgerConfig']>>, ParentType, ContextType, RequireFields<QueryLedgerConfigurationListArgs, 'input'>>;
  ledgerList?: Resolver<Maybe<ResolversTypes['ListLedgersResponse']>, ParentType, ContextType, RequireFields<QueryLedgerListArgs, 'clientId' | 'input'>>;
  ledgerPlaygroundBalance?: Resolver<Maybe<ResolversTypes['LedgerPlaygroundBalance']>, ParentType, ContextType, RequireFields<QueryLedgerPlaygroundBalanceArgs, 'clientId' | 'ledgerId'>>;
  ledgerPlaygroundBalanceList?: Resolver<Maybe<Array<ResolversTypes['LedgerPlaygroundBalance']>>, ParentType, ContextType, RequireFields<QueryLedgerPlaygroundBalanceListArgs, 'clientId' | 'sessionId'>>;
  ledgerPlaygroundTransaction?: Resolver<Maybe<ResolversTypes['LedgerPlaygroundTransaction']>, ParentType, ContextType, RequireFields<QueryLedgerPlaygroundTransactionArgs, 'clientId' | 'transactionId'>>;
  ledgerPlaygroundTransactionList?: Resolver<Maybe<Array<ResolversTypes['LedgerPlaygroundTransaction']>>, ParentType, ContextType, RequireFields<QueryLedgerPlaygroundTransactionListArgs, 'clientId' | 'ledgerId' | 'sessionId'>>;
  ledgers?: Resolver<Maybe<Array<ResolversTypes['LedgerV2']>>, ParentType, ContextType, RequireFields<QueryLedgersArgs, 'accountId' | 'clientId' | 'input'>>;
  listAccountHolders?: Resolver<Maybe<ResolversTypes['ListAccountHoldersResponse']>, ParentType, ContextType, RequireFields<QueryListAccountHoldersArgs, 'clientId' | 'input'>>;
  listAccounts?: Resolver<Maybe<Array<ResolversTypes['AccountV2']>>, ParentType, ContextType, RequireFields<QueryListAccountsArgs, 'clientId' | 'input'>>;
  listAddresses?: Resolver<Maybe<ResolversTypes['ListAddressesResponse']>, ParentType, ContextType, RequireFields<QueryListAddressesArgs, 'clientId' | 'input'>>;
  listAddressesV2?: Resolver<Maybe<ResolversTypes['ListAddressesResponseV2']>, ParentType, ContextType, RequireFields<QueryListAddressesV2Args, 'clientId' | 'input'>>;
  listApplicationCertificates?: Resolver<Maybe<ResolversTypes['ListApplicationCertificatesResponse']>, ParentType, ContextType, RequireFields<QueryListApplicationCertificatesArgs, 'applicationId'>>;
  listApplications?: Resolver<Maybe<ResolversTypes['ListApplicationsResponse']>, ParentType, ContextType, RequireFields<QueryListApplicationsArgs, 'organisationId'>>;
  listClients?: Resolver<Maybe<Array<ResolversTypes['Client']>>, ParentType, ContextType, RequireFields<QueryListClientsArgs, 'input'>>;
  listKmsBinRanges?: Resolver<Maybe<ResolversTypes['ListKmsBinRangesResponse']>, ParentType, ContextType, RequireFields<QueryListKmsBinRangesArgs, 'input'>>;
  listOrganisations?: Resolver<Maybe<ResolversTypes['ListOrganisationsResponse']>, ParentType, ContextType, RequireFields<QueryListOrganisationsArgs, 'limit'>>;
  listPaymentInstructions?: Resolver<Maybe<Array<ResolversTypes['ACHPaymentInstructionResponse']>>, ParentType, ContextType, RequireFields<QueryListPaymentInstructionsArgs, 'clientId' | 'input'>>;
  listTransactions?: Resolver<Maybe<ResolversTypes['ListTransactionsResponse']>, ParentType, ContextType, RequireFields<QueryListTransactionsArgs, 'clientId' | 'input'>>;
  listWebhookSubscriptions?: Resolver<Maybe<ResolversTypes['ListSubscriptionsResponse']>, ParentType, ContextType, RequireFields<QueryListWebhookSubscriptionsArgs, 'webhookId'>>;
  listWebhooks?: Resolver<Maybe<ResolversTypes['ListWebhooksResponse']>, ParentType, ContextType, RequireFields<QueryListWebhooksArgs, 'input'>>;
  loadSourceList?: Resolver<Maybe<ResolversTypes['GetLoadSourceResponse']>, ParentType, ContextType, RequireFields<QueryLoadSourceListArgs, 'publicToken'>>;
  mccList?: Resolver<Maybe<ResolversTypes['GetCardMCCResponse']>, ParentType, ContextType, RequireFields<QueryMccListArgs, 'publicToken'>>;
  merchantCategoryCodeList?: Resolver<Maybe<Array<ResolversTypes['MerchantCategoryCode']>>, ParentType, ContextType, RequireFields<QueryMerchantCategoryCodeListArgs, 'input'>>;
  oauthClient?: Resolver<Maybe<ResolversTypes['GetOauthClientResponse']>, ParentType, ContextType, RequireFields<QueryOauthClientArgs, 'clientId' | 'organisationId'>>;
  oauthClients?: Resolver<Maybe<ResolversTypes['ListOAuthClientsResponse']>, ParentType, ContextType, RequireFields<QueryOauthClientsArgs, 'applicationId' | 'limit' | 'nextKey' | 'organisationId'>>;
  offsetLedgerList?: Resolver<Maybe<Array<ResolversTypes['OffsetLedger']>>, ParentType, ContextType, RequireFields<QueryOffsetLedgerListArgs, 'input'>>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType, RequireFields<QueryOrganisationArgs, 'organisationId'>>;
  organisationBySlug?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType, RequireFields<QueryOrganisationBySlugArgs, 'slug'>>;
  organisationGroup?: Resolver<Maybe<ResolversTypes['OrganisationGroup']>, ParentType, ContextType, RequireFields<QueryOrganisationGroupArgs, 'groupId' | 'organisationId'>>;
  organisationGroups?: Resolver<Maybe<ResolversTypes['ListOrganisationGroupsResponse']>, ParentType, ContextType, RequireFields<QueryOrganisationGroupsArgs, 'limit' | 'organisationId'>>;
  organisationUsers?: Resolver<Maybe<ResolversTypes['UserListResponse']>, ParentType, ContextType, RequireFields<QueryOrganisationUsersArgs, 'organisationId'>>;
  panToken?: Resolver<Maybe<ResolversTypes['PANResponse']>, ParentType, ContextType, RequireFields<QueryPanTokenArgs, 'request'>>;
  paymentNetworkConfig?: Resolver<Maybe<ResolversTypes['PaymentNetworkConfigResponse']>, ParentType, ContextType, RequireFields<QueryPaymentNetworkConfigArgs, 'PK'>>;
  paymentNetworkConfigList?: Resolver<Maybe<Array<ResolversTypes['PaymentNetworkConfigResponse']>>, ParentType, ContextType>;
  paymentTokenUsageGroupDetails?: Resolver<Maybe<ResolversTypes['GetPaymentTokenUsageGroupDetailsResponse']>, ParentType, ContextType, RequireFields<QueryPaymentTokenUsageGroupDetailsArgs, 'groupId' | 'publicToken' | 'tokenId'>>;
  paymentTokenUsageRules?: Resolver<Maybe<ResolversTypes['PaymentTokenUsageRuleGroupResponse']>, ParentType, ContextType, RequireFields<QueryPaymentTokenUsageRulesArgs, 'publicToken' | 'tokenId'>>;
  permission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType, RequireFields<QueryPermissionArgs, 'permissionId'>>;
  permissions?: Resolver<Maybe<ResolversTypes['ListPermissionsResponse']>, ParentType, ContextType, RequireFields<QueryPermissionsArgs, 'activeOnly' | 'category' | 'limit' | 'riskLevel'>>;
  pingWebhook?: Resolver<Maybe<ResolversTypes['GetPingWebhook']>, ParentType, ContextType, RequireFields<QueryPingWebhookArgs, 'webhookId'>>;
  policyGroup?: Resolver<Maybe<ResolversTypes['PolicyGroup']>, ParentType, ContextType, RequireFields<QueryPolicyGroupArgs, 'id'>>;
  policyGroupList?: Resolver<Maybe<Array<ResolversTypes['PolicyGroup']>>, ParentType, ContextType, RequireFields<QueryPolicyGroupListArgs, 'input'>>;
  policyV2?: Resolver<Maybe<ResolversTypes['PolicyV2']>, ParentType, ContextType, RequireFields<QueryPolicyV2Args, 'id'>>;
  policyV2List?: Resolver<Maybe<Array<ResolversTypes['PolicyV2']>>, ParentType, ContextType, RequireFields<QueryPolicyV2ListArgs, 'input'>>;
  portalTransactions?: Resolver<Maybe<ResolversTypes['PortalTransactionsCollectionSegment']>, ParentType, ContextType, RequireFields<QueryPortalTransactionsArgs, 'input' | 'skip' | 'take'>>;
  products?: Resolver<Maybe<Array<ResolversTypes['ProgramManagerProductBasic']>>, ParentType, ContextType>;
  publicTokenCardHistory?: Resolver<Maybe<ResolversTypes['PublicTokenCardHistoryCollectionSegment']>, ParentType, ContextType, RequireFields<QueryPublicTokenCardHistoryArgs, 'input'>>;
  publicTokenCardStatusHistory?: Resolver<Maybe<ResolversTypes['PublicTokenCardStatusHistoryCollectionSegment']>, ParentType, ContextType, RequireFields<QueryPublicTokenCardStatusHistoryArgs, 'input'>>;
  publicTokenMetaHistory?: Resolver<Maybe<ResolversTypes['PublicTokenMetaHistoryCollectionSegment']>, ParentType, ContextType, RequireFields<QueryPublicTokenMetaHistoryArgs, 'input'>>;
  searchCards?: Resolver<Maybe<ResolversTypes['SearchCardsCollectionSegment']>, ParentType, ContextType, RequireFields<QuerySearchCardsArgs, 'input'>>;
  service?: Resolver<Maybe<ResolversTypes['ServiceResponse']>, ParentType, ContextType, RequireFields<QueryServiceArgs, 'PK'>>;
  serviceGroups?: Resolver<Maybe<Array<ResolversTypes['GroupResponse']>>, ParentType, ContextType>;
  serviceSignOnParameters?: Resolver<Maybe<ResolversTypes['NetworkSignOnParamsResponse']>, ParentType, ContextType, RequireFields<QueryServiceSignOnParametersArgs, 'network'>>;
  services?: Resolver<Maybe<Array<ResolversTypes['ServiceResponse']>>, ParentType, ContextType>;
  singleCardPaymentTokenDetails?: Resolver<Maybe<ResolversTypes['GetCardPaymentTokenDetailsResponse']>, ParentType, ContextType, RequireFields<QuerySingleCardPaymentTokenDetailsArgs, 'publicToken' | 'tokenId'>>;
  singleFeatureFlags?: Resolver<Maybe<ResolversTypes['SingleFlagData']>, ParentType, ContextType, RequireFields<QuerySingleFeatureFlagsArgs, 'flagName'>>;
  singleTransaction?: Resolver<Maybe<ResolversTypes['GetSingleTransactionResponse']>, ParentType, ContextType, RequireFields<QuerySingleTransactionArgs, 'transactionId'>>;
  systemChannel?: Resolver<Maybe<ResolversTypes['SystemChannel']>, ParentType, ContextType, RequireFields<QuerySystemChannelArgs, 'id'>>;
  systemChannelList?: Resolver<Maybe<Array<ResolversTypes['SystemChannel']>>, ParentType, ContextType>;
  tokenCacheStats?: Resolver<Maybe<ResolversTypes['TokenCacheStats']>, ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryTransactionArgs, 'clientId' | 'id'>>;
  transactionReasonCode?: Resolver<Maybe<ResolversTypes['TransactionReasonCode']>, ParentType, ContextType, RequireFields<QueryTransactionReasonCodeArgs, 'id'>>;
  transactionReasonCodeList?: Resolver<Maybe<Array<ResolversTypes['TransactionReasonCode']>>, ParentType, ContextType, RequireFields<QueryTransactionReasonCodeListArgs, 'input'>>;
  transactions?: Resolver<Maybe<ResolversTypes['TransactionsCollectionSegment']>, ParentType, ContextType, RequireFields<QueryTransactionsArgs, 'input' | 'skip' | 'take'>>;
  transactionsDetails?: Resolver<Maybe<Array<ResolversTypes['TransactionDetailResponse']>>, ParentType, ContextType, RequireFields<QueryTransactionsDetailsArgs, 'traceIdLifeCycle'>>;
  undeliveredNotifications?: Resolver<Maybe<ResolversTypes['UndeliveredNotificationsResponse']>, ParentType, ContextType, RequireFields<QueryUndeliveredNotificationsArgs, 'fromDate' | 'webhookId'>>;
  usageGroupListDetails?: Resolver<Maybe<ResolversTypes['GetUsageGroupListDetailsResponse']>, ParentType, ContextType, RequireFields<QueryUsageGroupListDetailsArgs, 'publicToken'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'userId'>>;
  viewClient?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<QueryViewClientArgs, 'id'>>;
  walletDetails?: Resolver<Maybe<ResolversTypes['GetWalletResponse']>, ParentType, ContextType, RequireFields<QueryWalletDetailsArgs, 'publicToken'>>;
  webhookEvents?: Resolver<Maybe<ResolversTypes['WebhookEventsResponse']>, ParentType, ContextType>;
  workflowsNames?: Resolver<Maybe<ResolversTypes['WorkflowsNamesResponse']>, ParentType, ContextType>;
};

export type RecurringFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringFees'] = ResolversParentTypes['RecurringFees']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticFeeRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  feeAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  feeEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  frequencyPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lowActivityAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partialAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recurringFee?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  repeat?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  repeatPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Regions'] = ResolversParentTypes['Regions']> = {
  defaultRegion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  regionDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  regionId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  regionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendNotificationItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendNotificationItem'] = ResolversParentTypes['ResendNotificationItem']> = {
  notificationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resendStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendNotificationsInnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendNotificationsInnerResponse'] = ResolversParentTypes['ResendNotificationsInnerResponse']> = {
  content?: Resolver<Maybe<Array<ResolversTypes['ResendNotificationItem']>>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResendNotificationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendNotificationsResponse'] = ResolversParentTypes['ResendNotificationsResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['ResendNotificationsInnerResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RotateSecretResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RotateSecretResponse'] = ResolversParentTypes['RotateSecretResponse']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastSecretRotation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SamlConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['SamlConfig'] = ResolversParentTypes['SamlConfig']> = {
  entityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadataUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadataXml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameIdFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sloUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ssoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wantAssertionsSigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  wantResponseSigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  x509Certificate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchCardsCollectionSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchCardsCollectionSegment'] = ResolversParentTypes['SearchCardsCollectionSegment']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['CardsResponse']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CollectionSegmentInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceHealthCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceHealthCheck'] = ResolversParentTypes['ServiceHealthCheck']> = {
  checkType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceResponse'] = ResolversParentTypes['ServiceResponse']> = {
  authorisor?: Resolver<ResolversTypes['AuthorisorType'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discoverSignOnParams?: Resolver<Maybe<ResolversTypes['DiscoverSignOnParams']>, ParentType, ContextType>;
  groupAssigned?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType>;
  isUpdating?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  maintenanceMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mastercardSignOnParams?: Resolver<Maybe<ResolversTypes['MastercardSignOnParams']>, ParentType, ContextType>;
  mneSignOnParams?: Resolver<Maybe<ResolversTypes['MNESignOnParams']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['NetworkType'], ParentType, ContextType>;
  networkConfig?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkConfigName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pk?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  port?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tasks?: Resolver<Array<ResolversTypes['Task']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visaSignOnParams?: Resolver<Maybe<ResolversTypes['VisaSignOnParams']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleFlagDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleFlagData'] = ResolversParentTypes['SingleFlagData']> = {
  flagData?: Resolver<ResolversTypes['FlagData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SplitKmsBinRangeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SplitKmsBinRangeResponse'] = ResolversParentTypes['SplitKmsBinRangeResponse']> = {
  binRanges?: Resolver<Maybe<Array<ResolversTypes['KmsBinRangeResponse']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatusResponse'] = ResolversParentTypes['StatusResponse']> = {
  cardStatusCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CardStatusCode'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubcategoriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subcategories'] = ResolversParentTypes['Subcategories']> = {
  counters?: Resolver<Maybe<ResolversTypes['Counters']>, ParentType, ContextType>;
  limits?: Resolver<Maybe<ResolversTypes['ProductLimits']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierAndVersionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierAndVersionResponse'] = ResolversParentTypes['SupplierAndVersionResponse']> = {
  providerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SystemChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['SystemChannel'] = ResolversParentTypes['SystemChannel']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectionRule?: Resolver<Maybe<ResolversTypes['RejectionRule']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['SystemChannelSourceType']>, ParentType, ContextType>;
  transactionDescriptionText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = {
  buildNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hostIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isUpdating?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskMaintenanceMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uptime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenCacheStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenCacheStats'] = ResolversParentTypes['TokenCacheStats']> = {
  exchangedTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subjectTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TokenisationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['TokenisationStatus'] = ResolversParentTypes['TokenisationStatus']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransStatus'] = ResolversParentTypes['TransStatus']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['CapAsset']>, ParentType, ContextType>;
  authorisationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingAmount?: Resolver<Maybe<ResolversTypes['CapAsset']>, ParentType, ContextType>;
  cashbackAmount?: Resolver<Maybe<ResolversTypes['CapAsset']>, ParentType, ContextType>;
  channelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declineReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exchangeRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ledgerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalChannelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processingChannel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectionReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementAmount?: Resolver<Maybe<ResolversTypes['CapAsset']>, ParentType, ContextType>;
  sign?: Resolver<Maybe<ResolversTypes['Sign']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Status']>, ParentType, ContextType>;
  subClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionAmount?: Resolver<Maybe<ResolversTypes['CapAsset']>, ParentType, ContextType>;
  transactionReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionSubtype?: Resolver<Maybe<ResolversTypes['TransactionSubType']>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['TransactionTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionAmount'] = ResolversParentTypes['TransactionAmount']> = {
  actualBalance?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  availableBalance?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  billingCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCurrencyNumericCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingValue?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  billingValueWithDirection?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  blockedAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  settlementAmount?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  settlementCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionValue?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionDetailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionDetailResponse'] = ResolversParentTypes['TransactionDetailResponse']> = {
  acquirerReferenceData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  additionalAmounts?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  additionalData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  additionalResponseData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adviceReasonData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  aid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  authorisationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  avsPostcode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avsStreet?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billingAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  billingCurrency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  blockedAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  cardAcceptorIdentificationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardAcceptorNameLocation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardAcceptorTerminalIdentification?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateExpiry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fees?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  fid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gpsPosData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iccData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Merchant']>, ParentType, ContextType>;
  merchantCategoryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentTokenId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  posData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  posEntryMode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processingCode?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  pubToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  responseStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  retrievalReference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settlementAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  settlementCurrency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stan?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tillTime?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  traceIdLifeCycle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionAmount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  transactionCurrency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transactionFees?: Resolver<Maybe<ResolversTypes['TransactionFeesResponse']>, ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  transactionOriginatingInstitution?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionFees'] = ResolversParentTypes['TransactionFees']> = {
  fixedFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  fxPadding?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  mccPadding?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  rateFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionFeesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionFeesResponse'] = ResolversParentTypes['TransactionFeesResponse']> = {
  domesticFixedFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  domesticRateFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  fxFixedFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  fxRateFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  nonDomesticFixedFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  nonDomesticRateFee?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionReasonCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionReasonCode'] = ResolversParentTypes['TransactionReasonCode']> = {
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['TRCTransactionType']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionResponse'] = ResolversParentTypes['TransactionResponse']> = {
  amount?: Resolver<ResolversTypes['Decimal'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  publicToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionStatus'] = ResolversParentTypes['TransactionStatus']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionType'] = ResolversParentTypes['TransactionType']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionTypesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionTypes'] = ResolversParentTypes['TransactionTypes']> = {
  defaultTicked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionsCollectionSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionsCollectionSegment'] = ResolversParentTypes['TransactionsCollectionSegment']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['GetTransactionsResponse']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['CollectionSegmentInfo'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustChainResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustChain'] = ResolversParentTypes['TrustChain']> = {
  caArn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificateChain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notAfter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notBefore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrustChainResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrustChainResponse'] = ResolversParentTypes['TrustChainResponse']> = {
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trustChain?: Resolver<ResolversTypes['TrustChain'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TypeValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['TypeValue'] = ResolversParentTypes['TypeValue']> = {
  decodedData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decodedDataString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  encodedData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UndeliveredNotificationItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndeliveredNotificationItem'] = ResolversParentTypes['UndeliveredNotificationItem']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notificationIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UndeliveredNotificationsInnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndeliveredNotificationsInnerResponse'] = ResolversParentTypes['UndeliveredNotificationsInnerResponse']> = {
  content?: Resolver<Maybe<Array<ResolversTypes['UndeliveredNotificationItem']>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UndeliveredNotificationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndeliveredNotificationsResponse'] = ResolversParentTypes['UndeliveredNotificationsResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['UndeliveredNotificationsInnerResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFeatureFlagResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateFeatureFlagResponse'] = ResolversParentTypes['UpdateFeatureFlagResponse']> = {
  deploymentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  flagName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  familyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  givenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitationSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organisationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  temporaryPassword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  threddRoles?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserListResponse'] = ResolversParentTypes['UserListResponse']> = {
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationChecksResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationChecks'] = ResolversParentTypes['VerificationChecks']> = {
  defaultTicked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  groupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variableTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFileMaintenanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFileMaintenance'] = ResolversParentTypes['VisaFileMaintenance']> = {
  requestData?: Resolver<ResolversTypes['VisaFileRequest'], ParentType, ContextType>;
  responseData?: Resolver<ResolversTypes['VisaFileResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFileMaintenanceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFileMaintenanceResponse'] = ResolversParentTypes['VisaFileMaintenanceResponse']> = {
  visaFileData?: Resolver<Maybe<Array<ResolversTypes['VisaFileMaintenance']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFileRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFileRequest'] = ResolversParentTypes['VisaFileRequest']> = {
  fileUpdateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retrievalReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemTraceAuditNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transmissionDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFileResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFileResponse'] = ResolversParentTypes['VisaFileResponse']> = {
  fileUpdateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retrievalReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemTraceAuditNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transmissionDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFleetResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFleet'] = ResolversParentTypes['VisaFleet']> = {
  evData?: Resolver<Maybe<ResolversTypes['VisaFleetEvData']>, ParentType, ContextType>;
  fleetData?: Resolver<Maybe<ResolversTypes['VisaFleetFleetData']>, ParentType, ContextType>;
  invoiceLineItem?: Resolver<Maybe<Array<ResolversTypes['VisaFleetInvoiceLineItem']>>, ParentType, ContextType>;
  promptData?: Resolver<Maybe<ResolversTypes['VisaFleetPromptData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFleetEvDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFleetEvData'] = ResolversParentTypes['VisaFleetEvData']> = {
  carbonFootprint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chargingPowerOutputCapacity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chargingReasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectorType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimatedKmMilesAdded?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  estimatedKmMilesAvailable?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  finishTimeOfCharge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maximumPowerDispensed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTimeOfCharge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalChargingTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalTimePluggedIn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFleetFleetDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFleetFleetData'] = ResolversParentTypes['VisaFleetFleetData']> = {
  expandedFuelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossFuelPrice?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  grossNonFuelPrice?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  netFuelPrice?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  netNonFuelPrice?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  nonFuelProductCode1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonFuelProductCode8?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  serviceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeOfPurchase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitCost?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  unitOfMeasure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFleetInvoiceLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFleetInvoiceLineItem'] = ResolversParentTypes['VisaFleetInvoiceLineItem']> = {
  commodityCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountPerLineItem?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  itemDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemSequenceNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lineItemTotal?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  unitCost?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  unitOfMeasure?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vatRate?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  vatTaxAmount?: Resolver<Maybe<ResolversTypes['DecimalAsFloat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaFleetPromptDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaFleetPromptData'] = ResolversParentTypes['VisaFleetPromptData']> = {
  fleetEmployeeNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fleetTrailerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fleetWorkOrderNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  odometerReading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visaFleetServiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisaSignOnParamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisaSignOnParams'] = ResolversParentTypes['VisaSignOnParams']> = {
  batchNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  flags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headerFormat?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageStatusFlags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reserved?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roundTripControlInfo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textFormat?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalletDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalletDetails'] = ResolversParentTypes['WalletDetails']> = {
  balanceDetails?: Resolver<Maybe<ResolversTypes['BalanceResponse']>, ParentType, ContextType>;
  isMfxPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  publicToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebServiceGroupFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebServiceGroupFees'] = ResolversParentTypes['WebServiceGroupFees']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticFeeRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  group?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nonDomesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  partialAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  processingCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  smsFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebServiceProductFeesResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebServiceProductFees'] = ResolversParentTypes['WebServiceProductFees']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticFeeRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  domesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticMinimumFee?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  nonDomesticRate?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>;
  partialAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookConfigResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookConfigResponse'] = ResolversParentTypes['WebhookConfigResponse']> = {
  customHeaders?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookDetailsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookDetailsResponse'] = ResolversParentTypes['WebhookDetailsResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['WebhookDtlResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookDtlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookDtlResponse'] = ResolversParentTypes['WebhookDtlResponse']> = {
  config?: Resolver<Maybe<ResolversTypes['WebhookConfigResponse']>, ParentType, ContextType>;
  createdTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  lastModifiedTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookEventsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookEventsResponse'] = ResolversParentTypes['WebhookEventsResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookInnerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookInnerResponse'] = ResolversParentTypes['WebhookInnerResponse']> = {
  createdTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookItemResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookItemResponse'] = ResolversParentTypes['WebhookItemResponse']> = {
  config?: Resolver<Maybe<ResolversTypes['WebhookConfigResponse']>, ParentType, ContextType>;
  createdTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customHeaders?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  events?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  lastModifiedTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookListDataResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookListDataResponse'] = ResolversParentTypes['WebhookListDataResponse']> = {
  endpointsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['WebhookItemResponse']>, ParentType, ContextType>;
  pageNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WebhookResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebhookResponse'] = ResolversParentTypes['WebhookResponse']> = {
  response?: Resolver<Maybe<ResolversTypes['WebhookInnerResponse']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeekDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeekDay'] = ResolversParentTypes['WeekDay']> = {
  endTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weekDay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowsNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkflowsName'] = ResolversParentTypes['WorkflowsName']> = {
  workflowName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowsNamesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkflowsNamesResponse'] = ResolversParentTypes['WorkflowsNamesResponse']> = {
  workflowsNames?: Resolver<Array<ResolversTypes['WorkflowsName']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WsBalanceTransferResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WsBalanceTransferResponse'] = ResolversParentTypes['WsBalanceTransferResponse']> = {
  issCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sysDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WsLoadCardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['WsLoadCardResponse'] = ResolversParentTypes['WsLoadCardResponse']> = {
  actionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publicToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sysDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ACHAssetResponse?: AchAssetResponseResolvers<ContextType>;
  ACHMonetaryUnitResponse?: AchMonetaryUnitResponseResolvers<ContextType>;
  ACHOriginatorResponse?: AchOriginatorResponseResolvers<ContextType>;
  ACHPaymentInstruction?: AchPaymentInstructionResolvers<ContextType>;
  ACHPaymentInstructionResponse?: AchPaymentInstructionResponseResolvers<ContextType>;
  ACHRecipientResponse?: AchRecipientResponseResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  AccountHolder?: AccountHolderResolvers<ContextType>;
  AccountHolderCommercialDetails?: AccountHolderCommercialDetailsResolvers<ContextType>;
  AccountHolderDeceasedData?: AccountHolderDeceasedDataResolvers<ContextType>;
  AccountHolderRetailDetails?: AccountHolderRetailDetailsResolvers<ContextType>;
  AccountHolderSCRAData?: AccountHolderScraDataResolvers<ContextType>;
  AccountV2?: AccountV2Resolvers<ContextType>;
  ActivateKeyResponse?: ActivateKeyResponseResolvers<ContextType>;
  AddSubscriptionsInnerResponse?: AddSubscriptionsInnerResponseResolvers<ContextType>;
  AddSubscriptionsResponse?: AddSubscriptionsResponseResolvers<ContextType>;
  AdditionalAmount?: AdditionalAmountResolvers<ContextType>;
  AdditionalDataDecodResponse?: AdditionalDataDecodResponseResolvers<ContextType>;
  AdditionalDataDecodeMC?: AdditionalDataDecodeMcResolvers<ContextType>;
  AdditionalDataDecoded?: AdditionalDataDecodedResolvers<ContextType>;
  AdditionalDetail?: AdditionalDetailResolvers<ContextType>;
  AdditionalResponseData?: AdditionalResponseDataResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AddressV2?: AddressV2Resolvers<ContextType>;
  ApexAddress?: ApexAddressResolvers<ContextType>;
  ApplicationMessageResponse?: ApplicationMessageResponseResolvers<ContextType>;
  ApplicationResponse?: ApplicationResponseResolvers<ContextType>;
  AttributeMapping?: AttributeMappingResolvers<ContextType>;
  AuditFields?: AuditFieldsResolvers<ContextType>;
  AuditLog?: AuditLogResolvers<ContextType>;
  AuditLogFieldValuePair?: AuditLogFieldValuePairResolvers<ContextType>;
  AuditLogLookupTableResponse?: AuditLogLookupTableResponseResolvers<ContextType>;
  AuditLogsExportResponse?: AuditLogsExportResponseResolvers<ContextType>;
  AuditLogsResponse?: AuditLogsResponseResolvers<ContextType>;
  AuthFees?: AuthFeesResolvers<ContextType>;
  AuthReversalResponse?: AuthReversalResponseResolvers<ContextType>;
  AuthorisationDecision?: AuthorisationDecisionResolvers<ContextType>;
  AuthorisationStatus?: AuthorisationStatusResolvers<ContextType>;
  Authorisor?: AuthorisorResolvers<ContextType>;
  AvsCardResponse?: AvsCardResponseResolvers<ContextType>;
  BalanceResponse?: BalanceResponseResolvers<ContextType>;
  BinRange?: BinRangeResolvers<ContextType>;
  CLAddress?: ClAddressResolvers<ContextType>;
  CVRDecodedResponse?: CvrDecodedResponseResolvers<ContextType>;
  CalendarGroupResponse?: CalendarGroupResponseResolvers<ContextType>;
  CapAsset?: CapAssetResolvers<ContextType>;
  CapMonetaryUnit?: CapMonetaryUnitResolvers<ContextType>;
  CardAcceptanceMethods?: CardAcceptanceMethodsResolvers<ContextType>;
  CardAcceptorDetailResponse?: CardAcceptorDetailResponseResolvers<ContextType>;
  CardAcceptorDetailResponseWithResolver?: CardAcceptorDetailResponseWithResolverResolvers<ContextType>;
  CardAcceptorsResponse?: CardAcceptorsResponseResolvers<ContextType>;
  CardActionUsers?: CardActionUsersResolvers<ContextType>;
  CardActions?: CardActionsResolvers<ContextType>;
  CardDetails?: CardDetailsResolvers<ContextType>;
  CardFeeResponse?: CardFeeResponseResolvers<ContextType>;
  CardGroupLimits?: CardGroupLimitsResolvers<ContextType>;
  CardHistoryResponse?: CardHistoryResponseResolvers<ContextType>;
  CardHolder?: CardHolderResolvers<ContextType>;
  CardLimits?: CardLimitsResolvers<ContextType>;
  CardLimitsSub?: CardLimitsSubResolvers<ContextType>;
  CardLoadSourcesResponse?: CardLoadSourcesResponseResolvers<ContextType>;
  CardMccDetailResponse?: CardMccDetailResponseResolvers<ContextType>;
  CardMetaHistoryResponse?: CardMetaHistoryResponseResolvers<ContextType>;
  CardNetworkType?: CardNetworkTypeResolvers<ContextType>;
  CardPinStatusResponse?: CardPinStatusResponseResolvers<ContextType>;
  CardPosSubLimitsResponse?: CardPosSubLimitsResponseResolvers<ContextType>;
  CardProduct?: CardProductResolvers<ContextType>;
  CardSpendLimitByProductResponse?: CardSpendLimitByProductResponseResolvers<ContextType>;
  CardStatus?: CardStatusResolvers<ContextType>;
  CardStatusResponse?: CardStatusResponseResolvers<ContextType>;
  CardsResponse?: CardsResponseResolvers<ContextType>;
  Certificate?: CertificateResolvers<ContextType>;
  CertificateMessageResponse?: CertificateMessageResponseResolvers<ContextType>;
  Channel?: ChannelResolvers<ContextType>;
  ClearCacheResponse?: ClearCacheResponseResolvers<ContextType>;
  Client?: ClientResolvers<ContextType>;
  ClientSpace?: ClientSpaceResolvers<ContextType>;
  CodeDescription?: CodeDescriptionResolvers<ContextType>;
  CollectionSegmentInfo?: CollectionSegmentInfoResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  Component?: ComponentResolvers<ContextType>;
  ConnectionServiceLatestBuildNumber?: ConnectionServiceLatestBuildNumberResolvers<ContextType>;
  ControlGroups?: ControlGroupsResolvers<ContextType>;
  ControlGroupsSub?: ControlGroupsSubResolvers<ContextType>;
  Counters?: CountersResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  CountryCurrencyCode?: CountryCurrencyCodeResolvers<ContextType>;
  CreateFeatureFlagResponse?: CreateFeatureFlagResponseResolvers<ContextType>;
  CreateKmsBinRangeResponse?: CreateKmsBinRangeResponseResolvers<ContextType>;
  CreateLedgerPlaygroundBalanceResponse?: CreateLedgerPlaygroundBalanceResponseResolvers<ContextType>;
  CreateLedgerPlaygroundTransactionResponse?: CreateLedgerPlaygroundTransactionResponseResolvers<ContextType>;
  CreateTransactionResponse?: CreateTransactionResponseResolvers<ContextType>;
  CredentialConfigurationResponse?: CredentialConfigurationResponseResolvers<ContextType>;
  CredentialResponse?: CredentialResponseResolvers<ContextType>;
  CurConRateResponse?: CurConRateResponseResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  CurrencyCode?: CurrencyCodeResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  CustomerAddress?: CustomerAddressResolvers<ContextType>;
  CustomerPhoneNumbers?: CustomerPhoneNumbersResolvers<ContextType>;
  DateOfBirth?: DateOfBirthResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DeactivateKeyResponse?: DeactivateKeyResponseResolvers<ContextType>;
  Decimal?: GraphQLScalarType;
  DecimalAsFloat?: GraphQLScalarType;
  DefaultMastercardSignOnParams?: DefaultMastercardSignOnParamsResolvers<ContextType>;
  DeleteFeatureFlagResponse?: DeleteFeatureFlagResponseResolvers<ContextType>;
  DeleteProductKeyLinkResponse?: DeleteProductKeyLinkResponseResolvers<ContextType>;
  DeleteSubscriptionResponse?: DeleteSubscriptionResponseResolvers<ContextType>;
  DeploymentStatusResponse?: DeploymentStatusResponseResolvers<ContextType>;
  DiscoverSignOnParams?: DiscoverSignOnParamsResolvers<ContextType>;
  EhiAcknowledgementResponse?: EhiAcknowledgementResponseResolvers<ContextType>;
  EhiResendResponse?: EhiResendResponseResolvers<ContextType>;
  Email?: EmailResolvers<ContextType>;
  Emv?: EmvResolvers<ContextType>;
  EvaluateFeatureFlagResponse?: EvaluateFeatureFlagResponseResolvers<ContextType>;
  EventSubscriptionItem?: EventSubscriptionItemResolvers<ContextType>;
  ExchangedTokenResponse?: ExchangedTokenResponseResolvers<ContextType>;
  ExportKeyResponse?: ExportKeyResponseResolvers<ContextType>;
  ExtendExpiryDateResponse?: ExtendExpiryDateResponseResolvers<ContextType>;
  FeatureFlag?: FeatureFlagResolvers<ContextType>;
  FeatureFlagEntry?: FeatureFlagEntryResolvers<ContextType>;
  FeatureFlagMetadata?: FeatureFlagMetadataResolvers<ContextType>;
  FeatureFlagStatus?: FeatureFlagStatusResolvers<ContextType>;
  FinancialProduct?: FinancialProductResolvers<ContextType>;
  FlagData?: FlagDataResolvers<ContextType>;
  FlagsResponse?: FlagsResponseResolvers<ContextType>;
  FxGroupResponse?: FxGroupResponseResolvers<ContextType>;
  FxRates?: FxRatesResolvers<ContextType>;
  GetApplicationCertificatePemResponse?: GetApplicationCertificatePemResponseResolvers<ContextType>;
  GetCardGroupLimitDetailResponse?: GetCardGroupLimitDetailResponseResolvers<ContextType>;
  GetCardImageResponse?: GetCardImageResponseResolvers<ContextType>;
  GetCardLimitResponse?: GetCardLimitResponseResolvers<ContextType>;
  GetCardMCCResponse?: GetCardMccResponseResolvers<ContextType>;
  GetCardPaymentTokenDetailsResponse?: GetCardPaymentTokenDetailsResponseResolvers<ContextType>;
  GetCardPaymentTokenDevicesResponse?: GetCardPaymentTokenDevicesResponseResolvers<ContextType>;
  GetCardResponse?: GetCardResponseResolvers<ContextType>;
  GetKeyByKeyIdResponse?: GetKeyByKeyIdResponseResolvers<ContextType>;
  GetLedgerOffsetPositionResponse?: GetLedgerOffsetPositionResponseResolvers<ContextType>;
  GetLoadSourceResponse?: GetLoadSourceResponseResolvers<ContextType>;
  GetOauthClientResponse?: GetOauthClientResponseResolvers<ContextType>;
  GetPaymentTokenUsageGroupDetailsResponse?: GetPaymentTokenUsageGroupDetailsResponseResolvers<ContextType>;
  GetPingWebhook?: GetPingWebhookResolvers<ContextType>;
  GetSingleTransactionResponse?: GetSingleTransactionResponseResolvers<ContextType>;
  GetTransactionsResponse?: GetTransactionsResponseResolvers<ContextType>;
  GetUsageGroupListDetailsResponse?: GetUsageGroupListDetailsResponseResolvers<ContextType>;
  GetWalletResponse?: GetWalletResponseResolvers<ContextType>;
  GpsStatusInfo?: GpsStatusInfoResolvers<ContextType>;
  GroupDetails?: GroupDetailsResolvers<ContextType>;
  GroupPermissionsResponse?: GroupPermissionsResponseResolvers<ContextType>;
  GroupResponse?: GroupResponseResolvers<ContextType>;
  GroupsResponse?: GroupsResponseResolvers<ContextType>;
  HealthCheckFlagging?: HealthCheckFlaggingResolvers<ContextType>;
  HealthCheckSource?: HealthCheckSourceResolvers<ContextType>;
  HealthcheckResponse?: HealthcheckResponseResolvers<ContextType>;
  HistoryResponse?: HistoryResponseResolvers<ContextType>;
  HmacSecretResponse?: HmacSecretResponseResolvers<ContextType>;
  IccDataDecoded?: IccDataDecodedResolvers<ContextType>;
  IdentityProvider?: IdentityProviderResolvers<ContextType>;
  IdentityProviderSamlConfigData?: IdentityProviderSamlConfigDataResolvers<ContextType>;
  IdpHealthCheckResponse?: IdpHealthCheckResponseResolvers<ContextType>;
  ImportParametersResponse?: ImportParametersResponseResolvers<ContextType>;
  InstrumentProduct?: InstrumentProductResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  KeyResponse?: KeyResponseResolvers<ContextType>;
  KmsBinRangeResponse?: KmsBinRangeResponseResolvers<ContextType>;
  Ledger?: LedgerResolvers<ContextType>;
  LedgerBalance?: LedgerBalanceResolvers<ContextType>;
  LedgerConfig?: LedgerConfigResolvers<ContextType>;
  LedgerConfiguration?: LedgerConfigurationResolvers<ContextType>;
  LedgerLoadLimit?: LedgerLoadLimitResolvers<ContextType>;
  LedgerLoadLimits?: LedgerLoadLimitsResolvers<ContextType>;
  LedgerPlaygroundBalance?: LedgerPlaygroundBalanceResolvers<ContextType>;
  LedgerPlaygroundSubtransaction?: LedgerPlaygroundSubtransactionResolvers<ContextType>;
  LedgerPlaygroundTransaction?: LedgerPlaygroundTransactionResolvers<ContextType>;
  LedgerPlaygroundTransactionBilling?: LedgerPlaygroundTransactionBillingResolvers<ContextType>;
  LedgerPlaygroundTransactionLedgerEntry?: LedgerPlaygroundTransactionLedgerEntryResolvers<ContextType>;
  LedgerPlaygroundTransactionStatus?: LedgerPlaygroundTransactionStatusResolvers<ContextType>;
  LedgerV2?: LedgerV2Resolvers<ContextType>;
  LimitCategory?: LimitCategoryResolvers<ContextType>;
  LimitedNetworkGroupResponse?: LimitedNetworkGroupResponseResolvers<ContextType>;
  LineOfCredit?: LineOfCreditResolvers<ContextType>;
  LineOfCreditV2?: LineOfCreditV2Resolvers<ContextType>;
  LinkKeyToProductResponse?: LinkKeyToProductResponseResolvers<ContextType>;
  LinkageGroupResponse?: LinkageGroupResponseResolvers<ContextType>;
  ListAccountHoldersResponse?: ListAccountHoldersResponseResolvers<ContextType>;
  ListAccountsResponse?: ListAccountsResponseResolvers<ContextType>;
  ListAddressesResponse?: ListAddressesResponseResolvers<ContextType>;
  ListAddressesResponseV2?: ListAddressesResponseV2Resolvers<ContextType>;
  ListApplicationCertificatesResponse?: ListApplicationCertificatesResponseResolvers<ContextType>;
  ListApplicationsResponse?: ListApplicationsResponseResolvers<ContextType>;
  ListCompaniesResponse?: ListCompaniesResponseResolvers<ContextType>;
  ListIdentityProvidersResponse?: ListIdentityProvidersResponseResolvers<ContextType>;
  ListKeysResponse?: ListKeysResponseResolvers<ContextType>;
  ListKmsBinRangesResponse?: ListKmsBinRangesResponseResolvers<ContextType>;
  ListLedgersResponse?: ListLedgersResponseResolvers<ContextType>;
  ListOAuthClientsResponse?: ListOAuthClientsResponseResolvers<ContextType>;
  ListOrganisationGroupsResponse?: ListOrganisationGroupsResponseResolvers<ContextType>;
  ListOrganisationsResponse?: ListOrganisationsResponseResolvers<ContextType>;
  ListPermissionsResponse?: ListPermissionsResponseResolvers<ContextType>;
  ListProductsResponse?: ListProductsResponseResolvers<ContextType>;
  ListSubscriptionsInnerResponse?: ListSubscriptionsInnerResponseResolvers<ContextType>;
  ListSubscriptionsResponse?: ListSubscriptionsResponseResolvers<ContextType>;
  ListTransactionsResponse?: ListTransactionsResponseResolvers<ContextType>;
  ListWebhooksResponse?: ListWebhooksResponseResolvers<ContextType>;
  LoadLimit?: LoadLimitResolvers<ContextType>;
  LoadLimits?: LoadLimitsResolvers<ContextType>;
  LoadUnloadCardResponse?: LoadUnloadCardResponseResolvers<ContextType>;
  Long?: GraphQLScalarType;
  MFAResponse?: MfaResponseResolvers<ContextType>;
  MFXCardType?: MfxCardTypeResolvers<ContextType>;
  MNESignOnParams?: MneSignOnParamsResolvers<ContextType>;
  MastercardSignOnParams?: MastercardSignOnParamsResolvers<ContextType>;
  Merchant?: MerchantResolvers<ContextType>;
  MerchantCategoryCode?: MerchantCategoryCodeResolvers<ContextType>;
  MessageResponse?: MessageResponseResolvers<ContextType>;
  Metadata?: MetadataResolvers<ContextType>;
  MfxCardTranResponse?: MfxCardTranResponseResolvers<ContextType>;
  MfxCardWalletTrnsfrDetailResponse?: MfxCardWalletTrnsfrDetailResponseResolvers<ContextType>;
  MfxCardWalletTrnsfrResponse?: MfxCardWalletTrnsfrResponseResolvers<ContextType>;
  Misc?: MiscResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NetworkSignOnParamsResponse?: NetworkSignOnParamsResponseResolvers<ContextType>;
  OAuthClient?: OAuthClientResolvers<ContextType>;
  OAuthClientCreatedResponse?: OAuthClientCreatedResponseResolvers<ContextType>;
  OffsetLedger?: OffsetLedgerResolvers<ContextType>;
  OidcConfig?: OidcConfigResolvers<ContextType>;
  OrangeFlowReason?: OrangeFlowReasonResolvers<ContextType>;
  Organisation?: OrganisationResolvers<ContextType>;
  OrganisationEmailDomainResponse?: OrganisationEmailDomainResponseResolvers<ContextType>;
  OrganisationGroup?: OrganisationGroupResolvers<ContextType>;
  PANResponse?: PanResponseResolvers<ContextType>;
  PMInformation?: PmInformationResolvers<ContextType>;
  POSDataDecoded?: PosDataDecodedResolvers<ContextType>;
  PastDueAmount?: PastDueAmountResolvers<ContextType>;
  PastDueAmountV2?: PastDueAmountV2Resolvers<ContextType>;
  PaymentNetworkConfigResponse?: PaymentNetworkConfigResponseResolvers<ContextType>;
  PaymentTokenStatus?: PaymentTokenStatusResolvers<ContextType>;
  PaymentTokenStatusResponse?: PaymentTokenStatusResponseResolvers<ContextType>;
  PaymentTokenUsageRuleDetail?: PaymentTokenUsageRuleDetailResolvers<ContextType>;
  PaymentTokenUsageRuleGroupResponse?: PaymentTokenUsageRuleGroupResponseResolvers<ContextType>;
  Permission?: PermissionResolvers<ContextType>;
  PhoneNumber?: PhoneNumberResolvers<ContextType>;
  PhoneNumbers?: PhoneNumbersResolvers<ContextType>;
  PingWebhookDetailResponse?: PingWebhookDetailResponseResolvers<ContextType>;
  PolicyConfiguration?: PolicyConfigurationResolvers<ContextType>;
  PolicyGroup?: PolicyGroupResolvers<ContextType>;
  PolicyV2?: PolicyV2Resolvers<ContextType>;
  PortalTransactionsCollectionSegment?: PortalTransactionsCollectionSegmentResolvers<ContextType>;
  Pos?: PosResolvers<ContextType>;
  PosCapabilities?: PosCapabilitiesResolvers<ContextType>;
  PosEntry?: PosEntryResolvers<ContextType>;
  PosSubLimitsResult?: PosSubLimitsResultResolvers<ContextType>;
  ProcessingCode?: ProcessingCodeResolvers<ContextType>;
  ProductLimits?: ProductLimitsResolvers<ContextType>;
  ProductResponse?: ProductResponseResolvers<ContextType>;
  ProgramManagerProductBasic?: ProgramManagerProductBasicResolvers<ContextType>;
  ProxyResponse?: ProxyResponseResolvers<ContextType>;
  PublicTokenCardHistoryCollectionSegment?: PublicTokenCardHistoryCollectionSegmentResolvers<ContextType>;
  PublicTokenCardStatusHistoryCollectionSegment?: PublicTokenCardStatusHistoryCollectionSegmentResolvers<ContextType>;
  PublicTokenMetaHistoryCollectionSegment?: PublicTokenMetaHistoryCollectionSegmentResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RecurringFees?: RecurringFeesResolvers<ContextType>;
  Regions?: RegionsResolvers<ContextType>;
  ResendNotificationItem?: ResendNotificationItemResolvers<ContextType>;
  ResendNotificationsInnerResponse?: ResendNotificationsInnerResponseResolvers<ContextType>;
  ResendNotificationsResponse?: ResendNotificationsResponseResolvers<ContextType>;
  RotateSecretResponse?: RotateSecretResponseResolvers<ContextType>;
  SamlConfig?: SamlConfigResolvers<ContextType>;
  SearchCardsCollectionSegment?: SearchCardsCollectionSegmentResolvers<ContextType>;
  ServiceHealthCheck?: ServiceHealthCheckResolvers<ContextType>;
  ServiceResponse?: ServiceResponseResolvers<ContextType>;
  SingleFlagData?: SingleFlagDataResolvers<ContextType>;
  SplitKmsBinRangeResponse?: SplitKmsBinRangeResponseResolvers<ContextType>;
  StatusResponse?: StatusResponseResolvers<ContextType>;
  Subcategories?: SubcategoriesResolvers<ContextType>;
  SupplierAndVersionResponse?: SupplierAndVersionResponseResolvers<ContextType>;
  SystemChannel?: SystemChannelResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TokenCacheStats?: TokenCacheStatsResolvers<ContextType>;
  TokenisationStatus?: TokenisationStatusResolvers<ContextType>;
  TransStatus?: TransStatusResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  TransactionAmount?: TransactionAmountResolvers<ContextType>;
  TransactionDetailResponse?: TransactionDetailResponseResolvers<ContextType>;
  TransactionFees?: TransactionFeesResolvers<ContextType>;
  TransactionFeesResponse?: TransactionFeesResponseResolvers<ContextType>;
  TransactionReasonCode?: TransactionReasonCodeResolvers<ContextType>;
  TransactionResponse?: TransactionResponseResolvers<ContextType>;
  TransactionStatus?: TransactionStatusResolvers<ContextType>;
  TransactionType?: TransactionTypeResolvers<ContextType>;
  TransactionTypes?: TransactionTypesResolvers<ContextType>;
  TransactionsCollectionSegment?: TransactionsCollectionSegmentResolvers<ContextType>;
  TrustChain?: TrustChainResolvers<ContextType>;
  TrustChainResponse?: TrustChainResponseResolvers<ContextType>;
  TypeValue?: TypeValueResolvers<ContextType>;
  UndeliveredNotificationItem?: UndeliveredNotificationItemResolvers<ContextType>;
  UndeliveredNotificationsInnerResponse?: UndeliveredNotificationsInnerResponseResolvers<ContextType>;
  UndeliveredNotificationsResponse?: UndeliveredNotificationsResponseResolvers<ContextType>;
  UpdateFeatureFlagResponse?: UpdateFeatureFlagResponseResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserListResponse?: UserListResponseResolvers<ContextType>;
  VerificationChecks?: VerificationChecksResolvers<ContextType>;
  VisaFileMaintenance?: VisaFileMaintenanceResolvers<ContextType>;
  VisaFileMaintenanceResponse?: VisaFileMaintenanceResponseResolvers<ContextType>;
  VisaFileRequest?: VisaFileRequestResolvers<ContextType>;
  VisaFileResponse?: VisaFileResponseResolvers<ContextType>;
  VisaFleet?: VisaFleetResolvers<ContextType>;
  VisaFleetEvData?: VisaFleetEvDataResolvers<ContextType>;
  VisaFleetFleetData?: VisaFleetFleetDataResolvers<ContextType>;
  VisaFleetInvoiceLineItem?: VisaFleetInvoiceLineItemResolvers<ContextType>;
  VisaFleetPromptData?: VisaFleetPromptDataResolvers<ContextType>;
  VisaSignOnParams?: VisaSignOnParamsResolvers<ContextType>;
  WalletDetails?: WalletDetailsResolvers<ContextType>;
  WebServiceGroupFees?: WebServiceGroupFeesResolvers<ContextType>;
  WebServiceProductFees?: WebServiceProductFeesResolvers<ContextType>;
  WebhookConfigResponse?: WebhookConfigResponseResolvers<ContextType>;
  WebhookDetailsResponse?: WebhookDetailsResponseResolvers<ContextType>;
  WebhookDtlResponse?: WebhookDtlResponseResolvers<ContextType>;
  WebhookEventsResponse?: WebhookEventsResponseResolvers<ContextType>;
  WebhookInnerResponse?: WebhookInnerResponseResolvers<ContextType>;
  WebhookItemResponse?: WebhookItemResponseResolvers<ContextType>;
  WebhookListDataResponse?: WebhookListDataResponseResolvers<ContextType>;
  WebhookResponse?: WebhookResponseResolvers<ContextType>;
  WeekDay?: WeekDayResolvers<ContextType>;
  WorkflowsName?: WorkflowsNameResolvers<ContextType>;
  WorkflowsNamesResponse?: WorkflowsNamesResponseResolvers<ContextType>;
  WsBalanceTransferResponse?: WsBalanceTransferResponseResolvers<ContextType>;
  WsLoadCardResponse?: WsLoadCardResponseResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  isAuthenticated?: IsAuthenticatedDirectiveResolver<any, any, ContextType>;
};
